(function () {
  "use strict";
  const At = "srgb",
    pn = "srgb-linear",
    Yn = "linear",
    Xe = "srgb",
    or = "300 es";
  class mn {
    addEventListener(e, t) {
      this._listeners === void 0 && (this._listeners = {});
      const n = this._listeners;
      n[e] === void 0 && (n[e] = []), n[e].indexOf(t) === -1 && n[e].push(t);
    }
    hasEventListener(e, t) {
      const n = this._listeners;
      return n === void 0 ? !1 : n[e] !== void 0 && n[e].indexOf(t) !== -1;
    }
    removeEventListener(e, t) {
      const n = this._listeners;
      if (n === void 0) return;
      const r = n[e];
      if (r !== void 0) {
        const s = r.indexOf(t);
        s !== -1 && r.splice(s, 1);
      }
    }
    dispatchEvent(e) {
      const t = this._listeners;
      if (t === void 0) return;
      const n = t[e.type];
      if (n !== void 0) {
        e.target = this;
        const r = n.slice(0);
        for (let s = 0, a = r.length; s < a; s++) r[s].call(this, e);
        e.target = null;
      }
    }
  }
  const dt = [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "0a",
      "0b",
      "0c",
      "0d",
      "0e",
      "0f",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "1a",
      "1b",
      "1c",
      "1d",
      "1e",
      "1f",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "2a",
      "2b",
      "2c",
      "2d",
      "2e",
      "2f",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "3a",
      "3b",
      "3c",
      "3d",
      "3e",
      "3f",
      "40",
      "41",
      "42",
      "43",
      "44",
      "45",
      "46",
      "47",
      "48",
      "49",
      "4a",
      "4b",
      "4c",
      "4d",
      "4e",
      "4f",
      "50",
      "51",
      "52",
      "53",
      "54",
      "55",
      "56",
      "57",
      "58",
      "59",
      "5a",
      "5b",
      "5c",
      "5d",
      "5e",
      "5f",
      "60",
      "61",
      "62",
      "63",
      "64",
      "65",
      "66",
      "67",
      "68",
      "69",
      "6a",
      "6b",
      "6c",
      "6d",
      "6e",
      "6f",
      "70",
      "71",
      "72",
      "73",
      "74",
      "75",
      "76",
      "77",
      "78",
      "79",
      "7a",
      "7b",
      "7c",
      "7d",
      "7e",
      "7f",
      "80",
      "81",
      "82",
      "83",
      "84",
      "85",
      "86",
      "87",
      "88",
      "89",
      "8a",
      "8b",
      "8c",
      "8d",
      "8e",
      "8f",
      "90",
      "91",
      "92",
      "93",
      "94",
      "95",
      "96",
      "97",
      "98",
      "99",
      "9a",
      "9b",
      "9c",
      "9d",
      "9e",
      "9f",
      "a0",
      "a1",
      "a2",
      "a3",
      "a4",
      "a5",
      "a6",
      "a7",
      "a8",
      "a9",
      "aa",
      "ab",
      "ac",
      "ad",
      "ae",
      "af",
      "b0",
      "b1",
      "b2",
      "b3",
      "b4",
      "b5",
      "b6",
      "b7",
      "b8",
      "b9",
      "ba",
      "bb",
      "bc",
      "bd",
      "be",
      "bf",
      "c0",
      "c1",
      "c2",
      "c3",
      "c4",
      "c5",
      "c6",
      "c7",
      "c8",
      "c9",
      "ca",
      "cb",
      "cc",
      "cd",
      "ce",
      "cf",
      "d0",
      "d1",
      "d2",
      "d3",
      "d4",
      "d5",
      "d6",
      "d7",
      "d8",
      "d9",
      "da",
      "db",
      "dc",
      "dd",
      "de",
      "df",
      "e0",
      "e1",
      "e2",
      "e3",
      "e4",
      "e5",
      "e6",
      "e7",
      "e8",
      "e9",
      "ea",
      "eb",
      "ec",
      "ed",
      "ee",
      "ef",
      "f0",
      "f1",
      "f2",
      "f3",
      "f4",
      "f5",
      "f6",
      "f7",
      "f8",
      "f9",
      "fa",
      "fb",
      "fc",
      "fd",
      "fe",
      "ff"
    ],
    yi = Math.PI / 180,
    Ai = 180 / Math.PI;
  function Fn() {
    const i = (Math.random() * 4294967295) | 0,
      e = (Math.random() * 4294967295) | 0,
      t = (Math.random() * 4294967295) | 0,
      n = (Math.random() * 4294967295) | 0;
    return (
      dt[i & 255] +
      dt[(i >> 8) & 255] +
      dt[(i >> 16) & 255] +
      dt[(i >> 24) & 255] +
      "-" +
      dt[e & 255] +
      dt[(e >> 8) & 255] +
      "-" +
      dt[((e >> 16) & 15) | 64] +
      dt[(e >> 24) & 255] +
      "-" +
      dt[(t & 63) | 128] +
      dt[(t >> 8) & 255] +
      "-" +
      dt[(t >> 16) & 255] +
      dt[(t >> 24) & 255] +
      dt[n & 255] +
      dt[(n >> 8) & 255] +
      dt[(n >> 16) & 255] +
      dt[(n >> 24) & 255]
    ).toLowerCase();
  }
  function Be(i, e, t) {
    return Math.max(e, Math.min(t, i));
  }
  function ys(i, e) {
    return ((i % e) + e) % e;
  }
  function bi(i, e, t) {
    return (1 - t) * i + t * e;
  }
  function Nn(i, e) {
    switch (e.constructor) {
      case Float32Array:
        return i;
      case Uint32Array:
        return i / 4294967295;
      case Uint16Array:
        return i / 65535;
      case Uint8Array:
        return i / 255;
      case Int32Array:
        return Math.max(i / 2147483647, -1);
      case Int16Array:
        return Math.max(i / 32767, -1);
      case Int8Array:
        return Math.max(i / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  function gt(i, e) {
    switch (e.constructor) {
      case Float32Array:
        return i;
      case Uint32Array:
        return Math.round(i * 4294967295);
      case Uint16Array:
        return Math.round(i * 65535);
      case Uint8Array:
        return Math.round(i * 255);
      case Int32Array:
        return Math.round(i * 2147483647);
      case Int16Array:
        return Math.round(i * 32767);
      case Int8Array:
        return Math.round(i * 127);
      default:
        throw new Error("Invalid component type.");
    }
  }
  class qe {
    constructor(e = 0, t = 0) {
      (qe.prototype.isVector2 = !0), (this.x = e), (this.y = t);
    }
    get width() {
      return this.x;
    }
    set width(e) {
      this.x = e;
    }
    get height() {
      return this.y;
    }
    set height(e) {
      this.y = e;
    }
    set(e, t) {
      return (this.x = e), (this.y = t), this;
    }
    setScalar(e) {
      return (this.x = e), (this.y = e), this;
    }
    setX(e) {
      return (this.x = e), this;
    }
    setY(e) {
      return (this.y = e), this;
    }
    setComponent(e, t) {
      switch (e) {
        case 0:
          this.x = t;
          break;
        case 1:
          this.y = t;
          break;
        default:
          throw new Error("index is out of range: " + e);
      }
      return this;
    }
    getComponent(e) {
      switch (e) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        default:
          throw new Error("index is out of range: " + e);
      }
    }
    clone() {
      return new this.constructor(this.x, this.y);
    }
    copy(e) {
      return (this.x = e.x), (this.y = e.y), this;
    }
    add(e) {
      return (this.x += e.x), (this.y += e.y), this;
    }
    addScalar(e) {
      return (this.x += e), (this.y += e), this;
    }
    addVectors(e, t) {
      return (this.x = e.x + t.x), (this.y = e.y + t.y), this;
    }
    addScaledVector(e, t) {
      return (this.x += e.x * t), (this.y += e.y * t), this;
    }
    sub(e) {
      return (this.x -= e.x), (this.y -= e.y), this;
    }
    subScalar(e) {
      return (this.x -= e), (this.y -= e), this;
    }
    subVectors(e, t) {
      return (this.x = e.x - t.x), (this.y = e.y - t.y), this;
    }
    multiply(e) {
      return (this.x *= e.x), (this.y *= e.y), this;
    }
    multiplyScalar(e) {
      return (this.x *= e), (this.y *= e), this;
    }
    divide(e) {
      return (this.x /= e.x), (this.y /= e.y), this;
    }
    divideScalar(e) {
      return this.multiplyScalar(1 / e);
    }
    applyMatrix3(e) {
      const t = this.x,
        n = this.y,
        r = e.elements;
      return (this.x = r[0] * t + r[3] * n + r[6]), (this.y = r[1] * t + r[4] * n + r[7]), this;
    }
    min(e) {
      return (this.x = Math.min(this.x, e.x)), (this.y = Math.min(this.y, e.y)), this;
    }
    max(e) {
      return (this.x = Math.max(this.x, e.x)), (this.y = Math.max(this.y, e.y)), this;
    }
    clamp(e, t) {
      return (this.x = Be(this.x, e.x, t.x)), (this.y = Be(this.y, e.y, t.y)), this;
    }
    clampScalar(e, t) {
      return (this.x = Be(this.x, e, t)), (this.y = Be(this.y, e, t)), this;
    }
    clampLength(e, t) {
      const n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Be(n, e, t));
    }
    floor() {
      return (this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), this;
    }
    ceil() {
      return (this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), this;
    }
    round() {
      return (this.x = Math.round(this.x)), (this.y = Math.round(this.y)), this;
    }
    roundToZero() {
      return (this.x = Math.trunc(this.x)), (this.y = Math.trunc(this.y)), this;
    }
    negate() {
      return (this.x = -this.x), (this.y = -this.y), this;
    }
    dot(e) {
      return this.x * e.x + this.y * e.y;
    }
    cross(e) {
      return this.x * e.y - this.y * e.x;
    }
    lengthSq() {
      return this.x * this.x + this.y * this.y;
    }
    length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    angle() {
      return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    angleTo(e) {
      const t = Math.sqrt(this.lengthSq() * e.lengthSq());
      if (t === 0) return Math.PI / 2;
      const n = this.dot(e) / t;
      return Math.acos(Be(n, -1, 1));
    }
    distanceTo(e) {
      return Math.sqrt(this.distanceToSquared(e));
    }
    distanceToSquared(e) {
      const t = this.x - e.x,
        n = this.y - e.y;
      return t * t + n * n;
    }
    manhattanDistanceTo(e) {
      return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
    }
    setLength(e) {
      return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
      return (this.x += (e.x - this.x) * t), (this.y += (e.y - this.y) * t), this;
    }
    lerpVectors(e, t, n) {
      return (this.x = e.x + (t.x - e.x) * n), (this.y = e.y + (t.y - e.y) * n), this;
    }
    equals(e) {
      return e.x === this.x && e.y === this.y;
    }
    fromArray(e, t = 0) {
      return (this.x = e[t]), (this.y = e[t + 1]), this;
    }
    toArray(e = [], t = 0) {
      return (e[t] = this.x), (e[t + 1] = this.y), e;
    }
    fromBufferAttribute(e, t) {
      return (this.x = e.getX(t)), (this.y = e.getY(t)), this;
    }
    rotateAround(e, t) {
      const n = Math.cos(t),
        r = Math.sin(t),
        s = this.x - e.x,
        a = this.y - e.y;
      return (this.x = s * n - a * r + e.x), (this.y = s * r + a * n + e.y), this;
    }
    random() {
      return (this.x = Math.random()), (this.y = Math.random()), this;
    }
    *[Symbol.iterator]() {
      yield this.x, yield this.y;
    }
  }
  class On {
    constructor(e = 0, t = 0, n = 0, r = 1) {
      (this.isQuaternion = !0), (this._x = e), (this._y = t), (this._z = n), (this._w = r);
    }
    static slerpFlat(e, t, n, r, s, a, o) {
      let c = n[r + 0],
        l = n[r + 1],
        h = n[r + 2],
        f = n[r + 3];
      const d = s[a + 0],
        m = s[a + 1],
        v = s[a + 2],
        x = s[a + 3];
      if (o === 0) {
        (e[t + 0] = c), (e[t + 1] = l), (e[t + 2] = h), (e[t + 3] = f);
        return;
      }
      if (o === 1) {
        (e[t + 0] = d), (e[t + 1] = m), (e[t + 2] = v), (e[t + 3] = x);
        return;
      }
      if (f !== x || c !== d || l !== m || h !== v) {
        let p = 1 - o;
        const u = c * d + l * m + h * v + f * x,
          C = u >= 0 ? 1 : -1,
          y = 1 - u * u;
        if (y > Number.EPSILON) {
          const D = Math.sqrt(y),
            w = Math.atan2(D, u * C);
          (p = Math.sin(p * w) / D), (o = Math.sin(o * w) / D);
        }
        const E = o * C;
        if (((c = c * p + d * E), (l = l * p + m * E), (h = h * p + v * E), (f = f * p + x * E), p === 1 - o)) {
          const D = 1 / Math.sqrt(c * c + l * l + h * h + f * f);
          (c *= D), (l *= D), (h *= D), (f *= D);
        }
      }
      (e[t] = c), (e[t + 1] = l), (e[t + 2] = h), (e[t + 3] = f);
    }
    static multiplyQuaternionsFlat(e, t, n, r, s, a) {
      const o = n[r],
        c = n[r + 1],
        l = n[r + 2],
        h = n[r + 3],
        f = s[a],
        d = s[a + 1],
        m = s[a + 2],
        v = s[a + 3];
      return (
        (e[t] = o * v + h * f + c * m - l * d),
        (e[t + 1] = c * v + h * d + l * f - o * m),
        (e[t + 2] = l * v + h * m + o * d - c * f),
        (e[t + 3] = h * v - o * f - c * d - l * m),
        e
      );
    }
    get x() {
      return this._x;
    }
    set x(e) {
      (this._x = e), this._onChangeCallback();
    }
    get y() {
      return this._y;
    }
    set y(e) {
      (this._y = e), this._onChangeCallback();
    }
    get z() {
      return this._z;
    }
    set z(e) {
      (this._z = e), this._onChangeCallback();
    }
    get w() {
      return this._w;
    }
    set w(e) {
      (this._w = e), this._onChangeCallback();
    }
    set(e, t, n, r) {
      return (this._x = e), (this._y = t), (this._z = n), (this._w = r), this._onChangeCallback(), this;
    }
    clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(e) {
      return (this._x = e.x), (this._y = e.y), (this._z = e.z), (this._w = e.w), this._onChangeCallback(), this;
    }
    setFromEuler(e, t = !0) {
      const n = e._x,
        r = e._y,
        s = e._z,
        a = e._order,
        o = Math.cos,
        c = Math.sin,
        l = o(n / 2),
        h = o(r / 2),
        f = o(s / 2),
        d = c(n / 2),
        m = c(r / 2),
        v = c(s / 2);
      switch (a) {
        case "XYZ":
          (this._x = d * h * f + l * m * v),
            (this._y = l * m * f - d * h * v),
            (this._z = l * h * v + d * m * f),
            (this._w = l * h * f - d * m * v);
          break;
        case "YXZ":
          (this._x = d * h * f + l * m * v),
            (this._y = l * m * f - d * h * v),
            (this._z = l * h * v - d * m * f),
            (this._w = l * h * f + d * m * v);
          break;
        case "ZXY":
          (this._x = d * h * f - l * m * v),
            (this._y = l * m * f + d * h * v),
            (this._z = l * h * v + d * m * f),
            (this._w = l * h * f - d * m * v);
          break;
        case "ZYX":
          (this._x = d * h * f - l * m * v),
            (this._y = l * m * f + d * h * v),
            (this._z = l * h * v - d * m * f),
            (this._w = l * h * f + d * m * v);
          break;
        case "YZX":
          (this._x = d * h * f + l * m * v),
            (this._y = l * m * f + d * h * v),
            (this._z = l * h * v - d * m * f),
            (this._w = l * h * f - d * m * v);
          break;
        case "XZY":
          (this._x = d * h * f - l * m * v),
            (this._y = l * m * f - d * h * v),
            (this._z = l * h * v + d * m * f),
            (this._w = l * h * f + d * m * v);
          break;
        default:
          console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
      }
      return t === !0 && this._onChangeCallback(), this;
    }
    setFromAxisAngle(e, t) {
      const n = t / 2,
        r = Math.sin(n);
      return (
        (this._x = e.x * r),
        (this._y = e.y * r),
        (this._z = e.z * r),
        (this._w = Math.cos(n)),
        this._onChangeCallback(),
        this
      );
    }
    setFromRotationMatrix(e) {
      const t = e.elements,
        n = t[0],
        r = t[4],
        s = t[8],
        a = t[1],
        o = t[5],
        c = t[9],
        l = t[2],
        h = t[6],
        f = t[10],
        d = n + o + f;
      if (d > 0) {
        const m = 0.5 / Math.sqrt(d + 1);
        (this._w = 0.25 / m), (this._x = (h - c) * m), (this._y = (s - l) * m), (this._z = (a - r) * m);
      } else if (n > o && n > f) {
        const m = 2 * Math.sqrt(1 + n - o - f);
        (this._w = (h - c) / m), (this._x = 0.25 * m), (this._y = (r + a) / m), (this._z = (s + l) / m);
      } else if (o > f) {
        const m = 2 * Math.sqrt(1 + o - n - f);
        (this._w = (s - l) / m), (this._x = (r + a) / m), (this._y = 0.25 * m), (this._z = (c + h) / m);
      } else {
        const m = 2 * Math.sqrt(1 + f - n - o);
        (this._w = (a - r) / m), (this._x = (s + l) / m), (this._y = (c + h) / m), (this._z = 0.25 * m);
      }
      return this._onChangeCallback(), this;
    }
    setFromUnitVectors(e, t) {
      let n = e.dot(t) + 1;
      return (
        n < 1e-8
          ? ((n = 0),
            Math.abs(e.x) > Math.abs(e.z)
              ? ((this._x = -e.y), (this._y = e.x), (this._z = 0), (this._w = n))
              : ((this._x = 0), (this._y = -e.z), (this._z = e.y), (this._w = n)))
          : ((this._x = e.y * t.z - e.z * t.y),
            (this._y = e.z * t.x - e.x * t.z),
            (this._z = e.x * t.y - e.y * t.x),
            (this._w = n)),
        this.normalize()
      );
    }
    angleTo(e) {
      return 2 * Math.acos(Math.abs(Be(this.dot(e), -1, 1)));
    }
    rotateTowards(e, t) {
      const n = this.angleTo(e);
      if (n === 0) return this;
      const r = Math.min(1, t / n);
      return this.slerp(e, r), this;
    }
    identity() {
      return this.set(0, 0, 0, 1);
    }
    invert() {
      return this.conjugate();
    }
    conjugate() {
      return (this._x *= -1), (this._y *= -1), (this._z *= -1), this._onChangeCallback(), this;
    }
    dot(e) {
      return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
    }
    lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
      let e = this.length();
      return (
        e === 0
          ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
          : ((e = 1 / e),
            (this._x = this._x * e),
            (this._y = this._y * e),
            (this._z = this._z * e),
            (this._w = this._w * e)),
        this._onChangeCallback(),
        this
      );
    }
    multiply(e) {
      return this.multiplyQuaternions(this, e);
    }
    premultiply(e) {
      return this.multiplyQuaternions(e, this);
    }
    multiplyQuaternions(e, t) {
      const n = e._x,
        r = e._y,
        s = e._z,
        a = e._w,
        o = t._x,
        c = t._y,
        l = t._z,
        h = t._w;
      return (
        (this._x = n * h + a * o + r * l - s * c),
        (this._y = r * h + a * c + s * o - n * l),
        (this._z = s * h + a * l + n * c - r * o),
        (this._w = a * h - n * o - r * c - s * l),
        this._onChangeCallback(),
        this
      );
    }
    slerp(e, t) {
      if (t === 0) return this;
      if (t === 1) return this.copy(e);
      const n = this._x,
        r = this._y,
        s = this._z,
        a = this._w;
      let o = a * e._w + n * e._x + r * e._y + s * e._z;
      if (
        (o < 0 ? ((this._w = -e._w), (this._x = -e._x), (this._y = -e._y), (this._z = -e._z), (o = -o)) : this.copy(e),
        o >= 1)
      )
        return (this._w = a), (this._x = n), (this._y = r), (this._z = s), this;
      const c = 1 - o * o;
      if (c <= Number.EPSILON) {
        const m = 1 - t;
        return (
          (this._w = m * a + t * this._w),
          (this._x = m * n + t * this._x),
          (this._y = m * r + t * this._y),
          (this._z = m * s + t * this._z),
          this.normalize(),
          this
        );
      }
      const l = Math.sqrt(c),
        h = Math.atan2(l, o),
        f = Math.sin((1 - t) * h) / l,
        d = Math.sin(t * h) / l;
      return (
        (this._w = a * f + this._w * d),
        (this._x = n * f + this._x * d),
        (this._y = r * f + this._y * d),
        (this._z = s * f + this._z * d),
        this._onChangeCallback(),
        this
      );
    }
    slerpQuaternions(e, t, n) {
      return this.copy(e).slerp(t, n);
    }
    random() {
      const e = 2 * Math.PI * Math.random(),
        t = 2 * Math.PI * Math.random(),
        n = Math.random(),
        r = Math.sqrt(1 - n),
        s = Math.sqrt(n);
      return this.set(r * Math.sin(e), r * Math.cos(e), s * Math.sin(t), s * Math.cos(t));
    }
    equals(e) {
      return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
    }
    fromArray(e, t = 0) {
      return (
        (this._x = e[t]),
        (this._y = e[t + 1]),
        (this._z = e[t + 2]),
        (this._w = e[t + 3]),
        this._onChangeCallback(),
        this
      );
    }
    toArray(e = [], t = 0) {
      return (e[t] = this._x), (e[t + 1] = this._y), (e[t + 2] = this._z), (e[t + 3] = this._w), e;
    }
    fromBufferAttribute(e, t) {
      return (
        (this._x = e.getX(t)),
        (this._y = e.getY(t)),
        (this._z = e.getZ(t)),
        (this._w = e.getW(t)),
        this._onChangeCallback(),
        this
      );
    }
    toJSON() {
      return this.toArray();
    }
    _onChange(e) {
      return (this._onChangeCallback = e), this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
      yield this._x, yield this._y, yield this._z, yield this._w;
    }
  }
  class O {
    constructor(e = 0, t = 0, n = 0) {
      (O.prototype.isVector3 = !0), (this.x = e), (this.y = t), (this.z = n);
    }
    set(e, t, n) {
      return n === void 0 && (n = this.z), (this.x = e), (this.y = t), (this.z = n), this;
    }
    setScalar(e) {
      return (this.x = e), (this.y = e), (this.z = e), this;
    }
    setX(e) {
      return (this.x = e), this;
    }
    setY(e) {
      return (this.y = e), this;
    }
    setZ(e) {
      return (this.z = e), this;
    }
    setComponent(e, t) {
      switch (e) {
        case 0:
          this.x = t;
          break;
        case 1:
          this.y = t;
          break;
        case 2:
          this.z = t;
          break;
        default:
          throw new Error("index is out of range: " + e);
      }
      return this;
    }
    getComponent(e) {
      switch (e) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        case 2:
          return this.z;
        default:
          throw new Error("index is out of range: " + e);
      }
    }
    clone() {
      return new this.constructor(this.x, this.y, this.z);
    }
    copy(e) {
      return (this.x = e.x), (this.y = e.y), (this.z = e.z), this;
    }
    add(e) {
      return (this.x += e.x), (this.y += e.y), (this.z += e.z), this;
    }
    addScalar(e) {
      return (this.x += e), (this.y += e), (this.z += e), this;
    }
    addVectors(e, t) {
      return (this.x = e.x + t.x), (this.y = e.y + t.y), (this.z = e.z + t.z), this;
    }
    addScaledVector(e, t) {
      return (this.x += e.x * t), (this.y += e.y * t), (this.z += e.z * t), this;
    }
    sub(e) {
      return (this.x -= e.x), (this.y -= e.y), (this.z -= e.z), this;
    }
    subScalar(e) {
      return (this.x -= e), (this.y -= e), (this.z -= e), this;
    }
    subVectors(e, t) {
      return (this.x = e.x - t.x), (this.y = e.y - t.y), (this.z = e.z - t.z), this;
    }
    multiply(e) {
      return (this.x *= e.x), (this.y *= e.y), (this.z *= e.z), this;
    }
    multiplyScalar(e) {
      return (this.x *= e), (this.y *= e), (this.z *= e), this;
    }
    multiplyVectors(e, t) {
      return (this.x = e.x * t.x), (this.y = e.y * t.y), (this.z = e.z * t.z), this;
    }
    applyEuler(e) {
      return this.applyQuaternion(lr.setFromEuler(e));
    }
    applyAxisAngle(e, t) {
      return this.applyQuaternion(lr.setFromAxisAngle(e, t));
    }
    applyMatrix3(e) {
      const t = this.x,
        n = this.y,
        r = this.z,
        s = e.elements;
      return (
        (this.x = s[0] * t + s[3] * n + s[6] * r),
        (this.y = s[1] * t + s[4] * n + s[7] * r),
        (this.z = s[2] * t + s[5] * n + s[8] * r),
        this
      );
    }
    applyNormalMatrix(e) {
      return this.applyMatrix3(e).normalize();
    }
    applyMatrix4(e) {
      const t = this.x,
        n = this.y,
        r = this.z,
        s = e.elements,
        a = 1 / (s[3] * t + s[7] * n + s[11] * r + s[15]);
      return (
        (this.x = (s[0] * t + s[4] * n + s[8] * r + s[12]) * a),
        (this.y = (s[1] * t + s[5] * n + s[9] * r + s[13]) * a),
        (this.z = (s[2] * t + s[6] * n + s[10] * r + s[14]) * a),
        this
      );
    }
    applyQuaternion(e) {
      const t = this.x,
        n = this.y,
        r = this.z,
        s = e.x,
        a = e.y,
        o = e.z,
        c = e.w,
        l = 2 * (a * r - o * n),
        h = 2 * (o * t - s * r),
        f = 2 * (s * n - a * t);
      return (
        (this.x = t + c * l + a * f - o * h),
        (this.y = n + c * h + o * l - s * f),
        (this.z = r + c * f + s * h - a * l),
        this
      );
    }
    project(e) {
      return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
    }
    unproject(e) {
      return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
    }
    transformDirection(e) {
      const t = this.x,
        n = this.y,
        r = this.z,
        s = e.elements;
      return (
        (this.x = s[0] * t + s[4] * n + s[8] * r),
        (this.y = s[1] * t + s[5] * n + s[9] * r),
        (this.z = s[2] * t + s[6] * n + s[10] * r),
        this.normalize()
      );
    }
    divide(e) {
      return (this.x /= e.x), (this.y /= e.y), (this.z /= e.z), this;
    }
    divideScalar(e) {
      return this.multiplyScalar(1 / e);
    }
    min(e) {
      return (this.x = Math.min(this.x, e.x)), (this.y = Math.min(this.y, e.y)), (this.z = Math.min(this.z, e.z)), this;
    }
    max(e) {
      return (this.x = Math.max(this.x, e.x)), (this.y = Math.max(this.y, e.y)), (this.z = Math.max(this.z, e.z)), this;
    }
    clamp(e, t) {
      return (this.x = Be(this.x, e.x, t.x)), (this.y = Be(this.y, e.y, t.y)), (this.z = Be(this.z, e.z, t.z)), this;
    }
    clampScalar(e, t) {
      return (this.x = Be(this.x, e, t)), (this.y = Be(this.y, e, t)), (this.z = Be(this.z, e, t)), this;
    }
    clampLength(e, t) {
      const n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Be(n, e, t));
    }
    floor() {
      return (this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), (this.z = Math.floor(this.z)), this;
    }
    ceil() {
      return (this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), (this.z = Math.ceil(this.z)), this;
    }
    round() {
      return (this.x = Math.round(this.x)), (this.y = Math.round(this.y)), (this.z = Math.round(this.z)), this;
    }
    roundToZero() {
      return (this.x = Math.trunc(this.x)), (this.y = Math.trunc(this.y)), (this.z = Math.trunc(this.z)), this;
    }
    negate() {
      return (this.x = -this.x), (this.y = -this.y), (this.z = -this.z), this;
    }
    dot(e) {
      return this.x * e.x + this.y * e.y + this.z * e.z;
    }
    lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
      return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
      return (this.x += (e.x - this.x) * t), (this.y += (e.y - this.y) * t), (this.z += (e.z - this.z) * t), this;
    }
    lerpVectors(e, t, n) {
      return (this.x = e.x + (t.x - e.x) * n), (this.y = e.y + (t.y - e.y) * n), (this.z = e.z + (t.z - e.z) * n), this;
    }
    cross(e) {
      return this.crossVectors(this, e);
    }
    crossVectors(e, t) {
      const n = e.x,
        r = e.y,
        s = e.z,
        a = t.x,
        o = t.y,
        c = t.z;
      return (this.x = r * c - s * o), (this.y = s * a - n * c), (this.z = n * o - r * a), this;
    }
    projectOnVector(e) {
      const t = e.lengthSq();
      if (t === 0) return this.set(0, 0, 0);
      const n = e.dot(this) / t;
      return this.copy(e).multiplyScalar(n);
    }
    projectOnPlane(e) {
      return Ri.copy(this).projectOnVector(e), this.sub(Ri);
    }
    reflect(e) {
      return this.sub(Ri.copy(e).multiplyScalar(2 * this.dot(e)));
    }
    angleTo(e) {
      const t = Math.sqrt(this.lengthSq() * e.lengthSq());
      if (t === 0) return Math.PI / 2;
      const n = this.dot(e) / t;
      return Math.acos(Be(n, -1, 1));
    }
    distanceTo(e) {
      return Math.sqrt(this.distanceToSquared(e));
    }
    distanceToSquared(e) {
      const t = this.x - e.x,
        n = this.y - e.y,
        r = this.z - e.z;
      return t * t + n * n + r * r;
    }
    manhattanDistanceTo(e) {
      return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
    }
    setFromSpherical(e) {
      return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
    }
    setFromSphericalCoords(e, t, n) {
      const r = Math.sin(t) * e;
      return (this.x = r * Math.sin(n)), (this.y = Math.cos(t) * e), (this.z = r * Math.cos(n)), this;
    }
    setFromCylindrical(e) {
      return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
    }
    setFromCylindricalCoords(e, t, n) {
      return (this.x = e * Math.sin(t)), (this.y = n), (this.z = e * Math.cos(t)), this;
    }
    setFromMatrixPosition(e) {
      const t = e.elements;
      return (this.x = t[12]), (this.y = t[13]), (this.z = t[14]), this;
    }
    setFromMatrixScale(e) {
      const t = this.setFromMatrixColumn(e, 0).length(),
        n = this.setFromMatrixColumn(e, 1).length(),
        r = this.setFromMatrixColumn(e, 2).length();
      return (this.x = t), (this.y = n), (this.z = r), this;
    }
    setFromMatrixColumn(e, t) {
      return this.fromArray(e.elements, t * 4);
    }
    setFromMatrix3Column(e, t) {
      return this.fromArray(e.elements, t * 3);
    }
    setFromEuler(e) {
      return (this.x = e._x), (this.y = e._y), (this.z = e._z), this;
    }
    setFromColor(e) {
      return (this.x = e.r), (this.y = e.g), (this.z = e.b), this;
    }
    equals(e) {
      return e.x === this.x && e.y === this.y && e.z === this.z;
    }
    fromArray(e, t = 0) {
      return (this.x = e[t]), (this.y = e[t + 1]), (this.z = e[t + 2]), this;
    }
    toArray(e = [], t = 0) {
      return (e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), e;
    }
    fromBufferAttribute(e, t) {
      return (this.x = e.getX(t)), (this.y = e.getY(t)), (this.z = e.getZ(t)), this;
    }
    random() {
      return (this.x = Math.random()), (this.y = Math.random()), (this.z = Math.random()), this;
    }
    randomDirection() {
      const e = Math.random() * Math.PI * 2,
        t = Math.random() * 2 - 1,
        n = Math.sqrt(1 - t * t);
      return (this.x = n * Math.cos(e)), (this.y = t), (this.z = n * Math.sin(e)), this;
    }
    *[Symbol.iterator]() {
      yield this.x, yield this.y, yield this.z;
    }
  }
  const Ri = new O(),
    lr = new On();
  class Le {
    constructor(e, t, n, r, s, a, o, c, l) {
      (Le.prototype.isMatrix3 = !0),
        (this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
        e !== void 0 && this.set(e, t, n, r, s, a, o, c, l);
    }
    set(e, t, n, r, s, a, o, c, l) {
      const h = this.elements;
      return (
        (h[0] = e), (h[1] = r), (h[2] = o), (h[3] = t), (h[4] = s), (h[5] = c), (h[6] = n), (h[7] = a), (h[8] = l), this
      );
    }
    identity() {
      return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(e) {
      const t = this.elements,
        n = e.elements;
      return (
        (t[0] = n[0]),
        (t[1] = n[1]),
        (t[2] = n[2]),
        (t[3] = n[3]),
        (t[4] = n[4]),
        (t[5] = n[5]),
        (t[6] = n[6]),
        (t[7] = n[7]),
        (t[8] = n[8]),
        this
      );
    }
    extractBasis(e, t, n) {
      return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(e) {
      const t = e.elements;
      return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
    }
    multiply(e) {
      return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
      return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
      const n = e.elements,
        r = t.elements,
        s = this.elements,
        a = n[0],
        o = n[3],
        c = n[6],
        l = n[1],
        h = n[4],
        f = n[7],
        d = n[2],
        m = n[5],
        v = n[8],
        x = r[0],
        p = r[3],
        u = r[6],
        C = r[1],
        y = r[4],
        E = r[7],
        D = r[2],
        w = r[5],
        P = r[8];
      return (
        (s[0] = a * x + o * C + c * D),
        (s[3] = a * p + o * y + c * w),
        (s[6] = a * u + o * E + c * P),
        (s[1] = l * x + h * C + f * D),
        (s[4] = l * p + h * y + f * w),
        (s[7] = l * u + h * E + f * P),
        (s[2] = d * x + m * C + v * D),
        (s[5] = d * p + m * y + v * w),
        (s[8] = d * u + m * E + v * P),
        this
      );
    }
    multiplyScalar(e) {
      const t = this.elements;
      return (
        (t[0] *= e),
        (t[3] *= e),
        (t[6] *= e),
        (t[1] *= e),
        (t[4] *= e),
        (t[7] *= e),
        (t[2] *= e),
        (t[5] *= e),
        (t[8] *= e),
        this
      );
    }
    determinant() {
      const e = this.elements,
        t = e[0],
        n = e[1],
        r = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        c = e[6],
        l = e[7],
        h = e[8];
      return t * a * h - t * o * l - n * s * h + n * o * c + r * s * l - r * a * c;
    }
    invert() {
      const e = this.elements,
        t = e[0],
        n = e[1],
        r = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        c = e[6],
        l = e[7],
        h = e[8],
        f = h * a - o * l,
        d = o * c - h * s,
        m = l * s - a * c,
        v = t * f + n * d + r * m;
      if (v === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
      const x = 1 / v;
      return (
        (e[0] = f * x),
        (e[1] = (r * l - h * n) * x),
        (e[2] = (o * n - r * a) * x),
        (e[3] = d * x),
        (e[4] = (h * t - r * c) * x),
        (e[5] = (r * s - o * t) * x),
        (e[6] = m * x),
        (e[7] = (n * c - l * t) * x),
        (e[8] = (a * t - n * s) * x),
        this
      );
    }
    transpose() {
      let e;
      const t = this.elements;
      return (
        (e = t[1]),
        (t[1] = t[3]),
        (t[3] = e),
        (e = t[2]),
        (t[2] = t[6]),
        (t[6] = e),
        (e = t[5]),
        (t[5] = t[7]),
        (t[7] = e),
        this
      );
    }
    getNormalMatrix(e) {
      return this.setFromMatrix4(e).invert().transpose();
    }
    transposeIntoArray(e) {
      const t = this.elements;
      return (
        (e[0] = t[0]),
        (e[1] = t[3]),
        (e[2] = t[6]),
        (e[3] = t[1]),
        (e[4] = t[4]),
        (e[5] = t[7]),
        (e[6] = t[2]),
        (e[7] = t[5]),
        (e[8] = t[8]),
        this
      );
    }
    setUvTransform(e, t, n, r, s, a, o) {
      const c = Math.cos(s),
        l = Math.sin(s);
      return (
        this.set(n * c, n * l, -n * (c * a + l * o) + a + e, -r * l, r * c, -r * (-l * a + c * o) + o + t, 0, 0, 1),
        this
      );
    }
    scale(e, t) {
      return this.premultiply(Ci.makeScale(e, t)), this;
    }
    rotate(e) {
      return this.premultiply(Ci.makeRotation(-e)), this;
    }
    translate(e, t) {
      return this.premultiply(Ci.makeTranslation(e, t)), this;
    }
    makeTranslation(e, t) {
      return e.isVector2 ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1) : this.set(1, 0, e, 0, 1, t, 0, 0, 1), this;
    }
    makeRotation(e) {
      const t = Math.cos(e),
        n = Math.sin(e);
      return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
    }
    makeScale(e, t) {
      return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this;
    }
    equals(e) {
      const t = this.elements,
        n = e.elements;
      for (let r = 0; r < 9; r++) if (t[r] !== n[r]) return !1;
      return !0;
    }
    fromArray(e, t = 0) {
      for (let n = 0; n < 9; n++) this.elements[n] = e[n + t];
      return this;
    }
    toArray(e = [], t = 0) {
      const n = this.elements;
      return (
        (e[t] = n[0]),
        (e[t + 1] = n[1]),
        (e[t + 2] = n[2]),
        (e[t + 3] = n[3]),
        (e[t + 4] = n[4]),
        (e[t + 5] = n[5]),
        (e[t + 6] = n[6]),
        (e[t + 7] = n[7]),
        (e[t + 8] = n[8]),
        e
      );
    }
    clone() {
      return new this.constructor().fromArray(this.elements);
    }
  }
  const Ci = new Le();
  function cr(i) {
    for (let e = i.length - 1; e >= 0; --e) if (i[e] >= 65535) return !0;
    return !1;
  }
  function $n(i) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", i);
  }
  function As() {
    const i = $n("canvas");
    return (i.style.display = "block"), i;
  }
  const ur = {};
  function _n(i) {
    i in ur || ((ur[i] = !0), console.warn(i));
  }
  function bs(i, e, t) {
    return new Promise(function (n, r) {
      function s() {
        switch (i.clientWaitSync(e, i.SYNC_FLUSH_COMMANDS_BIT, 0)) {
          case i.WAIT_FAILED:
            r();
            break;
          case i.TIMEOUT_EXPIRED:
            setTimeout(s, t);
            break;
          default:
            n();
        }
      }
      setTimeout(s, t);
    });
  }
  const hr = new Le().set(
      0.4123908,
      0.3575843,
      0.1804808,
      0.212639,
      0.7151687,
      0.0721923,
      0.0193308,
      0.1191948,
      0.9505322
    ),
    fr = new Le().set(
      3.2409699,
      -1.5373832,
      -0.4986108,
      -0.9692436,
      1.8759675,
      0.0415551,
      0.0556301,
      -0.203977,
      1.0569715
    );
  function Rs() {
    const i = {
        enabled: !0,
        workingColorSpace: pn,
        spaces: {},
        convert: function (r, s, a) {
          return (
            this.enabled === !1 ||
              s === a ||
              !s ||
              !a ||
              (this.spaces[s].transfer === Xe && ((r.r = Ot(r.r)), (r.g = Ot(r.g)), (r.b = Ot(r.b))),
              this.spaces[s].primaries !== this.spaces[a].primaries &&
                (r.applyMatrix3(this.spaces[s].toXYZ), r.applyMatrix3(this.spaces[a].fromXYZ)),
              this.spaces[a].transfer === Xe && ((r.r = gn(r.r)), (r.g = gn(r.g)), (r.b = gn(r.b)))),
            r
          );
        },
        workingToColorSpace: function (r, s) {
          return this.convert(r, this.workingColorSpace, s);
        },
        colorSpaceToWorking: function (r, s) {
          return this.convert(r, s, this.workingColorSpace);
        },
        getPrimaries: function (r) {
          return this.spaces[r].primaries;
        },
        getTransfer: function (r) {
          return r === "" ? Yn : this.spaces[r].transfer;
        },
        getLuminanceCoefficients: function (r, s = this.workingColorSpace) {
          return r.fromArray(this.spaces[s].luminanceCoefficients);
        },
        define: function (r) {
          Object.assign(this.spaces, r);
        },
        _getMatrix: function (r, s, a) {
          return r.copy(this.spaces[s].toXYZ).multiply(this.spaces[a].fromXYZ);
        },
        _getDrawingBufferColorSpace: function (r) {
          return this.spaces[r].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function (r = this.workingColorSpace) {
          return this.spaces[r].workingColorSpaceConfig.unpackColorSpace;
        },
        fromWorkingColorSpace: function (r, s) {
          return (
            _n("THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."),
            i.workingToColorSpace(r, s)
          );
        },
        toWorkingColorSpace: function (r, s) {
          return (
            _n("THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."),
            i.colorSpaceToWorking(r, s)
          );
        }
      },
      e = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06],
      t = [0.2126, 0.7152, 0.0722],
      n = [0.3127, 0.329];
    return (
      i.define({
        [pn]: {
          primaries: e,
          whitePoint: n,
          transfer: Yn,
          toXYZ: hr,
          fromXYZ: fr,
          luminanceCoefficients: t,
          workingColorSpaceConfig: { unpackColorSpace: At },
          outputColorSpaceConfig: { drawingBufferColorSpace: At }
        },
        [At]: {
          primaries: e,
          whitePoint: n,
          transfer: Xe,
          toXYZ: hr,
          fromXYZ: fr,
          luminanceCoefficients: t,
          outputColorSpaceConfig: { drawingBufferColorSpace: At }
        }
      }),
      i
    );
  }
  const ze = Rs();
  function Ot(i) {
    return i < 0.04045 ? i * 0.0773993808 : Math.pow(i * 0.9478672986 + 0.0521327014, 2.4);
  }
  function gn(i) {
    return i < 0.0031308 ? i * 12.92 : 1.055 * Math.pow(i, 0.41666) - 0.055;
  }
  let vn;
  class Cs {
    static getDataURL(e, t = "image/png") {
      if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u") return e.src;
      let n;
      if (e instanceof HTMLCanvasElement) n = e;
      else {
        vn === void 0 && (vn = $n("canvas")), (vn.width = e.width), (vn.height = e.height);
        const r = vn.getContext("2d");
        e instanceof ImageData ? r.putImageData(e, 0, 0) : r.drawImage(e, 0, 0, e.width, e.height), (n = vn);
      }
      return n.toDataURL(t);
    }
    static sRGBToLinear(e) {
      if (
        (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement) ||
        (typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement) ||
        (typeof ImageBitmap < "u" && e instanceof ImageBitmap)
      ) {
        const t = $n("canvas");
        (t.width = e.width), (t.height = e.height);
        const n = t.getContext("2d");
        n.drawImage(e, 0, 0, e.width, e.height);
        const r = n.getImageData(0, 0, e.width, e.height),
          s = r.data;
        for (let a = 0; a < s.length; a++) s[a] = Ot(s[a] / 255) * 255;
        return n.putImageData(r, 0, 0), t;
      } else if (e.data) {
        const t = e.data.slice(0);
        for (let n = 0; n < t.length; n++)
          t instanceof Uint8Array || t instanceof Uint8ClampedArray
            ? (t[n] = Math.floor(Ot(t[n] / 255) * 255))
            : (t[n] = Ot(t[n]));
        return { data: t, width: e.width, height: e.height };
      } else
        return (
          console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e
        );
    }
  }
  let ws = 0;
  class wi {
    constructor(e = null) {
      (this.isSource = !0),
        Object.defineProperty(this, "id", { value: ws++ }),
        (this.uuid = Fn()),
        (this.data = e),
        (this.dataReady = !0),
        (this.version = 0);
    }
    getSize(e) {
      const t = this.data;
      return (
        t instanceof HTMLVideoElement
          ? e.set(t.videoWidth, t.videoHeight, 0)
          : t instanceof VideoFrame
          ? e.set(t.displayHeight, t.displayWidth, 0)
          : t !== null
          ? e.set(t.width, t.height, t.depth || 0)
          : e.set(0, 0, 0),
        e
      );
    }
    set needsUpdate(e) {
      e === !0 && this.version++;
    }
    toJSON(e) {
      const t = e === void 0 || typeof e == "string";
      if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid];
      const n = { uuid: this.uuid, url: "" },
        r = this.data;
      if (r !== null) {
        let s;
        if (Array.isArray(r)) {
          s = [];
          for (let a = 0, o = r.length; a < o; a++) r[a].isDataTexture ? s.push(Pi(r[a].image)) : s.push(Pi(r[a]));
        } else s = Pi(r);
        n.url = s;
      }
      return t || (e.images[this.uuid] = n), n;
    }
  }
  function Pi(i) {
    return (typeof HTMLImageElement < "u" && i instanceof HTMLImageElement) ||
      (typeof HTMLCanvasElement < "u" && i instanceof HTMLCanvasElement) ||
      (typeof ImageBitmap < "u" && i instanceof ImageBitmap)
      ? Cs.getDataURL(i)
      : i.data
      ? { data: Array.from(i.data), width: i.width, height: i.height, type: i.data.constructor.name }
      : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
  }
  let Ps = 0;
  const Di = new O();
  class vt extends mn {
    constructor(
      e = vt.DEFAULT_IMAGE,
      t = vt.DEFAULT_MAPPING,
      n = 1001,
      r = 1001,
      s = 1006,
      a = 1008,
      o = 1023,
      c = 1009,
      l = vt.DEFAULT_ANISOTROPY,
      h = ""
    ) {
      super(),
        (this.isTexture = !0),
        Object.defineProperty(this, "id", { value: Ps++ }),
        (this.uuid = Fn()),
        (this.name = ""),
        (this.source = new wi(e)),
        (this.mipmaps = []),
        (this.mapping = t),
        (this.channel = 0),
        (this.wrapS = n),
        (this.wrapT = r),
        (this.magFilter = s),
        (this.minFilter = a),
        (this.anisotropy = l),
        (this.format = o),
        (this.internalFormat = null),
        (this.type = c),
        (this.offset = new qe(0, 0)),
        (this.repeat = new qe(1, 1)),
        (this.center = new qe(0, 0)),
        (this.rotation = 0),
        (this.matrixAutoUpdate = !0),
        (this.matrix = new Le()),
        (this.generateMipmaps = !0),
        (this.premultiplyAlpha = !1),
        (this.flipY = !0),
        (this.unpackAlignment = 4),
        (this.colorSpace = h),
        (this.userData = {}),
        (this.updateRanges = []),
        (this.version = 0),
        (this.onUpdate = null),
        (this.renderTarget = null),
        (this.isRenderTargetTexture = !1),
        (this.isArrayTexture = !!(e && e.depth && e.depth > 1)),
        (this.pmremVersion = 0);
    }
    get width() {
      return this.source.getSize(Di).x;
    }
    get height() {
      return this.source.getSize(Di).y;
    }
    get depth() {
      return this.source.getSize(Di).z;
    }
    get image() {
      return this.source.data;
    }
    set image(e = null) {
      this.source.data = e;
    }
    updateMatrix() {
      this.matrix.setUvTransform(
        this.offset.x,
        this.offset.y,
        this.repeat.x,
        this.repeat.y,
        this.rotation,
        this.center.x,
        this.center.y
      );
    }
    addUpdateRange(e, t) {
      this.updateRanges.push({ start: e, count: t });
    }
    clearUpdateRanges() {
      this.updateRanges.length = 0;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(e) {
      return (
        (this.name = e.name),
        (this.source = e.source),
        (this.mipmaps = e.mipmaps.slice(0)),
        (this.mapping = e.mapping),
        (this.channel = e.channel),
        (this.wrapS = e.wrapS),
        (this.wrapT = e.wrapT),
        (this.magFilter = e.magFilter),
        (this.minFilter = e.minFilter),
        (this.anisotropy = e.anisotropy),
        (this.format = e.format),
        (this.internalFormat = e.internalFormat),
        (this.type = e.type),
        this.offset.copy(e.offset),
        this.repeat.copy(e.repeat),
        this.center.copy(e.center),
        (this.rotation = e.rotation),
        (this.matrixAutoUpdate = e.matrixAutoUpdate),
        this.matrix.copy(e.matrix),
        (this.generateMipmaps = e.generateMipmaps),
        (this.premultiplyAlpha = e.premultiplyAlpha),
        (this.flipY = e.flipY),
        (this.unpackAlignment = e.unpackAlignment),
        (this.colorSpace = e.colorSpace),
        (this.renderTarget = e.renderTarget),
        (this.isRenderTargetTexture = e.isRenderTargetTexture),
        (this.isArrayTexture = e.isArrayTexture),
        (this.userData = JSON.parse(JSON.stringify(e.userData))),
        (this.needsUpdate = !0),
        this
      );
    }
    setValues(e) {
      for (const t in e) {
        const n = e[t];
        if (n === void 0) {
          console.warn(`THREE.Texture.setValues(): parameter '${t}' has value of undefined.`);
          continue;
        }
        const r = this[t];
        if (r === void 0) {
          console.warn(`THREE.Texture.setValues(): property '${t}' does not exist.`);
          continue;
        }
        (r && n && r.isVector2 && n.isVector2) ||
        (r && n && r.isVector3 && n.isVector3) ||
        (r && n && r.isMatrix3 && n.isMatrix3)
          ? r.copy(n)
          : (this[t] = n);
      }
    }
    toJSON(e) {
      const t = e === void 0 || typeof e == "string";
      if (!t && e.textures[this.uuid] !== void 0) return e.textures[this.uuid];
      const n = {
        metadata: { version: 4.7, type: "Texture", generator: "Texture.toJSON" },
        uuid: this.uuid,
        name: this.name,
        image: this.source.toJSON(e).uuid,
        mapping: this.mapping,
        channel: this.channel,
        repeat: [this.repeat.x, this.repeat.y],
        offset: [this.offset.x, this.offset.y],
        center: [this.center.x, this.center.y],
        rotation: this.rotation,
        wrap: [this.wrapS, this.wrapT],
        format: this.format,
        internalFormat: this.internalFormat,
        type: this.type,
        colorSpace: this.colorSpace,
        minFilter: this.minFilter,
        magFilter: this.magFilter,
        anisotropy: this.anisotropy,
        flipY: this.flipY,
        generateMipmaps: this.generateMipmaps,
        premultiplyAlpha: this.premultiplyAlpha,
        unpackAlignment: this.unpackAlignment
      };
      return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e.textures[this.uuid] = n), n;
    }
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
    transformUv(e) {
      if (this.mapping !== 300) return e;
      if ((e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1))
        switch (this.wrapS) {
          case 1e3:
            e.x = e.x - Math.floor(e.x);
            break;
          case 1001:
            e.x = e.x < 0 ? 0 : 1;
            break;
          case 1002:
            Math.abs(Math.floor(e.x) % 2) === 1 ? (e.x = Math.ceil(e.x) - e.x) : (e.x = e.x - Math.floor(e.x));
            break;
        }
      if (e.y < 0 || e.y > 1)
        switch (this.wrapT) {
          case 1e3:
            e.y = e.y - Math.floor(e.y);
            break;
          case 1001:
            e.y = e.y < 0 ? 0 : 1;
            break;
          case 1002:
            Math.abs(Math.floor(e.y) % 2) === 1 ? (e.y = Math.ceil(e.y) - e.y) : (e.y = e.y - Math.floor(e.y));
            break;
        }
      return this.flipY && (e.y = 1 - e.y), e;
    }
    set needsUpdate(e) {
      e === !0 && (this.version++, (this.source.needsUpdate = !0));
    }
    set needsPMREMUpdate(e) {
      e === !0 && this.pmremVersion++;
    }
  }
  (vt.DEFAULT_IMAGE = null), (vt.DEFAULT_MAPPING = 300), (vt.DEFAULT_ANISOTROPY = 1);
  class rt {
    constructor(e = 0, t = 0, n = 0, r = 1) {
      (rt.prototype.isVector4 = !0), (this.x = e), (this.y = t), (this.z = n), (this.w = r);
    }
    get width() {
      return this.z;
    }
    set width(e) {
      this.z = e;
    }
    get height() {
      return this.w;
    }
    set height(e) {
      this.w = e;
    }
    set(e, t, n, r) {
      return (this.x = e), (this.y = t), (this.z = n), (this.w = r), this;
    }
    setScalar(e) {
      return (this.x = e), (this.y = e), (this.z = e), (this.w = e), this;
    }
    setX(e) {
      return (this.x = e), this;
    }
    setY(e) {
      return (this.y = e), this;
    }
    setZ(e) {
      return (this.z = e), this;
    }
    setW(e) {
      return (this.w = e), this;
    }
    setComponent(e, t) {
      switch (e) {
        case 0:
          this.x = t;
          break;
        case 1:
          this.y = t;
          break;
        case 2:
          this.z = t;
          break;
        case 3:
          this.w = t;
          break;
        default:
          throw new Error("index is out of range: " + e);
      }
      return this;
    }
    getComponent(e) {
      switch (e) {
        case 0:
          return this.x;
        case 1:
          return this.y;
        case 2:
          return this.z;
        case 3:
          return this.w;
        default:
          throw new Error("index is out of range: " + e);
      }
    }
    clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(e) {
      return (this.x = e.x), (this.y = e.y), (this.z = e.z), (this.w = e.w !== void 0 ? e.w : 1), this;
    }
    add(e) {
      return (this.x += e.x), (this.y += e.y), (this.z += e.z), (this.w += e.w), this;
    }
    addScalar(e) {
      return (this.x += e), (this.y += e), (this.z += e), (this.w += e), this;
    }
    addVectors(e, t) {
      return (this.x = e.x + t.x), (this.y = e.y + t.y), (this.z = e.z + t.z), (this.w = e.w + t.w), this;
    }
    addScaledVector(e, t) {
      return (this.x += e.x * t), (this.y += e.y * t), (this.z += e.z * t), (this.w += e.w * t), this;
    }
    sub(e) {
      return (this.x -= e.x), (this.y -= e.y), (this.z -= e.z), (this.w -= e.w), this;
    }
    subScalar(e) {
      return (this.x -= e), (this.y -= e), (this.z -= e), (this.w -= e), this;
    }
    subVectors(e, t) {
      return (this.x = e.x - t.x), (this.y = e.y - t.y), (this.z = e.z - t.z), (this.w = e.w - t.w), this;
    }
    multiply(e) {
      return (this.x *= e.x), (this.y *= e.y), (this.z *= e.z), (this.w *= e.w), this;
    }
    multiplyScalar(e) {
      return (this.x *= e), (this.y *= e), (this.z *= e), (this.w *= e), this;
    }
    applyMatrix4(e) {
      const t = this.x,
        n = this.y,
        r = this.z,
        s = this.w,
        a = e.elements;
      return (
        (this.x = a[0] * t + a[4] * n + a[8] * r + a[12] * s),
        (this.y = a[1] * t + a[5] * n + a[9] * r + a[13] * s),
        (this.z = a[2] * t + a[6] * n + a[10] * r + a[14] * s),
        (this.w = a[3] * t + a[7] * n + a[11] * r + a[15] * s),
        this
      );
    }
    divide(e) {
      return (this.x /= e.x), (this.y /= e.y), (this.z /= e.z), (this.w /= e.w), this;
    }
    divideScalar(e) {
      return this.multiplyScalar(1 / e);
    }
    setAxisAngleFromQuaternion(e) {
      this.w = 2 * Math.acos(e.w);
      const t = Math.sqrt(1 - e.w * e.w);
      return (
        t < 1e-4
          ? ((this.x = 1), (this.y = 0), (this.z = 0))
          : ((this.x = e.x / t), (this.y = e.y / t), (this.z = e.z / t)),
        this
      );
    }
    setAxisAngleFromRotationMatrix(e) {
      let t, n, r, s;
      const c = e.elements,
        l = c[0],
        h = c[4],
        f = c[8],
        d = c[1],
        m = c[5],
        v = c[9],
        x = c[2],
        p = c[6],
        u = c[10];
      if (Math.abs(h - d) < 0.01 && Math.abs(f - x) < 0.01 && Math.abs(v - p) < 0.01) {
        if (Math.abs(h + d) < 0.1 && Math.abs(f + x) < 0.1 && Math.abs(v + p) < 0.1 && Math.abs(l + m + u - 3) < 0.1)
          return this.set(1, 0, 0, 0), this;
        t = Math.PI;
        const y = (l + 1) / 2,
          E = (m + 1) / 2,
          D = (u + 1) / 2,
          w = (h + d) / 4,
          P = (f + x) / 4,
          F = (v + p) / 4;
        return (
          y > E && y > D
            ? y < 0.01
              ? ((n = 0), (r = 0.707106781), (s = 0.707106781))
              : ((n = Math.sqrt(y)), (r = w / n), (s = P / n))
            : E > D
            ? E < 0.01
              ? ((n = 0.707106781), (r = 0), (s = 0.707106781))
              : ((r = Math.sqrt(E)), (n = w / r), (s = F / r))
            : D < 0.01
            ? ((n = 0.707106781), (r = 0.707106781), (s = 0))
            : ((s = Math.sqrt(D)), (n = P / s), (r = F / s)),
          this.set(n, r, s, t),
          this
        );
      }
      let C = Math.sqrt((p - v) * (p - v) + (f - x) * (f - x) + (d - h) * (d - h));
      return (
        Math.abs(C) < 0.001 && (C = 1),
        (this.x = (p - v) / C),
        (this.y = (f - x) / C),
        (this.z = (d - h) / C),
        (this.w = Math.acos((l + m + u - 1) / 2)),
        this
      );
    }
    setFromMatrixPosition(e) {
      const t = e.elements;
      return (this.x = t[12]), (this.y = t[13]), (this.z = t[14]), (this.w = t[15]), this;
    }
    min(e) {
      return (
        (this.x = Math.min(this.x, e.x)),
        (this.y = Math.min(this.y, e.y)),
        (this.z = Math.min(this.z, e.z)),
        (this.w = Math.min(this.w, e.w)),
        this
      );
    }
    max(e) {
      return (
        (this.x = Math.max(this.x, e.x)),
        (this.y = Math.max(this.y, e.y)),
        (this.z = Math.max(this.z, e.z)),
        (this.w = Math.max(this.w, e.w)),
        this
      );
    }
    clamp(e, t) {
      return (
        (this.x = Be(this.x, e.x, t.x)),
        (this.y = Be(this.y, e.y, t.y)),
        (this.z = Be(this.z, e.z, t.z)),
        (this.w = Be(this.w, e.w, t.w)),
        this
      );
    }
    clampScalar(e, t) {
      return (
        (this.x = Be(this.x, e, t)),
        (this.y = Be(this.y, e, t)),
        (this.z = Be(this.z, e, t)),
        (this.w = Be(this.w, e, t)),
        this
      );
    }
    clampLength(e, t) {
      const n = this.length();
      return this.divideScalar(n || 1).multiplyScalar(Be(n, e, t));
    }
    floor() {
      return (
        (this.x = Math.floor(this.x)),
        (this.y = Math.floor(this.y)),
        (this.z = Math.floor(this.z)),
        (this.w = Math.floor(this.w)),
        this
      );
    }
    ceil() {
      return (
        (this.x = Math.ceil(this.x)),
        (this.y = Math.ceil(this.y)),
        (this.z = Math.ceil(this.z)),
        (this.w = Math.ceil(this.w)),
        this
      );
    }
    round() {
      return (
        (this.x = Math.round(this.x)),
        (this.y = Math.round(this.y)),
        (this.z = Math.round(this.z)),
        (this.w = Math.round(this.w)),
        this
      );
    }
    roundToZero() {
      return (
        (this.x = Math.trunc(this.x)),
        (this.y = Math.trunc(this.y)),
        (this.z = Math.trunc(this.z)),
        (this.w = Math.trunc(this.w)),
        this
      );
    }
    negate() {
      return (this.x = -this.x), (this.y = -this.y), (this.z = -this.z), (this.w = -this.w), this;
    }
    dot(e) {
      return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
    }
    lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
      return this.divideScalar(this.length() || 1);
    }
    setLength(e) {
      return this.normalize().multiplyScalar(e);
    }
    lerp(e, t) {
      return (
        (this.x += (e.x - this.x) * t),
        (this.y += (e.y - this.y) * t),
        (this.z += (e.z - this.z) * t),
        (this.w += (e.w - this.w) * t),
        this
      );
    }
    lerpVectors(e, t, n) {
      return (
        (this.x = e.x + (t.x - e.x) * n),
        (this.y = e.y + (t.y - e.y) * n),
        (this.z = e.z + (t.z - e.z) * n),
        (this.w = e.w + (t.w - e.w) * n),
        this
      );
    }
    equals(e) {
      return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
    }
    fromArray(e, t = 0) {
      return (this.x = e[t]), (this.y = e[t + 1]), (this.z = e[t + 2]), (this.w = e[t + 3]), this;
    }
    toArray(e = [], t = 0) {
      return (e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), (e[t + 3] = this.w), e;
    }
    fromBufferAttribute(e, t) {
      return (this.x = e.getX(t)), (this.y = e.getY(t)), (this.z = e.getZ(t)), (this.w = e.getW(t)), this;
    }
    random() {
      return (
        (this.x = Math.random()), (this.y = Math.random()), (this.z = Math.random()), (this.w = Math.random()), this
      );
    }
    *[Symbol.iterator]() {
      yield this.x, yield this.y, yield this.z, yield this.w;
    }
  }
  class Ds extends mn {
    constructor(e = 1, t = 1, n = {}) {
      super(),
        (n = Object.assign(
          {
            generateMipmaps: !1,
            internalFormat: null,
            minFilter: 1006,
            depthBuffer: !0,
            stencilBuffer: !1,
            resolveDepthBuffer: !0,
            resolveStencilBuffer: !0,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: !1
          },
          n
        )),
        (this.isRenderTarget = !0),
        (this.width = e),
        (this.height = t),
        (this.depth = n.depth),
        (this.scissor = new rt(0, 0, e, t)),
        (this.scissorTest = !1),
        (this.viewport = new rt(0, 0, e, t));
      const r = { width: e, height: t, depth: n.depth },
        s = new vt(r);
      this.textures = [];
      const a = n.count;
      for (let o = 0; o < a; o++)
        (this.textures[o] = s.clone()),
          (this.textures[o].isRenderTargetTexture = !0),
          (this.textures[o].renderTarget = this);
      this._setTextureOptions(n),
        (this.depthBuffer = n.depthBuffer),
        (this.stencilBuffer = n.stencilBuffer),
        (this.resolveDepthBuffer = n.resolveDepthBuffer),
        (this.resolveStencilBuffer = n.resolveStencilBuffer),
        (this._depthTexture = null),
        (this.depthTexture = n.depthTexture),
        (this.samples = n.samples),
        (this.multiview = n.multiview);
    }
    _setTextureOptions(e = {}) {
      const t = { minFilter: 1006, generateMipmaps: !1, flipY: !1, internalFormat: null };
      e.mapping !== void 0 && (t.mapping = e.mapping),
        e.wrapS !== void 0 && (t.wrapS = e.wrapS),
        e.wrapT !== void 0 && (t.wrapT = e.wrapT),
        e.wrapR !== void 0 && (t.wrapR = e.wrapR),
        e.magFilter !== void 0 && (t.magFilter = e.magFilter),
        e.minFilter !== void 0 && (t.minFilter = e.minFilter),
        e.format !== void 0 && (t.format = e.format),
        e.type !== void 0 && (t.type = e.type),
        e.anisotropy !== void 0 && (t.anisotropy = e.anisotropy),
        e.colorSpace !== void 0 && (t.colorSpace = e.colorSpace),
        e.flipY !== void 0 && (t.flipY = e.flipY),
        e.generateMipmaps !== void 0 && (t.generateMipmaps = e.generateMipmaps),
        e.internalFormat !== void 0 && (t.internalFormat = e.internalFormat);
      for (let n = 0; n < this.textures.length; n++) this.textures[n].setValues(t);
    }
    get texture() {
      return this.textures[0];
    }
    set texture(e) {
      this.textures[0] = e;
    }
    set depthTexture(e) {
      this._depthTexture !== null && (this._depthTexture.renderTarget = null),
        e !== null && (e.renderTarget = this),
        (this._depthTexture = e);
    }
    get depthTexture() {
      return this._depthTexture;
    }
    setSize(e, t, n = 1) {
      if (this.width !== e || this.height !== t || this.depth !== n) {
        (this.width = e), (this.height = t), (this.depth = n);
        for (let r = 0, s = this.textures.length; r < s; r++)
          (this.textures[r].image.width = e),
            (this.textures[r].image.height = t),
            (this.textures[r].image.depth = n),
            (this.textures[r].isArrayTexture = this.textures[r].image.depth > 1);
        this.dispose();
      }
      this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(e) {
      (this.width = e.width),
        (this.height = e.height),
        (this.depth = e.depth),
        this.scissor.copy(e.scissor),
        (this.scissorTest = e.scissorTest),
        this.viewport.copy(e.viewport),
        (this.textures.length = 0);
      for (let t = 0, n = e.textures.length; t < n; t++) {
        (this.textures[t] = e.textures[t].clone()),
          (this.textures[t].isRenderTargetTexture = !0),
          (this.textures[t].renderTarget = this);
        const r = Object.assign({}, e.textures[t].image);
        this.textures[t].source = new wi(r);
      }
      return (
        (this.depthBuffer = e.depthBuffer),
        (this.stencilBuffer = e.stencilBuffer),
        (this.resolveDepthBuffer = e.resolveDepthBuffer),
        (this.resolveStencilBuffer = e.resolveStencilBuffer),
        e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()),
        (this.samples = e.samples),
        this
      );
    }
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
  }
  class en extends Ds {
    constructor(e = 1, t = 1, n = {}) {
      super(e, t, n), (this.isWebGLRenderTarget = !0);
    }
  }
  class dr extends vt {
    constructor(e = null, t = 1, n = 1, r = 1) {
      super(null),
        (this.isDataArrayTexture = !0),
        (this.image = { data: e, width: t, height: n, depth: r }),
        (this.magFilter = 1003),
        (this.minFilter = 1003),
        (this.wrapR = 1001),
        (this.generateMipmaps = !1),
        (this.flipY = !1),
        (this.unpackAlignment = 1),
        (this.layerUpdates = new Set());
    }
    addLayerUpdate(e) {
      this.layerUpdates.add(e);
    }
    clearLayerUpdates() {
      this.layerUpdates.clear();
    }
  }
  class Ls extends vt {
    constructor(e = null, t = 1, n = 1, r = 1) {
      super(null),
        (this.isData3DTexture = !0),
        (this.image = { data: e, width: t, height: n, depth: r }),
        (this.magFilter = 1003),
        (this.minFilter = 1003),
        (this.wrapR = 1001),
        (this.generateMipmaps = !1),
        (this.flipY = !1),
        (this.unpackAlignment = 1);
    }
  }
  class Bn {
    constructor(e = new O(1 / 0, 1 / 0, 1 / 0), t = new O(-1 / 0, -1 / 0, -1 / 0)) {
      (this.isBox3 = !0), (this.min = e), (this.max = t);
    }
    set(e, t) {
      return this.min.copy(e), this.max.copy(t), this;
    }
    setFromArray(e) {
      this.makeEmpty();
      for (let t = 0, n = e.length; t < n; t += 3) this.expandByPoint(wt.fromArray(e, t));
      return this;
    }
    setFromBufferAttribute(e) {
      this.makeEmpty();
      for (let t = 0, n = e.count; t < n; t++) this.expandByPoint(wt.fromBufferAttribute(e, t));
      return this;
    }
    setFromPoints(e) {
      this.makeEmpty();
      for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
      return this;
    }
    setFromCenterAndSize(e, t) {
      const n = wt.copy(t).multiplyScalar(0.5);
      return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
    }
    setFromObject(e, t = !1) {
      return this.makeEmpty(), this.expandByObject(e, t);
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(e) {
      return this.min.copy(e.min), this.max.copy(e.max), this;
    }
    makeEmpty() {
      return (this.min.x = this.min.y = this.min.z = 1 / 0), (this.max.x = this.max.y = this.max.z = -1 / 0), this;
    }
    isEmpty() {
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(e) {
      return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(e) {
      return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
    }
    expandByPoint(e) {
      return this.min.min(e), this.max.max(e), this;
    }
    expandByVector(e) {
      return this.min.sub(e), this.max.add(e), this;
    }
    expandByScalar(e) {
      return this.min.addScalar(-e), this.max.addScalar(e), this;
    }
    expandByObject(e, t = !1) {
      e.updateWorldMatrix(!1, !1);
      const n = e.geometry;
      if (n !== void 0) {
        const s = n.getAttribute("position");
        if (t === !0 && s !== void 0 && e.isInstancedMesh !== !0)
          for (let a = 0, o = s.count; a < o; a++)
            e.isMesh === !0 ? e.getVertexPosition(a, wt) : wt.fromBufferAttribute(s, a),
              wt.applyMatrix4(e.matrixWorld),
              this.expandByPoint(wt);
        else
          e.boundingBox !== void 0
            ? (e.boundingBox === null && e.computeBoundingBox(), Kn.copy(e.boundingBox))
            : (n.boundingBox === null && n.computeBoundingBox(), Kn.copy(n.boundingBox)),
            Kn.applyMatrix4(e.matrixWorld),
            this.union(Kn);
      }
      const r = e.children;
      for (let s = 0, a = r.length; s < a; s++) this.expandByObject(r[s], t);
      return this;
    }
    containsPoint(e) {
      return (
        e.x >= this.min.x &&
        e.x <= this.max.x &&
        e.y >= this.min.y &&
        e.y <= this.max.y &&
        e.z >= this.min.z &&
        e.z <= this.max.z
      );
    }
    containsBox(e) {
      return (
        this.min.x <= e.min.x &&
        e.max.x <= this.max.x &&
        this.min.y <= e.min.y &&
        e.max.y <= this.max.y &&
        this.min.z <= e.min.z &&
        e.max.z <= this.max.z
      );
    }
    getParameter(e, t) {
      return t.set(
        (e.x - this.min.x) / (this.max.x - this.min.x),
        (e.y - this.min.y) / (this.max.y - this.min.y),
        (e.z - this.min.z) / (this.max.z - this.min.z)
      );
    }
    intersectsBox(e) {
      return (
        e.max.x >= this.min.x &&
        e.min.x <= this.max.x &&
        e.max.y >= this.min.y &&
        e.min.y <= this.max.y &&
        e.max.z >= this.min.z &&
        e.min.z <= this.max.z
      );
    }
    intersectsSphere(e) {
      return this.clampPoint(e.center, wt), wt.distanceToSquared(e.center) <= e.radius * e.radius;
    }
    intersectsPlane(e) {
      let t, n;
      return (
        e.normal.x > 0
          ? ((t = e.normal.x * this.min.x), (n = e.normal.x * this.max.x))
          : ((t = e.normal.x * this.max.x), (n = e.normal.x * this.min.x)),
        e.normal.y > 0
          ? ((t += e.normal.y * this.min.y), (n += e.normal.y * this.max.y))
          : ((t += e.normal.y * this.max.y), (n += e.normal.y * this.min.y)),
        e.normal.z > 0
          ? ((t += e.normal.z * this.min.z), (n += e.normal.z * this.max.z))
          : ((t += e.normal.z * this.max.z), (n += e.normal.z * this.min.z)),
        t <= -e.constant && n >= -e.constant
      );
    }
    intersectsTriangle(e) {
      if (this.isEmpty()) return !1;
      this.getCenter(Gn),
        Zn.subVectors(this.max, Gn),
        xn.subVectors(e.a, Gn),
        Sn.subVectors(e.b, Gn),
        Mn.subVectors(e.c, Gn),
        $t.subVectors(Sn, xn),
        Kt.subVectors(Mn, Sn),
        tn.subVectors(xn, Mn);
      let t = [
        0,
        -$t.z,
        $t.y,
        0,
        -Kt.z,
        Kt.y,
        0,
        -tn.z,
        tn.y,
        $t.z,
        0,
        -$t.x,
        Kt.z,
        0,
        -Kt.x,
        tn.z,
        0,
        -tn.x,
        -$t.y,
        $t.x,
        0,
        -Kt.y,
        Kt.x,
        0,
        -tn.y,
        tn.x,
        0
      ];
      return !Li(t, xn, Sn, Mn, Zn) || ((t = [1, 0, 0, 0, 1, 0, 0, 0, 1]), !Li(t, xn, Sn, Mn, Zn))
        ? !1
        : (Jn.crossVectors($t, Kt), (t = [Jn.x, Jn.y, Jn.z]), Li(t, xn, Sn, Mn, Zn));
    }
    clampPoint(e, t) {
      return t.copy(e).clamp(this.min, this.max);
    }
    distanceToPoint(e) {
      return this.clampPoint(e, wt).distanceTo(e);
    }
    getBoundingSphere(e) {
      return (
        this.isEmpty() ? e.makeEmpty() : (this.getCenter(e.center), (e.radius = this.getSize(wt).length() * 0.5)), e
      );
    }
    intersect(e) {
      return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(e) {
      return this.min.min(e.min), this.max.max(e.max), this;
    }
    applyMatrix4(e) {
      return this.isEmpty()
        ? this
        : (Bt[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e),
          Bt[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e),
          Bt[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e),
          Bt[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e),
          Bt[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e),
          Bt[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e),
          Bt[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e),
          Bt[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e),
          this.setFromPoints(Bt),
          this);
    }
    translate(e) {
      return this.min.add(e), this.max.add(e), this;
    }
    equals(e) {
      return e.min.equals(this.min) && e.max.equals(this.max);
    }
    toJSON() {
      return { min: this.min.toArray(), max: this.max.toArray() };
    }
    fromJSON(e) {
      return this.min.fromArray(e.min), this.max.fromArray(e.max), this;
    }
  }
  const Bt = [new O(), new O(), new O(), new O(), new O(), new O(), new O(), new O()],
    wt = new O(),
    Kn = new Bn(),
    xn = new O(),
    Sn = new O(),
    Mn = new O(),
    $t = new O(),
    Kt = new O(),
    tn = new O(),
    Gn = new O(),
    Zn = new O(),
    Jn = new O(),
    nn = new O();
  function Li(i, e, t, n, r) {
    for (let s = 0, a = i.length - 3; s <= a; s += 3) {
      nn.fromArray(i, s);
      const o = r.x * Math.abs(nn.x) + r.y * Math.abs(nn.y) + r.z * Math.abs(nn.z),
        c = e.dot(nn),
        l = t.dot(nn),
        h = n.dot(nn);
      if (Math.max(-Math.max(c, l, h), Math.min(c, l, h)) > o) return !1;
    }
    return !0;
  }
  const Us = new Bn(),
    zn = new O(),
    Ui = new O();
  class jn {
    constructor(e = new O(), t = -1) {
      (this.isSphere = !0), (this.center = e), (this.radius = t);
    }
    set(e, t) {
      return this.center.copy(e), (this.radius = t), this;
    }
    setFromPoints(e, t) {
      const n = this.center;
      t !== void 0 ? n.copy(t) : Us.setFromPoints(e).getCenter(n);
      let r = 0;
      for (let s = 0, a = e.length; s < a; s++) r = Math.max(r, n.distanceToSquared(e[s]));
      return (this.radius = Math.sqrt(r)), this;
    }
    copy(e) {
      return this.center.copy(e.center), (this.radius = e.radius), this;
    }
    isEmpty() {
      return this.radius < 0;
    }
    makeEmpty() {
      return this.center.set(0, 0, 0), (this.radius = -1), this;
    }
    containsPoint(e) {
      return e.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(e) {
      return e.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(e) {
      const t = this.radius + e.radius;
      return e.center.distanceToSquared(this.center) <= t * t;
    }
    intersectsBox(e) {
      return e.intersectsSphere(this);
    }
    intersectsPlane(e) {
      return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(e, t) {
      const n = this.center.distanceToSquared(e);
      return (
        t.copy(e),
        n > this.radius * this.radius &&
          (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)),
        t
      );
    }
    getBoundingBox(e) {
      return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
    }
    applyMatrix4(e) {
      return this.center.applyMatrix4(e), (this.radius = this.radius * e.getMaxScaleOnAxis()), this;
    }
    translate(e) {
      return this.center.add(e), this;
    }
    expandByPoint(e) {
      if (this.isEmpty()) return this.center.copy(e), (this.radius = 0), this;
      zn.subVectors(e, this.center);
      const t = zn.lengthSq();
      if (t > this.radius * this.radius) {
        const n = Math.sqrt(t),
          r = (n - this.radius) * 0.5;
        this.center.addScaledVector(zn, r / n), (this.radius += r);
      }
      return this;
    }
    union(e) {
      return e.isEmpty()
        ? this
        : this.isEmpty()
        ? (this.copy(e), this)
        : (this.center.equals(e.center) === !0
            ? (this.radius = Math.max(this.radius, e.radius))
            : (Ui.subVectors(e.center, this.center).setLength(e.radius),
              this.expandByPoint(zn.copy(e.center).add(Ui)),
              this.expandByPoint(zn.copy(e.center).sub(Ui))),
          this);
    }
    equals(e) {
      return e.center.equals(this.center) && e.radius === this.radius;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    toJSON() {
      return { radius: this.radius, center: this.center.toArray() };
    }
    fromJSON(e) {
      return (this.radius = e.radius), this.center.fromArray(e.center), this;
    }
  }
  const Gt = new O(),
    Ii = new O(),
    Qn = new O(),
    Zt = new O(),
    Fi = new O(),
    ei = new O(),
    Ni = new O();
  class pr {
    constructor(e = new O(), t = new O(0, 0, -1)) {
      (this.origin = e), (this.direction = t);
    }
    set(e, t) {
      return this.origin.copy(e), this.direction.copy(t), this;
    }
    copy(e) {
      return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
    }
    at(e, t) {
      return t.copy(this.origin).addScaledVector(this.direction, e);
    }
    lookAt(e) {
      return this.direction.copy(e).sub(this.origin).normalize(), this;
    }
    recast(e) {
      return this.origin.copy(this.at(e, Gt)), this;
    }
    closestPointToPoint(e, t) {
      t.subVectors(e, this.origin);
      const n = t.dot(this.direction);
      return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
    }
    distanceToPoint(e) {
      return Math.sqrt(this.distanceSqToPoint(e));
    }
    distanceSqToPoint(e) {
      const t = Gt.subVectors(e, this.origin).dot(this.direction);
      return t < 0
        ? this.origin.distanceToSquared(e)
        : (Gt.copy(this.origin).addScaledVector(this.direction, t), Gt.distanceToSquared(e));
    }
    distanceSqToSegment(e, t, n, r) {
      Ii.copy(e).add(t).multiplyScalar(0.5), Qn.copy(t).sub(e).normalize(), Zt.copy(this.origin).sub(Ii);
      const s = e.distanceTo(t) * 0.5,
        a = -this.direction.dot(Qn),
        o = Zt.dot(this.direction),
        c = -Zt.dot(Qn),
        l = Zt.lengthSq(),
        h = Math.abs(1 - a * a);
      let f, d, m, v;
      if (h > 0)
        if (((f = a * c - o), (d = a * o - c), (v = s * h), f >= 0))
          if (d >= -v)
            if (d <= v) {
              const x = 1 / h;
              (f *= x), (d *= x), (m = f * (f + a * d + 2 * o) + d * (a * f + d + 2 * c) + l);
            } else (d = s), (f = Math.max(0, -(a * d + o))), (m = -f * f + d * (d + 2 * c) + l);
          else (d = -s), (f = Math.max(0, -(a * d + o))), (m = -f * f + d * (d + 2 * c) + l);
        else
          d <= -v
            ? ((f = Math.max(0, -(-a * s + o))),
              (d = f > 0 ? -s : Math.min(Math.max(-s, -c), s)),
              (m = -f * f + d * (d + 2 * c) + l))
            : d <= v
            ? ((f = 0), (d = Math.min(Math.max(-s, -c), s)), (m = d * (d + 2 * c) + l))
            : ((f = Math.max(0, -(a * s + o))),
              (d = f > 0 ? s : Math.min(Math.max(-s, -c), s)),
              (m = -f * f + d * (d + 2 * c) + l));
      else (d = a > 0 ? -s : s), (f = Math.max(0, -(a * d + o))), (m = -f * f + d * (d + 2 * c) + l);
      return n && n.copy(this.origin).addScaledVector(this.direction, f), r && r.copy(Ii).addScaledVector(Qn, d), m;
    }
    intersectSphere(e, t) {
      Gt.subVectors(e.center, this.origin);
      const n = Gt.dot(this.direction),
        r = Gt.dot(Gt) - n * n,
        s = e.radius * e.radius;
      if (r > s) return null;
      const a = Math.sqrt(s - r),
        o = n - a,
        c = n + a;
      return c < 0 ? null : o < 0 ? this.at(c, t) : this.at(o, t);
    }
    intersectsSphere(e) {
      return e.radius < 0 ? !1 : this.distanceSqToPoint(e.center) <= e.radius * e.radius;
    }
    distanceToPlane(e) {
      const t = e.normal.dot(this.direction);
      if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null;
      const n = -(this.origin.dot(e.normal) + e.constant) / t;
      return n >= 0 ? n : null;
    }
    intersectPlane(e, t) {
      const n = this.distanceToPlane(e);
      return n === null ? null : this.at(n, t);
    }
    intersectsPlane(e) {
      const t = e.distanceToPoint(this.origin);
      return t === 0 || e.normal.dot(this.direction) * t < 0;
    }
    intersectBox(e, t) {
      let n, r, s, a, o, c;
      const l = 1 / this.direction.x,
        h = 1 / this.direction.y,
        f = 1 / this.direction.z,
        d = this.origin;
      return (
        l >= 0
          ? ((n = (e.min.x - d.x) * l), (r = (e.max.x - d.x) * l))
          : ((n = (e.max.x - d.x) * l), (r = (e.min.x - d.x) * l)),
        h >= 0
          ? ((s = (e.min.y - d.y) * h), (a = (e.max.y - d.y) * h))
          : ((s = (e.max.y - d.y) * h), (a = (e.min.y - d.y) * h)),
        n > a ||
        s > r ||
        ((s > n || isNaN(n)) && (n = s),
        (a < r || isNaN(r)) && (r = a),
        f >= 0
          ? ((o = (e.min.z - d.z) * f), (c = (e.max.z - d.z) * f))
          : ((o = (e.max.z - d.z) * f), (c = (e.min.z - d.z) * f)),
        n > c || o > r) ||
        ((o > n || n !== n) && (n = o), (c < r || r !== r) && (r = c), r < 0)
          ? null
          : this.at(n >= 0 ? n : r, t)
      );
    }
    intersectsBox(e) {
      return this.intersectBox(e, Gt) !== null;
    }
    intersectTriangle(e, t, n, r, s) {
      Fi.subVectors(t, e), ei.subVectors(n, e), Ni.crossVectors(Fi, ei);
      let a = this.direction.dot(Ni),
        o;
      if (a > 0) {
        if (r) return null;
        o = 1;
      } else if (a < 0) (o = -1), (a = -a);
      else return null;
      Zt.subVectors(this.origin, e);
      const c = o * this.direction.dot(ei.crossVectors(Zt, ei));
      if (c < 0) return null;
      const l = o * this.direction.dot(Fi.cross(Zt));
      if (l < 0 || c + l > a) return null;
      const h = -o * Zt.dot(Ni);
      return h < 0 ? null : this.at(h / a, s);
    }
    applyMatrix4(e) {
      return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
    }
    equals(e) {
      return e.origin.equals(this.origin) && e.direction.equals(this.direction);
    }
    clone() {
      return new this.constructor().copy(this);
    }
  }
  class ot {
    constructor(e, t, n, r, s, a, o, c, l, h, f, d, m, v, x, p) {
      (ot.prototype.isMatrix4 = !0),
        (this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
        e !== void 0 && this.set(e, t, n, r, s, a, o, c, l, h, f, d, m, v, x, p);
    }
    set(e, t, n, r, s, a, o, c, l, h, f, d, m, v, x, p) {
      const u = this.elements;
      return (
        (u[0] = e),
        (u[4] = t),
        (u[8] = n),
        (u[12] = r),
        (u[1] = s),
        (u[5] = a),
        (u[9] = o),
        (u[13] = c),
        (u[2] = l),
        (u[6] = h),
        (u[10] = f),
        (u[14] = d),
        (u[3] = m),
        (u[7] = v),
        (u[11] = x),
        (u[15] = p),
        this
      );
    }
    identity() {
      return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
      return new ot().fromArray(this.elements);
    }
    copy(e) {
      const t = this.elements,
        n = e.elements;
      return (
        (t[0] = n[0]),
        (t[1] = n[1]),
        (t[2] = n[2]),
        (t[3] = n[3]),
        (t[4] = n[4]),
        (t[5] = n[5]),
        (t[6] = n[6]),
        (t[7] = n[7]),
        (t[8] = n[8]),
        (t[9] = n[9]),
        (t[10] = n[10]),
        (t[11] = n[11]),
        (t[12] = n[12]),
        (t[13] = n[13]),
        (t[14] = n[14]),
        (t[15] = n[15]),
        this
      );
    }
    copyPosition(e) {
      const t = this.elements,
        n = e.elements;
      return (t[12] = n[12]), (t[13] = n[13]), (t[14] = n[14]), this;
    }
    setFromMatrix3(e) {
      const t = e.elements;
      return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(e, t, n) {
      return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(e, t, n) {
      return this.set(e.x, t.x, n.x, 0, e.y, t.y, n.y, 0, e.z, t.z, n.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(e) {
      const t = this.elements,
        n = e.elements,
        r = 1 / En.setFromMatrixColumn(e, 0).length(),
        s = 1 / En.setFromMatrixColumn(e, 1).length(),
        a = 1 / En.setFromMatrixColumn(e, 2).length();
      return (
        (t[0] = n[0] * r),
        (t[1] = n[1] * r),
        (t[2] = n[2] * r),
        (t[3] = 0),
        (t[4] = n[4] * s),
        (t[5] = n[5] * s),
        (t[6] = n[6] * s),
        (t[7] = 0),
        (t[8] = n[8] * a),
        (t[9] = n[9] * a),
        (t[10] = n[10] * a),
        (t[11] = 0),
        (t[12] = 0),
        (t[13] = 0),
        (t[14] = 0),
        (t[15] = 1),
        this
      );
    }
    makeRotationFromEuler(e) {
      const t = this.elements,
        n = e.x,
        r = e.y,
        s = e.z,
        a = Math.cos(n),
        o = Math.sin(n),
        c = Math.cos(r),
        l = Math.sin(r),
        h = Math.cos(s),
        f = Math.sin(s);
      if (e.order === "XYZ") {
        const d = a * h,
          m = a * f,
          v = o * h,
          x = o * f;
        (t[0] = c * h),
          (t[4] = -c * f),
          (t[8] = l),
          (t[1] = m + v * l),
          (t[5] = d - x * l),
          (t[9] = -o * c),
          (t[2] = x - d * l),
          (t[6] = v + m * l),
          (t[10] = a * c);
      } else if (e.order === "YXZ") {
        const d = c * h,
          m = c * f,
          v = l * h,
          x = l * f;
        (t[0] = d + x * o),
          (t[4] = v * o - m),
          (t[8] = a * l),
          (t[1] = a * f),
          (t[5] = a * h),
          (t[9] = -o),
          (t[2] = m * o - v),
          (t[6] = x + d * o),
          (t[10] = a * c);
      } else if (e.order === "ZXY") {
        const d = c * h,
          m = c * f,
          v = l * h,
          x = l * f;
        (t[0] = d - x * o),
          (t[4] = -a * f),
          (t[8] = v + m * o),
          (t[1] = m + v * o),
          (t[5] = a * h),
          (t[9] = x - d * o),
          (t[2] = -a * l),
          (t[6] = o),
          (t[10] = a * c);
      } else if (e.order === "ZYX") {
        const d = a * h,
          m = a * f,
          v = o * h,
          x = o * f;
        (t[0] = c * h),
          (t[4] = v * l - m),
          (t[8] = d * l + x),
          (t[1] = c * f),
          (t[5] = x * l + d),
          (t[9] = m * l - v),
          (t[2] = -l),
          (t[6] = o * c),
          (t[10] = a * c);
      } else if (e.order === "YZX") {
        const d = a * c,
          m = a * l,
          v = o * c,
          x = o * l;
        (t[0] = c * h),
          (t[4] = x - d * f),
          (t[8] = v * f + m),
          (t[1] = f),
          (t[5] = a * h),
          (t[9] = -o * h),
          (t[2] = -l * h),
          (t[6] = m * f + v),
          (t[10] = d - x * f);
      } else if (e.order === "XZY") {
        const d = a * c,
          m = a * l,
          v = o * c,
          x = o * l;
        (t[0] = c * h),
          (t[4] = -f),
          (t[8] = l * h),
          (t[1] = d * f + x),
          (t[5] = a * h),
          (t[9] = m * f - v),
          (t[2] = v * f - m),
          (t[6] = o * h),
          (t[10] = x * f + d);
      }
      return (t[3] = 0), (t[7] = 0), (t[11] = 0), (t[12] = 0), (t[13] = 0), (t[14] = 0), (t[15] = 1), this;
    }
    makeRotationFromQuaternion(e) {
      return this.compose(Is, e, Fs);
    }
    lookAt(e, t, n) {
      const r = this.elements;
      return (
        Mt.subVectors(e, t),
        Mt.lengthSq() === 0 && (Mt.z = 1),
        Mt.normalize(),
        Jt.crossVectors(n, Mt),
        Jt.lengthSq() === 0 &&
          (Math.abs(n.z) === 1 ? (Mt.x += 1e-4) : (Mt.z += 1e-4), Mt.normalize(), Jt.crossVectors(n, Mt)),
        Jt.normalize(),
        ti.crossVectors(Mt, Jt),
        (r[0] = Jt.x),
        (r[4] = ti.x),
        (r[8] = Mt.x),
        (r[1] = Jt.y),
        (r[5] = ti.y),
        (r[9] = Mt.y),
        (r[2] = Jt.z),
        (r[6] = ti.z),
        (r[10] = Mt.z),
        this
      );
    }
    multiply(e) {
      return this.multiplyMatrices(this, e);
    }
    premultiply(e) {
      return this.multiplyMatrices(e, this);
    }
    multiplyMatrices(e, t) {
      const n = e.elements,
        r = t.elements,
        s = this.elements,
        a = n[0],
        o = n[4],
        c = n[8],
        l = n[12],
        h = n[1],
        f = n[5],
        d = n[9],
        m = n[13],
        v = n[2],
        x = n[6],
        p = n[10],
        u = n[14],
        C = n[3],
        y = n[7],
        E = n[11],
        D = n[15],
        w = r[0],
        P = r[4],
        F = r[8],
        M = r[12],
        S = r[1],
        b = r[5],
        q = r[9],
        V = r[13],
        H = r[2],
        K = r[6],
        X = r[10],
        ee = r[14],
        G = r[3],
        se = r[7],
        ue = r[11],
        Me = r[15];
      return (
        (s[0] = a * w + o * S + c * H + l * G),
        (s[4] = a * P + o * b + c * K + l * se),
        (s[8] = a * F + o * q + c * X + l * ue),
        (s[12] = a * M + o * V + c * ee + l * Me),
        (s[1] = h * w + f * S + d * H + m * G),
        (s[5] = h * P + f * b + d * K + m * se),
        (s[9] = h * F + f * q + d * X + m * ue),
        (s[13] = h * M + f * V + d * ee + m * Me),
        (s[2] = v * w + x * S + p * H + u * G),
        (s[6] = v * P + x * b + p * K + u * se),
        (s[10] = v * F + x * q + p * X + u * ue),
        (s[14] = v * M + x * V + p * ee + u * Me),
        (s[3] = C * w + y * S + E * H + D * G),
        (s[7] = C * P + y * b + E * K + D * se),
        (s[11] = C * F + y * q + E * X + D * ue),
        (s[15] = C * M + y * V + E * ee + D * Me),
        this
      );
    }
    multiplyScalar(e) {
      const t = this.elements;
      return (
        (t[0] *= e),
        (t[4] *= e),
        (t[8] *= e),
        (t[12] *= e),
        (t[1] *= e),
        (t[5] *= e),
        (t[9] *= e),
        (t[13] *= e),
        (t[2] *= e),
        (t[6] *= e),
        (t[10] *= e),
        (t[14] *= e),
        (t[3] *= e),
        (t[7] *= e),
        (t[11] *= e),
        (t[15] *= e),
        this
      );
    }
    determinant() {
      const e = this.elements,
        t = e[0],
        n = e[4],
        r = e[8],
        s = e[12],
        a = e[1],
        o = e[5],
        c = e[9],
        l = e[13],
        h = e[2],
        f = e[6],
        d = e[10],
        m = e[14],
        v = e[3],
        x = e[7],
        p = e[11],
        u = e[15];
      return (
        v * (+s * c * f - r * l * f - s * o * d + n * l * d + r * o * m - n * c * m) +
        x * (+t * c * m - t * l * d + s * a * d - r * a * m + r * l * h - s * c * h) +
        p * (+t * l * f - t * o * m - s * a * f + n * a * m + s * o * h - n * l * h) +
        u * (-r * o * h - t * c * f + t * o * d + r * a * f - n * a * d + n * c * h)
      );
    }
    transpose() {
      const e = this.elements;
      let t;
      return (
        (t = e[1]),
        (e[1] = e[4]),
        (e[4] = t),
        (t = e[2]),
        (e[2] = e[8]),
        (e[8] = t),
        (t = e[6]),
        (e[6] = e[9]),
        (e[9] = t),
        (t = e[3]),
        (e[3] = e[12]),
        (e[12] = t),
        (t = e[7]),
        (e[7] = e[13]),
        (e[13] = t),
        (t = e[11]),
        (e[11] = e[14]),
        (e[14] = t),
        this
      );
    }
    setPosition(e, t, n) {
      const r = this.elements;
      return (
        e.isVector3 ? ((r[12] = e.x), (r[13] = e.y), (r[14] = e.z)) : ((r[12] = e), (r[13] = t), (r[14] = n)), this
      );
    }
    invert() {
      const e = this.elements,
        t = e[0],
        n = e[1],
        r = e[2],
        s = e[3],
        a = e[4],
        o = e[5],
        c = e[6],
        l = e[7],
        h = e[8],
        f = e[9],
        d = e[10],
        m = e[11],
        v = e[12],
        x = e[13],
        p = e[14],
        u = e[15],
        C = f * p * l - x * d * l + x * c * m - o * p * m - f * c * u + o * d * u,
        y = v * d * l - h * p * l - v * c * m + a * p * m + h * c * u - a * d * u,
        E = h * x * l - v * f * l + v * o * m - a * x * m - h * o * u + a * f * u,
        D = v * f * c - h * x * c - v * o * d + a * x * d + h * o * p - a * f * p,
        w = t * C + n * y + r * E + s * D;
      if (w === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
      const P = 1 / w;
      return (
        (e[0] = C * P),
        (e[1] = (x * d * s - f * p * s - x * r * m + n * p * m + f * r * u - n * d * u) * P),
        (e[2] = (o * p * s - x * c * s + x * r * l - n * p * l - o * r * u + n * c * u) * P),
        (e[3] = (f * c * s - o * d * s - f * r * l + n * d * l + o * r * m - n * c * m) * P),
        (e[4] = y * P),
        (e[5] = (h * p * s - v * d * s + v * r * m - t * p * m - h * r * u + t * d * u) * P),
        (e[6] = (v * c * s - a * p * s - v * r * l + t * p * l + a * r * u - t * c * u) * P),
        (e[7] = (a * d * s - h * c * s + h * r * l - t * d * l - a * r * m + t * c * m) * P),
        (e[8] = E * P),
        (e[9] = (v * f * s - h * x * s - v * n * m + t * x * m + h * n * u - t * f * u) * P),
        (e[10] = (a * x * s - v * o * s + v * n * l - t * x * l - a * n * u + t * o * u) * P),
        (e[11] = (h * o * s - a * f * s - h * n * l + t * f * l + a * n * m - t * o * m) * P),
        (e[12] = D * P),
        (e[13] = (h * x * r - v * f * r + v * n * d - t * x * d - h * n * p + t * f * p) * P),
        (e[14] = (v * o * r - a * x * r - v * n * c + t * x * c + a * n * p - t * o * p) * P),
        (e[15] = (a * f * r - h * o * r + h * n * c - t * f * c - a * n * d + t * o * d) * P),
        this
      );
    }
    scale(e) {
      const t = this.elements,
        n = e.x,
        r = e.y,
        s = e.z;
      return (
        (t[0] *= n),
        (t[4] *= r),
        (t[8] *= s),
        (t[1] *= n),
        (t[5] *= r),
        (t[9] *= s),
        (t[2] *= n),
        (t[6] *= r),
        (t[10] *= s),
        (t[3] *= n),
        (t[7] *= r),
        (t[11] *= s),
        this
      );
    }
    getMaxScaleOnAxis() {
      const e = this.elements,
        t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
        n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
        r = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
      return Math.sqrt(Math.max(t, n, r));
    }
    makeTranslation(e, t, n) {
      return (
        e.isVector3
          ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1)
          : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1),
        this
      );
    }
    makeRotationX(e) {
      const t = Math.cos(e),
        n = Math.sin(e);
      return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(e) {
      const t = Math.cos(e),
        n = Math.sin(e);
      return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(e) {
      const t = Math.cos(e),
        n = Math.sin(e);
      return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(e, t) {
      const n = Math.cos(t),
        r = Math.sin(t),
        s = 1 - n,
        a = e.x,
        o = e.y,
        c = e.z,
        l = s * a,
        h = s * o;
      return (
        this.set(
          l * a + n,
          l * o - r * c,
          l * c + r * o,
          0,
          l * o + r * c,
          h * o + n,
          h * c - r * a,
          0,
          l * c - r * o,
          h * c + r * a,
          s * c * c + n,
          0,
          0,
          0,
          0,
          1
        ),
        this
      );
    }
    makeScale(e, t, n) {
      return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
    }
    makeShear(e, t, n, r, s, a) {
      return this.set(1, n, s, 0, e, 1, a, 0, t, r, 1, 0, 0, 0, 0, 1), this;
    }
    compose(e, t, n) {
      const r = this.elements,
        s = t._x,
        a = t._y,
        o = t._z,
        c = t._w,
        l = s + s,
        h = a + a,
        f = o + o,
        d = s * l,
        m = s * h,
        v = s * f,
        x = a * h,
        p = a * f,
        u = o * f,
        C = c * l,
        y = c * h,
        E = c * f,
        D = n.x,
        w = n.y,
        P = n.z;
      return (
        (r[0] = (1 - (x + u)) * D),
        (r[1] = (m + E) * D),
        (r[2] = (v - y) * D),
        (r[3] = 0),
        (r[4] = (m - E) * w),
        (r[5] = (1 - (d + u)) * w),
        (r[6] = (p + C) * w),
        (r[7] = 0),
        (r[8] = (v + y) * P),
        (r[9] = (p - C) * P),
        (r[10] = (1 - (d + x)) * P),
        (r[11] = 0),
        (r[12] = e.x),
        (r[13] = e.y),
        (r[14] = e.z),
        (r[15] = 1),
        this
      );
    }
    decompose(e, t, n) {
      const r = this.elements;
      let s = En.set(r[0], r[1], r[2]).length();
      const a = En.set(r[4], r[5], r[6]).length(),
        o = En.set(r[8], r[9], r[10]).length();
      this.determinant() < 0 && (s = -s), (e.x = r[12]), (e.y = r[13]), (e.z = r[14]), Pt.copy(this);
      const l = 1 / s,
        h = 1 / a,
        f = 1 / o;
      return (
        (Pt.elements[0] *= l),
        (Pt.elements[1] *= l),
        (Pt.elements[2] *= l),
        (Pt.elements[4] *= h),
        (Pt.elements[5] *= h),
        (Pt.elements[6] *= h),
        (Pt.elements[8] *= f),
        (Pt.elements[9] *= f),
        (Pt.elements[10] *= f),
        t.setFromRotationMatrix(Pt),
        (n.x = s),
        (n.y = a),
        (n.z = o),
        this
      );
    }
    makePerspective(e, t, n, r, s, a, o = 2e3, c = !1) {
      const l = this.elements,
        h = (2 * s) / (t - e),
        f = (2 * s) / (n - r),
        d = (t + e) / (t - e),
        m = (n + r) / (n - r);
      let v, x;
      if (c) (v = s / (a - s)), (x = (a * s) / (a - s));
      else if (o === 2e3) (v = -(a + s) / (a - s)), (x = (-2 * a * s) / (a - s));
      else if (o === 2001) (v = -a / (a - s)), (x = (-a * s) / (a - s));
      else throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + o);
      return (
        (l[0] = h),
        (l[4] = 0),
        (l[8] = d),
        (l[12] = 0),
        (l[1] = 0),
        (l[5] = f),
        (l[9] = m),
        (l[13] = 0),
        (l[2] = 0),
        (l[6] = 0),
        (l[10] = v),
        (l[14] = x),
        (l[3] = 0),
        (l[7] = 0),
        (l[11] = -1),
        (l[15] = 0),
        this
      );
    }
    makeOrthographic(e, t, n, r, s, a, o = 2e3, c = !1) {
      const l = this.elements,
        h = 2 / (t - e),
        f = 2 / (n - r),
        d = -(t + e) / (t - e),
        m = -(n + r) / (n - r);
      let v, x;
      if (c) (v = 1 / (a - s)), (x = a / (a - s));
      else if (o === 2e3) (v = -2 / (a - s)), (x = -(a + s) / (a - s));
      else if (o === 2001) (v = -1 / (a - s)), (x = -s / (a - s));
      else throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + o);
      return (
        (l[0] = h),
        (l[4] = 0),
        (l[8] = 0),
        (l[12] = d),
        (l[1] = 0),
        (l[5] = f),
        (l[9] = 0),
        (l[13] = m),
        (l[2] = 0),
        (l[6] = 0),
        (l[10] = v),
        (l[14] = x),
        (l[3] = 0),
        (l[7] = 0),
        (l[11] = 0),
        (l[15] = 1),
        this
      );
    }
    equals(e) {
      const t = this.elements,
        n = e.elements;
      for (let r = 0; r < 16; r++) if (t[r] !== n[r]) return !1;
      return !0;
    }
    fromArray(e, t = 0) {
      for (let n = 0; n < 16; n++) this.elements[n] = e[n + t];
      return this;
    }
    toArray(e = [], t = 0) {
      const n = this.elements;
      return (
        (e[t] = n[0]),
        (e[t + 1] = n[1]),
        (e[t + 2] = n[2]),
        (e[t + 3] = n[3]),
        (e[t + 4] = n[4]),
        (e[t + 5] = n[5]),
        (e[t + 6] = n[6]),
        (e[t + 7] = n[7]),
        (e[t + 8] = n[8]),
        (e[t + 9] = n[9]),
        (e[t + 10] = n[10]),
        (e[t + 11] = n[11]),
        (e[t + 12] = n[12]),
        (e[t + 13] = n[13]),
        (e[t + 14] = n[14]),
        (e[t + 15] = n[15]),
        e
      );
    }
  }
  const En = new O(),
    Pt = new ot(),
    Is = new O(0, 0, 0),
    Fs = new O(1, 1, 1),
    Jt = new O(),
    ti = new O(),
    Mt = new O(),
    mr = new ot(),
    _r = new On();
  class zt {
    constructor(e = 0, t = 0, n = 0, r = zt.DEFAULT_ORDER) {
      (this.isEuler = !0), (this._x = e), (this._y = t), (this._z = n), (this._order = r);
    }
    get x() {
      return this._x;
    }
    set x(e) {
      (this._x = e), this._onChangeCallback();
    }
    get y() {
      return this._y;
    }
    set y(e) {
      (this._y = e), this._onChangeCallback();
    }
    get z() {
      return this._z;
    }
    set z(e) {
      (this._z = e), this._onChangeCallback();
    }
    get order() {
      return this._order;
    }
    set order(e) {
      (this._order = e), this._onChangeCallback();
    }
    set(e, t, n, r = this._order) {
      return (this._x = e), (this._y = t), (this._z = n), (this._order = r), this._onChangeCallback(), this;
    }
    clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(e) {
      return (
        (this._x = e._x), (this._y = e._y), (this._z = e._z), (this._order = e._order), this._onChangeCallback(), this
      );
    }
    setFromRotationMatrix(e, t = this._order, n = !0) {
      const r = e.elements,
        s = r[0],
        a = r[4],
        o = r[8],
        c = r[1],
        l = r[5],
        h = r[9],
        f = r[2],
        d = r[6],
        m = r[10];
      switch (t) {
        case "XYZ":
          (this._y = Math.asin(Be(o, -1, 1))),
            Math.abs(o) < 0.9999999
              ? ((this._x = Math.atan2(-h, m)), (this._z = Math.atan2(-a, s)))
              : ((this._x = Math.atan2(d, l)), (this._z = 0));
          break;
        case "YXZ":
          (this._x = Math.asin(-Be(h, -1, 1))),
            Math.abs(h) < 0.9999999
              ? ((this._y = Math.atan2(o, m)), (this._z = Math.atan2(c, l)))
              : ((this._y = Math.atan2(-f, s)), (this._z = 0));
          break;
        case "ZXY":
          (this._x = Math.asin(Be(d, -1, 1))),
            Math.abs(d) < 0.9999999
              ? ((this._y = Math.atan2(-f, m)), (this._z = Math.atan2(-a, l)))
              : ((this._y = 0), (this._z = Math.atan2(c, s)));
          break;
        case "ZYX":
          (this._y = Math.asin(-Be(f, -1, 1))),
            Math.abs(f) < 0.9999999
              ? ((this._x = Math.atan2(d, m)), (this._z = Math.atan2(c, s)))
              : ((this._x = 0), (this._z = Math.atan2(-a, l)));
          break;
        case "YZX":
          (this._z = Math.asin(Be(c, -1, 1))),
            Math.abs(c) < 0.9999999
              ? ((this._x = Math.atan2(-h, l)), (this._y = Math.atan2(-f, s)))
              : ((this._x = 0), (this._y = Math.atan2(o, m)));
          break;
        case "XZY":
          (this._z = Math.asin(-Be(a, -1, 1))),
            Math.abs(a) < 0.9999999
              ? ((this._x = Math.atan2(d, l)), (this._y = Math.atan2(o, s)))
              : ((this._x = Math.atan2(-h, m)), (this._y = 0));
          break;
        default:
          console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
      }
      return (this._order = t), n === !0 && this._onChangeCallback(), this;
    }
    setFromQuaternion(e, t, n) {
      return mr.makeRotationFromQuaternion(e), this.setFromRotationMatrix(mr, t, n);
    }
    setFromVector3(e, t = this._order) {
      return this.set(e.x, e.y, e.z, t);
    }
    reorder(e) {
      return _r.setFromEuler(this), this.setFromQuaternion(_r, e);
    }
    equals(e) {
      return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
    }
    fromArray(e) {
      return (
        (this._x = e[0]),
        (this._y = e[1]),
        (this._z = e[2]),
        e[3] !== void 0 && (this._order = e[3]),
        this._onChangeCallback(),
        this
      );
    }
    toArray(e = [], t = 0) {
      return (e[t] = this._x), (e[t + 1] = this._y), (e[t + 2] = this._z), (e[t + 3] = this._order), e;
    }
    _onChange(e) {
      return (this._onChangeCallback = e), this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
      yield this._x, yield this._y, yield this._z, yield this._order;
    }
  }
  zt.DEFAULT_ORDER = "XYZ";
  class gr {
    constructor() {
      this.mask = 1;
    }
    set(e) {
      this.mask = ((1 << e) | 0) >>> 0;
    }
    enable(e) {
      this.mask |= (1 << e) | 0;
    }
    enableAll() {
      this.mask = -1;
    }
    toggle(e) {
      this.mask ^= (1 << e) | 0;
    }
    disable(e) {
      this.mask &= ~((1 << e) | 0);
    }
    disableAll() {
      this.mask = 0;
    }
    test(e) {
      return (this.mask & e.mask) !== 0;
    }
    isEnabled(e) {
      return (this.mask & ((1 << e) | 0)) !== 0;
    }
  }
  let Ns = 0;
  const vr = new O(),
    Tn = new On(),
    Vt = new ot(),
    ni = new O(),
    Vn = new O(),
    Os = new O(),
    Bs = new On(),
    xr = new O(1, 0, 0),
    Sr = new O(0, 1, 0),
    Mr = new O(0, 0, 1),
    Er = { type: "added" },
    Gs = { type: "removed" },
    yn = { type: "childadded", child: null },
    Oi = { type: "childremoved", child: null };
  class xt extends mn {
    constructor() {
      super(),
        (this.isObject3D = !0),
        Object.defineProperty(this, "id", { value: Ns++ }),
        (this.uuid = Fn()),
        (this.name = ""),
        (this.type = "Object3D"),
        (this.parent = null),
        (this.children = []),
        (this.up = xt.DEFAULT_UP.clone());
      const e = new O(),
        t = new zt(),
        n = new On(),
        r = new O(1, 1, 1);
      function s() {
        n.setFromEuler(t, !1);
      }
      function a() {
        t.setFromQuaternion(n, void 0, !1);
      }
      t._onChange(s),
        n._onChange(a),
        Object.defineProperties(this, {
          position: { configurable: !0, enumerable: !0, value: e },
          rotation: { configurable: !0, enumerable: !0, value: t },
          quaternion: { configurable: !0, enumerable: !0, value: n },
          scale: { configurable: !0, enumerable: !0, value: r },
          modelViewMatrix: { value: new ot() },
          normalMatrix: { value: new Le() }
        }),
        (this.matrix = new ot()),
        (this.matrixWorld = new ot()),
        (this.matrixAutoUpdate = xt.DEFAULT_MATRIX_AUTO_UPDATE),
        (this.matrixWorldAutoUpdate = xt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE),
        (this.matrixWorldNeedsUpdate = !1),
        (this.layers = new gr()),
        (this.visible = !0),
        (this.castShadow = !1),
        (this.receiveShadow = !1),
        (this.frustumCulled = !0),
        (this.renderOrder = 0),
        (this.animations = []),
        (this.customDepthMaterial = void 0),
        (this.customDistanceMaterial = void 0),
        (this.userData = {});
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(e) {
      this.matrixAutoUpdate && this.updateMatrix(),
        this.matrix.premultiply(e),
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(e) {
      return this.quaternion.premultiply(e), this;
    }
    setRotationFromAxisAngle(e, t) {
      this.quaternion.setFromAxisAngle(e, t);
    }
    setRotationFromEuler(e) {
      this.quaternion.setFromEuler(e, !0);
    }
    setRotationFromMatrix(e) {
      this.quaternion.setFromRotationMatrix(e);
    }
    setRotationFromQuaternion(e) {
      this.quaternion.copy(e);
    }
    rotateOnAxis(e, t) {
      return Tn.setFromAxisAngle(e, t), this.quaternion.multiply(Tn), this;
    }
    rotateOnWorldAxis(e, t) {
      return Tn.setFromAxisAngle(e, t), this.quaternion.premultiply(Tn), this;
    }
    rotateX(e) {
      return this.rotateOnAxis(xr, e);
    }
    rotateY(e) {
      return this.rotateOnAxis(Sr, e);
    }
    rotateZ(e) {
      return this.rotateOnAxis(Mr, e);
    }
    translateOnAxis(e, t) {
      return vr.copy(e).applyQuaternion(this.quaternion), this.position.add(vr.multiplyScalar(t)), this;
    }
    translateX(e) {
      return this.translateOnAxis(xr, e);
    }
    translateY(e) {
      return this.translateOnAxis(Sr, e);
    }
    translateZ(e) {
      return this.translateOnAxis(Mr, e);
    }
    localToWorld(e) {
      return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(e) {
      return this.updateWorldMatrix(!0, !1), e.applyMatrix4(Vt.copy(this.matrixWorld).invert());
    }
    lookAt(e, t, n) {
      e.isVector3 ? ni.copy(e) : ni.set(e, t, n);
      const r = this.parent;
      this.updateWorldMatrix(!0, !1),
        Vn.setFromMatrixPosition(this.matrixWorld),
        this.isCamera || this.isLight ? Vt.lookAt(Vn, ni, this.up) : Vt.lookAt(ni, Vn, this.up),
        this.quaternion.setFromRotationMatrix(Vt),
        r &&
          (Vt.extractRotation(r.matrixWorld), Tn.setFromRotationMatrix(Vt), this.quaternion.premultiply(Tn.invert()));
    }
    add(e) {
      if (arguments.length > 1) {
        for (let t = 0; t < arguments.length; t++) this.add(arguments[t]);
        return this;
      }
      return e === this
        ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this)
        : (e && e.isObject3D
            ? (e.removeFromParent(),
              (e.parent = this),
              this.children.push(e),
              e.dispatchEvent(Er),
              (yn.child = e),
              this.dispatchEvent(yn),
              (yn.child = null))
            : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e),
          this);
    }
    remove(e) {
      if (arguments.length > 1) {
        for (let n = 0; n < arguments.length; n++) this.remove(arguments[n]);
        return this;
      }
      const t = this.children.indexOf(e);
      return (
        t !== -1 &&
          ((e.parent = null),
          this.children.splice(t, 1),
          e.dispatchEvent(Gs),
          (Oi.child = e),
          this.dispatchEvent(Oi),
          (Oi.child = null)),
        this
      );
    }
    removeFromParent() {
      const e = this.parent;
      return e !== null && e.remove(this), this;
    }
    clear() {
      return this.remove(...this.children);
    }
    attach(e) {
      return (
        this.updateWorldMatrix(!0, !1),
        Vt.copy(this.matrixWorld).invert(),
        e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), Vt.multiply(e.parent.matrixWorld)),
        e.applyMatrix4(Vt),
        e.removeFromParent(),
        (e.parent = this),
        this.children.push(e),
        e.updateWorldMatrix(!1, !0),
        e.dispatchEvent(Er),
        (yn.child = e),
        this.dispatchEvent(yn),
        (yn.child = null),
        this
      );
    }
    getObjectById(e) {
      return this.getObjectByProperty("id", e);
    }
    getObjectByName(e) {
      return this.getObjectByProperty("name", e);
    }
    getObjectByProperty(e, t) {
      if (this[e] === t) return this;
      for (let n = 0, r = this.children.length; n < r; n++) {
        const a = this.children[n].getObjectByProperty(e, t);
        if (a !== void 0) return a;
      }
    }
    getObjectsByProperty(e, t, n = []) {
      this[e] === t && n.push(this);
      const r = this.children;
      for (let s = 0, a = r.length; s < a; s++) r[s].getObjectsByProperty(e, t, n);
      return n;
    }
    getWorldPosition(e) {
      return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(e) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Vn, e, Os), e;
    }
    getWorldScale(e) {
      return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Vn, Bs, e), e;
    }
    getWorldDirection(e) {
      this.updateWorldMatrix(!0, !1);
      const t = this.matrixWorld.elements;
      return e.set(t[8], t[9], t[10]).normalize();
    }
    raycast() {}
    traverse(e) {
      e(this);
      const t = this.children;
      for (let n = 0, r = t.length; n < r; n++) t[n].traverse(e);
    }
    traverseVisible(e) {
      if (this.visible === !1) return;
      e(this);
      const t = this.children;
      for (let n = 0, r = t.length; n < r; n++) t[n].traverseVisible(e);
    }
    traverseAncestors(e) {
      const t = this.parent;
      t !== null && (e(t), t.traverseAncestors(e));
    }
    updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale), (this.matrixWorldNeedsUpdate = !0);
    }
    updateMatrixWorld(e) {
      this.matrixAutoUpdate && this.updateMatrix(),
        (this.matrixWorldNeedsUpdate || e) &&
          (this.matrixWorldAutoUpdate === !0 &&
            (this.parent === null
              ? this.matrixWorld.copy(this.matrix)
              : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)),
          (this.matrixWorldNeedsUpdate = !1),
          (e = !0));
      const t = this.children;
      for (let n = 0, r = t.length; n < r; n++) t[n].updateMatrixWorld(e);
    }
    updateWorldMatrix(e, t) {
      const n = this.parent;
      if (
        (e === !0 && n !== null && n.updateWorldMatrix(!0, !1),
        this.matrixAutoUpdate && this.updateMatrix(),
        this.matrixWorldAutoUpdate === !0 &&
          (this.parent === null
            ? this.matrixWorld.copy(this.matrix)
            : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)),
        t === !0)
      ) {
        const r = this.children;
        for (let s = 0, a = r.length; s < a; s++) r[s].updateWorldMatrix(!1, !0);
      }
    }
    toJSON(e) {
      const t = e === void 0 || typeof e == "string",
        n = {};
      t &&
        ((e = {
          geometries: {},
          materials: {},
          textures: {},
          images: {},
          shapes: {},
          skeletons: {},
          animations: {},
          nodes: {}
        }),
        (n.metadata = { version: 4.7, type: "Object", generator: "Object3D.toJSON" }));
      const r = {};
      (r.uuid = this.uuid),
        (r.type = this.type),
        this.name !== "" && (r.name = this.name),
        this.castShadow === !0 && (r.castShadow = !0),
        this.receiveShadow === !0 && (r.receiveShadow = !0),
        this.visible === !1 && (r.visible = !1),
        this.frustumCulled === !1 && (r.frustumCulled = !1),
        this.renderOrder !== 0 && (r.renderOrder = this.renderOrder),
        Object.keys(this.userData).length > 0 && (r.userData = this.userData),
        (r.layers = this.layers.mask),
        (r.matrix = this.matrix.toArray()),
        (r.up = this.up.toArray()),
        this.matrixAutoUpdate === !1 && (r.matrixAutoUpdate = !1),
        this.isInstancedMesh &&
          ((r.type = "InstancedMesh"),
          (r.count = this.count),
          (r.instanceMatrix = this.instanceMatrix.toJSON()),
          this.instanceColor !== null && (r.instanceColor = this.instanceColor.toJSON())),
        this.isBatchedMesh &&
          ((r.type = "BatchedMesh"),
          (r.perObjectFrustumCulled = this.perObjectFrustumCulled),
          (r.sortObjects = this.sortObjects),
          (r.drawRanges = this._drawRanges),
          (r.reservedRanges = this._reservedRanges),
          (r.geometryInfo = this._geometryInfo.map(o => ({
            ...o,
            boundingBox: o.boundingBox ? o.boundingBox.toJSON() : void 0,
            boundingSphere: o.boundingSphere ? o.boundingSphere.toJSON() : void 0
          }))),
          (r.instanceInfo = this._instanceInfo.map(o => ({ ...o }))),
          (r.availableInstanceIds = this._availableInstanceIds.slice()),
          (r.availableGeometryIds = this._availableGeometryIds.slice()),
          (r.nextIndexStart = this._nextIndexStart),
          (r.nextVertexStart = this._nextVertexStart),
          (r.geometryCount = this._geometryCount),
          (r.maxInstanceCount = this._maxInstanceCount),
          (r.maxVertexCount = this._maxVertexCount),
          (r.maxIndexCount = this._maxIndexCount),
          (r.geometryInitialized = this._geometryInitialized),
          (r.matricesTexture = this._matricesTexture.toJSON(e)),
          (r.indirectTexture = this._indirectTexture.toJSON(e)),
          this._colorsTexture !== null && (r.colorsTexture = this._colorsTexture.toJSON(e)),
          this.boundingSphere !== null && (r.boundingSphere = this.boundingSphere.toJSON()),
          this.boundingBox !== null && (r.boundingBox = this.boundingBox.toJSON()));
      function s(o, c) {
        return o[c.uuid] === void 0 && (o[c.uuid] = c.toJSON(e)), c.uuid;
      }
      if (this.isScene)
        this.background &&
          (this.background.isColor
            ? (r.background = this.background.toJSON())
            : this.background.isTexture && (r.background = this.background.toJSON(e).uuid)),
          this.environment &&
            this.environment.isTexture &&
            this.environment.isRenderTargetTexture !== !0 &&
            (r.environment = this.environment.toJSON(e).uuid);
      else if (this.isMesh || this.isLine || this.isPoints) {
        r.geometry = s(e.geometries, this.geometry);
        const o = this.geometry.parameters;
        if (o !== void 0 && o.shapes !== void 0) {
          const c = o.shapes;
          if (Array.isArray(c))
            for (let l = 0, h = c.length; l < h; l++) {
              const f = c[l];
              s(e.shapes, f);
            }
          else s(e.shapes, c);
        }
      }
      if (
        (this.isSkinnedMesh &&
          ((r.bindMode = this.bindMode),
          (r.bindMatrix = this.bindMatrix.toArray()),
          this.skeleton !== void 0 && (s(e.skeletons, this.skeleton), (r.skeleton = this.skeleton.uuid))),
        this.material !== void 0)
      )
        if (Array.isArray(this.material)) {
          const o = [];
          for (let c = 0, l = this.material.length; c < l; c++) o.push(s(e.materials, this.material[c]));
          r.material = o;
        } else r.material = s(e.materials, this.material);
      if (this.children.length > 0) {
        r.children = [];
        for (let o = 0; o < this.children.length; o++) r.children.push(this.children[o].toJSON(e).object);
      }
      if (this.animations.length > 0) {
        r.animations = [];
        for (let o = 0; o < this.animations.length; o++) {
          const c = this.animations[o];
          r.animations.push(s(e.animations, c));
        }
      }
      if (t) {
        const o = a(e.geometries),
          c = a(e.materials),
          l = a(e.textures),
          h = a(e.images),
          f = a(e.shapes),
          d = a(e.skeletons),
          m = a(e.animations),
          v = a(e.nodes);
        o.length > 0 && (n.geometries = o),
          c.length > 0 && (n.materials = c),
          l.length > 0 && (n.textures = l),
          h.length > 0 && (n.images = h),
          f.length > 0 && (n.shapes = f),
          d.length > 0 && (n.skeletons = d),
          m.length > 0 && (n.animations = m),
          v.length > 0 && (n.nodes = v);
      }
      return (n.object = r), n;
      function a(o) {
        const c = [];
        for (const l in o) {
          const h = o[l];
          delete h.metadata, c.push(h);
        }
        return c;
      }
    }
    clone(e) {
      return new this.constructor().copy(this, e);
    }
    copy(e, t = !0) {
      if (
        ((this.name = e.name),
        this.up.copy(e.up),
        this.position.copy(e.position),
        (this.rotation.order = e.rotation.order),
        this.quaternion.copy(e.quaternion),
        this.scale.copy(e.scale),
        this.matrix.copy(e.matrix),
        this.matrixWorld.copy(e.matrixWorld),
        (this.matrixAutoUpdate = e.matrixAutoUpdate),
        (this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate),
        (this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate),
        (this.layers.mask = e.layers.mask),
        (this.visible = e.visible),
        (this.castShadow = e.castShadow),
        (this.receiveShadow = e.receiveShadow),
        (this.frustumCulled = e.frustumCulled),
        (this.renderOrder = e.renderOrder),
        (this.animations = e.animations.slice()),
        (this.userData = JSON.parse(JSON.stringify(e.userData))),
        t === !0)
      )
        for (let n = 0; n < e.children.length; n++) {
          const r = e.children[n];
          this.add(r.clone());
        }
      return this;
    }
  }
  (xt.DEFAULT_UP = new O(0, 1, 0)), (xt.DEFAULT_MATRIX_AUTO_UPDATE = !0), (xt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0);
  const Dt = new O(),
    Ht = new O(),
    Bi = new O(),
    kt = new O(),
    An = new O(),
    bn = new O(),
    Tr = new O(),
    Gi = new O(),
    zi = new O(),
    Vi = new O(),
    Hi = new rt(),
    ki = new rt(),
    Wi = new rt();
  class Lt {
    constructor(e = new O(), t = new O(), n = new O()) {
      (this.a = e), (this.b = t), (this.c = n);
    }
    static getNormal(e, t, n, r) {
      r.subVectors(n, t), Dt.subVectors(e, t), r.cross(Dt);
      const s = r.lengthSq();
      return s > 0 ? r.multiplyScalar(1 / Math.sqrt(s)) : r.set(0, 0, 0);
    }
    static getBarycoord(e, t, n, r, s) {
      Dt.subVectors(r, t), Ht.subVectors(n, t), Bi.subVectors(e, t);
      const a = Dt.dot(Dt),
        o = Dt.dot(Ht),
        c = Dt.dot(Bi),
        l = Ht.dot(Ht),
        h = Ht.dot(Bi),
        f = a * l - o * o;
      if (f === 0) return s.set(0, 0, 0), null;
      const d = 1 / f,
        m = (l * c - o * h) * d,
        v = (a * h - o * c) * d;
      return s.set(1 - m - v, v, m);
    }
    static containsPoint(e, t, n, r) {
      return this.getBarycoord(e, t, n, r, kt) === null ? !1 : kt.x >= 0 && kt.y >= 0 && kt.x + kt.y <= 1;
    }
    static getInterpolation(e, t, n, r, s, a, o, c) {
      return this.getBarycoord(e, t, n, r, kt) === null
        ? ((c.x = 0), (c.y = 0), "z" in c && (c.z = 0), "w" in c && (c.w = 0), null)
        : (c.setScalar(0), c.addScaledVector(s, kt.x), c.addScaledVector(a, kt.y), c.addScaledVector(o, kt.z), c);
    }
    static getInterpolatedAttribute(e, t, n, r, s, a) {
      return (
        Hi.setScalar(0),
        ki.setScalar(0),
        Wi.setScalar(0),
        Hi.fromBufferAttribute(e, t),
        ki.fromBufferAttribute(e, n),
        Wi.fromBufferAttribute(e, r),
        a.setScalar(0),
        a.addScaledVector(Hi, s.x),
        a.addScaledVector(ki, s.y),
        a.addScaledVector(Wi, s.z),
        a
      );
    }
    static isFrontFacing(e, t, n, r) {
      return Dt.subVectors(n, t), Ht.subVectors(e, t), Dt.cross(Ht).dot(r) < 0;
    }
    set(e, t, n) {
      return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
    }
    setFromPointsAndIndices(e, t, n, r) {
      return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[r]), this;
    }
    setFromAttributeAndIndices(e, t, n, r) {
      return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, n), this.c.fromBufferAttribute(e, r), this;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(e) {
      return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
    }
    getArea() {
      return Dt.subVectors(this.c, this.b), Ht.subVectors(this.a, this.b), Dt.cross(Ht).length() * 0.5;
    }
    getMidpoint(e) {
      return e
        .addVectors(this.a, this.b)
        .add(this.c)
        .multiplyScalar(1 / 3);
    }
    getNormal(e) {
      return Lt.getNormal(this.a, this.b, this.c, e);
    }
    getPlane(e) {
      return e.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(e, t) {
      return Lt.getBarycoord(e, this.a, this.b, this.c, t);
    }
    getInterpolation(e, t, n, r, s) {
      return Lt.getInterpolation(e, this.a, this.b, this.c, t, n, r, s);
    }
    containsPoint(e) {
      return Lt.containsPoint(e, this.a, this.b, this.c);
    }
    isFrontFacing(e) {
      return Lt.isFrontFacing(this.a, this.b, this.c, e);
    }
    intersectsBox(e) {
      return e.intersectsTriangle(this);
    }
    closestPointToPoint(e, t) {
      const n = this.a,
        r = this.b,
        s = this.c;
      let a, o;
      An.subVectors(r, n), bn.subVectors(s, n), Gi.subVectors(e, n);
      const c = An.dot(Gi),
        l = bn.dot(Gi);
      if (c <= 0 && l <= 0) return t.copy(n);
      zi.subVectors(e, r);
      const h = An.dot(zi),
        f = bn.dot(zi);
      if (h >= 0 && f <= h) return t.copy(r);
      const d = c * f - h * l;
      if (d <= 0 && c >= 0 && h <= 0) return (a = c / (c - h)), t.copy(n).addScaledVector(An, a);
      Vi.subVectors(e, s);
      const m = An.dot(Vi),
        v = bn.dot(Vi);
      if (v >= 0 && m <= v) return t.copy(s);
      const x = m * l - c * v;
      if (x <= 0 && l >= 0 && v <= 0) return (o = l / (l - v)), t.copy(n).addScaledVector(bn, o);
      const p = h * v - m * f;
      if (p <= 0 && f - h >= 0 && m - v >= 0)
        return Tr.subVectors(s, r), (o = (f - h) / (f - h + (m - v))), t.copy(r).addScaledVector(Tr, o);
      const u = 1 / (p + x + d);
      return (a = x * u), (o = d * u), t.copy(n).addScaledVector(An, a).addScaledVector(bn, o);
    }
    equals(e) {
      return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
    }
  }
  const yr = {
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    },
    jt = { h: 0, s: 0, l: 0 },
    ii = { h: 0, s: 0, l: 0 };
  function Xi(i, e, t) {
    return (
      t < 0 && (t += 1),
      t > 1 && (t -= 1),
      t < 1 / 6 ? i + (e - i) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? i + (e - i) * 6 * (2 / 3 - t) : i
    );
  }
  class ke {
    constructor(e, t, n) {
      return (this.isColor = !0), (this.r = 1), (this.g = 1), (this.b = 1), this.set(e, t, n);
    }
    set(e, t, n) {
      if (t === void 0 && n === void 0) {
        const r = e;
        r && r.isColor
          ? this.copy(r)
          : typeof r == "number"
          ? this.setHex(r)
          : typeof r == "string" && this.setStyle(r);
      } else this.setRGB(e, t, n);
      return this;
    }
    setScalar(e) {
      return (this.r = e), (this.g = e), (this.b = e), this;
    }
    setHex(e, t = At) {
      return (
        (e = Math.floor(e)),
        (this.r = ((e >> 16) & 255) / 255),
        (this.g = ((e >> 8) & 255) / 255),
        (this.b = (e & 255) / 255),
        ze.colorSpaceToWorking(this, t),
        this
      );
    }
    setRGB(e, t, n, r = ze.workingColorSpace) {
      return (this.r = e), (this.g = t), (this.b = n), ze.colorSpaceToWorking(this, r), this;
    }
    setHSL(e, t, n, r = ze.workingColorSpace) {
      if (((e = ys(e, 1)), (t = Be(t, 0, 1)), (n = Be(n, 0, 1)), t === 0)) this.r = this.g = this.b = n;
      else {
        const s = n <= 0.5 ? n * (1 + t) : n + t - n * t,
          a = 2 * n - s;
        (this.r = Xi(a, s, e + 1 / 3)), (this.g = Xi(a, s, e)), (this.b = Xi(a, s, e - 1 / 3));
      }
      return ze.colorSpaceToWorking(this, r), this;
    }
    setStyle(e, t = At) {
      function n(s) {
        s !== void 0 && parseFloat(s) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
      }
      let r;
      if ((r = /^(\w+)\(([^\)]*)\)/.exec(e))) {
        let s;
        const a = r[1],
          o = r[2];
        switch (a) {
          case "rgb":
          case "rgba":
            if ((s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)))
              return (
                n(s[4]),
                this.setRGB(
                  Math.min(255, parseInt(s[1], 10)) / 255,
                  Math.min(255, parseInt(s[2], 10)) / 255,
                  Math.min(255, parseInt(s[3], 10)) / 255,
                  t
                )
              );
            if ((s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)))
              return (
                n(s[4]),
                this.setRGB(
                  Math.min(100, parseInt(s[1], 10)) / 100,
                  Math.min(100, parseInt(s[2], 10)) / 100,
                  Math.min(100, parseInt(s[3], 10)) / 100,
                  t
                )
              );
            break;
          case "hsl":
          case "hsla":
            if ((s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(o)))
              return n(s[4]), this.setHSL(parseFloat(s[1]) / 360, parseFloat(s[2]) / 100, parseFloat(s[3]) / 100, t);
            break;
          default:
            console.warn("THREE.Color: Unknown color model " + e);
        }
      } else if ((r = /^\#([A-Fa-f\d]+)$/.exec(e))) {
        const s = r[1],
          a = s.length;
        if (a === 3)
          return this.setRGB(
            parseInt(s.charAt(0), 16) / 15,
            parseInt(s.charAt(1), 16) / 15,
            parseInt(s.charAt(2), 16) / 15,
            t
          );
        if (a === 6) return this.setHex(parseInt(s, 16), t);
        console.warn("THREE.Color: Invalid hex color " + e);
      } else if (e && e.length > 0) return this.setColorName(e, t);
      return this;
    }
    setColorName(e, t = At) {
      const n = yr[e.toLowerCase()];
      return n !== void 0 ? this.setHex(n, t) : console.warn("THREE.Color: Unknown color " + e), this;
    }
    clone() {
      return new this.constructor(this.r, this.g, this.b);
    }
    copy(e) {
      return (this.r = e.r), (this.g = e.g), (this.b = e.b), this;
    }
    copySRGBToLinear(e) {
      return (this.r = Ot(e.r)), (this.g = Ot(e.g)), (this.b = Ot(e.b)), this;
    }
    copyLinearToSRGB(e) {
      return (this.r = gn(e.r)), (this.g = gn(e.g)), (this.b = gn(e.b)), this;
    }
    convertSRGBToLinear() {
      return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
      return this.copyLinearToSRGB(this), this;
    }
    getHex(e = At) {
      return (
        ze.workingToColorSpace(pt.copy(this), e),
        Math.round(Be(pt.r * 255, 0, 255)) * 65536 +
          Math.round(Be(pt.g * 255, 0, 255)) * 256 +
          Math.round(Be(pt.b * 255, 0, 255))
      );
    }
    getHexString(e = At) {
      return ("000000" + this.getHex(e).toString(16)).slice(-6);
    }
    getHSL(e, t = ze.workingColorSpace) {
      ze.workingToColorSpace(pt.copy(this), t);
      const n = pt.r,
        r = pt.g,
        s = pt.b,
        a = Math.max(n, r, s),
        o = Math.min(n, r, s);
      let c, l;
      const h = (o + a) / 2;
      if (o === a) (c = 0), (l = 0);
      else {
        const f = a - o;
        switch (((l = h <= 0.5 ? f / (a + o) : f / (2 - a - o)), a)) {
          case n:
            c = (r - s) / f + (r < s ? 6 : 0);
            break;
          case r:
            c = (s - n) / f + 2;
            break;
          case s:
            c = (n - r) / f + 4;
            break;
        }
        c /= 6;
      }
      return (e.h = c), (e.s = l), (e.l = h), e;
    }
    getRGB(e, t = ze.workingColorSpace) {
      return ze.workingToColorSpace(pt.copy(this), t), (e.r = pt.r), (e.g = pt.g), (e.b = pt.b), e;
    }
    getStyle(e = At) {
      ze.workingToColorSpace(pt.copy(this), e);
      const t = pt.r,
        n = pt.g,
        r = pt.b;
      return e !== At
        ? `color(${e} ${t.toFixed(3)} ${n.toFixed(3)} ${r.toFixed(3)})`
        : `rgb(${Math.round(t * 255)},${Math.round(n * 255)},${Math.round(r * 255)})`;
    }
    offsetHSL(e, t, n) {
      return this.getHSL(jt), this.setHSL(jt.h + e, jt.s + t, jt.l + n);
    }
    add(e) {
      return (this.r += e.r), (this.g += e.g), (this.b += e.b), this;
    }
    addColors(e, t) {
      return (this.r = e.r + t.r), (this.g = e.g + t.g), (this.b = e.b + t.b), this;
    }
    addScalar(e) {
      return (this.r += e), (this.g += e), (this.b += e), this;
    }
    sub(e) {
      return (
        (this.r = Math.max(0, this.r - e.r)),
        (this.g = Math.max(0, this.g - e.g)),
        (this.b = Math.max(0, this.b - e.b)),
        this
      );
    }
    multiply(e) {
      return (this.r *= e.r), (this.g *= e.g), (this.b *= e.b), this;
    }
    multiplyScalar(e) {
      return (this.r *= e), (this.g *= e), (this.b *= e), this;
    }
    lerp(e, t) {
      return (this.r += (e.r - this.r) * t), (this.g += (e.g - this.g) * t), (this.b += (e.b - this.b) * t), this;
    }
    lerpColors(e, t, n) {
      return (this.r = e.r + (t.r - e.r) * n), (this.g = e.g + (t.g - e.g) * n), (this.b = e.b + (t.b - e.b) * n), this;
    }
    lerpHSL(e, t) {
      this.getHSL(jt), e.getHSL(ii);
      const n = bi(jt.h, ii.h, t),
        r = bi(jt.s, ii.s, t),
        s = bi(jt.l, ii.l, t);
      return this.setHSL(n, r, s), this;
    }
    setFromVector3(e) {
      return (this.r = e.x), (this.g = e.y), (this.b = e.z), this;
    }
    applyMatrix3(e) {
      const t = this.r,
        n = this.g,
        r = this.b,
        s = e.elements;
      return (
        (this.r = s[0] * t + s[3] * n + s[6] * r),
        (this.g = s[1] * t + s[4] * n + s[7] * r),
        (this.b = s[2] * t + s[5] * n + s[8] * r),
        this
      );
    }
    equals(e) {
      return e.r === this.r && e.g === this.g && e.b === this.b;
    }
    fromArray(e, t = 0) {
      return (this.r = e[t]), (this.g = e[t + 1]), (this.b = e[t + 2]), this;
    }
    toArray(e = [], t = 0) {
      return (e[t] = this.r), (e[t + 1] = this.g), (e[t + 2] = this.b), e;
    }
    fromBufferAttribute(e, t) {
      return (this.r = e.getX(t)), (this.g = e.getY(t)), (this.b = e.getZ(t)), this;
    }
    toJSON() {
      return this.getHex();
    }
    *[Symbol.iterator]() {
      yield this.r, yield this.g, yield this.b;
    }
  }
  const pt = new ke();
  ke.NAMES = yr;
  let zs = 0;
  class Hn extends mn {
    constructor() {
      super(),
        (this.isMaterial = !0),
        Object.defineProperty(this, "id", { value: zs++ }),
        (this.uuid = Fn()),
        (this.name = ""),
        (this.type = "Material"),
        (this.blending = 1),
        (this.side = 0),
        (this.vertexColors = !1),
        (this.opacity = 1),
        (this.transparent = !1),
        (this.alphaHash = !1),
        (this.blendSrc = 204),
        (this.blendDst = 205),
        (this.blendEquation = 100),
        (this.blendSrcAlpha = null),
        (this.blendDstAlpha = null),
        (this.blendEquationAlpha = null),
        (this.blendColor = new ke(0, 0, 0)),
        (this.blendAlpha = 0),
        (this.depthFunc = 3),
        (this.depthTest = !0),
        (this.depthWrite = !0),
        (this.stencilWriteMask = 255),
        (this.stencilFunc = 519),
        (this.stencilRef = 0),
        (this.stencilFuncMask = 255),
        (this.stencilFail = 7680),
        (this.stencilZFail = 7680),
        (this.stencilZPass = 7680),
        (this.stencilWrite = !1),
        (this.clippingPlanes = null),
        (this.clipIntersection = !1),
        (this.clipShadows = !1),
        (this.shadowSide = null),
        (this.colorWrite = !0),
        (this.precision = null),
        (this.polygonOffset = !1),
        (this.polygonOffsetFactor = 0),
        (this.polygonOffsetUnits = 0),
        (this.dithering = !1),
        (this.alphaToCoverage = !1),
        (this.premultipliedAlpha = !1),
        (this.forceSinglePass = !1),
        (this.allowOverride = !0),
        (this.visible = !0),
        (this.toneMapped = !0),
        (this.userData = {}),
        (this.version = 0),
        (this._alphaTest = 0);
    }
    get alphaTest() {
      return this._alphaTest;
    }
    set alphaTest(e) {
      this._alphaTest > 0 != e > 0 && this.version++, (this._alphaTest = e);
    }
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
      return this.onBeforeCompile.toString();
    }
    setValues(e) {
      if (e !== void 0)
        for (const t in e) {
          const n = e[t];
          if (n === void 0) {
            console.warn(`THREE.Material: parameter '${t}' has value of undefined.`);
            continue;
          }
          const r = this[t];
          if (r === void 0) {
            console.warn(`THREE.Material: '${t}' is not a property of THREE.${this.type}.`);
            continue;
          }
          r && r.isColor ? r.set(n) : r && r.isVector3 && n && n.isVector3 ? r.copy(n) : (this[t] = n);
        }
    }
    toJSON(e) {
      const t = e === void 0 || typeof e == "string";
      t && (e = { textures: {}, images: {} });
      const n = { metadata: { version: 4.7, type: "Material", generator: "Material.toJSON" } };
      (n.uuid = this.uuid),
        (n.type = this.type),
        this.name !== "" && (n.name = this.name),
        this.color && this.color.isColor && (n.color = this.color.getHex()),
        this.roughness !== void 0 && (n.roughness = this.roughness),
        this.metalness !== void 0 && (n.metalness = this.metalness),
        this.sheen !== void 0 && (n.sheen = this.sheen),
        this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()),
        this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness),
        this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()),
        this.emissiveIntensity !== void 0 &&
          this.emissiveIntensity !== 1 &&
          (n.emissiveIntensity = this.emissiveIntensity),
        this.specular && this.specular.isColor && (n.specular = this.specular.getHex()),
        this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity),
        this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()),
        this.shininess !== void 0 && (n.shininess = this.shininess),
        this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat),
        this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness),
        this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid),
        this.clearcoatRoughnessMap &&
          this.clearcoatRoughnessMap.isTexture &&
          (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid),
        this.clearcoatNormalMap &&
          this.clearcoatNormalMap.isTexture &&
          ((n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid),
          (n.clearcoatNormalScale = this.clearcoatNormalScale.toArray())),
        this.dispersion !== void 0 && (n.dispersion = this.dispersion),
        this.iridescence !== void 0 && (n.iridescence = this.iridescence),
        this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR),
        this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange),
        this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e).uuid),
        this.iridescenceThicknessMap &&
          this.iridescenceThicknessMap.isTexture &&
          (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid),
        this.anisotropy !== void 0 && (n.anisotropy = this.anisotropy),
        this.anisotropyRotation !== void 0 && (n.anisotropyRotation = this.anisotropyRotation),
        this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e).uuid),
        this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid),
        this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e).uuid),
        this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e).uuid),
        this.lightMap &&
          this.lightMap.isTexture &&
          ((n.lightMap = this.lightMap.toJSON(e).uuid), (n.lightMapIntensity = this.lightMapIntensity)),
        this.aoMap &&
          this.aoMap.isTexture &&
          ((n.aoMap = this.aoMap.toJSON(e).uuid), (n.aoMapIntensity = this.aoMapIntensity)),
        this.bumpMap &&
          this.bumpMap.isTexture &&
          ((n.bumpMap = this.bumpMap.toJSON(e).uuid), (n.bumpScale = this.bumpScale)),
        this.normalMap &&
          this.normalMap.isTexture &&
          ((n.normalMap = this.normalMap.toJSON(e).uuid),
          (n.normalMapType = this.normalMapType),
          (n.normalScale = this.normalScale.toArray())),
        this.displacementMap &&
          this.displacementMap.isTexture &&
          ((n.displacementMap = this.displacementMap.toJSON(e).uuid),
          (n.displacementScale = this.displacementScale),
          (n.displacementBias = this.displacementBias)),
        this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e).uuid),
        this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e).uuid),
        this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e).uuid),
        this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e).uuid),
        this.specularIntensityMap &&
          this.specularIntensityMap.isTexture &&
          (n.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid),
        this.specularColorMap &&
          this.specularColorMap.isTexture &&
          (n.specularColorMap = this.specularColorMap.toJSON(e).uuid),
        this.envMap &&
          this.envMap.isTexture &&
          ((n.envMap = this.envMap.toJSON(e).uuid), this.combine !== void 0 && (n.combine = this.combine)),
        this.envMapRotation !== void 0 && (n.envMapRotation = this.envMapRotation.toArray()),
        this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity),
        this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity),
        this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio),
        this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e).uuid),
        this.transmission !== void 0 && (n.transmission = this.transmission),
        this.transmissionMap &&
          this.transmissionMap.isTexture &&
          (n.transmissionMap = this.transmissionMap.toJSON(e).uuid),
        this.thickness !== void 0 && (n.thickness = this.thickness),
        this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e).uuid),
        this.attenuationDistance !== void 0 &&
          this.attenuationDistance !== 1 / 0 &&
          (n.attenuationDistance = this.attenuationDistance),
        this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()),
        this.size !== void 0 && (n.size = this.size),
        this.shadowSide !== null && (n.shadowSide = this.shadowSide),
        this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation),
        this.blending !== 1 && (n.blending = this.blending),
        this.side !== 0 && (n.side = this.side),
        this.vertexColors === !0 && (n.vertexColors = !0),
        this.opacity < 1 && (n.opacity = this.opacity),
        this.transparent === !0 && (n.transparent = !0),
        this.blendSrc !== 204 && (n.blendSrc = this.blendSrc),
        this.blendDst !== 205 && (n.blendDst = this.blendDst),
        this.blendEquation !== 100 && (n.blendEquation = this.blendEquation),
        this.blendSrcAlpha !== null && (n.blendSrcAlpha = this.blendSrcAlpha),
        this.blendDstAlpha !== null && (n.blendDstAlpha = this.blendDstAlpha),
        this.blendEquationAlpha !== null && (n.blendEquationAlpha = this.blendEquationAlpha),
        this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()),
        this.blendAlpha !== 0 && (n.blendAlpha = this.blendAlpha),
        this.depthFunc !== 3 && (n.depthFunc = this.depthFunc),
        this.depthTest === !1 && (n.depthTest = this.depthTest),
        this.depthWrite === !1 && (n.depthWrite = this.depthWrite),
        this.colorWrite === !1 && (n.colorWrite = this.colorWrite),
        this.stencilWriteMask !== 255 && (n.stencilWriteMask = this.stencilWriteMask),
        this.stencilFunc !== 519 && (n.stencilFunc = this.stencilFunc),
        this.stencilRef !== 0 && (n.stencilRef = this.stencilRef),
        this.stencilFuncMask !== 255 && (n.stencilFuncMask = this.stencilFuncMask),
        this.stencilFail !== 7680 && (n.stencilFail = this.stencilFail),
        this.stencilZFail !== 7680 && (n.stencilZFail = this.stencilZFail),
        this.stencilZPass !== 7680 && (n.stencilZPass = this.stencilZPass),
        this.stencilWrite === !0 && (n.stencilWrite = this.stencilWrite),
        this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation),
        this.polygonOffset === !0 && (n.polygonOffset = !0),
        this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor),
        this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits),
        this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth),
        this.dashSize !== void 0 && (n.dashSize = this.dashSize),
        this.gapSize !== void 0 && (n.gapSize = this.gapSize),
        this.scale !== void 0 && (n.scale = this.scale),
        this.dithering === !0 && (n.dithering = !0),
        this.alphaTest > 0 && (n.alphaTest = this.alphaTest),
        this.alphaHash === !0 && (n.alphaHash = !0),
        this.alphaToCoverage === !0 && (n.alphaToCoverage = !0),
        this.premultipliedAlpha === !0 && (n.premultipliedAlpha = !0),
        this.forceSinglePass === !0 && (n.forceSinglePass = !0),
        this.wireframe === !0 && (n.wireframe = !0),
        this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth),
        this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap),
        this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin),
        this.flatShading === !0 && (n.flatShading = !0),
        this.visible === !1 && (n.visible = !1),
        this.toneMapped === !1 && (n.toneMapped = !1),
        this.fog === !1 && (n.fog = !1),
        Object.keys(this.userData).length > 0 && (n.userData = this.userData);
      function r(s) {
        const a = [];
        for (const o in s) {
          const c = s[o];
          delete c.metadata, a.push(c);
        }
        return a;
      }
      if (t) {
        const s = r(e.textures),
          a = r(e.images);
        s.length > 0 && (n.textures = s), a.length > 0 && (n.images = a);
      }
      return n;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(e) {
      (this.name = e.name),
        (this.blending = e.blending),
        (this.side = e.side),
        (this.vertexColors = e.vertexColors),
        (this.opacity = e.opacity),
        (this.transparent = e.transparent),
        (this.blendSrc = e.blendSrc),
        (this.blendDst = e.blendDst),
        (this.blendEquation = e.blendEquation),
        (this.blendSrcAlpha = e.blendSrcAlpha),
        (this.blendDstAlpha = e.blendDstAlpha),
        (this.blendEquationAlpha = e.blendEquationAlpha),
        this.blendColor.copy(e.blendColor),
        (this.blendAlpha = e.blendAlpha),
        (this.depthFunc = e.depthFunc),
        (this.depthTest = e.depthTest),
        (this.depthWrite = e.depthWrite),
        (this.stencilWriteMask = e.stencilWriteMask),
        (this.stencilFunc = e.stencilFunc),
        (this.stencilRef = e.stencilRef),
        (this.stencilFuncMask = e.stencilFuncMask),
        (this.stencilFail = e.stencilFail),
        (this.stencilZFail = e.stencilZFail),
        (this.stencilZPass = e.stencilZPass),
        (this.stencilWrite = e.stencilWrite);
      const t = e.clippingPlanes;
      let n = null;
      if (t !== null) {
        const r = t.length;
        n = new Array(r);
        for (let s = 0; s !== r; ++s) n[s] = t[s].clone();
      }
      return (
        (this.clippingPlanes = n),
        (this.clipIntersection = e.clipIntersection),
        (this.clipShadows = e.clipShadows),
        (this.shadowSide = e.shadowSide),
        (this.colorWrite = e.colorWrite),
        (this.precision = e.precision),
        (this.polygonOffset = e.polygonOffset),
        (this.polygonOffsetFactor = e.polygonOffsetFactor),
        (this.polygonOffsetUnits = e.polygonOffsetUnits),
        (this.dithering = e.dithering),
        (this.alphaTest = e.alphaTest),
        (this.alphaHash = e.alphaHash),
        (this.alphaToCoverage = e.alphaToCoverage),
        (this.premultipliedAlpha = e.premultipliedAlpha),
        (this.forceSinglePass = e.forceSinglePass),
        (this.visible = e.visible),
        (this.toneMapped = e.toneMapped),
        (this.userData = JSON.parse(JSON.stringify(e.userData))),
        this
      );
    }
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
    set needsUpdate(e) {
      e === !0 && this.version++;
    }
  }
  class Ar extends Hn {
    constructor(e) {
      super(),
        (this.isMeshBasicMaterial = !0),
        (this.type = "MeshBasicMaterial"),
        (this.color = new ke(16777215)),
        (this.map = null),
        (this.lightMap = null),
        (this.lightMapIntensity = 1),
        (this.aoMap = null),
        (this.aoMapIntensity = 1),
        (this.specularMap = null),
        (this.alphaMap = null),
        (this.envMap = null),
        (this.envMapRotation = new zt()),
        (this.combine = 0),
        (this.reflectivity = 1),
        (this.refractionRatio = 0.98),
        (this.wireframe = !1),
        (this.wireframeLinewidth = 1),
        (this.wireframeLinecap = "round"),
        (this.wireframeLinejoin = "round"),
        (this.fog = !0),
        this.setValues(e);
    }
    copy(e) {
      return (
        super.copy(e),
        this.color.copy(e.color),
        (this.map = e.map),
        (this.lightMap = e.lightMap),
        (this.lightMapIntensity = e.lightMapIntensity),
        (this.aoMap = e.aoMap),
        (this.aoMapIntensity = e.aoMapIntensity),
        (this.specularMap = e.specularMap),
        (this.alphaMap = e.alphaMap),
        (this.envMap = e.envMap),
        this.envMapRotation.copy(e.envMapRotation),
        (this.combine = e.combine),
        (this.reflectivity = e.reflectivity),
        (this.refractionRatio = e.refractionRatio),
        (this.wireframe = e.wireframe),
        (this.wireframeLinewidth = e.wireframeLinewidth),
        (this.wireframeLinecap = e.wireframeLinecap),
        (this.wireframeLinejoin = e.wireframeLinejoin),
        (this.fog = e.fog),
        this
      );
    }
  }
  const lt = new O(),
    ri = new qe();
  let Vs = 0;
  class Ut {
    constructor(e, t, n = !1) {
      if (Array.isArray(e)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
      (this.isBufferAttribute = !0),
        Object.defineProperty(this, "id", { value: Vs++ }),
        (this.name = ""),
        (this.array = e),
        (this.itemSize = t),
        (this.count = e !== void 0 ? e.length / t : 0),
        (this.normalized = n),
        (this.usage = 35044),
        (this.updateRanges = []),
        (this.gpuType = 1015),
        (this.version = 0);
    }
    onUploadCallback() {}
    set needsUpdate(e) {
      e === !0 && this.version++;
    }
    setUsage(e) {
      return (this.usage = e), this;
    }
    addUpdateRange(e, t) {
      this.updateRanges.push({ start: e, count: t });
    }
    clearUpdateRanges() {
      this.updateRanges.length = 0;
    }
    copy(e) {
      return (
        (this.name = e.name),
        (this.array = new e.array.constructor(e.array)),
        (this.itemSize = e.itemSize),
        (this.count = e.count),
        (this.normalized = e.normalized),
        (this.usage = e.usage),
        (this.gpuType = e.gpuType),
        this
      );
    }
    copyAt(e, t, n) {
      (e *= this.itemSize), (n *= t.itemSize);
      for (let r = 0, s = this.itemSize; r < s; r++) this.array[e + r] = t.array[n + r];
      return this;
    }
    copyArray(e) {
      return this.array.set(e), this;
    }
    applyMatrix3(e) {
      if (this.itemSize === 2)
        for (let t = 0, n = this.count; t < n; t++)
          ri.fromBufferAttribute(this, t), ri.applyMatrix3(e), this.setXY(t, ri.x, ri.y);
      else if (this.itemSize === 3)
        for (let t = 0, n = this.count; t < n; t++)
          lt.fromBufferAttribute(this, t), lt.applyMatrix3(e), this.setXYZ(t, lt.x, lt.y, lt.z);
      return this;
    }
    applyMatrix4(e) {
      for (let t = 0, n = this.count; t < n; t++)
        lt.fromBufferAttribute(this, t), lt.applyMatrix4(e), this.setXYZ(t, lt.x, lt.y, lt.z);
      return this;
    }
    applyNormalMatrix(e) {
      for (let t = 0, n = this.count; t < n; t++)
        lt.fromBufferAttribute(this, t), lt.applyNormalMatrix(e), this.setXYZ(t, lt.x, lt.y, lt.z);
      return this;
    }
    transformDirection(e) {
      for (let t = 0, n = this.count; t < n; t++)
        lt.fromBufferAttribute(this, t), lt.transformDirection(e), this.setXYZ(t, lt.x, lt.y, lt.z);
      return this;
    }
    set(e, t = 0) {
      return this.array.set(e, t), this;
    }
    getComponent(e, t) {
      let n = this.array[e * this.itemSize + t];
      return this.normalized && (n = Nn(n, this.array)), n;
    }
    setComponent(e, t, n) {
      return this.normalized && (n = gt(n, this.array)), (this.array[e * this.itemSize + t] = n), this;
    }
    getX(e) {
      let t = this.array[e * this.itemSize];
      return this.normalized && (t = Nn(t, this.array)), t;
    }
    setX(e, t) {
      return this.normalized && (t = gt(t, this.array)), (this.array[e * this.itemSize] = t), this;
    }
    getY(e) {
      let t = this.array[e * this.itemSize + 1];
      return this.normalized && (t = Nn(t, this.array)), t;
    }
    setY(e, t) {
      return this.normalized && (t = gt(t, this.array)), (this.array[e * this.itemSize + 1] = t), this;
    }
    getZ(e) {
      let t = this.array[e * this.itemSize + 2];
      return this.normalized && (t = Nn(t, this.array)), t;
    }
    setZ(e, t) {
      return this.normalized && (t = gt(t, this.array)), (this.array[e * this.itemSize + 2] = t), this;
    }
    getW(e) {
      let t = this.array[e * this.itemSize + 3];
      return this.normalized && (t = Nn(t, this.array)), t;
    }
    setW(e, t) {
      return this.normalized && (t = gt(t, this.array)), (this.array[e * this.itemSize + 3] = t), this;
    }
    setXY(e, t, n) {
      return (
        (e *= this.itemSize),
        this.normalized && ((t = gt(t, this.array)), (n = gt(n, this.array))),
        (this.array[e + 0] = t),
        (this.array[e + 1] = n),
        this
      );
    }
    setXYZ(e, t, n, r) {
      return (
        (e *= this.itemSize),
        this.normalized && ((t = gt(t, this.array)), (n = gt(n, this.array)), (r = gt(r, this.array))),
        (this.array[e + 0] = t),
        (this.array[e + 1] = n),
        (this.array[e + 2] = r),
        this
      );
    }
    setXYZW(e, t, n, r, s) {
      return (
        (e *= this.itemSize),
        this.normalized &&
          ((t = gt(t, this.array)), (n = gt(n, this.array)), (r = gt(r, this.array)), (s = gt(s, this.array))),
        (this.array[e + 0] = t),
        (this.array[e + 1] = n),
        (this.array[e + 2] = r),
        (this.array[e + 3] = s),
        this
      );
    }
    onUpload(e) {
      return (this.onUploadCallback = e), this;
    }
    clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
      const e = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.from(this.array),
        normalized: this.normalized
      };
      return this.name !== "" && (e.name = this.name), this.usage !== 35044 && (e.usage = this.usage), e;
    }
  }
  class br extends Ut {
    constructor(e, t, n) {
      super(new Uint16Array(e), t, n);
    }
  }
  class Rr extends Ut {
    constructor(e, t, n) {
      super(new Uint32Array(e), t, n);
    }
  }
  class rn extends Ut {
    constructor(e, t, n) {
      super(new Float32Array(e), t, n);
    }
  }
  let Hs = 0;
  const bt = new ot(),
    qi = new xt(),
    Rn = new O(),
    Et = new Bn(),
    kn = new Bn(),
    ht = new O();
  class Wt extends mn {
    constructor() {
      super(),
        (this.isBufferGeometry = !0),
        Object.defineProperty(this, "id", { value: Hs++ }),
        (this.uuid = Fn()),
        (this.name = ""),
        (this.type = "BufferGeometry"),
        (this.index = null),
        (this.indirect = null),
        (this.attributes = {}),
        (this.morphAttributes = {}),
        (this.morphTargetsRelative = !1),
        (this.groups = []),
        (this.boundingBox = null),
        (this.boundingSphere = null),
        (this.drawRange = { start: 0, count: 1 / 0 }),
        (this.userData = {});
    }
    getIndex() {
      return this.index;
    }
    setIndex(e) {
      return Array.isArray(e) ? (this.index = new (cr(e) ? Rr : br)(e, 1)) : (this.index = e), this;
    }
    setIndirect(e) {
      return (this.indirect = e), this;
    }
    getIndirect() {
      return this.indirect;
    }
    getAttribute(e) {
      return this.attributes[e];
    }
    setAttribute(e, t) {
      return (this.attributes[e] = t), this;
    }
    deleteAttribute(e) {
      return delete this.attributes[e], this;
    }
    hasAttribute(e) {
      return this.attributes[e] !== void 0;
    }
    addGroup(e, t, n = 0) {
      this.groups.push({ start: e, count: t, materialIndex: n });
    }
    clearGroups() {
      this.groups = [];
    }
    setDrawRange(e, t) {
      (this.drawRange.start = e), (this.drawRange.count = t);
    }
    applyMatrix4(e) {
      const t = this.attributes.position;
      t !== void 0 && (t.applyMatrix4(e), (t.needsUpdate = !0));
      const n = this.attributes.normal;
      if (n !== void 0) {
        const s = new Le().getNormalMatrix(e);
        n.applyNormalMatrix(s), (n.needsUpdate = !0);
      }
      const r = this.attributes.tangent;
      return (
        r !== void 0 && (r.transformDirection(e), (r.needsUpdate = !0)),
        this.boundingBox !== null && this.computeBoundingBox(),
        this.boundingSphere !== null && this.computeBoundingSphere(),
        this
      );
    }
    applyQuaternion(e) {
      return bt.makeRotationFromQuaternion(e), this.applyMatrix4(bt), this;
    }
    rotateX(e) {
      return bt.makeRotationX(e), this.applyMatrix4(bt), this;
    }
    rotateY(e) {
      return bt.makeRotationY(e), this.applyMatrix4(bt), this;
    }
    rotateZ(e) {
      return bt.makeRotationZ(e), this.applyMatrix4(bt), this;
    }
    translate(e, t, n) {
      return bt.makeTranslation(e, t, n), this.applyMatrix4(bt), this;
    }
    scale(e, t, n) {
      return bt.makeScale(e, t, n), this.applyMatrix4(bt), this;
    }
    lookAt(e) {
      return qi.lookAt(e), qi.updateMatrix(), this.applyMatrix4(qi.matrix), this;
    }
    center() {
      return this.computeBoundingBox(), this.boundingBox.getCenter(Rn).negate(), this.translate(Rn.x, Rn.y, Rn.z), this;
    }
    setFromPoints(e) {
      const t = this.getAttribute("position");
      if (t === void 0) {
        const n = [];
        for (let r = 0, s = e.length; r < s; r++) {
          const a = e[r];
          n.push(a.x, a.y, a.z || 0);
        }
        this.setAttribute("position", new rn(n, 3));
      } else {
        const n = Math.min(e.length, t.count);
        for (let r = 0; r < n; r++) {
          const s = e[r];
          t.setXYZ(r, s.x, s.y, s.z || 0);
        }
        e.length > t.count &&
          console.warn(
            "THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."
          ),
          (t.needsUpdate = !0);
      }
      return this;
    }
    computeBoundingBox() {
      this.boundingBox === null && (this.boundingBox = new Bn());
      const e = this.attributes.position,
        t = this.morphAttributes.position;
      if (e && e.isGLBufferAttribute) {
        console.error(
          "THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.",
          this
        ),
          this.boundingBox.set(new O(-1 / 0, -1 / 0, -1 / 0), new O(1 / 0, 1 / 0, 1 / 0));
        return;
      }
      if (e !== void 0) {
        if ((this.boundingBox.setFromBufferAttribute(e), t))
          for (let n = 0, r = t.length; n < r; n++) {
            const s = t[n];
            Et.setFromBufferAttribute(s),
              this.morphTargetsRelative
                ? (ht.addVectors(this.boundingBox.min, Et.min),
                  this.boundingBox.expandByPoint(ht),
                  ht.addVectors(this.boundingBox.max, Et.max),
                  this.boundingBox.expandByPoint(ht))
                : (this.boundingBox.expandByPoint(Et.min), this.boundingBox.expandByPoint(Et.max));
          }
      } else this.boundingBox.makeEmpty();
      (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) &&
        console.error(
          'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',
          this
        );
    }
    computeBoundingSphere() {
      this.boundingSphere === null && (this.boundingSphere = new jn());
      const e = this.attributes.position,
        t = this.morphAttributes.position;
      if (e && e.isGLBufferAttribute) {
        console.error(
          "THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.",
          this
        ),
          this.boundingSphere.set(new O(), 1 / 0);
        return;
      }
      if (e) {
        const n = this.boundingSphere.center;
        if ((Et.setFromBufferAttribute(e), t))
          for (let s = 0, a = t.length; s < a; s++) {
            const o = t[s];
            kn.setFromBufferAttribute(o),
              this.morphTargetsRelative
                ? (ht.addVectors(Et.min, kn.min),
                  Et.expandByPoint(ht),
                  ht.addVectors(Et.max, kn.max),
                  Et.expandByPoint(ht))
                : (Et.expandByPoint(kn.min), Et.expandByPoint(kn.max));
          }
        Et.getCenter(n);
        let r = 0;
        for (let s = 0, a = e.count; s < a; s++)
          ht.fromBufferAttribute(e, s), (r = Math.max(r, n.distanceToSquared(ht)));
        if (t)
          for (let s = 0, a = t.length; s < a; s++) {
            const o = t[s],
              c = this.morphTargetsRelative;
            for (let l = 0, h = o.count; l < h; l++)
              ht.fromBufferAttribute(o, l),
                c && (Rn.fromBufferAttribute(e, l), ht.add(Rn)),
                (r = Math.max(r, n.distanceToSquared(ht)));
          }
        (this.boundingSphere.radius = Math.sqrt(r)),
          isNaN(this.boundingSphere.radius) &&
            console.error(
              'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
              this
            );
      }
    }
    computeTangents() {
      const e = this.index,
        t = this.attributes;
      if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
        console.error(
          "THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)"
        );
        return;
      }
      const n = t.position,
        r = t.normal,
        s = t.uv;
      this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Ut(new Float32Array(4 * n.count), 4));
      const a = this.getAttribute("tangent"),
        o = [],
        c = [];
      for (let F = 0; F < n.count; F++) (o[F] = new O()), (c[F] = new O());
      const l = new O(),
        h = new O(),
        f = new O(),
        d = new qe(),
        m = new qe(),
        v = new qe(),
        x = new O(),
        p = new O();
      function u(F, M, S) {
        l.fromBufferAttribute(n, F),
          h.fromBufferAttribute(n, M),
          f.fromBufferAttribute(n, S),
          d.fromBufferAttribute(s, F),
          m.fromBufferAttribute(s, M),
          v.fromBufferAttribute(s, S),
          h.sub(l),
          f.sub(l),
          m.sub(d),
          v.sub(d);
        const b = 1 / (m.x * v.y - v.x * m.y);
        isFinite(b) &&
          (x.copy(h).multiplyScalar(v.y).addScaledVector(f, -m.y).multiplyScalar(b),
          p.copy(f).multiplyScalar(m.x).addScaledVector(h, -v.x).multiplyScalar(b),
          o[F].add(x),
          o[M].add(x),
          o[S].add(x),
          c[F].add(p),
          c[M].add(p),
          c[S].add(p));
      }
      let C = this.groups;
      C.length === 0 && (C = [{ start: 0, count: e.count }]);
      for (let F = 0, M = C.length; F < M; ++F) {
        const S = C[F],
          b = S.start,
          q = S.count;
        for (let V = b, H = b + q; V < H; V += 3) u(e.getX(V + 0), e.getX(V + 1), e.getX(V + 2));
      }
      const y = new O(),
        E = new O(),
        D = new O(),
        w = new O();
      function P(F) {
        D.fromBufferAttribute(r, F), w.copy(D);
        const M = o[F];
        y.copy(M), y.sub(D.multiplyScalar(D.dot(M))).normalize(), E.crossVectors(w, M);
        const b = E.dot(c[F]) < 0 ? -1 : 1;
        a.setXYZW(F, y.x, y.y, y.z, b);
      }
      for (let F = 0, M = C.length; F < M; ++F) {
        const S = C[F],
          b = S.start,
          q = S.count;
        for (let V = b, H = b + q; V < H; V += 3) P(e.getX(V + 0)), P(e.getX(V + 1)), P(e.getX(V + 2));
      }
    }
    computeVertexNormals() {
      const e = this.index,
        t = this.getAttribute("position");
      if (t !== void 0) {
        let n = this.getAttribute("normal");
        if (n === void 0) (n = new Ut(new Float32Array(t.count * 3), 3)), this.setAttribute("normal", n);
        else for (let d = 0, m = n.count; d < m; d++) n.setXYZ(d, 0, 0, 0);
        const r = new O(),
          s = new O(),
          a = new O(),
          o = new O(),
          c = new O(),
          l = new O(),
          h = new O(),
          f = new O();
        if (e)
          for (let d = 0, m = e.count; d < m; d += 3) {
            const v = e.getX(d + 0),
              x = e.getX(d + 1),
              p = e.getX(d + 2);
            r.fromBufferAttribute(t, v),
              s.fromBufferAttribute(t, x),
              a.fromBufferAttribute(t, p),
              h.subVectors(a, s),
              f.subVectors(r, s),
              h.cross(f),
              o.fromBufferAttribute(n, v),
              c.fromBufferAttribute(n, x),
              l.fromBufferAttribute(n, p),
              o.add(h),
              c.add(h),
              l.add(h),
              n.setXYZ(v, o.x, o.y, o.z),
              n.setXYZ(x, c.x, c.y, c.z),
              n.setXYZ(p, l.x, l.y, l.z);
          }
        else
          for (let d = 0, m = t.count; d < m; d += 3)
            r.fromBufferAttribute(t, d + 0),
              s.fromBufferAttribute(t, d + 1),
              a.fromBufferAttribute(t, d + 2),
              h.subVectors(a, s),
              f.subVectors(r, s),
              h.cross(f),
              n.setXYZ(d + 0, h.x, h.y, h.z),
              n.setXYZ(d + 1, h.x, h.y, h.z),
              n.setXYZ(d + 2, h.x, h.y, h.z);
        this.normalizeNormals(), (n.needsUpdate = !0);
      }
    }
    normalizeNormals() {
      const e = this.attributes.normal;
      for (let t = 0, n = e.count; t < n; t++)
        ht.fromBufferAttribute(e, t), ht.normalize(), e.setXYZ(t, ht.x, ht.y, ht.z);
    }
    toNonIndexed() {
      function e(o, c) {
        const l = o.array,
          h = o.itemSize,
          f = o.normalized,
          d = new l.constructor(c.length * h);
        let m = 0,
          v = 0;
        for (let x = 0, p = c.length; x < p; x++) {
          o.isInterleavedBufferAttribute ? (m = c[x] * o.data.stride + o.offset) : (m = c[x] * h);
          for (let u = 0; u < h; u++) d[v++] = l[m++];
        }
        return new Ut(d, h, f);
      }
      if (this.index === null)
        return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
      const t = new Wt(),
        n = this.index.array,
        r = this.attributes;
      for (const o in r) {
        const c = r[o],
          l = e(c, n);
        t.setAttribute(o, l);
      }
      const s = this.morphAttributes;
      for (const o in s) {
        const c = [],
          l = s[o];
        for (let h = 0, f = l.length; h < f; h++) {
          const d = l[h],
            m = e(d, n);
          c.push(m);
        }
        t.morphAttributes[o] = c;
      }
      t.morphTargetsRelative = this.morphTargetsRelative;
      const a = this.groups;
      for (let o = 0, c = a.length; o < c; o++) {
        const l = a[o];
        t.addGroup(l.start, l.count, l.materialIndex);
      }
      return t;
    }
    toJSON() {
      const e = { metadata: { version: 4.7, type: "BufferGeometry", generator: "BufferGeometry.toJSON" } };
      if (
        ((e.uuid = this.uuid),
        (e.type = this.type),
        this.name !== "" && (e.name = this.name),
        Object.keys(this.userData).length > 0 && (e.userData = this.userData),
        this.parameters !== void 0)
      ) {
        const c = this.parameters;
        for (const l in c) c[l] !== void 0 && (e[l] = c[l]);
        return e;
      }
      e.data = { attributes: {} };
      const t = this.index;
      t !== null && (e.data.index = { type: t.array.constructor.name, array: Array.prototype.slice.call(t.array) });
      const n = this.attributes;
      for (const c in n) {
        const l = n[c];
        e.data.attributes[c] = l.toJSON(e.data);
      }
      const r = {};
      let s = !1;
      for (const c in this.morphAttributes) {
        const l = this.morphAttributes[c],
          h = [];
        for (let f = 0, d = l.length; f < d; f++) {
          const m = l[f];
          h.push(m.toJSON(e.data));
        }
        h.length > 0 && ((r[c] = h), (s = !0));
      }
      s && ((e.data.morphAttributes = r), (e.data.morphTargetsRelative = this.morphTargetsRelative));
      const a = this.groups;
      a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
      const o = this.boundingSphere;
      return o !== null && (e.data.boundingSphere = o.toJSON()), e;
    }
    clone() {
      return new this.constructor().copy(this);
    }
    copy(e) {
      (this.index = null),
        (this.attributes = {}),
        (this.morphAttributes = {}),
        (this.groups = []),
        (this.boundingBox = null),
        (this.boundingSphere = null);
      const t = {};
      this.name = e.name;
      const n = e.index;
      n !== null && this.setIndex(n.clone());
      const r = e.attributes;
      for (const l in r) {
        const h = r[l];
        this.setAttribute(l, h.clone(t));
      }
      const s = e.morphAttributes;
      for (const l in s) {
        const h = [],
          f = s[l];
        for (let d = 0, m = f.length; d < m; d++) h.push(f[d].clone(t));
        this.morphAttributes[l] = h;
      }
      this.morphTargetsRelative = e.morphTargetsRelative;
      const a = e.groups;
      for (let l = 0, h = a.length; l < h; l++) {
        const f = a[l];
        this.addGroup(f.start, f.count, f.materialIndex);
      }
      const o = e.boundingBox;
      o !== null && (this.boundingBox = o.clone());
      const c = e.boundingSphere;
      return (
        c !== null && (this.boundingSphere = c.clone()),
        (this.drawRange.start = e.drawRange.start),
        (this.drawRange.count = e.drawRange.count),
        (this.userData = e.userData),
        this
      );
    }
    dispose() {
      this.dispatchEvent({ type: "dispose" });
    }
  }
  const Cr = new ot(),
    sn = new pr(),
    si = new jn(),
    wr = new O(),
    ai = new O(),
    oi = new O(),
    li = new O(),
    Yi = new O(),
    ci = new O(),
    Pr = new O(),
    ui = new O();
  class Xt extends xt {
    constructor(e = new Wt(), t = new Ar()) {
      super(),
        (this.isMesh = !0),
        (this.type = "Mesh"),
        (this.geometry = e),
        (this.material = t),
        (this.morphTargetDictionary = void 0),
        (this.morphTargetInfluences = void 0),
        (this.count = 1),
        this.updateMorphTargets();
    }
    copy(e, t) {
      return (
        super.copy(e, t),
        e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()),
        e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)),
        (this.material = Array.isArray(e.material) ? e.material.slice() : e.material),
        (this.geometry = e.geometry),
        this
      );
    }
    updateMorphTargets() {
      const t = this.geometry.morphAttributes,
        n = Object.keys(t);
      if (n.length > 0) {
        const r = t[n[0]];
        if (r !== void 0) {
          (this.morphTargetInfluences = []), (this.morphTargetDictionary = {});
          for (let s = 0, a = r.length; s < a; s++) {
            const o = r[s].name || String(s);
            this.morphTargetInfluences.push(0), (this.morphTargetDictionary[o] = s);
          }
        }
      }
    }
    getVertexPosition(e, t) {
      const n = this.geometry,
        r = n.attributes.position,
        s = n.morphAttributes.position,
        a = n.morphTargetsRelative;
      t.fromBufferAttribute(r, e);
      const o = this.morphTargetInfluences;
      if (s && o) {
        ci.set(0, 0, 0);
        for (let c = 0, l = s.length; c < l; c++) {
          const h = o[c],
            f = s[c];
          h !== 0 && (Yi.fromBufferAttribute(f, e), a ? ci.addScaledVector(Yi, h) : ci.addScaledVector(Yi.sub(t), h));
        }
        t.add(ci);
      }
      return t;
    }
    raycast(e, t) {
      const n = this.geometry,
        r = this.material,
        s = this.matrixWorld;
      r !== void 0 &&
        (n.boundingSphere === null && n.computeBoundingSphere(),
        si.copy(n.boundingSphere),
        si.applyMatrix4(s),
        sn.copy(e.ray).recast(e.near),
        !(
          si.containsPoint(sn.origin) === !1 &&
          (sn.intersectSphere(si, wr) === null || sn.origin.distanceToSquared(wr) > (e.far - e.near) ** 2)
        ) &&
          (Cr.copy(s).invert(),
          sn.copy(e.ray).applyMatrix4(Cr),
          !(n.boundingBox !== null && sn.intersectsBox(n.boundingBox) === !1) && this._computeIntersections(e, t, sn)));
    }
    _computeIntersections(e, t, n) {
      let r;
      const s = this.geometry,
        a = this.material,
        o = s.index,
        c = s.attributes.position,
        l = s.attributes.uv,
        h = s.attributes.uv1,
        f = s.attributes.normal,
        d = s.groups,
        m = s.drawRange;
      if (o !== null)
        if (Array.isArray(a))
          for (let v = 0, x = d.length; v < x; v++) {
            const p = d[v],
              u = a[p.materialIndex],
              C = Math.max(p.start, m.start),
              y = Math.min(o.count, Math.min(p.start + p.count, m.start + m.count));
            for (let E = C, D = y; E < D; E += 3) {
              const w = o.getX(E),
                P = o.getX(E + 1),
                F = o.getX(E + 2);
              (r = hi(this, u, e, n, l, h, f, w, P, F)),
                r && ((r.faceIndex = Math.floor(E / 3)), (r.face.materialIndex = p.materialIndex), t.push(r));
            }
          }
        else {
          const v = Math.max(0, m.start),
            x = Math.min(o.count, m.start + m.count);
          for (let p = v, u = x; p < u; p += 3) {
            const C = o.getX(p),
              y = o.getX(p + 1),
              E = o.getX(p + 2);
            (r = hi(this, a, e, n, l, h, f, C, y, E)), r && ((r.faceIndex = Math.floor(p / 3)), t.push(r));
          }
        }
      else if (c !== void 0)
        if (Array.isArray(a))
          for (let v = 0, x = d.length; v < x; v++) {
            const p = d[v],
              u = a[p.materialIndex],
              C = Math.max(p.start, m.start),
              y = Math.min(c.count, Math.min(p.start + p.count, m.start + m.count));
            for (let E = C, D = y; E < D; E += 3) {
              const w = E,
                P = E + 1,
                F = E + 2;
              (r = hi(this, u, e, n, l, h, f, w, P, F)),
                r && ((r.faceIndex = Math.floor(E / 3)), (r.face.materialIndex = p.materialIndex), t.push(r));
            }
          }
        else {
          const v = Math.max(0, m.start),
            x = Math.min(c.count, m.start + m.count);
          for (let p = v, u = x; p < u; p += 3) {
            const C = p,
              y = p + 1,
              E = p + 2;
            (r = hi(this, a, e, n, l, h, f, C, y, E)), r && ((r.faceIndex = Math.floor(p / 3)), t.push(r));
          }
        }
    }
  }
  function ks(i, e, t, n, r, s, a, o) {
    let c;
    if (
      (e.side === 1 ? (c = n.intersectTriangle(a, s, r, !0, o)) : (c = n.intersectTriangle(r, s, a, e.side === 0, o)),
      c === null)
    )
      return null;
    ui.copy(o), ui.applyMatrix4(i.matrixWorld);
    const l = t.ray.origin.distanceTo(ui);
    return l < t.near || l > t.far ? null : { distance: l, point: ui.clone(), object: i };
  }
  function hi(i, e, t, n, r, s, a, o, c, l) {
    i.getVertexPosition(o, ai), i.getVertexPosition(c, oi), i.getVertexPosition(l, li);
    const h = ks(i, e, t, n, ai, oi, li, Pr);
    if (h) {
      const f = new O();
      Lt.getBarycoord(Pr, ai, oi, li, f),
        r && (h.uv = Lt.getInterpolatedAttribute(r, o, c, l, f, new qe())),
        s && (h.uv1 = Lt.getInterpolatedAttribute(s, o, c, l, f, new qe())),
        a &&
          ((h.normal = Lt.getInterpolatedAttribute(a, o, c, l, f, new O())),
          h.normal.dot(n.direction) > 0 && h.normal.multiplyScalar(-1));
      const d = { a: o, b: c, c: l, normal: new O(), materialIndex: 0 };
      Lt.getNormal(ai, oi, li, d.normal), (h.face = d), (h.barycoord = f);
    }
    return h;
  }
  class Wn extends Wt {
    constructor(e = 1, t = 1, n = 1, r = 1, s = 1, a = 1) {
      super(),
        (this.type = "BoxGeometry"),
        (this.parameters = { width: e, height: t, depth: n, widthSegments: r, heightSegments: s, depthSegments: a });
      const o = this;
      (r = Math.floor(r)), (s = Math.floor(s)), (a = Math.floor(a));
      const c = [],
        l = [],
        h = [],
        f = [];
      let d = 0,
        m = 0;
      v("z", "y", "x", -1, -1, n, t, e, a, s, 0),
        v("z", "y", "x", 1, -1, n, t, -e, a, s, 1),
        v("x", "z", "y", 1, 1, e, n, t, r, a, 2),
        v("x", "z", "y", 1, -1, e, n, -t, r, a, 3),
        v("x", "y", "z", 1, -1, e, t, n, r, s, 4),
        v("x", "y", "z", -1, -1, e, t, -n, r, s, 5),
        this.setIndex(c),
        this.setAttribute("position", new rn(l, 3)),
        this.setAttribute("normal", new rn(h, 3)),
        this.setAttribute("uv", new rn(f, 2));
      function v(x, p, u, C, y, E, D, w, P, F, M) {
        const S = E / P,
          b = D / F,
          q = E / 2,
          V = D / 2,
          H = w / 2,
          K = P + 1,
          X = F + 1;
        let ee = 0,
          G = 0;
        const se = new O();
        for (let ue = 0; ue < X; ue++) {
          const Me = ue * b - V;
          for (let Fe = 0; Fe < K; Fe++) {
            const Qe = Fe * S - q;
            (se[x] = Qe * C),
              (se[p] = Me * y),
              (se[u] = H),
              l.push(se.x, se.y, se.z),
              (se[x] = 0),
              (se[p] = 0),
              (se[u] = w > 0 ? 1 : -1),
              h.push(se.x, se.y, se.z),
              f.push(Fe / P),
              f.push(1 - ue / F),
              (ee += 1);
          }
        }
        for (let ue = 0; ue < F; ue++)
          for (let Me = 0; Me < P; Me++) {
            const Fe = d + Me + K * ue,
              Qe = d + Me + K * (ue + 1),
              $e = d + (Me + 1) + K * (ue + 1),
              W = d + (Me + 1) + K * ue;
            c.push(Fe, Qe, W), c.push(Qe, $e, W), (G += 6);
          }
        o.addGroup(m, G, M), (m += G), (d += ee);
      }
    }
    copy(e) {
      return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this;
    }
    static fromJSON(e) {
      return new Wn(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
    }
  }
  function Cn(i) {
    const e = {};
    for (const t in i) {
      e[t] = {};
      for (const n in i[t]) {
        const r = i[t][n];
        r &&
        (r.isColor ||
          r.isMatrix3 ||
          r.isMatrix4 ||
          r.isVector2 ||
          r.isVector3 ||
          r.isVector4 ||
          r.isTexture ||
          r.isQuaternion)
          ? r.isRenderTargetTexture
            ? (console.warn(
                "UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."
              ),
              (e[t][n] = null))
            : (e[t][n] = r.clone())
          : Array.isArray(r)
          ? (e[t][n] = r.slice())
          : (e[t][n] = r);
      }
    }
    return e;
  }
  function mt(i) {
    const e = {};
    for (let t = 0; t < i.length; t++) {
      const n = Cn(i[t]);
      for (const r in n) e[r] = n[r];
    }
    return e;
  }
  function Ws(i) {
    const e = [];
    for (let t = 0; t < i.length; t++) e.push(i[t].clone());
    return e;
  }
  function Dr(i) {
    const e = i.getRenderTarget();
    return e === null ? i.outputColorSpace : e.isXRRenderTarget === !0 ? e.texture.colorSpace : ze.workingColorSpace;
  }
  const Xs = { clone: Cn, merge: mt };
  var qs = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`,
    Ys = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
  class qt extends Hn {
    constructor(e) {
      super(),
        (this.isShaderMaterial = !0),
        (this.type = "ShaderMaterial"),
        (this.defines = {}),
        (this.uniforms = {}),
        (this.uniformsGroups = []),
        (this.vertexShader = qs),
        (this.fragmentShader = Ys),
        (this.linewidth = 1),
        (this.wireframe = !1),
        (this.wireframeLinewidth = 1),
        (this.fog = !1),
        (this.lights = !1),
        (this.clipping = !1),
        (this.forceSinglePass = !0),
        (this.extensions = { clipCullDistance: !1, multiDraw: !1 }),
        (this.defaultAttributeValues = { color: [1, 1, 1], uv: [0, 0], uv1: [0, 0] }),
        (this.index0AttributeName = void 0),
        (this.uniformsNeedUpdate = !1),
        (this.glslVersion = null),
        e !== void 0 && this.setValues(e);
    }
    copy(e) {
      return (
        super.copy(e),
        (this.fragmentShader = e.fragmentShader),
        (this.vertexShader = e.vertexShader),
        (this.uniforms = Cn(e.uniforms)),
        (this.uniformsGroups = Ws(e.uniformsGroups)),
        (this.defines = Object.assign({}, e.defines)),
        (this.wireframe = e.wireframe),
        (this.wireframeLinewidth = e.wireframeLinewidth),
        (this.fog = e.fog),
        (this.lights = e.lights),
        (this.clipping = e.clipping),
        (this.extensions = Object.assign({}, e.extensions)),
        (this.glslVersion = e.glslVersion),
        this
      );
    }
    toJSON(e) {
      const t = super.toJSON(e);
      (t.glslVersion = this.glslVersion), (t.uniforms = {});
      for (const r in this.uniforms) {
        const a = this.uniforms[r].value;
        a && a.isTexture
          ? (t.uniforms[r] = { type: "t", value: a.toJSON(e).uuid })
          : a && a.isColor
          ? (t.uniforms[r] = { type: "c", value: a.getHex() })
          : a && a.isVector2
          ? (t.uniforms[r] = { type: "v2", value: a.toArray() })
          : a && a.isVector3
          ? (t.uniforms[r] = { type: "v3", value: a.toArray() })
          : a && a.isVector4
          ? (t.uniforms[r] = { type: "v4", value: a.toArray() })
          : a && a.isMatrix3
          ? (t.uniforms[r] = { type: "m3", value: a.toArray() })
          : a && a.isMatrix4
          ? (t.uniforms[r] = { type: "m4", value: a.toArray() })
          : (t.uniforms[r] = { value: a });
      }
      Object.keys(this.defines).length > 0 && (t.defines = this.defines),
        (t.vertexShader = this.vertexShader),
        (t.fragmentShader = this.fragmentShader),
        (t.lights = this.lights),
        (t.clipping = this.clipping);
      const n = {};
      for (const r in this.extensions) this.extensions[r] === !0 && (n[r] = !0);
      return Object.keys(n).length > 0 && (t.extensions = n), t;
    }
  }
  class Lr extends xt {
    constructor() {
      super(),
        (this.isCamera = !0),
        (this.type = "Camera"),
        (this.matrixWorldInverse = new ot()),
        (this.projectionMatrix = new ot()),
        (this.projectionMatrixInverse = new ot()),
        (this.coordinateSystem = 2e3),
        (this._reversedDepth = !1);
    }
    get reversedDepth() {
      return this._reversedDepth;
    }
    copy(e, t) {
      return (
        super.copy(e, t),
        this.matrixWorldInverse.copy(e.matrixWorldInverse),
        this.projectionMatrix.copy(e.projectionMatrix),
        this.projectionMatrixInverse.copy(e.projectionMatrixInverse),
        (this.coordinateSystem = e.coordinateSystem),
        this
      );
    }
    getWorldDirection(e) {
      return super.getWorldDirection(e).negate();
    }
    updateMatrixWorld(e) {
      super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, t) {
      super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
      return new this.constructor().copy(this);
    }
  }
  const Qt = new O(),
    Ur = new qe(),
    Ir = new qe();
  class It extends Lr {
    constructor(e = 50, t = 1, n = 0.1, r = 2e3) {
      super(),
        (this.isPerspectiveCamera = !0),
        (this.type = "PerspectiveCamera"),
        (this.fov = e),
        (this.zoom = 1),
        (this.near = n),
        (this.far = r),
        (this.focus = 10),
        (this.aspect = t),
        (this.view = null),
        (this.filmGauge = 35),
        (this.filmOffset = 0),
        this.updateProjectionMatrix();
    }
    copy(e, t) {
      return (
        super.copy(e, t),
        (this.fov = e.fov),
        (this.zoom = e.zoom),
        (this.near = e.near),
        (this.far = e.far),
        (this.focus = e.focus),
        (this.aspect = e.aspect),
        (this.view = e.view === null ? null : Object.assign({}, e.view)),
        (this.filmGauge = e.filmGauge),
        (this.filmOffset = e.filmOffset),
        this
      );
    }
    setFocalLength(e) {
      const t = (0.5 * this.getFilmHeight()) / e;
      (this.fov = Ai * 2 * Math.atan(t)), this.updateProjectionMatrix();
    }
    getFocalLength() {
      const e = Math.tan(yi * 0.5 * this.fov);
      return (0.5 * this.getFilmHeight()) / e;
    }
    getEffectiveFOV() {
      return Ai * 2 * Math.atan(Math.tan(yi * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
      return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
      return this.filmGauge / Math.max(this.aspect, 1);
    }
    getViewBounds(e, t, n) {
      Qt.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse),
        t.set(Qt.x, Qt.y).multiplyScalar(-e / Qt.z),
        Qt.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse),
        n.set(Qt.x, Qt.y).multiplyScalar(-e / Qt.z);
    }
    getViewSize(e, t) {
      return this.getViewBounds(e, Ur, Ir), t.subVectors(Ir, Ur);
    }
    setViewOffset(e, t, n, r, s, a) {
      (this.aspect = e / t),
        this.view === null &&
          (this.view = { enabled: !0, fullWidth: 1, fullHeight: 1, offsetX: 0, offsetY: 0, width: 1, height: 1 }),
        (this.view.enabled = !0),
        (this.view.fullWidth = e),
        (this.view.fullHeight = t),
        (this.view.offsetX = n),
        (this.view.offsetY = r),
        (this.view.width = s),
        (this.view.height = a),
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
      this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
      const e = this.near;
      let t = (e * Math.tan(yi * 0.5 * this.fov)) / this.zoom,
        n = 2 * t,
        r = this.aspect * n,
        s = -0.5 * r;
      const a = this.view;
      if (this.view !== null && this.view.enabled) {
        const c = a.fullWidth,
          l = a.fullHeight;
        (s += (a.offsetX * r) / c), (t -= (a.offsetY * n) / l), (r *= a.width / c), (n *= a.height / l);
      }
      const o = this.filmOffset;
      o !== 0 && (s += (e * o) / this.getFilmWidth()),
        this.projectionMatrix.makePerspective(
          s,
          s + r,
          t,
          t - n,
          e,
          this.far,
          this.coordinateSystem,
          this.reversedDepth
        ),
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
      const t = super.toJSON(e);
      return (
        (t.object.fov = this.fov),
        (t.object.zoom = this.zoom),
        (t.object.near = this.near),
        (t.object.far = this.far),
        (t.object.focus = this.focus),
        (t.object.aspect = this.aspect),
        this.view !== null && (t.object.view = Object.assign({}, this.view)),
        (t.object.filmGauge = this.filmGauge),
        (t.object.filmOffset = this.filmOffset),
        t
      );
    }
  }
  const wn = -90,
    Pn = 1;
  class $s extends xt {
    constructor(e, t, n) {
      super(),
        (this.type = "CubeCamera"),
        (this.renderTarget = n),
        (this.coordinateSystem = null),
        (this.activeMipmapLevel = 0);
      const r = new It(wn, Pn, e, t);
      (r.layers = this.layers), this.add(r);
      const s = new It(wn, Pn, e, t);
      (s.layers = this.layers), this.add(s);
      const a = new It(wn, Pn, e, t);
      (a.layers = this.layers), this.add(a);
      const o = new It(wn, Pn, e, t);
      (o.layers = this.layers), this.add(o);
      const c = new It(wn, Pn, e, t);
      (c.layers = this.layers), this.add(c);
      const l = new It(wn, Pn, e, t);
      (l.layers = this.layers), this.add(l);
    }
    updateCoordinateSystem() {
      const e = this.coordinateSystem,
        t = this.children.concat(),
        [n, r, s, a, o, c] = t;
      for (const l of t) this.remove(l);
      if (e === 2e3)
        n.up.set(0, 1, 0),
          n.lookAt(1, 0, 0),
          r.up.set(0, 1, 0),
          r.lookAt(-1, 0, 0),
          s.up.set(0, 0, -1),
          s.lookAt(0, 1, 0),
          a.up.set(0, 0, 1),
          a.lookAt(0, -1, 0),
          o.up.set(0, 1, 0),
          o.lookAt(0, 0, 1),
          c.up.set(0, 1, 0),
          c.lookAt(0, 0, -1);
      else if (e === 2001)
        n.up.set(0, -1, 0),
          n.lookAt(-1, 0, 0),
          r.up.set(0, -1, 0),
          r.lookAt(1, 0, 0),
          s.up.set(0, 0, 1),
          s.lookAt(0, 1, 0),
          a.up.set(0, 0, -1),
          a.lookAt(0, -1, 0),
          o.up.set(0, -1, 0),
          o.lookAt(0, 0, 1),
          c.up.set(0, -1, 0),
          c.lookAt(0, 0, -1);
      else throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e);
      for (const l of t) this.add(l), l.updateMatrixWorld();
    }
    update(e, t) {
      this.parent === null && this.updateMatrixWorld();
      const { renderTarget: n, activeMipmapLevel: r } = this;
      this.coordinateSystem !== e.coordinateSystem &&
        ((this.coordinateSystem = e.coordinateSystem), this.updateCoordinateSystem());
      const [s, a, o, c, l, h] = this.children,
        f = e.getRenderTarget(),
        d = e.getActiveCubeFace(),
        m = e.getActiveMipmapLevel(),
        v = e.xr.enabled;
      e.xr.enabled = !1;
      const x = n.texture.generateMipmaps;
      (n.texture.generateMipmaps = !1),
        e.setRenderTarget(n, 0, r),
        e.render(t, s),
        e.setRenderTarget(n, 1, r),
        e.render(t, a),
        e.setRenderTarget(n, 2, r),
        e.render(t, o),
        e.setRenderTarget(n, 3, r),
        e.render(t, c),
        e.setRenderTarget(n, 4, r),
        e.render(t, l),
        (n.texture.generateMipmaps = x),
        e.setRenderTarget(n, 5, r),
        e.render(t, h),
        e.setRenderTarget(f, d, m),
        (e.xr.enabled = v),
        (n.texture.needsPMREMUpdate = !0);
    }
  }
  class Fr extends vt {
    constructor(e = [], t = 301, n, r, s, a, o, c, l, h) {
      super(e, t, n, r, s, a, o, c, l, h), (this.isCubeTexture = !0), (this.flipY = !1);
    }
    get images() {
      return this.image;
    }
    set images(e) {
      this.image = e;
    }
  }
  class Ks extends en {
    constructor(e = 1, t = {}) {
      super(e, e, t), (this.isWebGLCubeRenderTarget = !0);
      const n = { width: e, height: e, depth: 1 },
        r = [n, n, n, n, n, n];
      (this.texture = new Fr(r)), this._setTextureOptions(t), (this.texture.isRenderTargetTexture = !0);
    }
    fromEquirectangularTexture(e, t) {
      (this.texture.type = t.type),
        (this.texture.colorSpace = t.colorSpace),
        (this.texture.generateMipmaps = t.generateMipmaps),
        (this.texture.minFilter = t.minFilter),
        (this.texture.magFilter = t.magFilter);
      const n = {
          uniforms: { tEquirect: { value: null } },
          vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
          fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        },
        r = new Wn(5, 5, 5),
        s = new qt({
          name: "CubemapFromEquirect",
          uniforms: Cn(n.uniforms),
          vertexShader: n.vertexShader,
          fragmentShader: n.fragmentShader,
          side: 1,
          blending: 0
        });
      s.uniforms.tEquirect.value = t;
      const a = new Xt(r, s),
        o = t.minFilter;
      return (
        t.minFilter === 1008 && (t.minFilter = 1006),
        new $s(1, 10, this).update(e, a),
        (t.minFilter = o),
        a.geometry.dispose(),
        a.material.dispose(),
        this
      );
    }
    clear(e, t = !0, n = !0, r = !0) {
      const s = e.getRenderTarget();
      for (let a = 0; a < 6; a++) e.setRenderTarget(this, a), e.clear(t, n, r);
      e.setRenderTarget(s);
    }
  }
  class fi extends xt {
    constructor() {
      super(), (this.isGroup = !0), (this.type = "Group");
    }
  }
  const Zs = { type: "move" };
  class $i {
    constructor() {
      (this._targetRay = null), (this._grip = null), (this._hand = null);
    }
    getHandSpace() {
      return (
        this._hand === null &&
          ((this._hand = new fi()),
          (this._hand.matrixAutoUpdate = !1),
          (this._hand.visible = !1),
          (this._hand.joints = {}),
          (this._hand.inputState = { pinching: !1 })),
        this._hand
      );
    }
    getTargetRaySpace() {
      return (
        this._targetRay === null &&
          ((this._targetRay = new fi()),
          (this._targetRay.matrixAutoUpdate = !1),
          (this._targetRay.visible = !1),
          (this._targetRay.hasLinearVelocity = !1),
          (this._targetRay.linearVelocity = new O()),
          (this._targetRay.hasAngularVelocity = !1),
          (this._targetRay.angularVelocity = new O())),
        this._targetRay
      );
    }
    getGripSpace() {
      return (
        this._grip === null &&
          ((this._grip = new fi()),
          (this._grip.matrixAutoUpdate = !1),
          (this._grip.visible = !1),
          (this._grip.hasLinearVelocity = !1),
          (this._grip.linearVelocity = new O()),
          (this._grip.hasAngularVelocity = !1),
          (this._grip.angularVelocity = new O())),
        this._grip
      );
    }
    dispatchEvent(e) {
      return (
        this._targetRay !== null && this._targetRay.dispatchEvent(e),
        this._grip !== null && this._grip.dispatchEvent(e),
        this._hand !== null && this._hand.dispatchEvent(e),
        this
      );
    }
    connect(e) {
      if (e && e.hand) {
        const t = this._hand;
        if (t) for (const n of e.hand.values()) this._getHandJoint(t, n);
      }
      return this.dispatchEvent({ type: "connected", data: e }), this;
    }
    disconnect(e) {
      return (
        this.dispatchEvent({ type: "disconnected", data: e }),
        this._targetRay !== null && (this._targetRay.visible = !1),
        this._grip !== null && (this._grip.visible = !1),
        this._hand !== null && (this._hand.visible = !1),
        this
      );
    }
    update(e, t, n) {
      let r = null,
        s = null,
        a = null;
      const o = this._targetRay,
        c = this._grip,
        l = this._hand;
      if (e && t.session.visibilityState !== "visible-blurred") {
        if (l && e.hand) {
          a = !0;
          for (const x of e.hand.values()) {
            const p = t.getJointPose(x, n),
              u = this._getHandJoint(l, x);
            p !== null &&
              (u.matrix.fromArray(p.transform.matrix),
              u.matrix.decompose(u.position, u.rotation, u.scale),
              (u.matrixWorldNeedsUpdate = !0),
              (u.jointRadius = p.radius)),
              (u.visible = p !== null);
          }
          const h = l.joints["index-finger-tip"],
            f = l.joints["thumb-tip"],
            d = h.position.distanceTo(f.position),
            m = 0.02,
            v = 0.005;
          l.inputState.pinching && d > m + v
            ? ((l.inputState.pinching = !1),
              this.dispatchEvent({ type: "pinchend", handedness: e.handedness, target: this }))
            : !l.inputState.pinching &&
              d <= m - v &&
              ((l.inputState.pinching = !0),
              this.dispatchEvent({ type: "pinchstart", handedness: e.handedness, target: this }));
        } else
          c !== null &&
            e.gripSpace &&
            ((s = t.getPose(e.gripSpace, n)),
            s !== null &&
              (c.matrix.fromArray(s.transform.matrix),
              c.matrix.decompose(c.position, c.rotation, c.scale),
              (c.matrixWorldNeedsUpdate = !0),
              s.linearVelocity
                ? ((c.hasLinearVelocity = !0), c.linearVelocity.copy(s.linearVelocity))
                : (c.hasLinearVelocity = !1),
              s.angularVelocity
                ? ((c.hasAngularVelocity = !0), c.angularVelocity.copy(s.angularVelocity))
                : (c.hasAngularVelocity = !1)));
        o !== null &&
          ((r = t.getPose(e.targetRaySpace, n)),
          r === null && s !== null && (r = s),
          r !== null &&
            (o.matrix.fromArray(r.transform.matrix),
            o.matrix.decompose(o.position, o.rotation, o.scale),
            (o.matrixWorldNeedsUpdate = !0),
            r.linearVelocity
              ? ((o.hasLinearVelocity = !0), o.linearVelocity.copy(r.linearVelocity))
              : (o.hasLinearVelocity = !1),
            r.angularVelocity
              ? ((o.hasAngularVelocity = !0), o.angularVelocity.copy(r.angularVelocity))
              : (o.hasAngularVelocity = !1),
            this.dispatchEvent(Zs)));
      }
      return (
        o !== null && (o.visible = r !== null),
        c !== null && (c.visible = s !== null),
        l !== null && (l.visible = a !== null),
        this
      );
    }
    _getHandJoint(e, t) {
      if (e.joints[t.jointName] === void 0) {
        const n = new fi();
        (n.matrixAutoUpdate = !1), (n.visible = !1), (e.joints[t.jointName] = n), e.add(n);
      }
      return e.joints[t.jointName];
    }
  }
  class Js extends xt {
    constructor() {
      super(),
        (this.isScene = !0),
        (this.type = "Scene"),
        (this.background = null),
        (this.environment = null),
        (this.fog = null),
        (this.backgroundBlurriness = 0),
        (this.backgroundIntensity = 1),
        (this.backgroundRotation = new zt()),
        (this.environmentIntensity = 1),
        (this.environmentRotation = new zt()),
        (this.overrideMaterial = null),
        typeof __THREE_DEVTOOLS__ < "u" &&
          __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
    copy(e, t) {
      return (
        super.copy(e, t),
        e.background !== null && (this.background = e.background.clone()),
        e.environment !== null && (this.environment = e.environment.clone()),
        e.fog !== null && (this.fog = e.fog.clone()),
        (this.backgroundBlurriness = e.backgroundBlurriness),
        (this.backgroundIntensity = e.backgroundIntensity),
        this.backgroundRotation.copy(e.backgroundRotation),
        (this.environmentIntensity = e.environmentIntensity),
        this.environmentRotation.copy(e.environmentRotation),
        e.overrideMaterial !== null && (this.overrideMaterial = e.overrideMaterial.clone()),
        (this.matrixAutoUpdate = e.matrixAutoUpdate),
        this
      );
    }
    toJSON(e) {
      const t = super.toJSON(e);
      return (
        this.fog !== null && (t.object.fog = this.fog.toJSON()),
        this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness),
        this.backgroundIntensity !== 1 && (t.object.backgroundIntensity = this.backgroundIntensity),
        (t.object.backgroundRotation = this.backgroundRotation.toArray()),
        this.environmentIntensity !== 1 && (t.object.environmentIntensity = this.environmentIntensity),
        (t.object.environmentRotation = this.environmentRotation.toArray()),
        t
      );
    }
  }
  const Ki = new O(),
    js = new O(),
    Qs = new Le();
  class an {
    constructor(e = new O(1, 0, 0), t = 0) {
      (this.isPlane = !0), (this.normal = e), (this.constant = t);
    }
    set(e, t) {
      return this.normal.copy(e), (this.constant = t), this;
    }
    setComponents(e, t, n, r) {
      return this.normal.set(e, t, n), (this.constant = r), this;
    }
    setFromNormalAndCoplanarPoint(e, t) {
      return this.normal.copy(e), (this.constant = -t.dot(this.normal)), this;
    }
    setFromCoplanarPoints(e, t, n) {
      const r = Ki.subVectors(n, t).cross(js.subVectors(e, t)).normalize();
      return this.setFromNormalAndCoplanarPoint(r, e), this;
    }
    copy(e) {
      return this.normal.copy(e.normal), (this.constant = e.constant), this;
    }
    normalize() {
      const e = 1 / this.normal.length();
      return this.normal.multiplyScalar(e), (this.constant *= e), this;
    }
    negate() {
      return (this.constant *= -1), this.normal.negate(), this;
    }
    distanceToPoint(e) {
      return this.normal.dot(e) + this.constant;
    }
    distanceToSphere(e) {
      return this.distanceToPoint(e.center) - e.radius;
    }
    projectPoint(e, t) {
      return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e));
    }
    intersectLine(e, t) {
      const n = e.delta(Ki),
        r = this.normal.dot(n);
      if (r === 0) return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
      const s = -(e.start.dot(this.normal) + this.constant) / r;
      return s < 0 || s > 1 ? null : t.copy(e.start).addScaledVector(n, s);
    }
    intersectsLine(e) {
      const t = this.distanceToPoint(e.start),
        n = this.distanceToPoint(e.end);
      return (t < 0 && n > 0) || (n < 0 && t > 0);
    }
    intersectsBox(e) {
      return e.intersectsPlane(this);
    }
    intersectsSphere(e) {
      return e.intersectsPlane(this);
    }
    coplanarPoint(e) {
      return e.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(e, t) {
      const n = t || Qs.getNormalMatrix(e),
        r = this.coplanarPoint(Ki).applyMatrix4(e),
        s = this.normal.applyMatrix3(n).normalize();
      return (this.constant = -r.dot(s)), this;
    }
    translate(e) {
      return (this.constant -= e.dot(this.normal)), this;
    }
    equals(e) {
      return e.normal.equals(this.normal) && e.constant === this.constant;
    }
    clone() {
      return new this.constructor().copy(this);
    }
  }
  const on = new jn(),
    ea = new qe(0.5, 0.5),
    di = new O();
  class Nr {
    constructor(e = new an(), t = new an(), n = new an(), r = new an(), s = new an(), a = new an()) {
      this.planes = [e, t, n, r, s, a];
    }
    set(e, t, n, r, s, a) {
      const o = this.planes;
      return o[0].copy(e), o[1].copy(t), o[2].copy(n), o[3].copy(r), o[4].copy(s), o[5].copy(a), this;
    }
    copy(e) {
      const t = this.planes;
      for (let n = 0; n < 6; n++) t[n].copy(e.planes[n]);
      return this;
    }
    setFromProjectionMatrix(e, t = 2e3, n = !1) {
      const r = this.planes,
        s = e.elements,
        a = s[0],
        o = s[1],
        c = s[2],
        l = s[3],
        h = s[4],
        f = s[5],
        d = s[6],
        m = s[7],
        v = s[8],
        x = s[9],
        p = s[10],
        u = s[11],
        C = s[12],
        y = s[13],
        E = s[14],
        D = s[15];
      if (
        (r[0].setComponents(l - a, m - h, u - v, D - C).normalize(),
        r[1].setComponents(l + a, m + h, u + v, D + C).normalize(),
        r[2].setComponents(l + o, m + f, u + x, D + y).normalize(),
        r[3].setComponents(l - o, m - f, u - x, D - y).normalize(),
        n)
      )
        r[4].setComponents(c, d, p, E).normalize(), r[5].setComponents(l - c, m - d, u - p, D - E).normalize();
      else if ((r[4].setComponents(l - c, m - d, u - p, D - E).normalize(), t === 2e3))
        r[5].setComponents(l + c, m + d, u + p, D + E).normalize();
      else if (t === 2001) r[5].setComponents(c, d, p, E).normalize();
      else throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
      return this;
    }
    intersectsObject(e) {
      if (e.boundingSphere !== void 0)
        e.boundingSphere === null && e.computeBoundingSphere(), on.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);
      else {
        const t = e.geometry;
        t.boundingSphere === null && t.computeBoundingSphere(), on.copy(t.boundingSphere).applyMatrix4(e.matrixWorld);
      }
      return this.intersectsSphere(on);
    }
    intersectsSprite(e) {
      on.center.set(0, 0, 0);
      const t = ea.distanceTo(e.center);
      return (on.radius = 0.7071067811865476 + t), on.applyMatrix4(e.matrixWorld), this.intersectsSphere(on);
    }
    intersectsSphere(e) {
      const t = this.planes,
        n = e.center,
        r = -e.radius;
      for (let s = 0; s < 6; s++) if (t[s].distanceToPoint(n) < r) return !1;
      return !0;
    }
    intersectsBox(e) {
      const t = this.planes;
      for (let n = 0; n < 6; n++) {
        const r = t[n];
        if (
          ((di.x = r.normal.x > 0 ? e.max.x : e.min.x),
          (di.y = r.normal.y > 0 ? e.max.y : e.min.y),
          (di.z = r.normal.z > 0 ? e.max.z : e.min.z),
          r.distanceToPoint(di) < 0)
        )
          return !1;
      }
      return !0;
    }
    containsPoint(e) {
      const t = this.planes;
      for (let n = 0; n < 6; n++) if (t[n].distanceToPoint(e) < 0) return !1;
      return !0;
    }
    clone() {
      return new this.constructor().copy(this);
    }
  }
  class ta extends Hn {
    constructor(e) {
      super(),
        (this.isPointsMaterial = !0),
        (this.type = "PointsMaterial"),
        (this.color = new ke(16777215)),
        (this.map = null),
        (this.alphaMap = null),
        (this.size = 1),
        (this.sizeAttenuation = !0),
        (this.fog = !0),
        this.setValues(e);
    }
    copy(e) {
      return (
        super.copy(e),
        this.color.copy(e.color),
        (this.map = e.map),
        (this.alphaMap = e.alphaMap),
        (this.size = e.size),
        (this.sizeAttenuation = e.sizeAttenuation),
        (this.fog = e.fog),
        this
      );
    }
  }
  const Or = new ot(),
    Zi = new pr(),
    pi = new jn(),
    mi = new O();
  class na extends xt {
    constructor(e = new Wt(), t = new ta()) {
      super(),
        (this.isPoints = !0),
        (this.type = "Points"),
        (this.geometry = e),
        (this.material = t),
        (this.morphTargetDictionary = void 0),
        (this.morphTargetInfluences = void 0),
        this.updateMorphTargets();
    }
    copy(e, t) {
      return (
        super.copy(e, t),
        (this.material = Array.isArray(e.material) ? e.material.slice() : e.material),
        (this.geometry = e.geometry),
        this
      );
    }
    raycast(e, t) {
      const n = this.geometry,
        r = this.matrixWorld,
        s = e.params.Points.threshold,
        a = n.drawRange;
      if (
        (n.boundingSphere === null && n.computeBoundingSphere(),
        pi.copy(n.boundingSphere),
        pi.applyMatrix4(r),
        (pi.radius += s),
        e.ray.intersectsSphere(pi) === !1)
      )
        return;
      Or.copy(r).invert(), Zi.copy(e.ray).applyMatrix4(Or);
      const o = s / ((this.scale.x + this.scale.y + this.scale.z) / 3),
        c = o * o,
        l = n.index,
        f = n.attributes.position;
      if (l !== null) {
        const d = Math.max(0, a.start),
          m = Math.min(l.count, a.start + a.count);
        for (let v = d, x = m; v < x; v++) {
          const p = l.getX(v);
          mi.fromBufferAttribute(f, p), Br(mi, p, c, r, e, t, this);
        }
      } else {
        const d = Math.max(0, a.start),
          m = Math.min(f.count, a.start + a.count);
        for (let v = d, x = m; v < x; v++) mi.fromBufferAttribute(f, v), Br(mi, v, c, r, e, t, this);
      }
    }
    updateMorphTargets() {
      const t = this.geometry.morphAttributes,
        n = Object.keys(t);
      if (n.length > 0) {
        const r = t[n[0]];
        if (r !== void 0) {
          (this.morphTargetInfluences = []), (this.morphTargetDictionary = {});
          for (let s = 0, a = r.length; s < a; s++) {
            const o = r[s].name || String(s);
            this.morphTargetInfluences.push(0), (this.morphTargetDictionary[o] = s);
          }
        }
      }
    }
  }
  function Br(i, e, t, n, r, s, a) {
    const o = Zi.distanceSqToPoint(i);
    if (o < t) {
      const c = new O();
      Zi.closestPointToPoint(i, c), c.applyMatrix4(n);
      const l = r.ray.origin.distanceTo(c);
      if (l < r.near || l > r.far) return;
      s.push({
        distance: l,
        distanceToRay: Math.sqrt(o),
        point: c,
        index: e,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: a
      });
    }
  }
  class Gr extends vt {
    constructor(e, t, n = 1014, r, s, a, o = 1003, c = 1003, l, h = 1026, f = 1) {
      if (h !== 1026 && h !== 1027)
        throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
      const d = { width: e, height: t, depth: f };
      super(d, r, s, a, o, c, h, n, l),
        (this.isDepthTexture = !0),
        (this.flipY = !1),
        (this.generateMipmaps = !1),
        (this.compareFunction = null);
    }
    copy(e) {
      return (
        super.copy(e),
        (this.source = new wi(Object.assign({}, e.image))),
        (this.compareFunction = e.compareFunction),
        this
      );
    }
    toJSON(e) {
      const t = super.toJSON(e);
      return this.compareFunction !== null && (t.compareFunction = this.compareFunction), t;
    }
  }
  class _i extends Wt {
    constructor(e = 1, t = 1, n = 1, r = 1) {
      super(),
        (this.type = "PlaneGeometry"),
        (this.parameters = { width: e, height: t, widthSegments: n, heightSegments: r });
      const s = e / 2,
        a = t / 2,
        o = Math.floor(n),
        c = Math.floor(r),
        l = o + 1,
        h = c + 1,
        f = e / o,
        d = t / c,
        m = [],
        v = [],
        x = [],
        p = [];
      for (let u = 0; u < h; u++) {
        const C = u * d - a;
        for (let y = 0; y < l; y++) {
          const E = y * f - s;
          v.push(E, -C, 0), x.push(0, 0, 1), p.push(y / o), p.push(1 - u / c);
        }
      }
      for (let u = 0; u < c; u++)
        for (let C = 0; C < o; C++) {
          const y = C + l * u,
            E = C + l * (u + 1),
            D = C + 1 + l * (u + 1),
            w = C + 1 + l * u;
          m.push(y, E, w), m.push(E, D, w);
        }
      this.setIndex(m),
        this.setAttribute("position", new rn(v, 3)),
        this.setAttribute("normal", new rn(x, 3)),
        this.setAttribute("uv", new rn(p, 2));
    }
    copy(e) {
      return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this;
    }
    static fromJSON(e) {
      return new _i(e.width, e.height, e.widthSegments, e.heightSegments);
    }
  }
  class ia extends Hn {
    constructor(e) {
      super(),
        (this.isMeshDepthMaterial = !0),
        (this.type = "MeshDepthMaterial"),
        (this.depthPacking = 3200),
        (this.map = null),
        (this.alphaMap = null),
        (this.displacementMap = null),
        (this.displacementScale = 1),
        (this.displacementBias = 0),
        (this.wireframe = !1),
        (this.wireframeLinewidth = 1),
        this.setValues(e);
    }
    copy(e) {
      return (
        super.copy(e),
        (this.depthPacking = e.depthPacking),
        (this.map = e.map),
        (this.alphaMap = e.alphaMap),
        (this.displacementMap = e.displacementMap),
        (this.displacementScale = e.displacementScale),
        (this.displacementBias = e.displacementBias),
        (this.wireframe = e.wireframe),
        (this.wireframeLinewidth = e.wireframeLinewidth),
        this
      );
    }
  }
  class ra extends Hn {
    constructor(e) {
      super(),
        (this.isMeshDistanceMaterial = !0),
        (this.type = "MeshDistanceMaterial"),
        (this.map = null),
        (this.alphaMap = null),
        (this.displacementMap = null),
        (this.displacementScale = 1),
        (this.displacementBias = 0),
        this.setValues(e);
    }
    copy(e) {
      return (
        super.copy(e),
        (this.map = e.map),
        (this.alphaMap = e.alphaMap),
        (this.displacementMap = e.displacementMap),
        (this.displacementScale = e.displacementScale),
        (this.displacementBias = e.displacementBias),
        this
      );
    }
  }
  class zr extends Lr {
    constructor(e = -1, t = 1, n = 1, r = -1, s = 0.1, a = 2e3) {
      super(),
        (this.isOrthographicCamera = !0),
        (this.type = "OrthographicCamera"),
        (this.zoom = 1),
        (this.view = null),
        (this.left = e),
        (this.right = t),
        (this.top = n),
        (this.bottom = r),
        (this.near = s),
        (this.far = a),
        this.updateProjectionMatrix();
    }
    copy(e, t) {
      return (
        super.copy(e, t),
        (this.left = e.left),
        (this.right = e.right),
        (this.top = e.top),
        (this.bottom = e.bottom),
        (this.near = e.near),
        (this.far = e.far),
        (this.zoom = e.zoom),
        (this.view = e.view === null ? null : Object.assign({}, e.view)),
        this
      );
    }
    setViewOffset(e, t, n, r, s, a) {
      this.view === null &&
        (this.view = { enabled: !0, fullWidth: 1, fullHeight: 1, offsetX: 0, offsetY: 0, width: 1, height: 1 }),
        (this.view.enabled = !0),
        (this.view.fullWidth = e),
        (this.view.fullHeight = t),
        (this.view.offsetX = n),
        (this.view.offsetY = r),
        (this.view.width = s),
        (this.view.height = a),
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
      this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
      const e = (this.right - this.left) / (2 * this.zoom),
        t = (this.top - this.bottom) / (2 * this.zoom),
        n = (this.right + this.left) / 2,
        r = (this.top + this.bottom) / 2;
      let s = n - e,
        a = n + e,
        o = r + t,
        c = r - t;
      if (this.view !== null && this.view.enabled) {
        const l = (this.right - this.left) / this.view.fullWidth / this.zoom,
          h = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
        (s += l * this.view.offsetX),
          (a = s + l * this.view.width),
          (o -= h * this.view.offsetY),
          (c = o - h * this.view.height);
      }
      this.projectionMatrix.makeOrthographic(
        s,
        a,
        o,
        c,
        this.near,
        this.far,
        this.coordinateSystem,
        this.reversedDepth
      ),
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(e) {
      const t = super.toJSON(e);
      return (
        (t.object.zoom = this.zoom),
        (t.object.left = this.left),
        (t.object.right = this.right),
        (t.object.top = this.top),
        (t.object.bottom = this.bottom),
        (t.object.near = this.near),
        (t.object.far = this.far),
        this.view !== null && (t.object.view = Object.assign({}, this.view)),
        t
      );
    }
  }
  class sa extends It {
    constructor(e = []) {
      super(), (this.isArrayCamera = !0), (this.isMultiViewCamera = !1), (this.cameras = e);
    }
  }
  function Vr(i, e, t, n) {
    const r = aa(n);
    switch (t) {
      case 1021:
        return i * e;
      case 1028:
        return ((i * e) / r.components) * r.byteLength;
      case 1029:
        return ((i * e) / r.components) * r.byteLength;
      case 1030:
        return ((i * e * 2) / r.components) * r.byteLength;
      case 1031:
        return ((i * e * 2) / r.components) * r.byteLength;
      case 1022:
        return ((i * e * 3) / r.components) * r.byteLength;
      case 1023:
        return ((i * e * 4) / r.components) * r.byteLength;
      case 1033:
        return ((i * e * 4) / r.components) * r.byteLength;
      case 33776:
      case 33777:
        return Math.floor((i + 3) / 4) * Math.floor((e + 3) / 4) * 8;
      case 33778:
      case 33779:
        return Math.floor((i + 3) / 4) * Math.floor((e + 3) / 4) * 16;
      case 35841:
      case 35843:
        return (Math.max(i, 16) * Math.max(e, 8)) / 4;
      case 35840:
      case 35842:
        return (Math.max(i, 8) * Math.max(e, 8)) / 2;
      case 36196:
      case 37492:
        return Math.floor((i + 3) / 4) * Math.floor((e + 3) / 4) * 8;
      case 37496:
        return Math.floor((i + 3) / 4) * Math.floor((e + 3) / 4) * 16;
      case 37808:
        return Math.floor((i + 3) / 4) * Math.floor((e + 3) / 4) * 16;
      case 37809:
        return Math.floor((i + 4) / 5) * Math.floor((e + 3) / 4) * 16;
      case 37810:
        return Math.floor((i + 4) / 5) * Math.floor((e + 4) / 5) * 16;
      case 37811:
        return Math.floor((i + 5) / 6) * Math.floor((e + 4) / 5) * 16;
      case 37812:
        return Math.floor((i + 5) / 6) * Math.floor((e + 5) / 6) * 16;
      case 37813:
        return Math.floor((i + 7) / 8) * Math.floor((e + 4) / 5) * 16;
      case 37814:
        return Math.floor((i + 7) / 8) * Math.floor((e + 5) / 6) * 16;
      case 37815:
        return Math.floor((i + 7) / 8) * Math.floor((e + 7) / 8) * 16;
      case 37816:
        return Math.floor((i + 9) / 10) * Math.floor((e + 4) / 5) * 16;
      case 37817:
        return Math.floor((i + 9) / 10) * Math.floor((e + 5) / 6) * 16;
      case 37818:
        return Math.floor((i + 9) / 10) * Math.floor((e + 7) / 8) * 16;
      case 37819:
        return Math.floor((i + 9) / 10) * Math.floor((e + 9) / 10) * 16;
      case 37820:
        return Math.floor((i + 11) / 12) * Math.floor((e + 9) / 10) * 16;
      case 37821:
        return Math.floor((i + 11) / 12) * Math.floor((e + 11) / 12) * 16;
      case 36492:
      case 36494:
      case 36495:
        return Math.ceil(i / 4) * Math.ceil(e / 4) * 16;
      case 36283:
      case 36284:
        return Math.ceil(i / 4) * Math.ceil(e / 4) * 8;
      case 36285:
      case 36286:
        return Math.ceil(i / 4) * Math.ceil(e / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${t} format.`);
  }
  function aa(i) {
    switch (i) {
      case 1009:
      case 1010:
        return { byteLength: 1, components: 1 };
      case 1012:
      case 1011:
      case 1016:
        return { byteLength: 2, components: 1 };
      case 1017:
      case 1018:
        return { byteLength: 2, components: 4 };
      case 1014:
      case 1013:
      case 1015:
        return { byteLength: 4, components: 1 };
      case 35902:
        return { byteLength: 4, components: 3 };
    }
    throw new Error(`Unknown texture type ${i}.`);
  }
  typeof __THREE_DEVTOOLS__ < "u" &&
    __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: { revision: "179" } })),
    typeof window < "u" &&
      (window.__THREE__
        ? console.warn("WARNING: Multiple instances of Three.js being imported.")
        : (window.__THREE__ = "179"));
  function Hr() {
    let i = null,
      e = !1,
      t = null,
      n = null;
    function r(s, a) {
      t(s, a), (n = i.requestAnimationFrame(r));
    }
    return {
      start: function () {
        e !== !0 && t !== null && ((n = i.requestAnimationFrame(r)), (e = !0));
      },
      stop: function () {
        i.cancelAnimationFrame(n), (e = !1);
      },
      setAnimationLoop: function (s) {
        t = s;
      },
      setContext: function (s) {
        i = s;
      }
    };
  }
  function oa(i) {
    const e = new WeakMap();
    function t(o, c) {
      const l = o.array,
        h = o.usage,
        f = l.byteLength,
        d = i.createBuffer();
      i.bindBuffer(c, d), i.bufferData(c, l, h), o.onUploadCallback();
      let m;
      if (l instanceof Float32Array) m = i.FLOAT;
      else if (typeof Float16Array < "u" && l instanceof Float16Array) m = i.HALF_FLOAT;
      else if (l instanceof Uint16Array) o.isFloat16BufferAttribute ? (m = i.HALF_FLOAT) : (m = i.UNSIGNED_SHORT);
      else if (l instanceof Int16Array) m = i.SHORT;
      else if (l instanceof Uint32Array) m = i.UNSIGNED_INT;
      else if (l instanceof Int32Array) m = i.INT;
      else if (l instanceof Int8Array) m = i.BYTE;
      else if (l instanceof Uint8Array) m = i.UNSIGNED_BYTE;
      else if (l instanceof Uint8ClampedArray) m = i.UNSIGNED_BYTE;
      else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + l);
      return { buffer: d, type: m, bytesPerElement: l.BYTES_PER_ELEMENT, version: o.version, size: f };
    }
    function n(o, c, l) {
      const h = c.array,
        f = c.updateRanges;
      if ((i.bindBuffer(l, o), f.length === 0)) i.bufferSubData(l, 0, h);
      else {
        f.sort((m, v) => m.start - v.start);
        let d = 0;
        for (let m = 1; m < f.length; m++) {
          const v = f[d],
            x = f[m];
          x.start <= v.start + v.count + 1
            ? (v.count = Math.max(v.count, x.start + x.count - v.start))
            : (++d, (f[d] = x));
        }
        f.length = d + 1;
        for (let m = 0, v = f.length; m < v; m++) {
          const x = f[m];
          i.bufferSubData(l, x.start * h.BYTES_PER_ELEMENT, h, x.start, x.count);
        }
        c.clearUpdateRanges();
      }
      c.onUploadCallback();
    }
    function r(o) {
      return o.isInterleavedBufferAttribute && (o = o.data), e.get(o);
    }
    function s(o) {
      o.isInterleavedBufferAttribute && (o = o.data);
      const c = e.get(o);
      c && (i.deleteBuffer(c.buffer), e.delete(o));
    }
    function a(o, c) {
      if ((o.isInterleavedBufferAttribute && (o = o.data), o.isGLBufferAttribute)) {
        const h = e.get(o);
        (!h || h.version < o.version) &&
          e.set(o, { buffer: o.buffer, type: o.type, bytesPerElement: o.elementSize, version: o.version });
        return;
      }
      const l = e.get(o);
      if (l === void 0) e.set(o, t(o, c));
      else if (l.version < o.version) {
        if (l.size !== o.array.byteLength)
          throw new Error(
            "THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported."
          );
        n(l.buffer, o, c), (l.version = o.version);
      }
    }
    return { get: r, remove: s, update: a };
  }
  var la = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`,
    ca = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`,
    ua = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`,
    ha = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
    fa = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`,
    da = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`,
    pa = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`,
    ma = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`,
    _a = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`,
    ga = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`,
    va = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`,
    xa = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`,
    Sa = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`,
    Ma = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`,
    Ea = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`,
    Ta = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`,
    ya = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`,
    Aa = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`,
    ba = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`,
    Ra = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`,
    Ca = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`,
    wa = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`,
    Pa = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`,
    Da = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`,
    La = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`,
    Ua = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`,
    Ia = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`,
    Fa = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`,
    Na = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`,
    Oa = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`,
    Ba = "gl_FragColor = linearToOutputTexel( gl_FragColor );",
    Ga = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`,
    za = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`,
    Va = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`,
    Ha = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`,
    ka = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`,
    Wa = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`,
    Xa = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`,
    qa = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`,
    Ya = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`,
    $a = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`,
    Ka = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`,
    Za = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`,
    Ja = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`,
    ja = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`,
    Qa = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`,
    eo = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`,
    to = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`,
    no = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`,
    io = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`,
    ro = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`,
    so = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`,
    ao = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`,
    oo = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`,
    lo = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`,
    co = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`,
    uo = `#if defined( USE_LOGDEPTHBUF )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`,
    ho = `#if defined( USE_LOGDEPTHBUF )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
    fo = `#ifdef USE_LOGDEPTHBUF
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
    po = `#ifdef USE_LOGDEPTHBUF
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`,
    mo = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`,
    _o = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`,
    go = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`,
    vo = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
    xo = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`,
    So = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`,
    Mo = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`,
    Eo = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`,
    To = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
    yo = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`,
    Ao = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
    bo = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`,
    Ro = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`,
    Co = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
    wo = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
    Po = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`,
    Do = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`,
    Lo = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`,
    Uo = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`,
    Io = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`,
    Fo = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`,
    No = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`,
    Oo = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`,
    Bo = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`,
    Go = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`,
    zo = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`,
    Vo = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`,
    Ho = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`,
    ko = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`,
    Wo = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		float depth = unpackRGBAToDepth( texture2D( depths, uv ) );
		#ifdef USE_REVERSEDEPTHBUF
			return step( depth, compare );
		#else
			return step( compare, depth );
		#endif
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		#ifdef USE_REVERSEDEPTHBUF
			float hard_shadow = step( distribution.x, compare );
		#else
			float hard_shadow = step( compare , distribution.x );
		#endif
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`,
    Xo = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`,
    qo = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`,
    Yo = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`,
    $o = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`,
    Ko = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`,
    Zo = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`,
    Jo = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`,
    jo = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`,
    Qo = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`,
    el = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`,
    tl = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`,
    nl = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`,
    il = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		#else
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`,
    rl = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
    sl = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
    al = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`,
    ol = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
  const Ie = {
      alphahash_fragment: la,
      alphahash_pars_fragment: ca,
      alphamap_fragment: ua,
      alphamap_pars_fragment: ha,
      alphatest_fragment: fa,
      alphatest_pars_fragment: da,
      aomap_fragment: pa,
      aomap_pars_fragment: ma,
      batching_pars_vertex: _a,
      batching_vertex: ga,
      begin_vertex: va,
      beginnormal_vertex: xa,
      bsdfs: Sa,
      iridescence_fragment: Ma,
      bumpmap_pars_fragment: Ea,
      clipping_planes_fragment: Ta,
      clipping_planes_pars_fragment: ya,
      clipping_planes_pars_vertex: Aa,
      clipping_planes_vertex: ba,
      color_fragment: Ra,
      color_pars_fragment: Ca,
      color_pars_vertex: wa,
      color_vertex: Pa,
      common: Da,
      cube_uv_reflection_fragment: La,
      defaultnormal_vertex: Ua,
      displacementmap_pars_vertex: Ia,
      displacementmap_vertex: Fa,
      emissivemap_fragment: Na,
      emissivemap_pars_fragment: Oa,
      colorspace_fragment: Ba,
      colorspace_pars_fragment: Ga,
      envmap_fragment: za,
      envmap_common_pars_fragment: Va,
      envmap_pars_fragment: Ha,
      envmap_pars_vertex: ka,
      envmap_physical_pars_fragment: eo,
      envmap_vertex: Wa,
      fog_vertex: Xa,
      fog_pars_vertex: qa,
      fog_fragment: Ya,
      fog_pars_fragment: $a,
      gradientmap_pars_fragment: Ka,
      lightmap_pars_fragment: Za,
      lights_lambert_fragment: Ja,
      lights_lambert_pars_fragment: ja,
      lights_pars_begin: Qa,
      lights_toon_fragment: to,
      lights_toon_pars_fragment: no,
      lights_phong_fragment: io,
      lights_phong_pars_fragment: ro,
      lights_physical_fragment: so,
      lights_physical_pars_fragment: ao,
      lights_fragment_begin: oo,
      lights_fragment_maps: lo,
      lights_fragment_end: co,
      logdepthbuf_fragment: uo,
      logdepthbuf_pars_fragment: ho,
      logdepthbuf_pars_vertex: fo,
      logdepthbuf_vertex: po,
      map_fragment: mo,
      map_pars_fragment: _o,
      map_particle_fragment: go,
      map_particle_pars_fragment: vo,
      metalnessmap_fragment: xo,
      metalnessmap_pars_fragment: So,
      morphinstance_vertex: Mo,
      morphcolor_vertex: Eo,
      morphnormal_vertex: To,
      morphtarget_pars_vertex: yo,
      morphtarget_vertex: Ao,
      normal_fragment_begin: bo,
      normal_fragment_maps: Ro,
      normal_pars_fragment: Co,
      normal_pars_vertex: wo,
      normal_vertex: Po,
      normalmap_pars_fragment: Do,
      clearcoat_normal_fragment_begin: Lo,
      clearcoat_normal_fragment_maps: Uo,
      clearcoat_pars_fragment: Io,
      iridescence_pars_fragment: Fo,
      opaque_fragment: No,
      packing: Oo,
      premultiplied_alpha_fragment: Bo,
      project_vertex: Go,
      dithering_fragment: zo,
      dithering_pars_fragment: Vo,
      roughnessmap_fragment: Ho,
      roughnessmap_pars_fragment: ko,
      shadowmap_pars_fragment: Wo,
      shadowmap_pars_vertex: Xo,
      shadowmap_vertex: qo,
      shadowmask_pars_fragment: Yo,
      skinbase_vertex: $o,
      skinning_pars_vertex: Ko,
      skinning_vertex: Zo,
      skinnormal_vertex: Jo,
      specularmap_fragment: jo,
      specularmap_pars_fragment: Qo,
      tonemapping_fragment: el,
      tonemapping_pars_fragment: tl,
      transmission_fragment: nl,
      transmission_pars_fragment: il,
      uv_pars_fragment: rl,
      uv_pars_vertex: sl,
      uv_vertex: al,
      worldpos_vertex: ol,
      background_vert: `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`,
      background_frag: `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
      backgroundCube_vert: `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
      backgroundCube_frag: `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
      cube_vert: `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
      cube_frag: `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
      depth_vert: `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`,
      depth_frag: `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	#ifdef USE_REVERSEDEPTHBUF
		float fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];
	#else
		float fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;
	#endif
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`,
      distanceRGBA_vert: `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`,
      distanceRGBA_frag: `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`,
      equirect_vert: `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`,
      equirect_frag: `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
      linedashed_vert: `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
      linedashed_frag: `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
      meshbasic_vert: `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`,
      meshbasic_frag: `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
      meshlambert_vert: `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
      meshlambert_frag: `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
      meshmatcap_vert: `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`,
      meshmatcap_frag: `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
      meshnormal_vert: `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`,
      meshnormal_frag: `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`,
      meshphong_vert: `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
      meshphong_frag: `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
      meshphysical_vert: `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`,
      meshphysical_frag: `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
      meshtoon_vert: `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
      meshtoon_frag: `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
      points_vert: `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`,
      points_frag: `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
      shadow_vert: `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
      shadow_frag: `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`,
      sprite_vert: `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
      sprite_frag: `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`
    },
    re = {
      common: {
        diffuse: { value: new ke(16777215) },
        opacity: { value: 1 },
        map: { value: null },
        mapTransform: { value: new Le() },
        alphaMap: { value: null },
        alphaMapTransform: { value: new Le() },
        alphaTest: { value: 0 }
      },
      specularmap: { specularMap: { value: null }, specularMapTransform: { value: new Le() } },
      envmap: {
        envMap: { value: null },
        envMapRotation: { value: new Le() },
        flipEnvMap: { value: -1 },
        reflectivity: { value: 1 },
        ior: { value: 1.5 },
        refractionRatio: { value: 0.98 }
      },
      aomap: { aoMap: { value: null }, aoMapIntensity: { value: 1 }, aoMapTransform: { value: new Le() } },
      lightmap: { lightMap: { value: null }, lightMapIntensity: { value: 1 }, lightMapTransform: { value: new Le() } },
      bumpmap: { bumpMap: { value: null }, bumpMapTransform: { value: new Le() }, bumpScale: { value: 1 } },
      normalmap: {
        normalMap: { value: null },
        normalMapTransform: { value: new Le() },
        normalScale: { value: new qe(1, 1) }
      },
      displacementmap: {
        displacementMap: { value: null },
        displacementMapTransform: { value: new Le() },
        displacementScale: { value: 1 },
        displacementBias: { value: 0 }
      },
      emissivemap: { emissiveMap: { value: null }, emissiveMapTransform: { value: new Le() } },
      metalnessmap: { metalnessMap: { value: null }, metalnessMapTransform: { value: new Le() } },
      roughnessmap: { roughnessMap: { value: null }, roughnessMapTransform: { value: new Le() } },
      gradientmap: { gradientMap: { value: null } },
      fog: {
        fogDensity: { value: 25e-5 },
        fogNear: { value: 1 },
        fogFar: { value: 2e3 },
        fogColor: { value: new ke(16777215) }
      },
      lights: {
        ambientLightColor: { value: [] },
        lightProbe: { value: [] },
        directionalLights: { value: [], properties: { direction: {}, color: {} } },
        directionalLightShadows: {
          value: [],
          properties: { shadowIntensity: 1, shadowBias: {}, shadowNormalBias: {}, shadowRadius: {}, shadowMapSize: {} }
        },
        directionalShadowMap: { value: [] },
        directionalShadowMatrix: { value: [] },
        spotLights: {
          value: [],
          properties: { color: {}, position: {}, direction: {}, distance: {}, coneCos: {}, penumbraCos: {}, decay: {} }
        },
        spotLightShadows: {
          value: [],
          properties: { shadowIntensity: 1, shadowBias: {}, shadowNormalBias: {}, shadowRadius: {}, shadowMapSize: {} }
        },
        spotLightMap: { value: [] },
        spotShadowMap: { value: [] },
        spotLightMatrix: { value: [] },
        pointLights: { value: [], properties: { color: {}, position: {}, decay: {}, distance: {} } },
        pointLightShadows: {
          value: [],
          properties: {
            shadowIntensity: 1,
            shadowBias: {},
            shadowNormalBias: {},
            shadowRadius: {},
            shadowMapSize: {},
            shadowCameraNear: {},
            shadowCameraFar: {}
          }
        },
        pointShadowMap: { value: [] },
        pointShadowMatrix: { value: [] },
        hemisphereLights: { value: [], properties: { direction: {}, skyColor: {}, groundColor: {} } },
        rectAreaLights: { value: [], properties: { color: {}, position: {}, width: {}, height: {} } },
        ltc_1: { value: null },
        ltc_2: { value: null }
      },
      points: {
        diffuse: { value: new ke(16777215) },
        opacity: { value: 1 },
        size: { value: 1 },
        scale: { value: 1 },
        map: { value: null },
        alphaMap: { value: null },
        alphaMapTransform: { value: new Le() },
        alphaTest: { value: 0 },
        uvTransform: { value: new Le() }
      },
      sprite: {
        diffuse: { value: new ke(16777215) },
        opacity: { value: 1 },
        center: { value: new qe(0.5, 0.5) },
        rotation: { value: 0 },
        map: { value: null },
        mapTransform: { value: new Le() },
        alphaMap: { value: null },
        alphaMapTransform: { value: new Le() },
        alphaTest: { value: 0 }
      }
    },
    Ft = {
      basic: {
        uniforms: mt([re.common, re.specularmap, re.envmap, re.aomap, re.lightmap, re.fog]),
        vertexShader: Ie.meshbasic_vert,
        fragmentShader: Ie.meshbasic_frag
      },
      lambert: {
        uniforms: mt([
          re.common,
          re.specularmap,
          re.envmap,
          re.aomap,
          re.lightmap,
          re.emissivemap,
          re.bumpmap,
          re.normalmap,
          re.displacementmap,
          re.fog,
          re.lights,
          { emissive: { value: new ke(0) } }
        ]),
        vertexShader: Ie.meshlambert_vert,
        fragmentShader: Ie.meshlambert_frag
      },
      phong: {
        uniforms: mt([
          re.common,
          re.specularmap,
          re.envmap,
          re.aomap,
          re.lightmap,
          re.emissivemap,
          re.bumpmap,
          re.normalmap,
          re.displacementmap,
          re.fog,
          re.lights,
          { emissive: { value: new ke(0) }, specular: { value: new ke(1118481) }, shininess: { value: 30 } }
        ]),
        vertexShader: Ie.meshphong_vert,
        fragmentShader: Ie.meshphong_frag
      },
      standard: {
        uniforms: mt([
          re.common,
          re.envmap,
          re.aomap,
          re.lightmap,
          re.emissivemap,
          re.bumpmap,
          re.normalmap,
          re.displacementmap,
          re.roughnessmap,
          re.metalnessmap,
          re.fog,
          re.lights,
          {
            emissive: { value: new ke(0) },
            roughness: { value: 1 },
            metalness: { value: 0 },
            envMapIntensity: { value: 1 }
          }
        ]),
        vertexShader: Ie.meshphysical_vert,
        fragmentShader: Ie.meshphysical_frag
      },
      toon: {
        uniforms: mt([
          re.common,
          re.aomap,
          re.lightmap,
          re.emissivemap,
          re.bumpmap,
          re.normalmap,
          re.displacementmap,
          re.gradientmap,
          re.fog,
          re.lights,
          { emissive: { value: new ke(0) } }
        ]),
        vertexShader: Ie.meshtoon_vert,
        fragmentShader: Ie.meshtoon_frag
      },
      matcap: {
        uniforms: mt([re.common, re.bumpmap, re.normalmap, re.displacementmap, re.fog, { matcap: { value: null } }]),
        vertexShader: Ie.meshmatcap_vert,
        fragmentShader: Ie.meshmatcap_frag
      },
      points: { uniforms: mt([re.points, re.fog]), vertexShader: Ie.points_vert, fragmentShader: Ie.points_frag },
      dashed: {
        uniforms: mt([re.common, re.fog, { scale: { value: 1 }, dashSize: { value: 1 }, totalSize: { value: 2 } }]),
        vertexShader: Ie.linedashed_vert,
        fragmentShader: Ie.linedashed_frag
      },
      depth: {
        uniforms: mt([re.common, re.displacementmap]),
        vertexShader: Ie.depth_vert,
        fragmentShader: Ie.depth_frag
      },
      normal: {
        uniforms: mt([re.common, re.bumpmap, re.normalmap, re.displacementmap, { opacity: { value: 1 } }]),
        vertexShader: Ie.meshnormal_vert,
        fragmentShader: Ie.meshnormal_frag
      },
      sprite: { uniforms: mt([re.sprite, re.fog]), vertexShader: Ie.sprite_vert, fragmentShader: Ie.sprite_frag },
      background: {
        uniforms: { uvTransform: { value: new Le() }, t2D: { value: null }, backgroundIntensity: { value: 1 } },
        vertexShader: Ie.background_vert,
        fragmentShader: Ie.background_frag
      },
      backgroundCube: {
        uniforms: {
          envMap: { value: null },
          flipEnvMap: { value: -1 },
          backgroundBlurriness: { value: 0 },
          backgroundIntensity: { value: 1 },
          backgroundRotation: { value: new Le() }
        },
        vertexShader: Ie.backgroundCube_vert,
        fragmentShader: Ie.backgroundCube_frag
      },
      cube: {
        uniforms: { tCube: { value: null }, tFlip: { value: -1 }, opacity: { value: 1 } },
        vertexShader: Ie.cube_vert,
        fragmentShader: Ie.cube_frag
      },
      equirect: {
        uniforms: { tEquirect: { value: null } },
        vertexShader: Ie.equirect_vert,
        fragmentShader: Ie.equirect_frag
      },
      distanceRGBA: {
        uniforms: mt([
          re.common,
          re.displacementmap,
          { referencePosition: { value: new O() }, nearDistance: { value: 1 }, farDistance: { value: 1e3 } }
        ]),
        vertexShader: Ie.distanceRGBA_vert,
        fragmentShader: Ie.distanceRGBA_frag
      },
      shadow: {
        uniforms: mt([re.lights, re.fog, { color: { value: new ke(0) }, opacity: { value: 1 } }]),
        vertexShader: Ie.shadow_vert,
        fragmentShader: Ie.shadow_frag
      }
    };
  Ft.physical = {
    uniforms: mt([
      Ft.standard.uniforms,
      {
        clearcoat: { value: 0 },
        clearcoatMap: { value: null },
        clearcoatMapTransform: { value: new Le() },
        clearcoatNormalMap: { value: null },
        clearcoatNormalMapTransform: { value: new Le() },
        clearcoatNormalScale: { value: new qe(1, 1) },
        clearcoatRoughness: { value: 0 },
        clearcoatRoughnessMap: { value: null },
        clearcoatRoughnessMapTransform: { value: new Le() },
        dispersion: { value: 0 },
        iridescence: { value: 0 },
        iridescenceMap: { value: null },
        iridescenceMapTransform: { value: new Le() },
        iridescenceIOR: { value: 1.3 },
        iridescenceThicknessMinimum: { value: 100 },
        iridescenceThicknessMaximum: { value: 400 },
        iridescenceThicknessMap: { value: null },
        iridescenceThicknessMapTransform: { value: new Le() },
        sheen: { value: 0 },
        sheenColor: { value: new ke(0) },
        sheenColorMap: { value: null },
        sheenColorMapTransform: { value: new Le() },
        sheenRoughness: { value: 1 },
        sheenRoughnessMap: { value: null },
        sheenRoughnessMapTransform: { value: new Le() },
        transmission: { value: 0 },
        transmissionMap: { value: null },
        transmissionMapTransform: { value: new Le() },
        transmissionSamplerSize: { value: new qe() },
        transmissionSamplerMap: { value: null },
        thickness: { value: 0 },
        thicknessMap: { value: null },
        thicknessMapTransform: { value: new Le() },
        attenuationDistance: { value: 0 },
        attenuationColor: { value: new ke(0) },
        specularColor: { value: new ke(1, 1, 1) },
        specularColorMap: { value: null },
        specularColorMapTransform: { value: new Le() },
        specularIntensity: { value: 1 },
        specularIntensityMap: { value: null },
        specularIntensityMapTransform: { value: new Le() },
        anisotropyVector: { value: new qe() },
        anisotropyMap: { value: null },
        anisotropyMapTransform: { value: new Le() }
      }
    ]),
    vertexShader: Ie.meshphysical_vert,
    fragmentShader: Ie.meshphysical_frag
  };
  const gi = { r: 0, b: 0, g: 0 },
    ln = new zt(),
    ll = new ot();
  function cl(i, e, t, n, r, s, a) {
    const o = new ke(0);
    let c = s === !0 ? 0 : 1,
      l,
      h,
      f = null,
      d = 0,
      m = null;
    function v(y) {
      let E = y.isScene === !0 ? y.background : null;
      return E && E.isTexture && (E = (y.backgroundBlurriness > 0 ? t : e).get(E)), E;
    }
    function x(y) {
      let E = !1;
      const D = v(y);
      D === null ? u(o, c) : D && D.isColor && (u(D, 1), (E = !0));
      const w = i.xr.getEnvironmentBlendMode();
      w === "additive"
        ? n.buffers.color.setClear(0, 0, 0, 1, a)
        : w === "alpha-blend" && n.buffers.color.setClear(0, 0, 0, 0, a),
        (i.autoClear || E) &&
          (n.buffers.depth.setTest(!0),
          n.buffers.depth.setMask(!0),
          n.buffers.color.setMask(!0),
          i.clear(i.autoClearColor, i.autoClearDepth, i.autoClearStencil));
    }
    function p(y, E) {
      const D = v(E);
      D && (D.isCubeTexture || D.mapping === 306)
        ? (h === void 0 &&
            ((h = new Xt(
              new Wn(1, 1, 1),
              new qt({
                name: "BackgroundCubeMaterial",
                uniforms: Cn(Ft.backgroundCube.uniforms),
                vertexShader: Ft.backgroundCube.vertexShader,
                fragmentShader: Ft.backgroundCube.fragmentShader,
                side: 1,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
              })
            )),
            h.geometry.deleteAttribute("normal"),
            h.geometry.deleteAttribute("uv"),
            (h.onBeforeRender = function (w, P, F) {
              this.matrixWorld.copyPosition(F.matrixWorld);
            }),
            Object.defineProperty(h.material, "envMap", {
              get: function () {
                return this.uniforms.envMap.value;
              }
            }),
            r.update(h)),
          ln.copy(E.backgroundRotation),
          (ln.x *= -1),
          (ln.y *= -1),
          (ln.z *= -1),
          D.isCubeTexture && D.isRenderTargetTexture === !1 && ((ln.y *= -1), (ln.z *= -1)),
          (h.material.uniforms.envMap.value = D),
          (h.material.uniforms.flipEnvMap.value = D.isCubeTexture && D.isRenderTargetTexture === !1 ? -1 : 1),
          (h.material.uniforms.backgroundBlurriness.value = E.backgroundBlurriness),
          (h.material.uniforms.backgroundIntensity.value = E.backgroundIntensity),
          h.material.uniforms.backgroundRotation.value.setFromMatrix4(ll.makeRotationFromEuler(ln)),
          (h.material.toneMapped = ze.getTransfer(D.colorSpace) !== Xe),
          (f !== D || d !== D.version || m !== i.toneMapping) &&
            ((h.material.needsUpdate = !0), (f = D), (d = D.version), (m = i.toneMapping)),
          h.layers.enableAll(),
          y.unshift(h, h.geometry, h.material, 0, 0, null))
        : D &&
          D.isTexture &&
          (l === void 0 &&
            ((l = new Xt(
              new _i(2, 2),
              new qt({
                name: "BackgroundMaterial",
                uniforms: Cn(Ft.background.uniforms),
                vertexShader: Ft.background.vertexShader,
                fragmentShader: Ft.background.fragmentShader,
                side: 0,
                depthTest: !1,
                depthWrite: !1,
                fog: !1,
                allowOverride: !1
              })
            )),
            l.geometry.deleteAttribute("normal"),
            Object.defineProperty(l.material, "map", {
              get: function () {
                return this.uniforms.t2D.value;
              }
            }),
            r.update(l)),
          (l.material.uniforms.t2D.value = D),
          (l.material.uniforms.backgroundIntensity.value = E.backgroundIntensity),
          (l.material.toneMapped = ze.getTransfer(D.colorSpace) !== Xe),
          D.matrixAutoUpdate === !0 && D.updateMatrix(),
          l.material.uniforms.uvTransform.value.copy(D.matrix),
          (f !== D || d !== D.version || m !== i.toneMapping) &&
            ((l.material.needsUpdate = !0), (f = D), (d = D.version), (m = i.toneMapping)),
          l.layers.enableAll(),
          y.unshift(l, l.geometry, l.material, 0, 0, null));
    }
    function u(y, E) {
      y.getRGB(gi, Dr(i)), n.buffers.color.setClear(gi.r, gi.g, gi.b, E, a);
    }
    function C() {
      h !== void 0 && (h.geometry.dispose(), h.material.dispose(), (h = void 0)),
        l !== void 0 && (l.geometry.dispose(), l.material.dispose(), (l = void 0));
    }
    return {
      getClearColor: function () {
        return o;
      },
      setClearColor: function (y, E = 1) {
        o.set(y), (c = E), u(o, c);
      },
      getClearAlpha: function () {
        return c;
      },
      setClearAlpha: function (y) {
        (c = y), u(o, c);
      },
      render: x,
      addToRenderList: p,
      dispose: C
    };
  }
  function ul(i, e) {
    const t = i.getParameter(i.MAX_VERTEX_ATTRIBS),
      n = {},
      r = d(null);
    let s = r,
      a = !1;
    function o(S, b, q, V, H) {
      let K = !1;
      const X = f(V, q, b);
      s !== X && ((s = X), l(s.object)),
        (K = m(S, V, q, H)),
        K && v(S, V, q, H),
        H !== null && e.update(H, i.ELEMENT_ARRAY_BUFFER),
        (K || a) && ((a = !1), E(S, b, q, V), H !== null && i.bindBuffer(i.ELEMENT_ARRAY_BUFFER, e.get(H).buffer));
    }
    function c() {
      return i.createVertexArray();
    }
    function l(S) {
      return i.bindVertexArray(S);
    }
    function h(S) {
      return i.deleteVertexArray(S);
    }
    function f(S, b, q) {
      const V = q.wireframe === !0;
      let H = n[S.id];
      H === void 0 && ((H = {}), (n[S.id] = H));
      let K = H[b.id];
      K === void 0 && ((K = {}), (H[b.id] = K));
      let X = K[V];
      return X === void 0 && ((X = d(c())), (K[V] = X)), X;
    }
    function d(S) {
      const b = [],
        q = [],
        V = [];
      for (let H = 0; H < t; H++) (b[H] = 0), (q[H] = 0), (V[H] = 0);
      return {
        geometry: null,
        program: null,
        wireframe: !1,
        newAttributes: b,
        enabledAttributes: q,
        attributeDivisors: V,
        object: S,
        attributes: {},
        index: null
      };
    }
    function m(S, b, q, V) {
      const H = s.attributes,
        K = b.attributes;
      let X = 0;
      const ee = q.getAttributes();
      for (const G in ee)
        if (ee[G].location >= 0) {
          const ue = H[G];
          let Me = K[G];
          if (
            (Me === void 0 &&
              (G === "instanceMatrix" && S.instanceMatrix && (Me = S.instanceMatrix),
              G === "instanceColor" && S.instanceColor && (Me = S.instanceColor)),
            ue === void 0 || ue.attribute !== Me || (Me && ue.data !== Me.data))
          )
            return !0;
          X++;
        }
      return s.attributesNum !== X || s.index !== V;
    }
    function v(S, b, q, V) {
      const H = {},
        K = b.attributes;
      let X = 0;
      const ee = q.getAttributes();
      for (const G in ee)
        if (ee[G].location >= 0) {
          let ue = K[G];
          ue === void 0 &&
            (G === "instanceMatrix" && S.instanceMatrix && (ue = S.instanceMatrix),
            G === "instanceColor" && S.instanceColor && (ue = S.instanceColor));
          const Me = {};
          (Me.attribute = ue), ue && ue.data && (Me.data = ue.data), (H[G] = Me), X++;
        }
      (s.attributes = H), (s.attributesNum = X), (s.index = V);
    }
    function x() {
      const S = s.newAttributes;
      for (let b = 0, q = S.length; b < q; b++) S[b] = 0;
    }
    function p(S) {
      u(S, 0);
    }
    function u(S, b) {
      const q = s.newAttributes,
        V = s.enabledAttributes,
        H = s.attributeDivisors;
      (q[S] = 1),
        V[S] === 0 && (i.enableVertexAttribArray(S), (V[S] = 1)),
        H[S] !== b && (i.vertexAttribDivisor(S, b), (H[S] = b));
    }
    function C() {
      const S = s.newAttributes,
        b = s.enabledAttributes;
      for (let q = 0, V = b.length; q < V; q++) b[q] !== S[q] && (i.disableVertexAttribArray(q), (b[q] = 0));
    }
    function y(S, b, q, V, H, K, X) {
      X === !0 ? i.vertexAttribIPointer(S, b, q, H, K) : i.vertexAttribPointer(S, b, q, V, H, K);
    }
    function E(S, b, q, V) {
      x();
      const H = V.attributes,
        K = q.getAttributes(),
        X = b.defaultAttributeValues;
      for (const ee in K) {
        const G = K[ee];
        if (G.location >= 0) {
          let se = H[ee];
          if (
            (se === void 0 &&
              (ee === "instanceMatrix" && S.instanceMatrix && (se = S.instanceMatrix),
              ee === "instanceColor" && S.instanceColor && (se = S.instanceColor)),
            se !== void 0)
          ) {
            const ue = se.normalized,
              Me = se.itemSize,
              Fe = e.get(se);
            if (Fe === void 0) continue;
            const Qe = Fe.buffer,
              $e = Fe.type,
              W = Fe.bytesPerElement,
              ae = $e === i.INT || $e === i.UNSIGNED_INT || se.gpuType === 1013;
            if (se.isInterleavedBufferAttribute) {
              const ne = se.data,
                Ae = ne.stride,
                be = se.offset;
              if (ne.isInstancedInterleavedBuffer) {
                for (let Pe = 0; Pe < G.locationSize; Pe++) u(G.location + Pe, ne.meshPerAttribute);
                S.isInstancedMesh !== !0 &&
                  V._maxInstanceCount === void 0 &&
                  (V._maxInstanceCount = ne.meshPerAttribute * ne.count);
              } else for (let Pe = 0; Pe < G.locationSize; Pe++) p(G.location + Pe);
              i.bindBuffer(i.ARRAY_BUFFER, Qe);
              for (let Pe = 0; Pe < G.locationSize; Pe++)
                y(G.location + Pe, Me / G.locationSize, $e, ue, Ae * W, (be + (Me / G.locationSize) * Pe) * W, ae);
            } else {
              if (se.isInstancedBufferAttribute) {
                for (let ne = 0; ne < G.locationSize; ne++) u(G.location + ne, se.meshPerAttribute);
                S.isInstancedMesh !== !0 &&
                  V._maxInstanceCount === void 0 &&
                  (V._maxInstanceCount = se.meshPerAttribute * se.count);
              } else for (let ne = 0; ne < G.locationSize; ne++) p(G.location + ne);
              i.bindBuffer(i.ARRAY_BUFFER, Qe);
              for (let ne = 0; ne < G.locationSize; ne++)
                y(G.location + ne, Me / G.locationSize, $e, ue, Me * W, (Me / G.locationSize) * ne * W, ae);
            }
          } else if (X !== void 0) {
            const ue = X[ee];
            if (ue !== void 0)
              switch (ue.length) {
                case 2:
                  i.vertexAttrib2fv(G.location, ue);
                  break;
                case 3:
                  i.vertexAttrib3fv(G.location, ue);
                  break;
                case 4:
                  i.vertexAttrib4fv(G.location, ue);
                  break;
                default:
                  i.vertexAttrib1fv(G.location, ue);
              }
          }
        }
      }
      C();
    }
    function D() {
      F();
      for (const S in n) {
        const b = n[S];
        for (const q in b) {
          const V = b[q];
          for (const H in V) h(V[H].object), delete V[H];
          delete b[q];
        }
        delete n[S];
      }
    }
    function w(S) {
      if (n[S.id] === void 0) return;
      const b = n[S.id];
      for (const q in b) {
        const V = b[q];
        for (const H in V) h(V[H].object), delete V[H];
        delete b[q];
      }
      delete n[S.id];
    }
    function P(S) {
      for (const b in n) {
        const q = n[b];
        if (q[S.id] === void 0) continue;
        const V = q[S.id];
        for (const H in V) h(V[H].object), delete V[H];
        delete q[S.id];
      }
    }
    function F() {
      M(), (a = !0), s !== r && ((s = r), l(s.object));
    }
    function M() {
      (r.geometry = null), (r.program = null), (r.wireframe = !1);
    }
    return {
      setup: o,
      reset: F,
      resetDefaultState: M,
      dispose: D,
      releaseStatesOfGeometry: w,
      releaseStatesOfProgram: P,
      initAttributes: x,
      enableAttribute: p,
      disableUnusedAttributes: C
    };
  }
  function hl(i, e, t) {
    let n;
    function r(l) {
      n = l;
    }
    function s(l, h) {
      i.drawArrays(n, l, h), t.update(h, n, 1);
    }
    function a(l, h, f) {
      f !== 0 && (i.drawArraysInstanced(n, l, h, f), t.update(h, n, f));
    }
    function o(l, h, f) {
      if (f === 0) return;
      e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(n, l, 0, h, 0, f);
      let m = 0;
      for (let v = 0; v < f; v++) m += h[v];
      t.update(m, n, 1);
    }
    function c(l, h, f, d) {
      if (f === 0) return;
      const m = e.get("WEBGL_multi_draw");
      if (m === null) for (let v = 0; v < l.length; v++) a(l[v], h[v], d[v]);
      else {
        m.multiDrawArraysInstancedWEBGL(n, l, 0, h, 0, d, 0, f);
        let v = 0;
        for (let x = 0; x < f; x++) v += h[x] * d[x];
        t.update(v, n, 1);
      }
    }
    (this.setMode = r),
      (this.render = s),
      (this.renderInstances = a),
      (this.renderMultiDraw = o),
      (this.renderMultiDrawInstances = c);
  }
  function fl(i, e, t, n) {
    let r;
    function s() {
      if (r !== void 0) return r;
      if (e.has("EXT_texture_filter_anisotropic") === !0) {
        const P = e.get("EXT_texture_filter_anisotropic");
        r = i.getParameter(P.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
      } else r = 0;
      return r;
    }
    function a(P) {
      return !(P !== 1023 && n.convert(P) !== i.getParameter(i.IMPLEMENTATION_COLOR_READ_FORMAT));
    }
    function o(P) {
      const F = P === 1016 && (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"));
      return !(P !== 1009 && n.convert(P) !== i.getParameter(i.IMPLEMENTATION_COLOR_READ_TYPE) && P !== 1015 && !F);
    }
    function c(P) {
      if (P === "highp") {
        if (
          i.getShaderPrecisionFormat(i.VERTEX_SHADER, i.HIGH_FLOAT).precision > 0 &&
          i.getShaderPrecisionFormat(i.FRAGMENT_SHADER, i.HIGH_FLOAT).precision > 0
        )
          return "highp";
        P = "mediump";
      }
      return P === "mediump" &&
        i.getShaderPrecisionFormat(i.VERTEX_SHADER, i.MEDIUM_FLOAT).precision > 0 &&
        i.getShaderPrecisionFormat(i.FRAGMENT_SHADER, i.MEDIUM_FLOAT).precision > 0
        ? "mediump"
        : "lowp";
    }
    let l = t.precision !== void 0 ? t.precision : "highp";
    const h = c(l);
    h !== l && (console.warn("THREE.WebGLRenderer:", l, "not supported, using", h, "instead."), (l = h));
    const f = t.logarithmicDepthBuffer === !0,
      d = t.reversedDepthBuffer === !0 && e.has("EXT_clip_control"),
      m = i.getParameter(i.MAX_TEXTURE_IMAGE_UNITS),
      v = i.getParameter(i.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
      x = i.getParameter(i.MAX_TEXTURE_SIZE),
      p = i.getParameter(i.MAX_CUBE_MAP_TEXTURE_SIZE),
      u = i.getParameter(i.MAX_VERTEX_ATTRIBS),
      C = i.getParameter(i.MAX_VERTEX_UNIFORM_VECTORS),
      y = i.getParameter(i.MAX_VARYING_VECTORS),
      E = i.getParameter(i.MAX_FRAGMENT_UNIFORM_VECTORS),
      D = v > 0,
      w = i.getParameter(i.MAX_SAMPLES);
    return {
      isWebGL2: !0,
      getMaxAnisotropy: s,
      getMaxPrecision: c,
      textureFormatReadable: a,
      textureTypeReadable: o,
      precision: l,
      logarithmicDepthBuffer: f,
      reversedDepthBuffer: d,
      maxTextures: m,
      maxVertexTextures: v,
      maxTextureSize: x,
      maxCubemapSize: p,
      maxAttributes: u,
      maxVertexUniforms: C,
      maxVaryings: y,
      maxFragmentUniforms: E,
      vertexTextures: D,
      maxSamples: w
    };
  }
  function dl(i) {
    const e = this;
    let t = null,
      n = 0,
      r = !1,
      s = !1;
    const a = new an(),
      o = new Le(),
      c = { value: null, needsUpdate: !1 };
    (this.uniform = c),
      (this.numPlanes = 0),
      (this.numIntersection = 0),
      (this.init = function (f, d) {
        const m = f.length !== 0 || d || n !== 0 || r;
        return (r = d), (n = f.length), m;
      }),
      (this.beginShadows = function () {
        (s = !0), h(null);
      }),
      (this.endShadows = function () {
        s = !1;
      }),
      (this.setGlobalState = function (f, d) {
        t = h(f, d, 0);
      }),
      (this.setState = function (f, d, m) {
        const v = f.clippingPlanes,
          x = f.clipIntersection,
          p = f.clipShadows,
          u = i.get(f);
        if (!r || v === null || v.length === 0 || (s && !p)) s ? h(null) : l();
        else {
          const C = s ? 0 : n,
            y = C * 4;
          let E = u.clippingState || null;
          (c.value = E), (E = h(v, d, y, m));
          for (let D = 0; D !== y; ++D) E[D] = t[D];
          (u.clippingState = E), (this.numIntersection = x ? this.numPlanes : 0), (this.numPlanes += C);
        }
      });
    function l() {
      c.value !== t && ((c.value = t), (c.needsUpdate = n > 0)), (e.numPlanes = n), (e.numIntersection = 0);
    }
    function h(f, d, m, v) {
      const x = f !== null ? f.length : 0;
      let p = null;
      if (x !== 0) {
        if (((p = c.value), v !== !0 || p === null)) {
          const u = m + x * 4,
            C = d.matrixWorldInverse;
          o.getNormalMatrix(C), (p === null || p.length < u) && (p = new Float32Array(u));
          for (let y = 0, E = m; y !== x; ++y, E += 4)
            a.copy(f[y]).applyMatrix4(C, o), a.normal.toArray(p, E), (p[E + 3] = a.constant);
        }
        (c.value = p), (c.needsUpdate = !0);
      }
      return (e.numPlanes = x), (e.numIntersection = 0), p;
    }
  }
  function pl(i) {
    let e = new WeakMap();
    function t(a, o) {
      return o === 303 ? (a.mapping = 301) : o === 304 && (a.mapping = 302), a;
    }
    function n(a) {
      if (a && a.isTexture) {
        const o = a.mapping;
        if (o === 303 || o === 304)
          if (e.has(a)) {
            const c = e.get(a).texture;
            return t(c, a.mapping);
          } else {
            const c = a.image;
            if (c && c.height > 0) {
              const l = new Ks(c.height);
              return (
                l.fromEquirectangularTexture(i, a),
                e.set(a, l),
                a.addEventListener("dispose", r),
                t(l.texture, a.mapping)
              );
            } else return null;
          }
      }
      return a;
    }
    function r(a) {
      const o = a.target;
      o.removeEventListener("dispose", r);
      const c = e.get(o);
      c !== void 0 && (e.delete(o), c.dispose());
    }
    function s() {
      e = new WeakMap();
    }
    return { get: n, dispose: s };
  }
  const Dn = 4,
    kr = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582],
    cn = 20,
    Ji = new zr(),
    Wr = new ke();
  let ji = null,
    Qi = 0,
    er = 0,
    tr = !1;
  const un = (1 + Math.sqrt(5)) / 2,
    Ln = 1 / un,
    Xr = [
      new O(-un, Ln, 0),
      new O(un, Ln, 0),
      new O(-Ln, 0, un),
      new O(Ln, 0, un),
      new O(0, un, -Ln),
      new O(0, un, Ln),
      new O(-1, 1, -1),
      new O(1, 1, -1),
      new O(-1, 1, 1),
      new O(1, 1, 1)
    ],
    ml = new O();
  class qr {
    constructor(e) {
      (this._renderer = e),
        (this._pingPongRenderTarget = null),
        (this._lodMax = 0),
        (this._cubeSize = 0),
        (this._lodPlanes = []),
        (this._sizeLods = []),
        (this._sigmas = []),
        (this._blurMaterial = null),
        (this._cubemapMaterial = null),
        (this._equirectMaterial = null),
        this._compileMaterial(this._blurMaterial);
    }
    fromScene(e, t = 0, n = 0.1, r = 100, s = {}) {
      const { size: a = 256, position: o = ml } = s;
      (ji = this._renderer.getRenderTarget()),
        (Qi = this._renderer.getActiveCubeFace()),
        (er = this._renderer.getActiveMipmapLevel()),
        (tr = this._renderer.xr.enabled),
        (this._renderer.xr.enabled = !1),
        this._setSize(a);
      const c = this._allocateTargets();
      return (
        (c.depthBuffer = !0),
        this._sceneToCubeUV(e, n, r, c, o),
        t > 0 && this._blur(c, 0, 0, t),
        this._applyPMREM(c),
        this._cleanup(c),
        c
      );
    }
    fromEquirectangular(e, t = null) {
      return this._fromTexture(e, t);
    }
    fromCubemap(e, t = null) {
      return this._fromTexture(e, t);
    }
    compileCubemapShader() {
      this._cubemapMaterial === null && ((this._cubemapMaterial = Kr()), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
      this._equirectMaterial === null &&
        ((this._equirectMaterial = $r()), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
      this._dispose(),
        this._cubemapMaterial !== null && this._cubemapMaterial.dispose(),
        this._equirectMaterial !== null && this._equirectMaterial.dispose();
    }
    _setSize(e) {
      (this._lodMax = Math.floor(Math.log2(e))), (this._cubeSize = Math.pow(2, this._lodMax));
    }
    _dispose() {
      this._blurMaterial !== null && this._blurMaterial.dispose(),
        this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
      for (let e = 0; e < this._lodPlanes.length; e++) this._lodPlanes[e].dispose();
    }
    _cleanup(e) {
      this._renderer.setRenderTarget(ji, Qi, er),
        (this._renderer.xr.enabled = tr),
        (e.scissorTest = !1),
        vi(e, 0, 0, e.width, e.height);
    }
    _fromTexture(e, t) {
      e.mapping === 301 || e.mapping === 302
        ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width)
        : this._setSize(e.image.width / 4),
        (ji = this._renderer.getRenderTarget()),
        (Qi = this._renderer.getActiveCubeFace()),
        (er = this._renderer.getActiveMipmapLevel()),
        (tr = this._renderer.xr.enabled),
        (this._renderer.xr.enabled = !1);
      const n = t || this._allocateTargets();
      return this._textureToCubeUV(e, n), this._applyPMREM(n), this._cleanup(n), n;
    }
    _allocateTargets() {
      const e = 3 * Math.max(this._cubeSize, 112),
        t = 4 * this._cubeSize,
        n = {
          magFilter: 1006,
          minFilter: 1006,
          generateMipmaps: !1,
          type: 1016,
          format: 1023,
          colorSpace: pn,
          depthBuffer: !1
        },
        r = Yr(e, t, n);
      if (
        this._pingPongRenderTarget === null ||
        this._pingPongRenderTarget.width !== e ||
        this._pingPongRenderTarget.height !== t
      ) {
        this._pingPongRenderTarget !== null && this._dispose(), (this._pingPongRenderTarget = Yr(e, t, n));
        const { _lodMax: s } = this;
        ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = _l(s)),
          (this._blurMaterial = gl(s, e, t));
      }
      return r;
    }
    _compileMaterial(e) {
      const t = new Xt(this._lodPlanes[0], e);
      this._renderer.compile(t, Ji);
    }
    _sceneToCubeUV(e, t, n, r, s) {
      const c = new It(90, 1, t, n),
        l = [1, -1, 1, 1, 1, 1],
        h = [1, 1, 1, -1, -1, -1],
        f = this._renderer,
        d = f.autoClear,
        m = f.toneMapping;
      f.getClearColor(Wr),
        (f.toneMapping = 0),
        (f.autoClear = !1),
        f.state.buffers.depth.getReversed() && (f.setRenderTarget(r), f.clearDepth(), f.setRenderTarget(null));
      const x = new Ar({ name: "PMREM.Background", side: 1, depthWrite: !1, depthTest: !1 }),
        p = new Xt(new Wn(), x);
      let u = !1;
      const C = e.background;
      C ? C.isColor && (x.color.copy(C), (e.background = null), (u = !0)) : (x.color.copy(Wr), (u = !0));
      for (let y = 0; y < 6; y++) {
        const E = y % 3;
        E === 0
          ? (c.up.set(0, l[y], 0), c.position.set(s.x, s.y, s.z), c.lookAt(s.x + h[y], s.y, s.z))
          : E === 1
          ? (c.up.set(0, 0, l[y]), c.position.set(s.x, s.y, s.z), c.lookAt(s.x, s.y + h[y], s.z))
          : (c.up.set(0, l[y], 0), c.position.set(s.x, s.y, s.z), c.lookAt(s.x, s.y, s.z + h[y]));
        const D = this._cubeSize;
        vi(r, E * D, y > 2 ? D : 0, D, D), f.setRenderTarget(r), u && f.render(p, c), f.render(e, c);
      }
      p.geometry.dispose(), p.material.dispose(), (f.toneMapping = m), (f.autoClear = d), (e.background = C);
    }
    _textureToCubeUV(e, t) {
      const n = this._renderer,
        r = e.mapping === 301 || e.mapping === 302;
      r
        ? (this._cubemapMaterial === null && (this._cubemapMaterial = Kr()),
          (this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1))
        : this._equirectMaterial === null && (this._equirectMaterial = $r());
      const s = r ? this._cubemapMaterial : this._equirectMaterial,
        a = new Xt(this._lodPlanes[0], s),
        o = s.uniforms;
      o.envMap.value = e;
      const c = this._cubeSize;
      vi(t, 0, 0, 3 * c, 2 * c), n.setRenderTarget(t), n.render(a, Ji);
    }
    _applyPMREM(e) {
      const t = this._renderer,
        n = t.autoClear;
      t.autoClear = !1;
      const r = this._lodPlanes.length;
      for (let s = 1; s < r; s++) {
        const a = Math.sqrt(this._sigmas[s] * this._sigmas[s] - this._sigmas[s - 1] * this._sigmas[s - 1]),
          o = Xr[(r - s - 1) % Xr.length];
        this._blur(e, s - 1, s, a, o);
      }
      t.autoClear = n;
    }
    _blur(e, t, n, r, s) {
      const a = this._pingPongRenderTarget;
      this._halfBlur(e, a, t, n, r, "latitudinal", s), this._halfBlur(a, e, n, n, r, "longitudinal", s);
    }
    _halfBlur(e, t, n, r, s, a, o) {
      const c = this._renderer,
        l = this._blurMaterial;
      a !== "latitudinal" &&
        a !== "longitudinal" &&
        console.error("blur direction must be either latitudinal or longitudinal!");
      const h = 3,
        f = new Xt(this._lodPlanes[r], l),
        d = l.uniforms,
        m = this._sizeLods[n] - 1,
        v = isFinite(s) ? Math.PI / (2 * m) : (2 * Math.PI) / (2 * cn - 1),
        x = s / v,
        p = isFinite(s) ? 1 + Math.floor(h * x) : cn;
      p > cn &&
        console.warn(
          `sigmaRadians, ${s}, is too large and will clip, as it requested ${p} samples when the maximum is set to ${cn}`
        );
      const u = [];
      let C = 0;
      for (let P = 0; P < cn; ++P) {
        const F = P / x,
          M = Math.exp((-F * F) / 2);
        u.push(M), P === 0 ? (C += M) : P < p && (C += 2 * M);
      }
      for (let P = 0; P < u.length; P++) u[P] = u[P] / C;
      (d.envMap.value = e.texture),
        (d.samples.value = p),
        (d.weights.value = u),
        (d.latitudinal.value = a === "latitudinal"),
        o && (d.poleAxis.value = o);
      const { _lodMax: y } = this;
      (d.dTheta.value = v), (d.mipInt.value = y - n);
      const E = this._sizeLods[r],
        D = 3 * E * (r > y - Dn ? r - y + Dn : 0),
        w = 4 * (this._cubeSize - E);
      vi(t, D, w, 3 * E, 2 * E), c.setRenderTarget(t), c.render(f, Ji);
    }
  }
  function _l(i) {
    const e = [],
      t = [],
      n = [];
    let r = i;
    const s = i - Dn + 1 + kr.length;
    for (let a = 0; a < s; a++) {
      const o = Math.pow(2, r);
      t.push(o);
      let c = 1 / o;
      a > i - Dn ? (c = kr[a - i + Dn - 1]) : a === 0 && (c = 0), n.push(c);
      const l = 1 / (o - 2),
        h = -l,
        f = 1 + l,
        d = [h, h, f, h, f, f, h, h, f, f, h, f],
        m = 6,
        v = 6,
        x = 3,
        p = 2,
        u = 1,
        C = new Float32Array(x * v * m),
        y = new Float32Array(p * v * m),
        E = new Float32Array(u * v * m);
      for (let w = 0; w < m; w++) {
        const P = ((w % 3) * 2) / 3 - 1,
          F = w > 2 ? 0 : -1,
          M = [P, F, 0, P + 2 / 3, F, 0, P + 2 / 3, F + 1, 0, P, F, 0, P + 2 / 3, F + 1, 0, P, F + 1, 0];
        C.set(M, x * v * w), y.set(d, p * v * w);
        const S = [w, w, w, w, w, w];
        E.set(S, u * v * w);
      }
      const D = new Wt();
      D.setAttribute("position", new Ut(C, x)),
        D.setAttribute("uv", new Ut(y, p)),
        D.setAttribute("faceIndex", new Ut(E, u)),
        e.push(D),
        r > Dn && r--;
    }
    return { lodPlanes: e, sizeLods: t, sigmas: n };
  }
  function Yr(i, e, t) {
    const n = new en(i, e, t);
    return (n.texture.mapping = 306), (n.texture.name = "PMREM.cubeUv"), (n.scissorTest = !0), n;
  }
  function vi(i, e, t, n, r) {
    i.viewport.set(e, t, n, r), i.scissor.set(e, t, n, r);
  }
  function gl(i, e, t) {
    const n = new Float32Array(cn),
      r = new O(0, 1, 0);
    return new qt({
      name: "SphericalGaussianBlur",
      defines: { n: cn, CUBEUV_TEXEL_WIDTH: 1 / e, CUBEUV_TEXEL_HEIGHT: 1 / t, CUBEUV_MAX_MIP: `${i}.0` },
      uniforms: {
        envMap: { value: null },
        samples: { value: 1 },
        weights: { value: n },
        latitudinal: { value: !1 },
        dTheta: { value: 0 },
        mipInt: { value: 0 },
        poleAxis: { value: r }
      },
      vertexShader: nr(),
      fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
      blending: 0,
      depthTest: !1,
      depthWrite: !1
    });
  }
  function $r() {
    return new qt({
      name: "EquirectangularToCubeUV",
      uniforms: { envMap: { value: null } },
      vertexShader: nr(),
      fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
      blending: 0,
      depthTest: !1,
      depthWrite: !1
    });
  }
  function Kr() {
    return new qt({
      name: "CubemapToCubeUV",
      uniforms: { envMap: { value: null }, flipEnvMap: { value: -1 } },
      vertexShader: nr(),
      fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
      blending: 0,
      depthTest: !1,
      depthWrite: !1
    });
  }
  function nr() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
  }
  function vl(i) {
    let e = new WeakMap(),
      t = null;
    function n(o) {
      if (o && o.isTexture) {
        const c = o.mapping,
          l = c === 303 || c === 304,
          h = c === 301 || c === 302;
        if (l || h) {
          let f = e.get(o);
          const d = f !== void 0 ? f.texture.pmremVersion : 0;
          if (o.isRenderTargetTexture && o.pmremVersion !== d)
            return (
              t === null && (t = new qr(i)),
              (f = l ? t.fromEquirectangular(o, f) : t.fromCubemap(o, f)),
              (f.texture.pmremVersion = o.pmremVersion),
              e.set(o, f),
              f.texture
            );
          if (f !== void 0) return f.texture;
          {
            const m = o.image;
            return (l && m && m.height > 0) || (h && m && r(m))
              ? (t === null && (t = new qr(i)),
                (f = l ? t.fromEquirectangular(o) : t.fromCubemap(o)),
                (f.texture.pmremVersion = o.pmremVersion),
                e.set(o, f),
                o.addEventListener("dispose", s),
                f.texture)
              : null;
          }
        }
      }
      return o;
    }
    function r(o) {
      let c = 0;
      const l = 6;
      for (let h = 0; h < l; h++) o[h] !== void 0 && c++;
      return c === l;
    }
    function s(o) {
      const c = o.target;
      c.removeEventListener("dispose", s);
      const l = e.get(c);
      l !== void 0 && (e.delete(c), l.dispose());
    }
    function a() {
      (e = new WeakMap()), t !== null && (t.dispose(), (t = null));
    }
    return { get: n, dispose: a };
  }
  function xl(i) {
    const e = {};
    function t(n) {
      if (e[n] !== void 0) return e[n];
      let r;
      switch (n) {
        case "WEBGL_depth_texture":
          r =
            i.getExtension("WEBGL_depth_texture") ||
            i.getExtension("MOZ_WEBGL_depth_texture") ||
            i.getExtension("WEBKIT_WEBGL_depth_texture");
          break;
        case "EXT_texture_filter_anisotropic":
          r =
            i.getExtension("EXT_texture_filter_anisotropic") ||
            i.getExtension("MOZ_EXT_texture_filter_anisotropic") ||
            i.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
          break;
        case "WEBGL_compressed_texture_s3tc":
          r =
            i.getExtension("WEBGL_compressed_texture_s3tc") ||
            i.getExtension("MOZ_WEBGL_compressed_texture_s3tc") ||
            i.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
          break;
        case "WEBGL_compressed_texture_pvrtc":
          r =
            i.getExtension("WEBGL_compressed_texture_pvrtc") || i.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
          break;
        default:
          r = i.getExtension(n);
      }
      return (e[n] = r), r;
    }
    return {
      has: function (n) {
        return t(n) !== null;
      },
      init: function () {
        t("EXT_color_buffer_float"),
          t("WEBGL_clip_cull_distance"),
          t("OES_texture_float_linear"),
          t("EXT_color_buffer_half_float"),
          t("WEBGL_multisampled_render_to_texture"),
          t("WEBGL_render_shared_exponent");
      },
      get: function (n) {
        const r = t(n);
        return r === null && _n("THREE.WebGLRenderer: " + n + " extension not supported."), r;
      }
    };
  }
  function Sl(i, e, t, n) {
    const r = {},
      s = new WeakMap();
    function a(f) {
      const d = f.target;
      d.index !== null && e.remove(d.index);
      for (const v in d.attributes) e.remove(d.attributes[v]);
      d.removeEventListener("dispose", a), delete r[d.id];
      const m = s.get(d);
      m && (e.remove(m), s.delete(d)),
        n.releaseStatesOfGeometry(d),
        d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount,
        t.memory.geometries--;
    }
    function o(f, d) {
      return r[d.id] === !0 || (d.addEventListener("dispose", a), (r[d.id] = !0), t.memory.geometries++), d;
    }
    function c(f) {
      const d = f.attributes;
      for (const m in d) e.update(d[m], i.ARRAY_BUFFER);
    }
    function l(f) {
      const d = [],
        m = f.index,
        v = f.attributes.position;
      let x = 0;
      if (m !== null) {
        const C = m.array;
        x = m.version;
        for (let y = 0, E = C.length; y < E; y += 3) {
          const D = C[y + 0],
            w = C[y + 1],
            P = C[y + 2];
          d.push(D, w, w, P, P, D);
        }
      } else if (v !== void 0) {
        const C = v.array;
        x = v.version;
        for (let y = 0, E = C.length / 3 - 1; y < E; y += 3) {
          const D = y + 0,
            w = y + 1,
            P = y + 2;
          d.push(D, w, w, P, P, D);
        }
      } else return;
      const p = new (cr(d) ? Rr : br)(d, 1);
      p.version = x;
      const u = s.get(f);
      u && e.remove(u), s.set(f, p);
    }
    function h(f) {
      const d = s.get(f);
      if (d) {
        const m = f.index;
        m !== null && d.version < m.version && l(f);
      } else l(f);
      return s.get(f);
    }
    return { get: o, update: c, getWireframeAttribute: h };
  }
  function Ml(i, e, t) {
    let n;
    function r(d) {
      n = d;
    }
    let s, a;
    function o(d) {
      (s = d.type), (a = d.bytesPerElement);
    }
    function c(d, m) {
      i.drawElements(n, m, s, d * a), t.update(m, n, 1);
    }
    function l(d, m, v) {
      v !== 0 && (i.drawElementsInstanced(n, m, s, d * a, v), t.update(m, n, v));
    }
    function h(d, m, v) {
      if (v === 0) return;
      e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(n, m, 0, s, d, 0, v);
      let p = 0;
      for (let u = 0; u < v; u++) p += m[u];
      t.update(p, n, 1);
    }
    function f(d, m, v, x) {
      if (v === 0) return;
      const p = e.get("WEBGL_multi_draw");
      if (p === null) for (let u = 0; u < d.length; u++) l(d[u] / a, m[u], x[u]);
      else {
        p.multiDrawElementsInstancedWEBGL(n, m, 0, s, d, 0, x, 0, v);
        let u = 0;
        for (let C = 0; C < v; C++) u += m[C] * x[C];
        t.update(u, n, 1);
      }
    }
    (this.setMode = r),
      (this.setIndex = o),
      (this.render = c),
      (this.renderInstances = l),
      (this.renderMultiDraw = h),
      (this.renderMultiDrawInstances = f);
  }
  function El(i) {
    const e = { geometries: 0, textures: 0 },
      t = { frame: 0, calls: 0, triangles: 0, points: 0, lines: 0 };
    function n(s, a, o) {
      switch ((t.calls++, a)) {
        case i.TRIANGLES:
          t.triangles += o * (s / 3);
          break;
        case i.LINES:
          t.lines += o * (s / 2);
          break;
        case i.LINE_STRIP:
          t.lines += o * (s - 1);
          break;
        case i.LINE_LOOP:
          t.lines += o * s;
          break;
        case i.POINTS:
          t.points += o * s;
          break;
        default:
          console.error("THREE.WebGLInfo: Unknown draw mode:", a);
          break;
      }
    }
    function r() {
      (t.calls = 0), (t.triangles = 0), (t.points = 0), (t.lines = 0);
    }
    return { memory: e, render: t, programs: null, autoReset: !0, reset: r, update: n };
  }
  function Tl(i, e, t) {
    const n = new WeakMap(),
      r = new rt();
    function s(a, o, c) {
      const l = a.morphTargetInfluences,
        h = o.morphAttributes.position || o.morphAttributes.normal || o.morphAttributes.color,
        f = h !== void 0 ? h.length : 0;
      let d = n.get(o);
      if (d === void 0 || d.count !== f) {
        let M = function () {
          P.dispose(), n.delete(o), o.removeEventListener("dispose", M);
        };
        d !== void 0 && d.texture.dispose();
        const m = o.morphAttributes.position !== void 0,
          v = o.morphAttributes.normal !== void 0,
          x = o.morphAttributes.color !== void 0,
          p = o.morphAttributes.position || [],
          u = o.morphAttributes.normal || [],
          C = o.morphAttributes.color || [];
        let y = 0;
        m === !0 && (y = 1), v === !0 && (y = 2), x === !0 && (y = 3);
        let E = o.attributes.position.count * y,
          D = 1;
        E > e.maxTextureSize && ((D = Math.ceil(E / e.maxTextureSize)), (E = e.maxTextureSize));
        const w = new Float32Array(E * D * 4 * f),
          P = new dr(w, E, D, f);
        (P.type = 1015), (P.needsUpdate = !0);
        const F = y * 4;
        for (let S = 0; S < f; S++) {
          const b = p[S],
            q = u[S],
            V = C[S],
            H = E * D * 4 * S;
          for (let K = 0; K < b.count; K++) {
            const X = K * F;
            m === !0 &&
              (r.fromBufferAttribute(b, K),
              (w[H + X + 0] = r.x),
              (w[H + X + 1] = r.y),
              (w[H + X + 2] = r.z),
              (w[H + X + 3] = 0)),
              v === !0 &&
                (r.fromBufferAttribute(q, K),
                (w[H + X + 4] = r.x),
                (w[H + X + 5] = r.y),
                (w[H + X + 6] = r.z),
                (w[H + X + 7] = 0)),
              x === !0 &&
                (r.fromBufferAttribute(V, K),
                (w[H + X + 8] = r.x),
                (w[H + X + 9] = r.y),
                (w[H + X + 10] = r.z),
                (w[H + X + 11] = V.itemSize === 4 ? r.w : 1));
          }
        }
        (d = { count: f, texture: P, size: new qe(E, D) }), n.set(o, d), o.addEventListener("dispose", M);
      }
      if (a.isInstancedMesh === !0 && a.morphTexture !== null)
        c.getUniforms().setValue(i, "morphTexture", a.morphTexture, t);
      else {
        let m = 0;
        for (let x = 0; x < l.length; x++) m += l[x];
        const v = o.morphTargetsRelative ? 1 : 1 - m;
        c.getUniforms().setValue(i, "morphTargetBaseInfluence", v),
          c.getUniforms().setValue(i, "morphTargetInfluences", l);
      }
      c.getUniforms().setValue(i, "morphTargetsTexture", d.texture, t),
        c.getUniforms().setValue(i, "morphTargetsTextureSize", d.size);
    }
    return { update: s };
  }
  function yl(i, e, t, n) {
    let r = new WeakMap();
    function s(c) {
      const l = n.render.frame,
        h = c.geometry,
        f = e.get(c, h);
      if (
        (r.get(f) !== l && (e.update(f), r.set(f, l)),
        c.isInstancedMesh &&
          (c.hasEventListener("dispose", o) === !1 && c.addEventListener("dispose", o),
          r.get(c) !== l &&
            (t.update(c.instanceMatrix, i.ARRAY_BUFFER),
            c.instanceColor !== null && t.update(c.instanceColor, i.ARRAY_BUFFER),
            r.set(c, l))),
        c.isSkinnedMesh)
      ) {
        const d = c.skeleton;
        r.get(d) !== l && (d.update(), r.set(d, l));
      }
      return f;
    }
    function a() {
      r = new WeakMap();
    }
    function o(c) {
      const l = c.target;
      l.removeEventListener("dispose", o),
        t.remove(l.instanceMatrix),
        l.instanceColor !== null && t.remove(l.instanceColor);
    }
    return { update: s, dispose: a };
  }
  const Zr = new vt(),
    Jr = new Gr(1, 1),
    jr = new dr(),
    Qr = new Ls(),
    es = new Fr(),
    ts = [],
    ns = [],
    is = new Float32Array(16),
    rs = new Float32Array(9),
    ss = new Float32Array(4);
  function Un(i, e, t) {
    const n = i[0];
    if (n <= 0 || n > 0) return i;
    const r = e * t;
    let s = ts[r];
    if ((s === void 0 && ((s = new Float32Array(r)), (ts[r] = s)), e !== 0)) {
      n.toArray(s, 0);
      for (let a = 1, o = 0; a !== e; ++a) (o += t), i[a].toArray(s, o);
    }
    return s;
  }
  function ct(i, e) {
    if (i.length !== e.length) return !1;
    for (let t = 0, n = i.length; t < n; t++) if (i[t] !== e[t]) return !1;
    return !0;
  }
  function ut(i, e) {
    for (let t = 0, n = e.length; t < n; t++) i[t] = e[t];
  }
  function xi(i, e) {
    let t = ns[e];
    t === void 0 && ((t = new Int32Array(e)), (ns[e] = t));
    for (let n = 0; n !== e; ++n) t[n] = i.allocateTextureUnit();
    return t;
  }
  function Al(i, e) {
    const t = this.cache;
    t[0] !== e && (i.uniform1f(this.addr, e), (t[0] = e));
  }
  function bl(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y) && (i.uniform2f(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y));
    else {
      if (ct(t, e)) return;
      i.uniform2fv(this.addr, e), ut(t, e);
    }
  }
  function Rl(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
        (i.uniform3f(this.addr, e.x, e.y, e.z), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z));
    else if (e.r !== void 0)
      (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) &&
        (i.uniform3f(this.addr, e.r, e.g, e.b), (t[0] = e.r), (t[1] = e.g), (t[2] = e.b));
    else {
      if (ct(t, e)) return;
      i.uniform3fv(this.addr, e), ut(t, e);
    }
  }
  function Cl(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
        (i.uniform4f(this.addr, e.x, e.y, e.z, e.w), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z), (t[3] = e.w));
    else {
      if (ct(t, e)) return;
      i.uniform4fv(this.addr, e), ut(t, e);
    }
  }
  function wl(i, e) {
    const t = this.cache,
      n = e.elements;
    if (n === void 0) {
      if (ct(t, e)) return;
      i.uniformMatrix2fv(this.addr, !1, e), ut(t, e);
    } else {
      if (ct(t, n)) return;
      ss.set(n), i.uniformMatrix2fv(this.addr, !1, ss), ut(t, n);
    }
  }
  function Pl(i, e) {
    const t = this.cache,
      n = e.elements;
    if (n === void 0) {
      if (ct(t, e)) return;
      i.uniformMatrix3fv(this.addr, !1, e), ut(t, e);
    } else {
      if (ct(t, n)) return;
      rs.set(n), i.uniformMatrix3fv(this.addr, !1, rs), ut(t, n);
    }
  }
  function Dl(i, e) {
    const t = this.cache,
      n = e.elements;
    if (n === void 0) {
      if (ct(t, e)) return;
      i.uniformMatrix4fv(this.addr, !1, e), ut(t, e);
    } else {
      if (ct(t, n)) return;
      is.set(n), i.uniformMatrix4fv(this.addr, !1, is), ut(t, n);
    }
  }
  function Ll(i, e) {
    const t = this.cache;
    t[0] !== e && (i.uniform1i(this.addr, e), (t[0] = e));
  }
  function Ul(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y) && (i.uniform2i(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y));
    else {
      if (ct(t, e)) return;
      i.uniform2iv(this.addr, e), ut(t, e);
    }
  }
  function Il(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
        (i.uniform3i(this.addr, e.x, e.y, e.z), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z));
    else {
      if (ct(t, e)) return;
      i.uniform3iv(this.addr, e), ut(t, e);
    }
  }
  function Fl(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
        (i.uniform4i(this.addr, e.x, e.y, e.z, e.w), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z), (t[3] = e.w));
    else {
      if (ct(t, e)) return;
      i.uniform4iv(this.addr, e), ut(t, e);
    }
  }
  function Nl(i, e) {
    const t = this.cache;
    t[0] !== e && (i.uniform1ui(this.addr, e), (t[0] = e));
  }
  function Ol(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y) && (i.uniform2ui(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y));
    else {
      if (ct(t, e)) return;
      i.uniform2uiv(this.addr, e), ut(t, e);
    }
  }
  function Bl(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
        (i.uniform3ui(this.addr, e.x, e.y, e.z), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z));
    else {
      if (ct(t, e)) return;
      i.uniform3uiv(this.addr, e), ut(t, e);
    }
  }
  function Gl(i, e) {
    const t = this.cache;
    if (e.x !== void 0)
      (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
        (i.uniform4ui(this.addr, e.x, e.y, e.z, e.w), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z), (t[3] = e.w));
    else {
      if (ct(t, e)) return;
      i.uniform4uiv(this.addr, e), ut(t, e);
    }
  }
  function zl(i, e, t) {
    const n = this.cache,
      r = t.allocateTextureUnit();
    n[0] !== r && (i.uniform1i(this.addr, r), (n[0] = r));
    let s;
    this.type === i.SAMPLER_2D_SHADOW ? ((Jr.compareFunction = 515), (s = Jr)) : (s = Zr), t.setTexture2D(e || s, r);
  }
  function Vl(i, e, t) {
    const n = this.cache,
      r = t.allocateTextureUnit();
    n[0] !== r && (i.uniform1i(this.addr, r), (n[0] = r)), t.setTexture3D(e || Qr, r);
  }
  function Hl(i, e, t) {
    const n = this.cache,
      r = t.allocateTextureUnit();
    n[0] !== r && (i.uniform1i(this.addr, r), (n[0] = r)), t.setTextureCube(e || es, r);
  }
  function kl(i, e, t) {
    const n = this.cache,
      r = t.allocateTextureUnit();
    n[0] !== r && (i.uniform1i(this.addr, r), (n[0] = r)), t.setTexture2DArray(e || jr, r);
  }
  function Wl(i) {
    switch (i) {
      case 5126:
        return Al;
      case 35664:
        return bl;
      case 35665:
        return Rl;
      case 35666:
        return Cl;
      case 35674:
        return wl;
      case 35675:
        return Pl;
      case 35676:
        return Dl;
      case 5124:
      case 35670:
        return Ll;
      case 35667:
      case 35671:
        return Ul;
      case 35668:
      case 35672:
        return Il;
      case 35669:
      case 35673:
        return Fl;
      case 5125:
        return Nl;
      case 36294:
        return Ol;
      case 36295:
        return Bl;
      case 36296:
        return Gl;
      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return zl;
      case 35679:
      case 36299:
      case 36307:
        return Vl;
      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return Hl;
      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return kl;
    }
  }
  function Xl(i, e) {
    i.uniform1fv(this.addr, e);
  }
  function ql(i, e) {
    const t = Un(e, this.size, 2);
    i.uniform2fv(this.addr, t);
  }
  function Yl(i, e) {
    const t = Un(e, this.size, 3);
    i.uniform3fv(this.addr, t);
  }
  function $l(i, e) {
    const t = Un(e, this.size, 4);
    i.uniform4fv(this.addr, t);
  }
  function Kl(i, e) {
    const t = Un(e, this.size, 4);
    i.uniformMatrix2fv(this.addr, !1, t);
  }
  function Zl(i, e) {
    const t = Un(e, this.size, 9);
    i.uniformMatrix3fv(this.addr, !1, t);
  }
  function Jl(i, e) {
    const t = Un(e, this.size, 16);
    i.uniformMatrix4fv(this.addr, !1, t);
  }
  function jl(i, e) {
    i.uniform1iv(this.addr, e);
  }
  function Ql(i, e) {
    i.uniform2iv(this.addr, e);
  }
  function ec(i, e) {
    i.uniform3iv(this.addr, e);
  }
  function tc(i, e) {
    i.uniform4iv(this.addr, e);
  }
  function nc(i, e) {
    i.uniform1uiv(this.addr, e);
  }
  function ic(i, e) {
    i.uniform2uiv(this.addr, e);
  }
  function rc(i, e) {
    i.uniform3uiv(this.addr, e);
  }
  function sc(i, e) {
    i.uniform4uiv(this.addr, e);
  }
  function ac(i, e, t) {
    const n = this.cache,
      r = e.length,
      s = xi(t, r);
    ct(n, s) || (i.uniform1iv(this.addr, s), ut(n, s));
    for (let a = 0; a !== r; ++a) t.setTexture2D(e[a] || Zr, s[a]);
  }
  function oc(i, e, t) {
    const n = this.cache,
      r = e.length,
      s = xi(t, r);
    ct(n, s) || (i.uniform1iv(this.addr, s), ut(n, s));
    for (let a = 0; a !== r; ++a) t.setTexture3D(e[a] || Qr, s[a]);
  }
  function lc(i, e, t) {
    const n = this.cache,
      r = e.length,
      s = xi(t, r);
    ct(n, s) || (i.uniform1iv(this.addr, s), ut(n, s));
    for (let a = 0; a !== r; ++a) t.setTextureCube(e[a] || es, s[a]);
  }
  function cc(i, e, t) {
    const n = this.cache,
      r = e.length,
      s = xi(t, r);
    ct(n, s) || (i.uniform1iv(this.addr, s), ut(n, s));
    for (let a = 0; a !== r; ++a) t.setTexture2DArray(e[a] || jr, s[a]);
  }
  function uc(i) {
    switch (i) {
      case 5126:
        return Xl;
      case 35664:
        return ql;
      case 35665:
        return Yl;
      case 35666:
        return $l;
      case 35674:
        return Kl;
      case 35675:
        return Zl;
      case 35676:
        return Jl;
      case 5124:
      case 35670:
        return jl;
      case 35667:
      case 35671:
        return Ql;
      case 35668:
      case 35672:
        return ec;
      case 35669:
      case 35673:
        return tc;
      case 5125:
        return nc;
      case 36294:
        return ic;
      case 36295:
        return rc;
      case 36296:
        return sc;
      case 35678:
      case 36198:
      case 36298:
      case 36306:
      case 35682:
        return ac;
      case 35679:
      case 36299:
      case 36307:
        return oc;
      case 35680:
      case 36300:
      case 36308:
      case 36293:
        return lc;
      case 36289:
      case 36303:
      case 36311:
      case 36292:
        return cc;
    }
  }
  class hc {
    constructor(e, t, n) {
      (this.id = e), (this.addr = n), (this.cache = []), (this.type = t.type), (this.setValue = Wl(t.type));
    }
  }
  class fc {
    constructor(e, t, n) {
      (this.id = e),
        (this.addr = n),
        (this.cache = []),
        (this.type = t.type),
        (this.size = t.size),
        (this.setValue = uc(t.type));
    }
  }
  class dc {
    constructor(e) {
      (this.id = e), (this.seq = []), (this.map = {});
    }
    setValue(e, t, n) {
      const r = this.seq;
      for (let s = 0, a = r.length; s !== a; ++s) {
        const o = r[s];
        o.setValue(e, t[o.id], n);
      }
    }
  }
  const ir = /(\w+)(\])?(\[|\.)?/g;
  function as(i, e) {
    i.seq.push(e), (i.map[e.id] = e);
  }
  function pc(i, e, t) {
    const n = i.name,
      r = n.length;
    for (ir.lastIndex = 0; ; ) {
      const s = ir.exec(n),
        a = ir.lastIndex;
      let o = s[1];
      const c = s[2] === "]",
        l = s[3];
      if ((c && (o = o | 0), l === void 0 || (l === "[" && a + 2 === r))) {
        as(t, l === void 0 ? new hc(o, i, e) : new fc(o, i, e));
        break;
      } else {
        let f = t.map[o];
        f === void 0 && ((f = new dc(o)), as(t, f)), (t = f);
      }
    }
  }
  class Si {
    constructor(e, t) {
      (this.seq = []), (this.map = {});
      const n = e.getProgramParameter(t, e.ACTIVE_UNIFORMS);
      for (let r = 0; r < n; ++r) {
        const s = e.getActiveUniform(t, r),
          a = e.getUniformLocation(t, s.name);
        pc(s, a, this);
      }
    }
    setValue(e, t, n, r) {
      const s = this.map[t];
      s !== void 0 && s.setValue(e, n, r);
    }
    setOptional(e, t, n) {
      const r = t[n];
      r !== void 0 && this.setValue(e, n, r);
    }
    static upload(e, t, n, r) {
      for (let s = 0, a = t.length; s !== a; ++s) {
        const o = t[s],
          c = n[o.id];
        c.needsUpdate !== !1 && o.setValue(e, c.value, r);
      }
    }
    static seqWithValue(e, t) {
      const n = [];
      for (let r = 0, s = e.length; r !== s; ++r) {
        const a = e[r];
        a.id in t && n.push(a);
      }
      return n;
    }
  }
  function os(i, e, t) {
    const n = i.createShader(e);
    return i.shaderSource(n, t), i.compileShader(n), n;
  }
  const mc = 37297;
  let _c = 0;
  function gc(i, e) {
    const t = i.split(`
`),
      n = [],
      r = Math.max(e - 6, 0),
      s = Math.min(e + 6, t.length);
    for (let a = r; a < s; a++) {
      const o = a + 1;
      n.push(`${o === e ? ">" : " "} ${o}: ${t[a]}`);
    }
    return n.join(`
`);
  }
  const ls = new Le();
  function vc(i) {
    ze._getMatrix(ls, ze.workingColorSpace, i);
    const e = `mat3( ${ls.elements.map(t => t.toFixed(4))} )`;
    switch (ze.getTransfer(i)) {
      case Yn:
        return [e, "LinearTransferOETF"];
      case Xe:
        return [e, "sRGBTransferOETF"];
      default:
        return console.warn("THREE.WebGLProgram: Unsupported color space: ", i), [e, "LinearTransferOETF"];
    }
  }
  function cs(i, e, t) {
    const n = i.getShaderParameter(e, i.COMPILE_STATUS),
      s = (i.getShaderInfoLog(e) || "").trim();
    if (n && s === "") return "";
    const a = /ERROR: 0:(\d+)/.exec(s);
    if (a) {
      const o = parseInt(a[1]);
      return (
        t.toUpperCase() +
        `

` +
        s +
        `

` +
        gc(i.getShaderSource(e), o)
      );
    } else return s;
  }
  function xc(i, e) {
    const t = vc(e);
    return [`vec4 ${i}( vec4 value ) {`, `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`, "}"].join(`
`);
  }
  function Sc(i, e) {
    let t;
    switch (e) {
      case 1:
        t = "Linear";
        break;
      case 2:
        t = "Reinhard";
        break;
      case 3:
        t = "Cineon";
        break;
      case 4:
        t = "ACESFilmic";
        break;
      case 6:
        t = "AgX";
        break;
      case 7:
        t = "Neutral";
        break;
      case 5:
        t = "Custom";
        break;
      default:
        console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), (t = "Linear");
    }
    return "vec3 " + i + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
  }
  const Mi = new O();
  function Mc() {
    ze.getLuminanceCoefficients(Mi);
    const i = Mi.x.toFixed(4),
      e = Mi.y.toFixed(4),
      t = Mi.z.toFixed(4);
    return [
      "float luminance( const in vec3 rgb ) {",
      `	const vec3 weights = vec3( ${i}, ${e}, ${t} );`,
      "	return dot( weights, rgb );",
      "}"
    ].join(`
`);
  }
  function Ec(i) {
    return [
      i.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
      i.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
    ].filter(Xn).join(`
`);
  }
  function Tc(i) {
    const e = [];
    for (const t in i) {
      const n = i[t];
      n !== !1 && e.push("#define " + t + " " + n);
    }
    return e.join(`
`);
  }
  function yc(i, e) {
    const t = {},
      n = i.getProgramParameter(e, i.ACTIVE_ATTRIBUTES);
    for (let r = 0; r < n; r++) {
      const s = i.getActiveAttrib(e, r),
        a = s.name;
      let o = 1;
      s.type === i.FLOAT_MAT2 && (o = 2),
        s.type === i.FLOAT_MAT3 && (o = 3),
        s.type === i.FLOAT_MAT4 && (o = 4),
        (t[a] = { type: s.type, location: i.getAttribLocation(e, a), locationSize: o });
    }
    return t;
  }
  function Xn(i) {
    return i !== "";
  }
  function us(i, e) {
    const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps;
    return i
      .replace(/NUM_DIR_LIGHTS/g, e.numDirLights)
      .replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights)
      .replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps)
      .replace(/NUM_SPOT_LIGHT_COORDS/g, t)
      .replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights)
      .replace(/NUM_POINT_LIGHTS/g, e.numPointLights)
      .replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights)
      .replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows)
      .replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps)
      .replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows)
      .replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
  }
  function hs(i, e) {
    return i
      .replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes)
      .replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
  }
  const Ac = /^[ \t]*#include +<([\w\d./]+)>/gm;
  function rr(i) {
    return i.replace(Ac, Rc);
  }
  const bc = new Map();
  function Rc(i, e) {
    let t = Ie[e];
    if (t === void 0) {
      const n = bc.get(e);
      if (n !== void 0)
        (t = Ie[n]),
          console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', e, n);
      else throw new Error("Can not resolve #include <" + e + ">");
    }
    return rr(t);
  }
  const Cc =
    /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
  function fs(i) {
    return i.replace(Cc, wc);
  }
  function wc(i, e, t, n) {
    let r = "";
    for (let s = parseInt(e); s < parseInt(t); s++)
      r += n.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s);
    return r;
  }
  function ds(i) {
    let e = `precision ${i.precision} float;
	precision ${i.precision} int;
	precision ${i.precision} sampler2D;
	precision ${i.precision} samplerCube;
	precision ${i.precision} sampler3D;
	precision ${i.precision} sampler2DArray;
	precision ${i.precision} sampler2DShadow;
	precision ${i.precision} samplerCubeShadow;
	precision ${i.precision} sampler2DArrayShadow;
	precision ${i.precision} isampler2D;
	precision ${i.precision} isampler3D;
	precision ${i.precision} isamplerCube;
	precision ${i.precision} isampler2DArray;
	precision ${i.precision} usampler2D;
	precision ${i.precision} usampler3D;
	precision ${i.precision} usamplerCube;
	precision ${i.precision} usampler2DArray;
	`;
    return (
      i.precision === "highp"
        ? (e += `
#define HIGH_PRECISION`)
        : i.precision === "mediump"
        ? (e += `
#define MEDIUM_PRECISION`)
        : i.precision === "lowp" &&
          (e += `
#define LOW_PRECISION`),
      e
    );
  }
  function Pc(i) {
    let e = "SHADOWMAP_TYPE_BASIC";
    return (
      i.shadowMapType === 1
        ? (e = "SHADOWMAP_TYPE_PCF")
        : i.shadowMapType === 2
        ? (e = "SHADOWMAP_TYPE_PCF_SOFT")
        : i.shadowMapType === 3 && (e = "SHADOWMAP_TYPE_VSM"),
      e
    );
  }
  function Dc(i) {
    let e = "ENVMAP_TYPE_CUBE";
    if (i.envMap)
      switch (i.envMapMode) {
        case 301:
        case 302:
          e = "ENVMAP_TYPE_CUBE";
          break;
        case 306:
          e = "ENVMAP_TYPE_CUBE_UV";
          break;
      }
    return e;
  }
  function Lc(i) {
    let e = "ENVMAP_MODE_REFLECTION";
    return i.envMap && i.envMapMode === 302 && (e = "ENVMAP_MODE_REFRACTION"), e;
  }
  function Uc(i) {
    let e = "ENVMAP_BLENDING_NONE";
    if (i.envMap)
      switch (i.combine) {
        case 0:
          e = "ENVMAP_BLENDING_MULTIPLY";
          break;
        case 1:
          e = "ENVMAP_BLENDING_MIX";
          break;
        case 2:
          e = "ENVMAP_BLENDING_ADD";
          break;
      }
    return e;
  }
  function Ic(i) {
    const e = i.envMapCubeUVHeight;
    if (e === null) return null;
    const t = Math.log2(e) - 2,
      n = 1 / e;
    return { texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)), texelHeight: n, maxMip: t };
  }
  function Fc(i, e, t, n) {
    const r = i.getContext(),
      s = t.defines;
    let a = t.vertexShader,
      o = t.fragmentShader;
    const c = Pc(t),
      l = Dc(t),
      h = Lc(t),
      f = Uc(t),
      d = Ic(t),
      m = Ec(t),
      v = Tc(s),
      x = r.createProgram();
    let p,
      u,
      C = t.glslVersion
        ? "#version " +
          t.glslVersion +
          `
`
        : "";
    t.isRawShaderMaterial
      ? ((p = ["#define SHADER_TYPE " + t.shaderType, "#define SHADER_NAME " + t.shaderName, v].filter(Xn).join(`
`)),
        p.length > 0 &&
          (p += `
`),
        (u = ["#define SHADER_TYPE " + t.shaderType, "#define SHADER_NAME " + t.shaderName, v].filter(Xn).join(`
`)),
        u.length > 0 &&
          (u += `
`))
      : ((p = [
          ds(t),
          "#define SHADER_TYPE " + t.shaderType,
          "#define SHADER_NAME " + t.shaderName,
          v,
          t.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
          t.batching ? "#define USE_BATCHING" : "",
          t.batchingColor ? "#define USE_BATCHING_COLOR" : "",
          t.instancing ? "#define USE_INSTANCING" : "",
          t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
          t.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
          t.useFog && t.fog ? "#define USE_FOG" : "",
          t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
          t.map ? "#define USE_MAP" : "",
          t.envMap ? "#define USE_ENVMAP" : "",
          t.envMap ? "#define " + h : "",
          t.lightMap ? "#define USE_LIGHTMAP" : "",
          t.aoMap ? "#define USE_AOMAP" : "",
          t.bumpMap ? "#define USE_BUMPMAP" : "",
          t.normalMap ? "#define USE_NORMALMAP" : "",
          t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
          t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
          t.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
          t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
          t.anisotropy ? "#define USE_ANISOTROPY" : "",
          t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
          t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
          t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
          t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
          t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
          t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
          t.specularMap ? "#define USE_SPECULARMAP" : "",
          t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
          t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
          t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
          t.metalnessMap ? "#define USE_METALNESSMAP" : "",
          t.alphaMap ? "#define USE_ALPHAMAP" : "",
          t.alphaHash ? "#define USE_ALPHAHASH" : "",
          t.transmission ? "#define USE_TRANSMISSION" : "",
          t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
          t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
          t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
          t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
          t.mapUv ? "#define MAP_UV " + t.mapUv : "",
          t.alphaMapUv ? "#define ALPHAMAP_UV " + t.alphaMapUv : "",
          t.lightMapUv ? "#define LIGHTMAP_UV " + t.lightMapUv : "",
          t.aoMapUv ? "#define AOMAP_UV " + t.aoMapUv : "",
          t.emissiveMapUv ? "#define EMISSIVEMAP_UV " + t.emissiveMapUv : "",
          t.bumpMapUv ? "#define BUMPMAP_UV " + t.bumpMapUv : "",
          t.normalMapUv ? "#define NORMALMAP_UV " + t.normalMapUv : "",
          t.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + t.displacementMapUv : "",
          t.metalnessMapUv ? "#define METALNESSMAP_UV " + t.metalnessMapUv : "",
          t.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + t.roughnessMapUv : "",
          t.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + t.anisotropyMapUv : "",
          t.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + t.clearcoatMapUv : "",
          t.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + t.clearcoatNormalMapUv : "",
          t.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + t.clearcoatRoughnessMapUv : "",
          t.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + t.iridescenceMapUv : "",
          t.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + t.iridescenceThicknessMapUv : "",
          t.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + t.sheenColorMapUv : "",
          t.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + t.sheenRoughnessMapUv : "",
          t.specularMapUv ? "#define SPECULARMAP_UV " + t.specularMapUv : "",
          t.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + t.specularColorMapUv : "",
          t.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + t.specularIntensityMapUv : "",
          t.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + t.transmissionMapUv : "",
          t.thicknessMapUv ? "#define THICKNESSMAP_UV " + t.thicknessMapUv : "",
          t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
          t.vertexColors ? "#define USE_COLOR" : "",
          t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
          t.vertexUv1s ? "#define USE_UV1" : "",
          t.vertexUv2s ? "#define USE_UV2" : "",
          t.vertexUv3s ? "#define USE_UV3" : "",
          t.pointsUvs ? "#define USE_POINTS_UV" : "",
          t.flatShading ? "#define FLAT_SHADED" : "",
          t.skinning ? "#define USE_SKINNING" : "",
          t.morphTargets ? "#define USE_MORPHTARGETS" : "",
          t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
          t.morphColors ? "#define USE_MORPHCOLORS" : "",
          t.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
          t.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
          t.doubleSided ? "#define DOUBLE_SIDED" : "",
          t.flipSided ? "#define FLIP_SIDED" : "",
          t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
          t.shadowMapEnabled ? "#define " + c : "",
          t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
          t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
          t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
          t.reversedDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
          "uniform mat4 modelMatrix;",
          "uniform mat4 modelViewMatrix;",
          "uniform mat4 projectionMatrix;",
          "uniform mat4 viewMatrix;",
          "uniform mat3 normalMatrix;",
          "uniform vec3 cameraPosition;",
          "uniform bool isOrthographic;",
          "#ifdef USE_INSTANCING",
          "	attribute mat4 instanceMatrix;",
          "#endif",
          "#ifdef USE_INSTANCING_COLOR",
          "	attribute vec3 instanceColor;",
          "#endif",
          "#ifdef USE_INSTANCING_MORPH",
          "	uniform sampler2D morphTexture;",
          "#endif",
          "attribute vec3 position;",
          "attribute vec3 normal;",
          "attribute vec2 uv;",
          "#ifdef USE_UV1",
          "	attribute vec2 uv1;",
          "#endif",
          "#ifdef USE_UV2",
          "	attribute vec2 uv2;",
          "#endif",
          "#ifdef USE_UV3",
          "	attribute vec2 uv3;",
          "#endif",
          "#ifdef USE_TANGENT",
          "	attribute vec4 tangent;",
          "#endif",
          "#if defined( USE_COLOR_ALPHA )",
          "	attribute vec4 color;",
          "#elif defined( USE_COLOR )",
          "	attribute vec3 color;",
          "#endif",
          "#ifdef USE_SKINNING",
          "	attribute vec4 skinIndex;",
          "	attribute vec4 skinWeight;",
          "#endif",
          `
`
        ].filter(Xn).join(`
`)),
        (u = [
          ds(t),
          "#define SHADER_TYPE " + t.shaderType,
          "#define SHADER_NAME " + t.shaderName,
          v,
          t.useFog && t.fog ? "#define USE_FOG" : "",
          t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
          t.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
          t.map ? "#define USE_MAP" : "",
          t.matcap ? "#define USE_MATCAP" : "",
          t.envMap ? "#define USE_ENVMAP" : "",
          t.envMap ? "#define " + l : "",
          t.envMap ? "#define " + h : "",
          t.envMap ? "#define " + f : "",
          d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
          d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
          d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
          t.lightMap ? "#define USE_LIGHTMAP" : "",
          t.aoMap ? "#define USE_AOMAP" : "",
          t.bumpMap ? "#define USE_BUMPMAP" : "",
          t.normalMap ? "#define USE_NORMALMAP" : "",
          t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
          t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
          t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
          t.anisotropy ? "#define USE_ANISOTROPY" : "",
          t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
          t.clearcoat ? "#define USE_CLEARCOAT" : "",
          t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
          t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
          t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
          t.dispersion ? "#define USE_DISPERSION" : "",
          t.iridescence ? "#define USE_IRIDESCENCE" : "",
          t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
          t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
          t.specularMap ? "#define USE_SPECULARMAP" : "",
          t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
          t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
          t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
          t.metalnessMap ? "#define USE_METALNESSMAP" : "",
          t.alphaMap ? "#define USE_ALPHAMAP" : "",
          t.alphaTest ? "#define USE_ALPHATEST" : "",
          t.alphaHash ? "#define USE_ALPHAHASH" : "",
          t.sheen ? "#define USE_SHEEN" : "",
          t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
          t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
          t.transmission ? "#define USE_TRANSMISSION" : "",
          t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
          t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
          t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
          t.vertexColors || t.instancingColor || t.batchingColor ? "#define USE_COLOR" : "",
          t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
          t.vertexUv1s ? "#define USE_UV1" : "",
          t.vertexUv2s ? "#define USE_UV2" : "",
          t.vertexUv3s ? "#define USE_UV3" : "",
          t.pointsUvs ? "#define USE_POINTS_UV" : "",
          t.gradientMap ? "#define USE_GRADIENTMAP" : "",
          t.flatShading ? "#define FLAT_SHADED" : "",
          t.doubleSided ? "#define DOUBLE_SIDED" : "",
          t.flipSided ? "#define FLIP_SIDED" : "",
          t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
          t.shadowMapEnabled ? "#define " + c : "",
          t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
          t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
          t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
          t.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
          t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
          t.reversedDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
          "uniform mat4 viewMatrix;",
          "uniform vec3 cameraPosition;",
          "uniform bool isOrthographic;",
          t.toneMapping !== 0 ? "#define TONE_MAPPING" : "",
          t.toneMapping !== 0 ? Ie.tonemapping_pars_fragment : "",
          t.toneMapping !== 0 ? Sc("toneMapping", t.toneMapping) : "",
          t.dithering ? "#define DITHERING" : "",
          t.opaque ? "#define OPAQUE" : "",
          Ie.colorspace_pars_fragment,
          xc("linearToOutputTexel", t.outputColorSpace),
          Mc(),
          t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
          `
`
        ].filter(Xn).join(`
`))),
      (a = rr(a)),
      (a = us(a, t)),
      (a = hs(a, t)),
      (o = rr(o)),
      (o = us(o, t)),
      (o = hs(o, t)),
      (a = fs(a)),
      (o = fs(o)),
      t.isRawShaderMaterial !== !0 &&
        ((C = `#version 300 es
`),
        (p =
          [m, "#define attribute in", "#define varying out", "#define texture2D texture"].join(`
`) +
          `
` +
          p),
        (u =
          [
            "#define varying in",
            t.glslVersion === or ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
            t.glslVersion === or ? "" : "#define gl_FragColor pc_fragColor",
            "#define gl_FragDepthEXT gl_FragDepth",
            "#define texture2D texture",
            "#define textureCube texture",
            "#define texture2DProj textureProj",
            "#define texture2DLodEXT textureLod",
            "#define texture2DProjLodEXT textureProjLod",
            "#define textureCubeLodEXT textureLod",
            "#define texture2DGradEXT textureGrad",
            "#define texture2DProjGradEXT textureProjGrad",
            "#define textureCubeGradEXT textureGrad"
          ].join(`
`) +
          `
` +
          u));
    const y = C + p + a,
      E = C + u + o,
      D = os(r, r.VERTEX_SHADER, y),
      w = os(r, r.FRAGMENT_SHADER, E);
    r.attachShader(x, D),
      r.attachShader(x, w),
      t.index0AttributeName !== void 0
        ? r.bindAttribLocation(x, 0, t.index0AttributeName)
        : t.morphTargets === !0 && r.bindAttribLocation(x, 0, "position"),
      r.linkProgram(x);
    function P(b) {
      if (i.debug.checkShaderErrors) {
        const q = r.getProgramInfoLog(x) || "",
          V = r.getShaderInfoLog(D) || "",
          H = r.getShaderInfoLog(w) || "",
          K = q.trim(),
          X = V.trim(),
          ee = H.trim();
        let G = !0,
          se = !0;
        if (r.getProgramParameter(x, r.LINK_STATUS) === !1)
          if (((G = !1), typeof i.debug.onShaderError == "function")) i.debug.onShaderError(r, x, D, w);
          else {
            const ue = cs(r, D, "vertex"),
              Me = cs(r, w, "fragment");
            console.error(
              "THREE.WebGLProgram: Shader Error " +
                r.getError() +
                " - VALIDATE_STATUS " +
                r.getProgramParameter(x, r.VALIDATE_STATUS) +
                `

Material Name: ` +
                b.name +
                `
Material Type: ` +
                b.type +
                `

Program Info Log: ` +
                K +
                `
` +
                ue +
                `
` +
                Me
            );
          }
        else K !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", K) : (X === "" || ee === "") && (se = !1);
        se &&
          (b.diagnostics = {
            runnable: G,
            programLog: K,
            vertexShader: { log: X, prefix: p },
            fragmentShader: { log: ee, prefix: u }
          });
      }
      r.deleteShader(D), r.deleteShader(w), (F = new Si(r, x)), (M = yc(r, x));
    }
    let F;
    this.getUniforms = function () {
      return F === void 0 && P(this), F;
    };
    let M;
    this.getAttributes = function () {
      return M === void 0 && P(this), M;
    };
    let S = t.rendererExtensionParallelShaderCompile === !1;
    return (
      (this.isReady = function () {
        return S === !1 && (S = r.getProgramParameter(x, mc)), S;
      }),
      (this.destroy = function () {
        n.releaseStatesOfProgram(this), r.deleteProgram(x), (this.program = void 0);
      }),
      (this.type = t.shaderType),
      (this.name = t.shaderName),
      (this.id = _c++),
      (this.cacheKey = e),
      (this.usedTimes = 1),
      (this.program = x),
      (this.vertexShader = D),
      (this.fragmentShader = w),
      this
    );
  }
  let Nc = 0;
  class Oc {
    constructor() {
      (this.shaderCache = new Map()), (this.materialCache = new Map());
    }
    update(e) {
      const t = e.vertexShader,
        n = e.fragmentShader,
        r = this._getShaderStage(t),
        s = this._getShaderStage(n),
        a = this._getShaderCacheForMaterial(e);
      return a.has(r) === !1 && (a.add(r), r.usedTimes++), a.has(s) === !1 && (a.add(s), s.usedTimes++), this;
    }
    remove(e) {
      const t = this.materialCache.get(e);
      for (const n of t) n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
      return this.materialCache.delete(e), this;
    }
    getVertexShaderID(e) {
      return this._getShaderStage(e.vertexShader).id;
    }
    getFragmentShaderID(e) {
      return this._getShaderStage(e.fragmentShader).id;
    }
    dispose() {
      this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(e) {
      const t = this.materialCache;
      let n = t.get(e);
      return n === void 0 && ((n = new Set()), t.set(e, n)), n;
    }
    _getShaderStage(e) {
      const t = this.shaderCache;
      let n = t.get(e);
      return n === void 0 && ((n = new Bc(e)), t.set(e, n)), n;
    }
  }
  class Bc {
    constructor(e) {
      (this.id = Nc++), (this.code = e), (this.usedTimes = 0);
    }
  }
  function Gc(i, e, t, n, r, s, a) {
    const o = new gr(),
      c = new Oc(),
      l = new Set(),
      h = [],
      f = r.logarithmicDepthBuffer,
      d = r.vertexTextures;
    let m = r.precision;
    const v = {
      MeshDepthMaterial: "depth",
      MeshDistanceMaterial: "distanceRGBA",
      MeshNormalMaterial: "normal",
      MeshBasicMaterial: "basic",
      MeshLambertMaterial: "lambert",
      MeshPhongMaterial: "phong",
      MeshToonMaterial: "toon",
      MeshStandardMaterial: "physical",
      MeshPhysicalMaterial: "physical",
      MeshMatcapMaterial: "matcap",
      LineBasicMaterial: "basic",
      LineDashedMaterial: "dashed",
      PointsMaterial: "points",
      ShadowMaterial: "shadow",
      SpriteMaterial: "sprite"
    };
    function x(M) {
      return l.add(M), M === 0 ? "uv" : `uv${M}`;
    }
    function p(M, S, b, q, V) {
      const H = q.fog,
        K = V.geometry,
        X = M.isMeshStandardMaterial ? q.environment : null,
        ee = (M.isMeshStandardMaterial ? t : e).get(M.envMap || X),
        G = ee && ee.mapping === 306 ? ee.image.height : null,
        se = v[M.type];
      M.precision !== null &&
        ((m = r.getMaxPrecision(M.precision)),
        m !== M.precision &&
          console.warn("THREE.WebGLProgram.getParameters:", M.precision, "not supported, using", m, "instead."));
      const ue = K.morphAttributes.position || K.morphAttributes.normal || K.morphAttributes.color,
        Me = ue !== void 0 ? ue.length : 0;
      let Fe = 0;
      K.morphAttributes.position !== void 0 && (Fe = 1),
        K.morphAttributes.normal !== void 0 && (Fe = 2),
        K.morphAttributes.color !== void 0 && (Fe = 3);
      let Qe, $e, W, ae;
      if (se) {
        const We = Ft[se];
        (Qe = We.vertexShader), ($e = We.fragmentShader);
      } else
        (Qe = M.vertexShader),
          ($e = M.fragmentShader),
          c.update(M),
          (W = c.getVertexShaderID(M)),
          (ae = c.getFragmentShaderID(M));
      const ne = i.getRenderTarget(),
        Ae = i.state.buffers.depth.getReversed(),
        be = V.isInstancedMesh === !0,
        Pe = V.isBatchedMesh === !0,
        st = !!M.map,
        Ge = !!M.matcap,
        A = !!ee,
        Ze = !!M.aoMap,
        Te = !!M.lightMap,
        He = !!M.bumpMap,
        Se = !!M.normalMap,
        et = !!M.displacementMap,
        de = !!M.emissiveMap,
        Ne = !!M.metalnessMap,
        ft = !!M.roughnessMap,
        at = M.anisotropy > 0,
        T = M.clearcoat > 0,
        _ = M.dispersion > 0,
        I = M.iridescence > 0,
        k = M.sheen > 0,
        $ = M.transmission > 0,
        z = at && !!M.anisotropyMap,
        xe = T && !!M.clearcoatMap,
        te = T && !!M.clearcoatNormalMap,
        _e = T && !!M.clearcoatRoughnessMap,
        ge = I && !!M.iridescenceMap,
        j = I && !!M.iridescenceThicknessMap,
        ce = k && !!M.sheenColorMap,
        Ce = k && !!M.sheenRoughnessMap,
        ve = !!M.specularMap,
        oe = !!M.specularColorMap,
        Ue = !!M.specularIntensityMap,
        R = $ && !!M.transmissionMap,
        Q = $ && !!M.thicknessMap,
        ie = !!M.gradientMap,
        fe = !!M.alphaMap,
        Z = M.alphaTest > 0,
        Y = !!M.alphaHash,
        me = !!M.extensions;
      let De = 0;
      M.toneMapped && (ne === null || ne.isXRRenderTarget === !0) && (De = i.toneMapping);
      const Je = {
        shaderID: se,
        shaderType: M.type,
        shaderName: M.name,
        vertexShader: Qe,
        fragmentShader: $e,
        defines: M.defines,
        customVertexShaderID: W,
        customFragmentShaderID: ae,
        isRawShaderMaterial: M.isRawShaderMaterial === !0,
        glslVersion: M.glslVersion,
        precision: m,
        batching: Pe,
        batchingColor: Pe && V._colorsTexture !== null,
        instancing: be,
        instancingColor: be && V.instanceColor !== null,
        instancingMorph: be && V.morphTexture !== null,
        supportsVertexTextures: d,
        outputColorSpace: ne === null ? i.outputColorSpace : ne.isXRRenderTarget === !0 ? ne.texture.colorSpace : pn,
        alphaToCoverage: !!M.alphaToCoverage,
        map: st,
        matcap: Ge,
        envMap: A,
        envMapMode: A && ee.mapping,
        envMapCubeUVHeight: G,
        aoMap: Ze,
        lightMap: Te,
        bumpMap: He,
        normalMap: Se,
        displacementMap: d && et,
        emissiveMap: de,
        normalMapObjectSpace: Se && M.normalMapType === 1,
        normalMapTangentSpace: Se && M.normalMapType === 0,
        metalnessMap: Ne,
        roughnessMap: ft,
        anisotropy: at,
        anisotropyMap: z,
        clearcoat: T,
        clearcoatMap: xe,
        clearcoatNormalMap: te,
        clearcoatRoughnessMap: _e,
        dispersion: _,
        iridescence: I,
        iridescenceMap: ge,
        iridescenceThicknessMap: j,
        sheen: k,
        sheenColorMap: ce,
        sheenRoughnessMap: Ce,
        specularMap: ve,
        specularColorMap: oe,
        specularIntensityMap: Ue,
        transmission: $,
        transmissionMap: R,
        thicknessMap: Q,
        gradientMap: ie,
        opaque: M.transparent === !1 && M.blending === 1 && M.alphaToCoverage === !1,
        alphaMap: fe,
        alphaTest: Z,
        alphaHash: Y,
        combine: M.combine,
        mapUv: st && x(M.map.channel),
        aoMapUv: Ze && x(M.aoMap.channel),
        lightMapUv: Te && x(M.lightMap.channel),
        bumpMapUv: He && x(M.bumpMap.channel),
        normalMapUv: Se && x(M.normalMap.channel),
        displacementMapUv: et && x(M.displacementMap.channel),
        emissiveMapUv: de && x(M.emissiveMap.channel),
        metalnessMapUv: Ne && x(M.metalnessMap.channel),
        roughnessMapUv: ft && x(M.roughnessMap.channel),
        anisotropyMapUv: z && x(M.anisotropyMap.channel),
        clearcoatMapUv: xe && x(M.clearcoatMap.channel),
        clearcoatNormalMapUv: te && x(M.clearcoatNormalMap.channel),
        clearcoatRoughnessMapUv: _e && x(M.clearcoatRoughnessMap.channel),
        iridescenceMapUv: ge && x(M.iridescenceMap.channel),
        iridescenceThicknessMapUv: j && x(M.iridescenceThicknessMap.channel),
        sheenColorMapUv: ce && x(M.sheenColorMap.channel),
        sheenRoughnessMapUv: Ce && x(M.sheenRoughnessMap.channel),
        specularMapUv: ve && x(M.specularMap.channel),
        specularColorMapUv: oe && x(M.specularColorMap.channel),
        specularIntensityMapUv: Ue && x(M.specularIntensityMap.channel),
        transmissionMapUv: R && x(M.transmissionMap.channel),
        thicknessMapUv: Q && x(M.thicknessMap.channel),
        alphaMapUv: fe && x(M.alphaMap.channel),
        vertexTangents: !!K.attributes.tangent && (Se || at),
        vertexColors: M.vertexColors,
        vertexAlphas: M.vertexColors === !0 && !!K.attributes.color && K.attributes.color.itemSize === 4,
        pointsUvs: V.isPoints === !0 && !!K.attributes.uv && (st || fe),
        fog: !!H,
        useFog: M.fog === !0,
        fogExp2: !!H && H.isFogExp2,
        flatShading: M.flatShading === !0 && M.wireframe === !1,
        sizeAttenuation: M.sizeAttenuation === !0,
        logarithmicDepthBuffer: f,
        reversedDepthBuffer: Ae,
        skinning: V.isSkinnedMesh === !0,
        morphTargets: K.morphAttributes.position !== void 0,
        morphNormals: K.morphAttributes.normal !== void 0,
        morphColors: K.morphAttributes.color !== void 0,
        morphTargetsCount: Me,
        morphTextureStride: Fe,
        numDirLights: S.directional.length,
        numPointLights: S.point.length,
        numSpotLights: S.spot.length,
        numSpotLightMaps: S.spotLightMap.length,
        numRectAreaLights: S.rectArea.length,
        numHemiLights: S.hemi.length,
        numDirLightShadows: S.directionalShadowMap.length,
        numPointLightShadows: S.pointShadowMap.length,
        numSpotLightShadows: S.spotShadowMap.length,
        numSpotLightShadowsWithMaps: S.numSpotLightShadowsWithMaps,
        numLightProbes: S.numLightProbes,
        numClippingPlanes: a.numPlanes,
        numClipIntersection: a.numIntersection,
        dithering: M.dithering,
        shadowMapEnabled: i.shadowMap.enabled && b.length > 0,
        shadowMapType: i.shadowMap.type,
        toneMapping: De,
        decodeVideoTexture: st && M.map.isVideoTexture === !0 && ze.getTransfer(M.map.colorSpace) === Xe,
        decodeVideoTextureEmissive:
          de && M.emissiveMap.isVideoTexture === !0 && ze.getTransfer(M.emissiveMap.colorSpace) === Xe,
        premultipliedAlpha: M.premultipliedAlpha,
        doubleSided: M.side === 2,
        flipSided: M.side === 1,
        useDepthPacking: M.depthPacking >= 0,
        depthPacking: M.depthPacking || 0,
        index0AttributeName: M.index0AttributeName,
        extensionClipCullDistance: me && M.extensions.clipCullDistance === !0 && n.has("WEBGL_clip_cull_distance"),
        extensionMultiDraw: ((me && M.extensions.multiDraw === !0) || Pe) && n.has("WEBGL_multi_draw"),
        rendererExtensionParallelShaderCompile: n.has("KHR_parallel_shader_compile"),
        customProgramCacheKey: M.customProgramCacheKey()
      };
      return (Je.vertexUv1s = l.has(1)), (Je.vertexUv2s = l.has(2)), (Je.vertexUv3s = l.has(3)), l.clear(), Je;
    }
    function u(M) {
      const S = [];
      if (
        (M.shaderID ? S.push(M.shaderID) : (S.push(M.customVertexShaderID), S.push(M.customFragmentShaderID)),
        M.defines !== void 0)
      )
        for (const b in M.defines) S.push(b), S.push(M.defines[b]);
      return (
        M.isRawShaderMaterial === !1 && (C(S, M), y(S, M), S.push(i.outputColorSpace)),
        S.push(M.customProgramCacheKey),
        S.join()
      );
    }
    function C(M, S) {
      M.push(S.precision),
        M.push(S.outputColorSpace),
        M.push(S.envMapMode),
        M.push(S.envMapCubeUVHeight),
        M.push(S.mapUv),
        M.push(S.alphaMapUv),
        M.push(S.lightMapUv),
        M.push(S.aoMapUv),
        M.push(S.bumpMapUv),
        M.push(S.normalMapUv),
        M.push(S.displacementMapUv),
        M.push(S.emissiveMapUv),
        M.push(S.metalnessMapUv),
        M.push(S.roughnessMapUv),
        M.push(S.anisotropyMapUv),
        M.push(S.clearcoatMapUv),
        M.push(S.clearcoatNormalMapUv),
        M.push(S.clearcoatRoughnessMapUv),
        M.push(S.iridescenceMapUv),
        M.push(S.iridescenceThicknessMapUv),
        M.push(S.sheenColorMapUv),
        M.push(S.sheenRoughnessMapUv),
        M.push(S.specularMapUv),
        M.push(S.specularColorMapUv),
        M.push(S.specularIntensityMapUv),
        M.push(S.transmissionMapUv),
        M.push(S.thicknessMapUv),
        M.push(S.combine),
        M.push(S.fogExp2),
        M.push(S.sizeAttenuation),
        M.push(S.morphTargetsCount),
        M.push(S.morphAttributeCount),
        M.push(S.numDirLights),
        M.push(S.numPointLights),
        M.push(S.numSpotLights),
        M.push(S.numSpotLightMaps),
        M.push(S.numHemiLights),
        M.push(S.numRectAreaLights),
        M.push(S.numDirLightShadows),
        M.push(S.numPointLightShadows),
        M.push(S.numSpotLightShadows),
        M.push(S.numSpotLightShadowsWithMaps),
        M.push(S.numLightProbes),
        M.push(S.shadowMapType),
        M.push(S.toneMapping),
        M.push(S.numClippingPlanes),
        M.push(S.numClipIntersection),
        M.push(S.depthPacking);
    }
    function y(M, S) {
      o.disableAll(),
        S.supportsVertexTextures && o.enable(0),
        S.instancing && o.enable(1),
        S.instancingColor && o.enable(2),
        S.instancingMorph && o.enable(3),
        S.matcap && o.enable(4),
        S.envMap && o.enable(5),
        S.normalMapObjectSpace && o.enable(6),
        S.normalMapTangentSpace && o.enable(7),
        S.clearcoat && o.enable(8),
        S.iridescence && o.enable(9),
        S.alphaTest && o.enable(10),
        S.vertexColors && o.enable(11),
        S.vertexAlphas && o.enable(12),
        S.vertexUv1s && o.enable(13),
        S.vertexUv2s && o.enable(14),
        S.vertexUv3s && o.enable(15),
        S.vertexTangents && o.enable(16),
        S.anisotropy && o.enable(17),
        S.alphaHash && o.enable(18),
        S.batching && o.enable(19),
        S.dispersion && o.enable(20),
        S.batchingColor && o.enable(21),
        S.gradientMap && o.enable(22),
        M.push(o.mask),
        o.disableAll(),
        S.fog && o.enable(0),
        S.useFog && o.enable(1),
        S.flatShading && o.enable(2),
        S.logarithmicDepthBuffer && o.enable(3),
        S.reversedDepthBuffer && o.enable(4),
        S.skinning && o.enable(5),
        S.morphTargets && o.enable(6),
        S.morphNormals && o.enable(7),
        S.morphColors && o.enable(8),
        S.premultipliedAlpha && o.enable(9),
        S.shadowMapEnabled && o.enable(10),
        S.doubleSided && o.enable(11),
        S.flipSided && o.enable(12),
        S.useDepthPacking && o.enable(13),
        S.dithering && o.enable(14),
        S.transmission && o.enable(15),
        S.sheen && o.enable(16),
        S.opaque && o.enable(17),
        S.pointsUvs && o.enable(18),
        S.decodeVideoTexture && o.enable(19),
        S.decodeVideoTextureEmissive && o.enable(20),
        S.alphaToCoverage && o.enable(21),
        M.push(o.mask);
    }
    function E(M) {
      const S = v[M.type];
      let b;
      if (S) {
        const q = Ft[S];
        b = Xs.clone(q.uniforms);
      } else b = M.uniforms;
      return b;
    }
    function D(M, S) {
      let b;
      for (let q = 0, V = h.length; q < V; q++) {
        const H = h[q];
        if (H.cacheKey === S) {
          (b = H), ++b.usedTimes;
          break;
        }
      }
      return b === void 0 && ((b = new Fc(i, S, M, s)), h.push(b)), b;
    }
    function w(M) {
      if (--M.usedTimes === 0) {
        const S = h.indexOf(M);
        (h[S] = h[h.length - 1]), h.pop(), M.destroy();
      }
    }
    function P(M) {
      c.remove(M);
    }
    function F() {
      c.dispose();
    }
    return {
      getParameters: p,
      getProgramCacheKey: u,
      getUniforms: E,
      acquireProgram: D,
      releaseProgram: w,
      releaseShaderCache: P,
      programs: h,
      dispose: F
    };
  }
  function zc() {
    let i = new WeakMap();
    function e(a) {
      return i.has(a);
    }
    function t(a) {
      let o = i.get(a);
      return o === void 0 && ((o = {}), i.set(a, o)), o;
    }
    function n(a) {
      i.delete(a);
    }
    function r(a, o, c) {
      i.get(a)[o] = c;
    }
    function s() {
      i = new WeakMap();
    }
    return { has: e, get: t, remove: n, update: r, dispose: s };
  }
  function Vc(i, e) {
    return i.groupOrder !== e.groupOrder
      ? i.groupOrder - e.groupOrder
      : i.renderOrder !== e.renderOrder
      ? i.renderOrder - e.renderOrder
      : i.material.id !== e.material.id
      ? i.material.id - e.material.id
      : i.z !== e.z
      ? i.z - e.z
      : i.id - e.id;
  }
  function ps(i, e) {
    return i.groupOrder !== e.groupOrder
      ? i.groupOrder - e.groupOrder
      : i.renderOrder !== e.renderOrder
      ? i.renderOrder - e.renderOrder
      : i.z !== e.z
      ? e.z - i.z
      : i.id - e.id;
  }
  function ms() {
    const i = [];
    let e = 0;
    const t = [],
      n = [],
      r = [];
    function s() {
      (e = 0), (t.length = 0), (n.length = 0), (r.length = 0);
    }
    function a(f, d, m, v, x, p) {
      let u = i[e];
      return (
        u === void 0
          ? ((u = {
              id: f.id,
              object: f,
              geometry: d,
              material: m,
              groupOrder: v,
              renderOrder: f.renderOrder,
              z: x,
              group: p
            }),
            (i[e] = u))
          : ((u.id = f.id),
            (u.object = f),
            (u.geometry = d),
            (u.material = m),
            (u.groupOrder = v),
            (u.renderOrder = f.renderOrder),
            (u.z = x),
            (u.group = p)),
        e++,
        u
      );
    }
    function o(f, d, m, v, x, p) {
      const u = a(f, d, m, v, x, p);
      m.transmission > 0 ? n.push(u) : m.transparent === !0 ? r.push(u) : t.push(u);
    }
    function c(f, d, m, v, x, p) {
      const u = a(f, d, m, v, x, p);
      m.transmission > 0 ? n.unshift(u) : m.transparent === !0 ? r.unshift(u) : t.unshift(u);
    }
    function l(f, d) {
      t.length > 1 && t.sort(f || Vc), n.length > 1 && n.sort(d || ps), r.length > 1 && r.sort(d || ps);
    }
    function h() {
      for (let f = e, d = i.length; f < d; f++) {
        const m = i[f];
        if (m.id === null) break;
        (m.id = null), (m.object = null), (m.geometry = null), (m.material = null), (m.group = null);
      }
    }
    return { opaque: t, transmissive: n, transparent: r, init: s, push: o, unshift: c, finish: h, sort: l };
  }
  function Hc() {
    let i = new WeakMap();
    function e(n, r) {
      const s = i.get(n);
      let a;
      return (
        s === void 0 ? ((a = new ms()), i.set(n, [a])) : r >= s.length ? ((a = new ms()), s.push(a)) : (a = s[r]), a
      );
    }
    function t() {
      i = new WeakMap();
    }
    return { get: e, dispose: t };
  }
  function kc() {
    const i = {};
    return {
      get: function (e) {
        if (i[e.id] !== void 0) return i[e.id];
        let t;
        switch (e.type) {
          case "DirectionalLight":
            t = { direction: new O(), color: new ke() };
            break;
          case "SpotLight":
            t = {
              position: new O(),
              direction: new O(),
              color: new ke(),
              distance: 0,
              coneCos: 0,
              penumbraCos: 0,
              decay: 0
            };
            break;
          case "PointLight":
            t = { position: new O(), color: new ke(), distance: 0, decay: 0 };
            break;
          case "HemisphereLight":
            t = { direction: new O(), skyColor: new ke(), groundColor: new ke() };
            break;
          case "RectAreaLight":
            t = { color: new ke(), position: new O(), halfWidth: new O(), halfHeight: new O() };
            break;
        }
        return (i[e.id] = t), t;
      }
    };
  }
  function Wc() {
    const i = {};
    return {
      get: function (e) {
        if (i[e.id] !== void 0) return i[e.id];
        let t;
        switch (e.type) {
          case "DirectionalLight":
            t = { shadowIntensity: 1, shadowBias: 0, shadowNormalBias: 0, shadowRadius: 1, shadowMapSize: new qe() };
            break;
          case "SpotLight":
            t = { shadowIntensity: 1, shadowBias: 0, shadowNormalBias: 0, shadowRadius: 1, shadowMapSize: new qe() };
            break;
          case "PointLight":
            t = {
              shadowIntensity: 1,
              shadowBias: 0,
              shadowNormalBias: 0,
              shadowRadius: 1,
              shadowMapSize: new qe(),
              shadowCameraNear: 1,
              shadowCameraFar: 1e3
            };
            break;
        }
        return (i[e.id] = t), t;
      }
    };
  }
  let Xc = 0;
  function qc(i, e) {
    return (e.castShadow ? 2 : 0) - (i.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (i.map ? 1 : 0);
  }
  function Yc(i) {
    const e = new kc(),
      t = Wc(),
      n = {
        version: 0,
        hash: {
          directionalLength: -1,
          pointLength: -1,
          spotLength: -1,
          rectAreaLength: -1,
          hemiLength: -1,
          numDirectionalShadows: -1,
          numPointShadows: -1,
          numSpotShadows: -1,
          numSpotMaps: -1,
          numLightProbes: -1
        },
        ambient: [0, 0, 0],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
      };
    for (let l = 0; l < 9; l++) n.probe.push(new O());
    const r = new O(),
      s = new ot(),
      a = new ot();
    function o(l) {
      let h = 0,
        f = 0,
        d = 0;
      for (let M = 0; M < 9; M++) n.probe[M].set(0, 0, 0);
      let m = 0,
        v = 0,
        x = 0,
        p = 0,
        u = 0,
        C = 0,
        y = 0,
        E = 0,
        D = 0,
        w = 0,
        P = 0;
      l.sort(qc);
      for (let M = 0, S = l.length; M < S; M++) {
        const b = l[M],
          q = b.color,
          V = b.intensity,
          H = b.distance,
          K = b.shadow && b.shadow.map ? b.shadow.map.texture : null;
        if (b.isAmbientLight) (h += q.r * V), (f += q.g * V), (d += q.b * V);
        else if (b.isLightProbe) {
          for (let X = 0; X < 9; X++) n.probe[X].addScaledVector(b.sh.coefficients[X], V);
          P++;
        } else if (b.isDirectionalLight) {
          const X = e.get(b);
          if ((X.color.copy(b.color).multiplyScalar(b.intensity), b.castShadow)) {
            const ee = b.shadow,
              G = t.get(b);
            (G.shadowIntensity = ee.intensity),
              (G.shadowBias = ee.bias),
              (G.shadowNormalBias = ee.normalBias),
              (G.shadowRadius = ee.radius),
              (G.shadowMapSize = ee.mapSize),
              (n.directionalShadow[m] = G),
              (n.directionalShadowMap[m] = K),
              (n.directionalShadowMatrix[m] = b.shadow.matrix),
              C++;
          }
          (n.directional[m] = X), m++;
        } else if (b.isSpotLight) {
          const X = e.get(b);
          X.position.setFromMatrixPosition(b.matrixWorld),
            X.color.copy(q).multiplyScalar(V),
            (X.distance = H),
            (X.coneCos = Math.cos(b.angle)),
            (X.penumbraCos = Math.cos(b.angle * (1 - b.penumbra))),
            (X.decay = b.decay),
            (n.spot[x] = X);
          const ee = b.shadow;
          if (
            (b.map && ((n.spotLightMap[D] = b.map), D++, ee.updateMatrices(b), b.castShadow && w++),
            (n.spotLightMatrix[x] = ee.matrix),
            b.castShadow)
          ) {
            const G = t.get(b);
            (G.shadowIntensity = ee.intensity),
              (G.shadowBias = ee.bias),
              (G.shadowNormalBias = ee.normalBias),
              (G.shadowRadius = ee.radius),
              (G.shadowMapSize = ee.mapSize),
              (n.spotShadow[x] = G),
              (n.spotShadowMap[x] = K),
              E++;
          }
          x++;
        } else if (b.isRectAreaLight) {
          const X = e.get(b);
          X.color.copy(q).multiplyScalar(V),
            X.halfWidth.set(b.width * 0.5, 0, 0),
            X.halfHeight.set(0, b.height * 0.5, 0),
            (n.rectArea[p] = X),
            p++;
        } else if (b.isPointLight) {
          const X = e.get(b);
          if (
            (X.color.copy(b.color).multiplyScalar(b.intensity),
            (X.distance = b.distance),
            (X.decay = b.decay),
            b.castShadow)
          ) {
            const ee = b.shadow,
              G = t.get(b);
            (G.shadowIntensity = ee.intensity),
              (G.shadowBias = ee.bias),
              (G.shadowNormalBias = ee.normalBias),
              (G.shadowRadius = ee.radius),
              (G.shadowMapSize = ee.mapSize),
              (G.shadowCameraNear = ee.camera.near),
              (G.shadowCameraFar = ee.camera.far),
              (n.pointShadow[v] = G),
              (n.pointShadowMap[v] = K),
              (n.pointShadowMatrix[v] = b.shadow.matrix),
              y++;
          }
          (n.point[v] = X), v++;
        } else if (b.isHemisphereLight) {
          const X = e.get(b);
          X.skyColor.copy(b.color).multiplyScalar(V),
            X.groundColor.copy(b.groundColor).multiplyScalar(V),
            (n.hemi[u] = X),
            u++;
        }
      }
      p > 0 &&
        (i.has("OES_texture_float_linear") === !0
          ? ((n.rectAreaLTC1 = re.LTC_FLOAT_1), (n.rectAreaLTC2 = re.LTC_FLOAT_2))
          : ((n.rectAreaLTC1 = re.LTC_HALF_1), (n.rectAreaLTC2 = re.LTC_HALF_2))),
        (n.ambient[0] = h),
        (n.ambient[1] = f),
        (n.ambient[2] = d);
      const F = n.hash;
      (F.directionalLength !== m ||
        F.pointLength !== v ||
        F.spotLength !== x ||
        F.rectAreaLength !== p ||
        F.hemiLength !== u ||
        F.numDirectionalShadows !== C ||
        F.numPointShadows !== y ||
        F.numSpotShadows !== E ||
        F.numSpotMaps !== D ||
        F.numLightProbes !== P) &&
        ((n.directional.length = m),
        (n.spot.length = x),
        (n.rectArea.length = p),
        (n.point.length = v),
        (n.hemi.length = u),
        (n.directionalShadow.length = C),
        (n.directionalShadowMap.length = C),
        (n.pointShadow.length = y),
        (n.pointShadowMap.length = y),
        (n.spotShadow.length = E),
        (n.spotShadowMap.length = E),
        (n.directionalShadowMatrix.length = C),
        (n.pointShadowMatrix.length = y),
        (n.spotLightMatrix.length = E + D - w),
        (n.spotLightMap.length = D),
        (n.numSpotLightShadowsWithMaps = w),
        (n.numLightProbes = P),
        (F.directionalLength = m),
        (F.pointLength = v),
        (F.spotLength = x),
        (F.rectAreaLength = p),
        (F.hemiLength = u),
        (F.numDirectionalShadows = C),
        (F.numPointShadows = y),
        (F.numSpotShadows = E),
        (F.numSpotMaps = D),
        (F.numLightProbes = P),
        (n.version = Xc++));
    }
    function c(l, h) {
      let f = 0,
        d = 0,
        m = 0,
        v = 0,
        x = 0;
      const p = h.matrixWorldInverse;
      for (let u = 0, C = l.length; u < C; u++) {
        const y = l[u];
        if (y.isDirectionalLight) {
          const E = n.directional[f];
          E.direction.setFromMatrixPosition(y.matrixWorld),
            r.setFromMatrixPosition(y.target.matrixWorld),
            E.direction.sub(r),
            E.direction.transformDirection(p),
            f++;
        } else if (y.isSpotLight) {
          const E = n.spot[m];
          E.position.setFromMatrixPosition(y.matrixWorld),
            E.position.applyMatrix4(p),
            E.direction.setFromMatrixPosition(y.matrixWorld),
            r.setFromMatrixPosition(y.target.matrixWorld),
            E.direction.sub(r),
            E.direction.transformDirection(p),
            m++;
        } else if (y.isRectAreaLight) {
          const E = n.rectArea[v];
          E.position.setFromMatrixPosition(y.matrixWorld),
            E.position.applyMatrix4(p),
            a.identity(),
            s.copy(y.matrixWorld),
            s.premultiply(p),
            a.extractRotation(s),
            E.halfWidth.set(y.width * 0.5, 0, 0),
            E.halfHeight.set(0, y.height * 0.5, 0),
            E.halfWidth.applyMatrix4(a),
            E.halfHeight.applyMatrix4(a),
            v++;
        } else if (y.isPointLight) {
          const E = n.point[d];
          E.position.setFromMatrixPosition(y.matrixWorld), E.position.applyMatrix4(p), d++;
        } else if (y.isHemisphereLight) {
          const E = n.hemi[x];
          E.direction.setFromMatrixPosition(y.matrixWorld), E.direction.transformDirection(p), x++;
        }
      }
    }
    return { setup: o, setupView: c, state: n };
  }
  function _s(i) {
    const e = new Yc(i),
      t = [],
      n = [];
    function r(h) {
      (l.camera = h), (t.length = 0), (n.length = 0);
    }
    function s(h) {
      t.push(h);
    }
    function a(h) {
      n.push(h);
    }
    function o() {
      e.setup(t);
    }
    function c(h) {
      e.setupView(t, h);
    }
    const l = { lightsArray: t, shadowsArray: n, camera: null, lights: e, transmissionRenderTarget: {} };
    return { init: r, state: l, setupLights: o, setupLightsView: c, pushLight: s, pushShadow: a };
  }
  function $c(i) {
    let e = new WeakMap();
    function t(r, s = 0) {
      const a = e.get(r);
      let o;
      return (
        a === void 0 ? ((o = new _s(i)), e.set(r, [o])) : s >= a.length ? ((o = new _s(i)), a.push(o)) : (o = a[s]), o
      );
    }
    function n() {
      e = new WeakMap();
    }
    return { get: t, dispose: n };
  }
  const Kc = `void main() {
	gl_Position = vec4( position, 1.0 );
}`,
    Zc = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
  function Jc(i, e, t) {
    let n = new Nr();
    const r = new qe(),
      s = new qe(),
      a = new rt(),
      o = new ia({ depthPacking: 3201 }),
      c = new ra(),
      l = {},
      h = t.maxTextureSize,
      f = { 0: 1, 1: 0, 2: 2 },
      d = new qt({
        defines: { VSM_SAMPLES: 8 },
        uniforms: { shadow_pass: { value: null }, resolution: { value: new qe() }, radius: { value: 4 } },
        vertexShader: Kc,
        fragmentShader: Zc
      }),
      m = d.clone();
    m.defines.HORIZONTAL_PASS = 1;
    const v = new Wt();
    v.setAttribute("position", new Ut(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3));
    const x = new Xt(v, d),
      p = this;
    (this.enabled = !1), (this.autoUpdate = !0), (this.needsUpdate = !1), (this.type = 1);
    let u = this.type;
    this.render = function (w, P, F) {
      if (p.enabled === !1 || (p.autoUpdate === !1 && p.needsUpdate === !1) || w.length === 0) return;
      const M = i.getRenderTarget(),
        S = i.getActiveCubeFace(),
        b = i.getActiveMipmapLevel(),
        q = i.state;
      q.setBlending(0),
        q.buffers.depth.getReversed() ? q.buffers.color.setClear(0, 0, 0, 0) : q.buffers.color.setClear(1, 1, 1, 1),
        q.buffers.depth.setTest(!0),
        q.setScissorTest(!1);
      const V = u !== 3 && this.type === 3,
        H = u === 3 && this.type !== 3;
      for (let K = 0, X = w.length; K < X; K++) {
        const ee = w[K],
          G = ee.shadow;
        if (G === void 0) {
          console.warn("THREE.WebGLShadowMap:", ee, "has no shadow.");
          continue;
        }
        if (G.autoUpdate === !1 && G.needsUpdate === !1) continue;
        r.copy(G.mapSize);
        const se = G.getFrameExtents();
        if (
          (r.multiply(se),
          s.copy(G.mapSize),
          (r.x > h || r.y > h) &&
            (r.x > h && ((s.x = Math.floor(h / se.x)), (r.x = s.x * se.x), (G.mapSize.x = s.x)),
            r.y > h && ((s.y = Math.floor(h / se.y)), (r.y = s.y * se.y), (G.mapSize.y = s.y))),
          G.map === null || V === !0 || H === !0)
        ) {
          const Me = this.type !== 3 ? { minFilter: 1003, magFilter: 1003 } : {};
          G.map !== null && G.map.dispose(),
            (G.map = new en(r.x, r.y, Me)),
            (G.map.texture.name = ee.name + ".shadowMap"),
            G.camera.updateProjectionMatrix();
        }
        i.setRenderTarget(G.map), i.clear();
        const ue = G.getViewportCount();
        for (let Me = 0; Me < ue; Me++) {
          const Fe = G.getViewport(Me);
          a.set(s.x * Fe.x, s.y * Fe.y, s.x * Fe.z, s.y * Fe.w),
            q.viewport(a),
            G.updateMatrices(ee, Me),
            (n = G.getFrustum()),
            E(P, F, G.camera, ee, this.type);
        }
        G.isPointLightShadow !== !0 && this.type === 3 && C(G, F), (G.needsUpdate = !1);
      }
      (u = this.type), (p.needsUpdate = !1), i.setRenderTarget(M, S, b);
    };
    function C(w, P) {
      const F = e.update(x);
      d.defines.VSM_SAMPLES !== w.blurSamples &&
        ((d.defines.VSM_SAMPLES = w.blurSamples),
        (m.defines.VSM_SAMPLES = w.blurSamples),
        (d.needsUpdate = !0),
        (m.needsUpdate = !0)),
        w.mapPass === null && (w.mapPass = new en(r.x, r.y)),
        (d.uniforms.shadow_pass.value = w.map.texture),
        (d.uniforms.resolution.value = w.mapSize),
        (d.uniforms.radius.value = w.radius),
        i.setRenderTarget(w.mapPass),
        i.clear(),
        i.renderBufferDirect(P, null, F, d, x, null),
        (m.uniforms.shadow_pass.value = w.mapPass.texture),
        (m.uniforms.resolution.value = w.mapSize),
        (m.uniforms.radius.value = w.radius),
        i.setRenderTarget(w.map),
        i.clear(),
        i.renderBufferDirect(P, null, F, m, x, null);
    }
    function y(w, P, F, M) {
      let S = null;
      const b = F.isPointLight === !0 ? w.customDistanceMaterial : w.customDepthMaterial;
      if (b !== void 0) S = b;
      else if (
        ((S = F.isPointLight === !0 ? c : o),
        (i.localClippingEnabled &&
          P.clipShadows === !0 &&
          Array.isArray(P.clippingPlanes) &&
          P.clippingPlanes.length !== 0) ||
          (P.displacementMap && P.displacementScale !== 0) ||
          (P.alphaMap && P.alphaTest > 0) ||
          (P.map && P.alphaTest > 0) ||
          P.alphaToCoverage === !0)
      ) {
        const q = S.uuid,
          V = P.uuid;
        let H = l[q];
        H === void 0 && ((H = {}), (l[q] = H));
        let K = H[V];
        K === void 0 && ((K = S.clone()), (H[V] = K), P.addEventListener("dispose", D)), (S = K);
      }
      if (
        ((S.visible = P.visible),
        (S.wireframe = P.wireframe),
        M === 3
          ? (S.side = P.shadowSide !== null ? P.shadowSide : P.side)
          : (S.side = P.shadowSide !== null ? P.shadowSide : f[P.side]),
        (S.alphaMap = P.alphaMap),
        (S.alphaTest = P.alphaToCoverage === !0 ? 0.5 : P.alphaTest),
        (S.map = P.map),
        (S.clipShadows = P.clipShadows),
        (S.clippingPlanes = P.clippingPlanes),
        (S.clipIntersection = P.clipIntersection),
        (S.displacementMap = P.displacementMap),
        (S.displacementScale = P.displacementScale),
        (S.displacementBias = P.displacementBias),
        (S.wireframeLinewidth = P.wireframeLinewidth),
        (S.linewidth = P.linewidth),
        F.isPointLight === !0 && S.isMeshDistanceMaterial === !0)
      ) {
        const q = i.properties.get(S);
        q.light = F;
      }
      return S;
    }
    function E(w, P, F, M, S) {
      if (w.visible === !1) return;
      if (
        w.layers.test(P.layers) &&
        (w.isMesh || w.isLine || w.isPoints) &&
        (w.castShadow || (w.receiveShadow && S === 3)) &&
        (!w.frustumCulled || n.intersectsObject(w))
      ) {
        w.modelViewMatrix.multiplyMatrices(F.matrixWorldInverse, w.matrixWorld);
        const V = e.update(w),
          H = w.material;
        if (Array.isArray(H)) {
          const K = V.groups;
          for (let X = 0, ee = K.length; X < ee; X++) {
            const G = K[X],
              se = H[G.materialIndex];
            if (se && se.visible) {
              const ue = y(w, se, M, S);
              w.onBeforeShadow(i, w, P, F, V, ue, G),
                i.renderBufferDirect(F, null, V, ue, w, G),
                w.onAfterShadow(i, w, P, F, V, ue, G);
            }
          }
        } else if (H.visible) {
          const K = y(w, H, M, S);
          w.onBeforeShadow(i, w, P, F, V, K, null),
            i.renderBufferDirect(F, null, V, K, w, null),
            w.onAfterShadow(i, w, P, F, V, K, null);
        }
      }
      const q = w.children;
      for (let V = 0, H = q.length; V < H; V++) E(q[V], P, F, M, S);
    }
    function D(w) {
      w.target.removeEventListener("dispose", D);
      for (const F in l) {
        const M = l[F],
          S = w.target.uuid;
        S in M && (M[S].dispose(), delete M[S]);
      }
    }
  }
  const jc = { 0: 1, 2: 6, 4: 7, 3: 5, 1: 0, 6: 2, 7: 4, 5: 3 };
  function Qc(i, e) {
    function t() {
      let R = !1;
      const Q = new rt();
      let ie = null;
      const fe = new rt(0, 0, 0, 0);
      return {
        setMask: function (Z) {
          ie !== Z && !R && (i.colorMask(Z, Z, Z, Z), (ie = Z));
        },
        setLocked: function (Z) {
          R = Z;
        },
        setClear: function (Z, Y, me, De, Je) {
          Je === !0 && ((Z *= De), (Y *= De), (me *= De)),
            Q.set(Z, Y, me, De),
            fe.equals(Q) === !1 && (i.clearColor(Z, Y, me, De), fe.copy(Q));
        },
        reset: function () {
          (R = !1), (ie = null), fe.set(-1, 0, 0, 0);
        }
      };
    }
    function n() {
      let R = !1,
        Q = !1,
        ie = null,
        fe = null,
        Z = null;
      return {
        setReversed: function (Y) {
          if (Q !== Y) {
            const me = e.get("EXT_clip_control");
            Y
              ? me.clipControlEXT(me.LOWER_LEFT_EXT, me.ZERO_TO_ONE_EXT)
              : me.clipControlEXT(me.LOWER_LEFT_EXT, me.NEGATIVE_ONE_TO_ONE_EXT),
              (Q = Y);
            const De = Z;
            (Z = null), this.setClear(De);
          }
        },
        getReversed: function () {
          return Q;
        },
        setTest: function (Y) {
          Y ? ne(i.DEPTH_TEST) : Ae(i.DEPTH_TEST);
        },
        setMask: function (Y) {
          ie !== Y && !R && (i.depthMask(Y), (ie = Y));
        },
        setFunc: function (Y) {
          if ((Q && (Y = jc[Y]), fe !== Y)) {
            switch (Y) {
              case 0:
                i.depthFunc(i.NEVER);
                break;
              case 1:
                i.depthFunc(i.ALWAYS);
                break;
              case 2:
                i.depthFunc(i.LESS);
                break;
              case 3:
                i.depthFunc(i.LEQUAL);
                break;
              case 4:
                i.depthFunc(i.EQUAL);
                break;
              case 5:
                i.depthFunc(i.GEQUAL);
                break;
              case 6:
                i.depthFunc(i.GREATER);
                break;
              case 7:
                i.depthFunc(i.NOTEQUAL);
                break;
              default:
                i.depthFunc(i.LEQUAL);
            }
            fe = Y;
          }
        },
        setLocked: function (Y) {
          R = Y;
        },
        setClear: function (Y) {
          Z !== Y && (Q && (Y = 1 - Y), i.clearDepth(Y), (Z = Y));
        },
        reset: function () {
          (R = !1), (ie = null), (fe = null), (Z = null), (Q = !1);
        }
      };
    }
    function r() {
      let R = !1,
        Q = null,
        ie = null,
        fe = null,
        Z = null,
        Y = null,
        me = null,
        De = null,
        Je = null;
      return {
        setTest: function (We) {
          R || (We ? ne(i.STENCIL_TEST) : Ae(i.STENCIL_TEST));
        },
        setMask: function (We) {
          Q !== We && !R && (i.stencilMask(We), (Q = We));
        },
        setFunc: function (We, Yt, Nt) {
          (ie !== We || fe !== Yt || Z !== Nt) && (i.stencilFunc(We, Yt, Nt), (ie = We), (fe = Yt), (Z = Nt));
        },
        setOp: function (We, Yt, Nt) {
          (Y !== We || me !== Yt || De !== Nt) && (i.stencilOp(We, Yt, Nt), (Y = We), (me = Yt), (De = Nt));
        },
        setLocked: function (We) {
          R = We;
        },
        setClear: function (We) {
          Je !== We && (i.clearStencil(We), (Je = We));
        },
        reset: function () {
          (R = !1), (Q = null), (ie = null), (fe = null), (Z = null), (Y = null), (me = null), (De = null), (Je = null);
        }
      };
    }
    const s = new t(),
      a = new n(),
      o = new r(),
      c = new WeakMap(),
      l = new WeakMap();
    let h = {},
      f = {},
      d = new WeakMap(),
      m = [],
      v = null,
      x = !1,
      p = null,
      u = null,
      C = null,
      y = null,
      E = null,
      D = null,
      w = null,
      P = new ke(0, 0, 0),
      F = 0,
      M = !1,
      S = null,
      b = null,
      q = null,
      V = null,
      H = null;
    const K = i.getParameter(i.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let X = !1,
      ee = 0;
    const G = i.getParameter(i.VERSION);
    G.indexOf("WebGL") !== -1
      ? ((ee = parseFloat(/^WebGL (\d)/.exec(G)[1])), (X = ee >= 1))
      : G.indexOf("OpenGL ES") !== -1 && ((ee = parseFloat(/^OpenGL ES (\d)/.exec(G)[1])), (X = ee >= 2));
    let se = null,
      ue = {};
    const Me = i.getParameter(i.SCISSOR_BOX),
      Fe = i.getParameter(i.VIEWPORT),
      Qe = new rt().fromArray(Me),
      $e = new rt().fromArray(Fe);
    function W(R, Q, ie, fe) {
      const Z = new Uint8Array(4),
        Y = i.createTexture();
      i.bindTexture(R, Y),
        i.texParameteri(R, i.TEXTURE_MIN_FILTER, i.NEAREST),
        i.texParameteri(R, i.TEXTURE_MAG_FILTER, i.NEAREST);
      for (let me = 0; me < ie; me++)
        R === i.TEXTURE_3D || R === i.TEXTURE_2D_ARRAY
          ? i.texImage3D(Q, 0, i.RGBA, 1, 1, fe, 0, i.RGBA, i.UNSIGNED_BYTE, Z)
          : i.texImage2D(Q + me, 0, i.RGBA, 1, 1, 0, i.RGBA, i.UNSIGNED_BYTE, Z);
      return Y;
    }
    const ae = {};
    (ae[i.TEXTURE_2D] = W(i.TEXTURE_2D, i.TEXTURE_2D, 1)),
      (ae[i.TEXTURE_CUBE_MAP] = W(i.TEXTURE_CUBE_MAP, i.TEXTURE_CUBE_MAP_POSITIVE_X, 6)),
      (ae[i.TEXTURE_2D_ARRAY] = W(i.TEXTURE_2D_ARRAY, i.TEXTURE_2D_ARRAY, 1, 1)),
      (ae[i.TEXTURE_3D] = W(i.TEXTURE_3D, i.TEXTURE_3D, 1, 1)),
      s.setClear(0, 0, 0, 1),
      a.setClear(1),
      o.setClear(0),
      ne(i.DEPTH_TEST),
      a.setFunc(3),
      He(!1),
      Se(1),
      ne(i.CULL_FACE),
      Ze(0);
    function ne(R) {
      h[R] !== !0 && (i.enable(R), (h[R] = !0));
    }
    function Ae(R) {
      h[R] !== !1 && (i.disable(R), (h[R] = !1));
    }
    function be(R, Q) {
      return f[R] !== Q
        ? (i.bindFramebuffer(R, Q),
          (f[R] = Q),
          R === i.DRAW_FRAMEBUFFER && (f[i.FRAMEBUFFER] = Q),
          R === i.FRAMEBUFFER && (f[i.DRAW_FRAMEBUFFER] = Q),
          !0)
        : !1;
    }
    function Pe(R, Q) {
      let ie = m,
        fe = !1;
      if (R) {
        (ie = d.get(Q)), ie === void 0 && ((ie = []), d.set(Q, ie));
        const Z = R.textures;
        if (ie.length !== Z.length || ie[0] !== i.COLOR_ATTACHMENT0) {
          for (let Y = 0, me = Z.length; Y < me; Y++) ie[Y] = i.COLOR_ATTACHMENT0 + Y;
          (ie.length = Z.length), (fe = !0);
        }
      } else ie[0] !== i.BACK && ((ie[0] = i.BACK), (fe = !0));
      fe && i.drawBuffers(ie);
    }
    function st(R) {
      return v !== R ? (i.useProgram(R), (v = R), !0) : !1;
    }
    const Ge = { 100: i.FUNC_ADD, 101: i.FUNC_SUBTRACT, 102: i.FUNC_REVERSE_SUBTRACT };
    (Ge[103] = i.MIN), (Ge[104] = i.MAX);
    const A = {
      200: i.ZERO,
      201: i.ONE,
      202: i.SRC_COLOR,
      204: i.SRC_ALPHA,
      210: i.SRC_ALPHA_SATURATE,
      208: i.DST_COLOR,
      206: i.DST_ALPHA,
      203: i.ONE_MINUS_SRC_COLOR,
      205: i.ONE_MINUS_SRC_ALPHA,
      209: i.ONE_MINUS_DST_COLOR,
      207: i.ONE_MINUS_DST_ALPHA,
      211: i.CONSTANT_COLOR,
      212: i.ONE_MINUS_CONSTANT_COLOR,
      213: i.CONSTANT_ALPHA,
      214: i.ONE_MINUS_CONSTANT_ALPHA
    };
    function Ze(R, Q, ie, fe, Z, Y, me, De, Je, We) {
      if (R === 0) {
        x === !0 && (Ae(i.BLEND), (x = !1));
        return;
      }
      if ((x === !1 && (ne(i.BLEND), (x = !0)), R !== 5)) {
        if (R !== p || We !== M) {
          if (((u !== 100 || E !== 100) && (i.blendEquation(i.FUNC_ADD), (u = 100), (E = 100)), We))
            switch (R) {
              case 1:
                i.blendFuncSeparate(i.ONE, i.ONE_MINUS_SRC_ALPHA, i.ONE, i.ONE_MINUS_SRC_ALPHA);
                break;
              case 2:
                i.blendFunc(i.ONE, i.ONE);
                break;
              case 3:
                i.blendFuncSeparate(i.ZERO, i.ONE_MINUS_SRC_COLOR, i.ZERO, i.ONE);
                break;
              case 4:
                i.blendFuncSeparate(i.DST_COLOR, i.ONE_MINUS_SRC_ALPHA, i.ZERO, i.ONE);
                break;
              default:
                console.error("THREE.WebGLState: Invalid blending: ", R);
                break;
            }
          else
            switch (R) {
              case 1:
                i.blendFuncSeparate(i.SRC_ALPHA, i.ONE_MINUS_SRC_ALPHA, i.ONE, i.ONE_MINUS_SRC_ALPHA);
                break;
              case 2:
                i.blendFuncSeparate(i.SRC_ALPHA, i.ONE, i.ONE, i.ONE);
                break;
              case 3:
                console.error("THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                break;
              case 4:
                console.error("THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                break;
              default:
                console.error("THREE.WebGLState: Invalid blending: ", R);
                break;
            }
          (C = null), (y = null), (D = null), (w = null), P.set(0, 0, 0), (F = 0), (p = R), (M = We);
        }
        return;
      }
      (Z = Z || Q),
        (Y = Y || ie),
        (me = me || fe),
        (Q !== u || Z !== E) && (i.blendEquationSeparate(Ge[Q], Ge[Z]), (u = Q), (E = Z)),
        (ie !== C || fe !== y || Y !== D || me !== w) &&
          (i.blendFuncSeparate(A[ie], A[fe], A[Y], A[me]), (C = ie), (y = fe), (D = Y), (w = me)),
        (De.equals(P) === !1 || Je !== F) && (i.blendColor(De.r, De.g, De.b, Je), P.copy(De), (F = Je)),
        (p = R),
        (M = !1);
    }
    function Te(R, Q) {
      R.side === 2 ? Ae(i.CULL_FACE) : ne(i.CULL_FACE);
      let ie = R.side === 1;
      Q && (ie = !ie),
        He(ie),
        R.blending === 1 && R.transparent === !1
          ? Ze(0)
          : Ze(
              R.blending,
              R.blendEquation,
              R.blendSrc,
              R.blendDst,
              R.blendEquationAlpha,
              R.blendSrcAlpha,
              R.blendDstAlpha,
              R.blendColor,
              R.blendAlpha,
              R.premultipliedAlpha
            ),
        a.setFunc(R.depthFunc),
        a.setTest(R.depthTest),
        a.setMask(R.depthWrite),
        s.setMask(R.colorWrite);
      const fe = R.stencilWrite;
      o.setTest(fe),
        fe &&
          (o.setMask(R.stencilWriteMask),
          o.setFunc(R.stencilFunc, R.stencilRef, R.stencilFuncMask),
          o.setOp(R.stencilFail, R.stencilZFail, R.stencilZPass)),
        de(R.polygonOffset, R.polygonOffsetFactor, R.polygonOffsetUnits),
        R.alphaToCoverage === !0 ? ne(i.SAMPLE_ALPHA_TO_COVERAGE) : Ae(i.SAMPLE_ALPHA_TO_COVERAGE);
    }
    function He(R) {
      S !== R && (R ? i.frontFace(i.CW) : i.frontFace(i.CCW), (S = R));
    }
    function Se(R) {
      R !== 0
        ? (ne(i.CULL_FACE),
          R !== b && (R === 1 ? i.cullFace(i.BACK) : R === 2 ? i.cullFace(i.FRONT) : i.cullFace(i.FRONT_AND_BACK)))
        : Ae(i.CULL_FACE),
        (b = R);
    }
    function et(R) {
      R !== q && (X && i.lineWidth(R), (q = R));
    }
    function de(R, Q, ie) {
      R
        ? (ne(i.POLYGON_OFFSET_FILL), (V !== Q || H !== ie) && (i.polygonOffset(Q, ie), (V = Q), (H = ie)))
        : Ae(i.POLYGON_OFFSET_FILL);
    }
    function Ne(R) {
      R ? ne(i.SCISSOR_TEST) : Ae(i.SCISSOR_TEST);
    }
    function ft(R) {
      R === void 0 && (R = i.TEXTURE0 + K - 1), se !== R && (i.activeTexture(R), (se = R));
    }
    function at(R, Q, ie) {
      ie === void 0 && (se === null ? (ie = i.TEXTURE0 + K - 1) : (ie = se));
      let fe = ue[ie];
      fe === void 0 && ((fe = { type: void 0, texture: void 0 }), (ue[ie] = fe)),
        (fe.type !== R || fe.texture !== Q) &&
          (se !== ie && (i.activeTexture(ie), (se = ie)),
          i.bindTexture(R, Q || ae[R]),
          (fe.type = R),
          (fe.texture = Q));
    }
    function T() {
      const R = ue[se];
      R !== void 0 && R.type !== void 0 && (i.bindTexture(R.type, null), (R.type = void 0), (R.texture = void 0));
    }
    function _() {
      try {
        i.compressedTexImage2D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function I() {
      try {
        i.compressedTexImage3D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function k() {
      try {
        i.texSubImage2D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function $() {
      try {
        i.texSubImage3D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function z() {
      try {
        i.compressedTexSubImage2D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function xe() {
      try {
        i.compressedTexSubImage3D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function te() {
      try {
        i.texStorage2D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function _e() {
      try {
        i.texStorage3D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function ge() {
      try {
        i.texImage2D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function j() {
      try {
        i.texImage3D(...arguments);
      } catch (R) {
        console.error("THREE.WebGLState:", R);
      }
    }
    function ce(R) {
      Qe.equals(R) === !1 && (i.scissor(R.x, R.y, R.z, R.w), Qe.copy(R));
    }
    function Ce(R) {
      $e.equals(R) === !1 && (i.viewport(R.x, R.y, R.z, R.w), $e.copy(R));
    }
    function ve(R, Q) {
      let ie = l.get(Q);
      ie === void 0 && ((ie = new WeakMap()), l.set(Q, ie));
      let fe = ie.get(R);
      fe === void 0 && ((fe = i.getUniformBlockIndex(Q, R.name)), ie.set(R, fe));
    }
    function oe(R, Q) {
      const fe = l.get(Q).get(R);
      c.get(Q) !== fe && (i.uniformBlockBinding(Q, fe, R.__bindingPointIndex), c.set(Q, fe));
    }
    function Ue() {
      i.disable(i.BLEND),
        i.disable(i.CULL_FACE),
        i.disable(i.DEPTH_TEST),
        i.disable(i.POLYGON_OFFSET_FILL),
        i.disable(i.SCISSOR_TEST),
        i.disable(i.STENCIL_TEST),
        i.disable(i.SAMPLE_ALPHA_TO_COVERAGE),
        i.blendEquation(i.FUNC_ADD),
        i.blendFunc(i.ONE, i.ZERO),
        i.blendFuncSeparate(i.ONE, i.ZERO, i.ONE, i.ZERO),
        i.blendColor(0, 0, 0, 0),
        i.colorMask(!0, !0, !0, !0),
        i.clearColor(0, 0, 0, 0),
        i.depthMask(!0),
        i.depthFunc(i.LESS),
        a.setReversed(!1),
        i.clearDepth(1),
        i.stencilMask(4294967295),
        i.stencilFunc(i.ALWAYS, 0, 4294967295),
        i.stencilOp(i.KEEP, i.KEEP, i.KEEP),
        i.clearStencil(0),
        i.cullFace(i.BACK),
        i.frontFace(i.CCW),
        i.polygonOffset(0, 0),
        i.activeTexture(i.TEXTURE0),
        i.bindFramebuffer(i.FRAMEBUFFER, null),
        i.bindFramebuffer(i.DRAW_FRAMEBUFFER, null),
        i.bindFramebuffer(i.READ_FRAMEBUFFER, null),
        i.useProgram(null),
        i.lineWidth(1),
        i.scissor(0, 0, i.canvas.width, i.canvas.height),
        i.viewport(0, 0, i.canvas.width, i.canvas.height),
        (h = {}),
        (se = null),
        (ue = {}),
        (f = {}),
        (d = new WeakMap()),
        (m = []),
        (v = null),
        (x = !1),
        (p = null),
        (u = null),
        (C = null),
        (y = null),
        (E = null),
        (D = null),
        (w = null),
        (P = new ke(0, 0, 0)),
        (F = 0),
        (M = !1),
        (S = null),
        (b = null),
        (q = null),
        (V = null),
        (H = null),
        Qe.set(0, 0, i.canvas.width, i.canvas.height),
        $e.set(0, 0, i.canvas.width, i.canvas.height),
        s.reset(),
        a.reset(),
        o.reset();
    }
    return {
      buffers: { color: s, depth: a, stencil: o },
      enable: ne,
      disable: Ae,
      bindFramebuffer: be,
      drawBuffers: Pe,
      useProgram: st,
      setBlending: Ze,
      setMaterial: Te,
      setFlipSided: He,
      setCullFace: Se,
      setLineWidth: et,
      setPolygonOffset: de,
      setScissorTest: Ne,
      activeTexture: ft,
      bindTexture: at,
      unbindTexture: T,
      compressedTexImage2D: _,
      compressedTexImage3D: I,
      texImage2D: ge,
      texImage3D: j,
      updateUBOMapping: ve,
      uniformBlockBinding: oe,
      texStorage2D: te,
      texStorage3D: _e,
      texSubImage2D: k,
      texSubImage3D: $,
      compressedTexSubImage2D: z,
      compressedTexSubImage3D: xe,
      scissor: ce,
      viewport: Ce,
      reset: Ue
    };
  }
  function eu(i, e, t, n, r, s, a) {
    const o = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null,
      c = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent),
      l = new qe(),
      h = new WeakMap();
    let f;
    const d = new WeakMap();
    let m = !1;
    try {
      m = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch {}
    function v(T, _) {
      return m ? new OffscreenCanvas(T, _) : $n("canvas");
    }
    function x(T, _, I) {
      let k = 1;
      const $ = at(T);
      if ((($.width > I || $.height > I) && (k = I / Math.max($.width, $.height)), k < 1))
        if (
          (typeof HTMLImageElement < "u" && T instanceof HTMLImageElement) ||
          (typeof HTMLCanvasElement < "u" && T instanceof HTMLCanvasElement) ||
          (typeof ImageBitmap < "u" && T instanceof ImageBitmap) ||
          (typeof VideoFrame < "u" && T instanceof VideoFrame)
        ) {
          const z = Math.floor(k * $.width),
            xe = Math.floor(k * $.height);
          f === void 0 && (f = v(z, xe));
          const te = _ ? v(z, xe) : f;
          return (
            (te.width = z),
            (te.height = xe),
            te.getContext("2d").drawImage(T, 0, 0, z, xe),
            console.warn(
              "THREE.WebGLRenderer: Texture has been resized from (" +
                $.width +
                "x" +
                $.height +
                ") to (" +
                z +
                "x" +
                xe +
                ")."
            ),
            te
          );
        } else
          return (
            "data" in T &&
              console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + $.width + "x" + $.height + ")."),
            T
          );
      return T;
    }
    function p(T) {
      return T.generateMipmaps;
    }
    function u(T) {
      i.generateMipmap(T);
    }
    function C(T) {
      return T.isWebGLCubeRenderTarget
        ? i.TEXTURE_CUBE_MAP
        : T.isWebGL3DRenderTarget
        ? i.TEXTURE_3D
        : T.isWebGLArrayRenderTarget || T.isCompressedArrayTexture
        ? i.TEXTURE_2D_ARRAY
        : i.TEXTURE_2D;
    }
    function y(T, _, I, k, $ = !1) {
      if (T !== null) {
        if (i[T] !== void 0) return i[T];
        console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + T + "'");
      }
      let z = _;
      if (
        (_ === i.RED &&
          (I === i.FLOAT && (z = i.R32F), I === i.HALF_FLOAT && (z = i.R16F), I === i.UNSIGNED_BYTE && (z = i.R8)),
        _ === i.RED_INTEGER &&
          (I === i.UNSIGNED_BYTE && (z = i.R8UI),
          I === i.UNSIGNED_SHORT && (z = i.R16UI),
          I === i.UNSIGNED_INT && (z = i.R32UI),
          I === i.BYTE && (z = i.R8I),
          I === i.SHORT && (z = i.R16I),
          I === i.INT && (z = i.R32I)),
        _ === i.RG &&
          (I === i.FLOAT && (z = i.RG32F), I === i.HALF_FLOAT && (z = i.RG16F), I === i.UNSIGNED_BYTE && (z = i.RG8)),
        _ === i.RG_INTEGER &&
          (I === i.UNSIGNED_BYTE && (z = i.RG8UI),
          I === i.UNSIGNED_SHORT && (z = i.RG16UI),
          I === i.UNSIGNED_INT && (z = i.RG32UI),
          I === i.BYTE && (z = i.RG8I),
          I === i.SHORT && (z = i.RG16I),
          I === i.INT && (z = i.RG32I)),
        _ === i.RGB_INTEGER &&
          (I === i.UNSIGNED_BYTE && (z = i.RGB8UI),
          I === i.UNSIGNED_SHORT && (z = i.RGB16UI),
          I === i.UNSIGNED_INT && (z = i.RGB32UI),
          I === i.BYTE && (z = i.RGB8I),
          I === i.SHORT && (z = i.RGB16I),
          I === i.INT && (z = i.RGB32I)),
        _ === i.RGBA_INTEGER &&
          (I === i.UNSIGNED_BYTE && (z = i.RGBA8UI),
          I === i.UNSIGNED_SHORT && (z = i.RGBA16UI),
          I === i.UNSIGNED_INT && (z = i.RGBA32UI),
          I === i.BYTE && (z = i.RGBA8I),
          I === i.SHORT && (z = i.RGBA16I),
          I === i.INT && (z = i.RGBA32I)),
        _ === i.RGB && I === i.UNSIGNED_INT_5_9_9_9_REV && (z = i.RGB9_E5),
        _ === i.RGBA)
      ) {
        const xe = $ ? Yn : ze.getTransfer(k);
        I === i.FLOAT && (z = i.RGBA32F),
          I === i.HALF_FLOAT && (z = i.RGBA16F),
          I === i.UNSIGNED_BYTE && (z = xe === Xe ? i.SRGB8_ALPHA8 : i.RGBA8),
          I === i.UNSIGNED_SHORT_4_4_4_4 && (z = i.RGBA4),
          I === i.UNSIGNED_SHORT_5_5_5_1 && (z = i.RGB5_A1);
      }
      return (
        (z === i.R16F || z === i.R32F || z === i.RG16F || z === i.RG32F || z === i.RGBA16F || z === i.RGBA32F) &&
          e.get("EXT_color_buffer_float"),
        z
      );
    }
    function E(T, _) {
      let I;
      return (
        T
          ? _ === null || _ === 1014 || _ === 1020
            ? (I = i.DEPTH24_STENCIL8)
            : _ === 1015
            ? (I = i.DEPTH32F_STENCIL8)
            : _ === 1012 &&
              ((I = i.DEPTH24_STENCIL8),
              console.warn(
                "DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment."
              ))
          : _ === null || _ === 1014 || _ === 1020
          ? (I = i.DEPTH_COMPONENT24)
          : _ === 1015
          ? (I = i.DEPTH_COMPONENT32F)
          : _ === 1012 && (I = i.DEPTH_COMPONENT16),
        I
      );
    }
    function D(T, _) {
      return p(T) === !0 || (T.isFramebufferTexture && T.minFilter !== 1003 && T.minFilter !== 1006)
        ? Math.log2(Math.max(_.width, _.height)) + 1
        : T.mipmaps !== void 0 && T.mipmaps.length > 0
        ? T.mipmaps.length
        : T.isCompressedTexture && Array.isArray(T.image)
        ? _.mipmaps.length
        : 1;
    }
    function w(T) {
      const _ = T.target;
      _.removeEventListener("dispose", w), F(_), _.isVideoTexture && h.delete(_);
    }
    function P(T) {
      const _ = T.target;
      _.removeEventListener("dispose", P), S(_);
    }
    function F(T) {
      const _ = n.get(T);
      if (_.__webglInit === void 0) return;
      const I = T.source,
        k = d.get(I);
      if (k) {
        const $ = k[_.__cacheKey];
        $.usedTimes--, $.usedTimes === 0 && M(T), Object.keys(k).length === 0 && d.delete(I);
      }
      n.remove(T);
    }
    function M(T) {
      const _ = n.get(T);
      i.deleteTexture(_.__webglTexture);
      const I = T.source,
        k = d.get(I);
      delete k[_.__cacheKey], a.memory.textures--;
    }
    function S(T) {
      const _ = n.get(T);
      if ((T.depthTexture && (T.depthTexture.dispose(), n.remove(T.depthTexture)), T.isWebGLCubeRenderTarget))
        for (let k = 0; k < 6; k++) {
          if (Array.isArray(_.__webglFramebuffer[k]))
            for (let $ = 0; $ < _.__webglFramebuffer[k].length; $++) i.deleteFramebuffer(_.__webglFramebuffer[k][$]);
          else i.deleteFramebuffer(_.__webglFramebuffer[k]);
          _.__webglDepthbuffer && i.deleteRenderbuffer(_.__webglDepthbuffer[k]);
        }
      else {
        if (Array.isArray(_.__webglFramebuffer))
          for (let k = 0; k < _.__webglFramebuffer.length; k++) i.deleteFramebuffer(_.__webglFramebuffer[k]);
        else i.deleteFramebuffer(_.__webglFramebuffer);
        if (
          (_.__webglDepthbuffer && i.deleteRenderbuffer(_.__webglDepthbuffer),
          _.__webglMultisampledFramebuffer && i.deleteFramebuffer(_.__webglMultisampledFramebuffer),
          _.__webglColorRenderbuffer)
        )
          for (let k = 0; k < _.__webglColorRenderbuffer.length; k++)
            _.__webglColorRenderbuffer[k] && i.deleteRenderbuffer(_.__webglColorRenderbuffer[k]);
        _.__webglDepthRenderbuffer && i.deleteRenderbuffer(_.__webglDepthRenderbuffer);
      }
      const I = T.textures;
      for (let k = 0, $ = I.length; k < $; k++) {
        const z = n.get(I[k]);
        z.__webglTexture && (i.deleteTexture(z.__webglTexture), a.memory.textures--), n.remove(I[k]);
      }
      n.remove(T);
    }
    let b = 0;
    function q() {
      b = 0;
    }
    function V() {
      const T = b;
      return (
        T >= r.maxTextures &&
          console.warn(
            "THREE.WebGLTextures: Trying to use " + T + " texture units while this GPU supports only " + r.maxTextures
          ),
        (b += 1),
        T
      );
    }
    function H(T) {
      const _ = [];
      return (
        _.push(T.wrapS),
        _.push(T.wrapT),
        _.push(T.wrapR || 0),
        _.push(T.magFilter),
        _.push(T.minFilter),
        _.push(T.anisotropy),
        _.push(T.internalFormat),
        _.push(T.format),
        _.push(T.type),
        _.push(T.generateMipmaps),
        _.push(T.premultiplyAlpha),
        _.push(T.flipY),
        _.push(T.unpackAlignment),
        _.push(T.colorSpace),
        _.join()
      );
    }
    function K(T, _) {
      const I = n.get(T);
      if (
        (T.isVideoTexture && Ne(T),
        T.isRenderTargetTexture === !1 && T.isExternalTexture !== !0 && T.version > 0 && I.__version !== T.version)
      ) {
        const k = T.image;
        if (k === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
        else if (k.complete === !1)
          console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
        else {
          ae(I, T, _);
          return;
        }
      } else T.isExternalTexture && (I.__webglTexture = T.sourceTexture ? T.sourceTexture : null);
      t.bindTexture(i.TEXTURE_2D, I.__webglTexture, i.TEXTURE0 + _);
    }
    function X(T, _) {
      const I = n.get(T);
      if (T.isRenderTargetTexture === !1 && T.version > 0 && I.__version !== T.version) {
        ae(I, T, _);
        return;
      }
      t.bindTexture(i.TEXTURE_2D_ARRAY, I.__webglTexture, i.TEXTURE0 + _);
    }
    function ee(T, _) {
      const I = n.get(T);
      if (T.isRenderTargetTexture === !1 && T.version > 0 && I.__version !== T.version) {
        ae(I, T, _);
        return;
      }
      t.bindTexture(i.TEXTURE_3D, I.__webglTexture, i.TEXTURE0 + _);
    }
    function G(T, _) {
      const I = n.get(T);
      if (T.version > 0 && I.__version !== T.version) {
        ne(I, T, _);
        return;
      }
      t.bindTexture(i.TEXTURE_CUBE_MAP, I.__webglTexture, i.TEXTURE0 + _);
    }
    const se = { 1e3: i.REPEAT, 1001: i.CLAMP_TO_EDGE, 1002: i.MIRRORED_REPEAT },
      ue = {
        1003: i.NEAREST,
        1004: i.NEAREST_MIPMAP_NEAREST,
        1005: i.NEAREST_MIPMAP_LINEAR,
        1006: i.LINEAR,
        1007: i.LINEAR_MIPMAP_NEAREST,
        1008: i.LINEAR_MIPMAP_LINEAR
      },
      Me = {
        512: i.NEVER,
        519: i.ALWAYS,
        513: i.LESS,
        515: i.LEQUAL,
        514: i.EQUAL,
        518: i.GEQUAL,
        516: i.GREATER,
        517: i.NOTEQUAL
      };
    function Fe(T, _) {
      if (
        (_.type === 1015 &&
          e.has("OES_texture_float_linear") === !1 &&
          (_.magFilter === 1006 ||
            _.magFilter === 1007 ||
            _.magFilter === 1005 ||
            _.magFilter === 1008 ||
            _.minFilter === 1006 ||
            _.minFilter === 1007 ||
            _.minFilter === 1005 ||
            _.minFilter === 1008) &&
          console.warn(
            "THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."
          ),
        i.texParameteri(T, i.TEXTURE_WRAP_S, se[_.wrapS]),
        i.texParameteri(T, i.TEXTURE_WRAP_T, se[_.wrapT]),
        (T === i.TEXTURE_3D || T === i.TEXTURE_2D_ARRAY) && i.texParameteri(T, i.TEXTURE_WRAP_R, se[_.wrapR]),
        i.texParameteri(T, i.TEXTURE_MAG_FILTER, ue[_.magFilter]),
        i.texParameteri(T, i.TEXTURE_MIN_FILTER, ue[_.minFilter]),
        _.compareFunction &&
          (i.texParameteri(T, i.TEXTURE_COMPARE_MODE, i.COMPARE_REF_TO_TEXTURE),
          i.texParameteri(T, i.TEXTURE_COMPARE_FUNC, Me[_.compareFunction])),
        e.has("EXT_texture_filter_anisotropic") === !0)
      ) {
        if (
          _.magFilter === 1003 ||
          (_.minFilter !== 1005 && _.minFilter !== 1008) ||
          (_.type === 1015 && e.has("OES_texture_float_linear") === !1)
        )
          return;
        if (_.anisotropy > 1 || n.get(_).__currentAnisotropy) {
          const I = e.get("EXT_texture_filter_anisotropic");
          i.texParameterf(T, I.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(_.anisotropy, r.getMaxAnisotropy())),
            (n.get(_).__currentAnisotropy = _.anisotropy);
        }
      }
    }
    function Qe(T, _) {
      let I = !1;
      T.__webglInit === void 0 && ((T.__webglInit = !0), _.addEventListener("dispose", w));
      const k = _.source;
      let $ = d.get(k);
      $ === void 0 && (($ = {}), d.set(k, $));
      const z = H(_);
      if (z !== T.__cacheKey) {
        $[z] === void 0 && (($[z] = { texture: i.createTexture(), usedTimes: 0 }), a.memory.textures++, (I = !0)),
          $[z].usedTimes++;
        const xe = $[T.__cacheKey];
        xe !== void 0 && ($[T.__cacheKey].usedTimes--, xe.usedTimes === 0 && M(_)),
          (T.__cacheKey = z),
          (T.__webglTexture = $[z].texture);
      }
      return I;
    }
    function $e(T, _, I) {
      return Math.floor(Math.floor(T / I) / _);
    }
    function W(T, _, I, k) {
      const z = T.updateRanges;
      if (z.length === 0) t.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, _.width, _.height, I, k, _.data);
      else {
        z.sort((j, ce) => j.start - ce.start);
        let xe = 0;
        for (let j = 1; j < z.length; j++) {
          const ce = z[xe],
            Ce = z[j],
            ve = ce.start + ce.count,
            oe = $e(Ce.start, _.width, 4),
            Ue = $e(ce.start, _.width, 4);
          Ce.start <= ve + 1 && oe === Ue && $e(Ce.start + Ce.count - 1, _.width, 4) === oe
            ? (ce.count = Math.max(ce.count, Ce.start + Ce.count - ce.start))
            : (++xe, (z[xe] = Ce));
        }
        z.length = xe + 1;
        const te = i.getParameter(i.UNPACK_ROW_LENGTH),
          _e = i.getParameter(i.UNPACK_SKIP_PIXELS),
          ge = i.getParameter(i.UNPACK_SKIP_ROWS);
        i.pixelStorei(i.UNPACK_ROW_LENGTH, _.width);
        for (let j = 0, ce = z.length; j < ce; j++) {
          const Ce = z[j],
            ve = Math.floor(Ce.start / 4),
            oe = Math.ceil(Ce.count / 4),
            Ue = ve % _.width,
            R = Math.floor(ve / _.width),
            Q = oe,
            ie = 1;
          i.pixelStorei(i.UNPACK_SKIP_PIXELS, Ue),
            i.pixelStorei(i.UNPACK_SKIP_ROWS, R),
            t.texSubImage2D(i.TEXTURE_2D, 0, Ue, R, Q, ie, I, k, _.data);
        }
        T.clearUpdateRanges(),
          i.pixelStorei(i.UNPACK_ROW_LENGTH, te),
          i.pixelStorei(i.UNPACK_SKIP_PIXELS, _e),
          i.pixelStorei(i.UNPACK_SKIP_ROWS, ge);
      }
    }
    function ae(T, _, I) {
      let k = i.TEXTURE_2D;
      (_.isDataArrayTexture || _.isCompressedArrayTexture) && (k = i.TEXTURE_2D_ARRAY),
        _.isData3DTexture && (k = i.TEXTURE_3D);
      const $ = Qe(T, _),
        z = _.source;
      t.bindTexture(k, T.__webglTexture, i.TEXTURE0 + I);
      const xe = n.get(z);
      if (z.version !== xe.__version || $ === !0) {
        t.activeTexture(i.TEXTURE0 + I);
        const te = ze.getPrimaries(ze.workingColorSpace),
          _e = _.colorSpace === "" ? null : ze.getPrimaries(_.colorSpace),
          ge = _.colorSpace === "" || te === _e ? i.NONE : i.BROWSER_DEFAULT_WEBGL;
        i.pixelStorei(i.UNPACK_FLIP_Y_WEBGL, _.flipY),
          i.pixelStorei(i.UNPACK_PREMULTIPLY_ALPHA_WEBGL, _.premultiplyAlpha),
          i.pixelStorei(i.UNPACK_ALIGNMENT, _.unpackAlignment),
          i.pixelStorei(i.UNPACK_COLORSPACE_CONVERSION_WEBGL, ge);
        let j = x(_.image, !1, r.maxTextureSize);
        j = ft(_, j);
        const ce = s.convert(_.format, _.colorSpace),
          Ce = s.convert(_.type);
        let ve = y(_.internalFormat, ce, Ce, _.colorSpace, _.isVideoTexture);
        Fe(k, _);
        let oe;
        const Ue = _.mipmaps,
          R = _.isVideoTexture !== !0,
          Q = xe.__version === void 0 || $ === !0,
          ie = z.dataReady,
          fe = D(_, j);
        if (_.isDepthTexture)
          (ve = E(_.format === 1027, _.type)),
            Q &&
              (R
                ? t.texStorage2D(i.TEXTURE_2D, 1, ve, j.width, j.height)
                : t.texImage2D(i.TEXTURE_2D, 0, ve, j.width, j.height, 0, ce, Ce, null));
        else if (_.isDataTexture)
          if (Ue.length > 0) {
            R && Q && t.texStorage2D(i.TEXTURE_2D, fe, ve, Ue[0].width, Ue[0].height);
            for (let Z = 0, Y = Ue.length; Z < Y; Z++)
              (oe = Ue[Z]),
                R
                  ? ie && t.texSubImage2D(i.TEXTURE_2D, Z, 0, 0, oe.width, oe.height, ce, Ce, oe.data)
                  : t.texImage2D(i.TEXTURE_2D, Z, ve, oe.width, oe.height, 0, ce, Ce, oe.data);
            _.generateMipmaps = !1;
          } else
            R
              ? (Q && t.texStorage2D(i.TEXTURE_2D, fe, ve, j.width, j.height), ie && W(_, j, ce, Ce))
              : t.texImage2D(i.TEXTURE_2D, 0, ve, j.width, j.height, 0, ce, Ce, j.data);
        else if (_.isCompressedTexture)
          if (_.isCompressedArrayTexture) {
            R && Q && t.texStorage3D(i.TEXTURE_2D_ARRAY, fe, ve, Ue[0].width, Ue[0].height, j.depth);
            for (let Z = 0, Y = Ue.length; Z < Y; Z++)
              if (((oe = Ue[Z]), _.format !== 1023))
                if (ce !== null)
                  if (R) {
                    if (ie)
                      if (_.layerUpdates.size > 0) {
                        const me = Vr(oe.width, oe.height, _.format, _.type);
                        for (const De of _.layerUpdates) {
                          const Je = oe.data.subarray(
                            (De * me) / oe.data.BYTES_PER_ELEMENT,
                            ((De + 1) * me) / oe.data.BYTES_PER_ELEMENT
                          );
                          t.compressedTexSubImage3D(i.TEXTURE_2D_ARRAY, Z, 0, 0, De, oe.width, oe.height, 1, ce, Je);
                        }
                        _.clearLayerUpdates();
                      } else
                        t.compressedTexSubImage3D(
                          i.TEXTURE_2D_ARRAY,
                          Z,
                          0,
                          0,
                          0,
                          oe.width,
                          oe.height,
                          j.depth,
                          ce,
                          oe.data
                        );
                  } else
                    t.compressedTexImage3D(i.TEXTURE_2D_ARRAY, Z, ve, oe.width, oe.height, j.depth, 0, oe.data, 0, 0);
                else
                  console.warn(
                    "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"
                  );
              else
                R
                  ? ie && t.texSubImage3D(i.TEXTURE_2D_ARRAY, Z, 0, 0, 0, oe.width, oe.height, j.depth, ce, Ce, oe.data)
                  : t.texImage3D(i.TEXTURE_2D_ARRAY, Z, ve, oe.width, oe.height, j.depth, 0, ce, Ce, oe.data);
          } else {
            R && Q && t.texStorage2D(i.TEXTURE_2D, fe, ve, Ue[0].width, Ue[0].height);
            for (let Z = 0, Y = Ue.length; Z < Y; Z++)
              (oe = Ue[Z]),
                _.format !== 1023
                  ? ce !== null
                    ? R
                      ? ie && t.compressedTexSubImage2D(i.TEXTURE_2D, Z, 0, 0, oe.width, oe.height, ce, oe.data)
                      : t.compressedTexImage2D(i.TEXTURE_2D, Z, ve, oe.width, oe.height, 0, oe.data)
                    : console.warn(
                        "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"
                      )
                  : R
                  ? ie && t.texSubImage2D(i.TEXTURE_2D, Z, 0, 0, oe.width, oe.height, ce, Ce, oe.data)
                  : t.texImage2D(i.TEXTURE_2D, Z, ve, oe.width, oe.height, 0, ce, Ce, oe.data);
          }
        else if (_.isDataArrayTexture)
          if (R) {
            if ((Q && t.texStorage3D(i.TEXTURE_2D_ARRAY, fe, ve, j.width, j.height, j.depth), ie))
              if (_.layerUpdates.size > 0) {
                const Z = Vr(j.width, j.height, _.format, _.type);
                for (const Y of _.layerUpdates) {
                  const me = j.data.subarray(
                    (Y * Z) / j.data.BYTES_PER_ELEMENT,
                    ((Y + 1) * Z) / j.data.BYTES_PER_ELEMENT
                  );
                  t.texSubImage3D(i.TEXTURE_2D_ARRAY, 0, 0, 0, Y, j.width, j.height, 1, ce, Ce, me);
                }
                _.clearLayerUpdates();
              } else t.texSubImage3D(i.TEXTURE_2D_ARRAY, 0, 0, 0, 0, j.width, j.height, j.depth, ce, Ce, j.data);
          } else t.texImage3D(i.TEXTURE_2D_ARRAY, 0, ve, j.width, j.height, j.depth, 0, ce, Ce, j.data);
        else if (_.isData3DTexture)
          R
            ? (Q && t.texStorage3D(i.TEXTURE_3D, fe, ve, j.width, j.height, j.depth),
              ie && t.texSubImage3D(i.TEXTURE_3D, 0, 0, 0, 0, j.width, j.height, j.depth, ce, Ce, j.data))
            : t.texImage3D(i.TEXTURE_3D, 0, ve, j.width, j.height, j.depth, 0, ce, Ce, j.data);
        else if (_.isFramebufferTexture) {
          if (Q)
            if (R) t.texStorage2D(i.TEXTURE_2D, fe, ve, j.width, j.height);
            else {
              let Z = j.width,
                Y = j.height;
              for (let me = 0; me < fe; me++)
                t.texImage2D(i.TEXTURE_2D, me, ve, Z, Y, 0, ce, Ce, null), (Z >>= 1), (Y >>= 1);
            }
        } else if (Ue.length > 0) {
          if (R && Q) {
            const Z = at(Ue[0]);
            t.texStorage2D(i.TEXTURE_2D, fe, ve, Z.width, Z.height);
          }
          for (let Z = 0, Y = Ue.length; Z < Y; Z++)
            (oe = Ue[Z]),
              R
                ? ie && t.texSubImage2D(i.TEXTURE_2D, Z, 0, 0, ce, Ce, oe)
                : t.texImage2D(i.TEXTURE_2D, Z, ve, ce, Ce, oe);
          _.generateMipmaps = !1;
        } else if (R) {
          if (Q) {
            const Z = at(j);
            t.texStorage2D(i.TEXTURE_2D, fe, ve, Z.width, Z.height);
          }
          ie && t.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, ce, Ce, j);
        } else t.texImage2D(i.TEXTURE_2D, 0, ve, ce, Ce, j);
        p(_) && u(k), (xe.__version = z.version), _.onUpdate && _.onUpdate(_);
      }
      T.__version = _.version;
    }
    function ne(T, _, I) {
      if (_.image.length !== 6) return;
      const k = Qe(T, _),
        $ = _.source;
      t.bindTexture(i.TEXTURE_CUBE_MAP, T.__webglTexture, i.TEXTURE0 + I);
      const z = n.get($);
      if ($.version !== z.__version || k === !0) {
        t.activeTexture(i.TEXTURE0 + I);
        const xe = ze.getPrimaries(ze.workingColorSpace),
          te = _.colorSpace === "" ? null : ze.getPrimaries(_.colorSpace),
          _e = _.colorSpace === "" || xe === te ? i.NONE : i.BROWSER_DEFAULT_WEBGL;
        i.pixelStorei(i.UNPACK_FLIP_Y_WEBGL, _.flipY),
          i.pixelStorei(i.UNPACK_PREMULTIPLY_ALPHA_WEBGL, _.premultiplyAlpha),
          i.pixelStorei(i.UNPACK_ALIGNMENT, _.unpackAlignment),
          i.pixelStorei(i.UNPACK_COLORSPACE_CONVERSION_WEBGL, _e);
        const ge = _.isCompressedTexture || _.image[0].isCompressedTexture,
          j = _.image[0] && _.image[0].isDataTexture,
          ce = [];
        for (let Y = 0; Y < 6; Y++)
          !ge && !j ? (ce[Y] = x(_.image[Y], !0, r.maxCubemapSize)) : (ce[Y] = j ? _.image[Y].image : _.image[Y]),
            (ce[Y] = ft(_, ce[Y]));
        const Ce = ce[0],
          ve = s.convert(_.format, _.colorSpace),
          oe = s.convert(_.type),
          Ue = y(_.internalFormat, ve, oe, _.colorSpace),
          R = _.isVideoTexture !== !0,
          Q = z.__version === void 0 || k === !0,
          ie = $.dataReady;
        let fe = D(_, Ce);
        Fe(i.TEXTURE_CUBE_MAP, _);
        let Z;
        if (ge) {
          R && Q && t.texStorage2D(i.TEXTURE_CUBE_MAP, fe, Ue, Ce.width, Ce.height);
          for (let Y = 0; Y < 6; Y++) {
            Z = ce[Y].mipmaps;
            for (let me = 0; me < Z.length; me++) {
              const De = Z[me];
              _.format !== 1023
                ? ve !== null
                  ? R
                    ? ie &&
                      t.compressedTexSubImage2D(
                        i.TEXTURE_CUBE_MAP_POSITIVE_X + Y,
                        me,
                        0,
                        0,
                        De.width,
                        De.height,
                        ve,
                        De.data
                      )
                    : t.compressedTexImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, me, Ue, De.width, De.height, 0, De.data)
                  : console.warn(
                      "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()"
                    )
                : R
                ? ie &&
                  t.texSubImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, me, 0, 0, De.width, De.height, ve, oe, De.data)
                : t.texImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, me, Ue, De.width, De.height, 0, ve, oe, De.data);
            }
          }
        } else {
          if (((Z = _.mipmaps), R && Q)) {
            Z.length > 0 && fe++;
            const Y = at(ce[0]);
            t.texStorage2D(i.TEXTURE_CUBE_MAP, fe, Ue, Y.width, Y.height);
          }
          for (let Y = 0; Y < 6; Y++)
            if (j) {
              R
                ? ie &&
                  t.texSubImage2D(
                    i.TEXTURE_CUBE_MAP_POSITIVE_X + Y,
                    0,
                    0,
                    0,
                    ce[Y].width,
                    ce[Y].height,
                    ve,
                    oe,
                    ce[Y].data
                  )
                : t.texImage2D(
                    i.TEXTURE_CUBE_MAP_POSITIVE_X + Y,
                    0,
                    Ue,
                    ce[Y].width,
                    ce[Y].height,
                    0,
                    ve,
                    oe,
                    ce[Y].data
                  );
              for (let me = 0; me < Z.length; me++) {
                const Je = Z[me].image[Y].image;
                R
                  ? ie &&
                    t.texSubImage2D(
                      i.TEXTURE_CUBE_MAP_POSITIVE_X + Y,
                      me + 1,
                      0,
                      0,
                      Je.width,
                      Je.height,
                      ve,
                      oe,
                      Je.data
                    )
                  : t.texImage2D(
                      i.TEXTURE_CUBE_MAP_POSITIVE_X + Y,
                      me + 1,
                      Ue,
                      Je.width,
                      Je.height,
                      0,
                      ve,
                      oe,
                      Je.data
                    );
              }
            } else {
              R
                ? ie && t.texSubImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, 0, 0, 0, ve, oe, ce[Y])
                : t.texImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, 0, Ue, ve, oe, ce[Y]);
              for (let me = 0; me < Z.length; me++) {
                const De = Z[me];
                R
                  ? ie && t.texSubImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, me + 1, 0, 0, ve, oe, De.image[Y])
                  : t.texImage2D(i.TEXTURE_CUBE_MAP_POSITIVE_X + Y, me + 1, Ue, ve, oe, De.image[Y]);
              }
            }
        }
        p(_) && u(i.TEXTURE_CUBE_MAP), (z.__version = $.version), _.onUpdate && _.onUpdate(_);
      }
      T.__version = _.version;
    }
    function Ae(T, _, I, k, $, z) {
      const xe = s.convert(I.format, I.colorSpace),
        te = s.convert(I.type),
        _e = y(I.internalFormat, xe, te, I.colorSpace),
        ge = n.get(_),
        j = n.get(I);
      if (((j.__renderTarget = _), !ge.__hasExternalTextures)) {
        const ce = Math.max(1, _.width >> z),
          Ce = Math.max(1, _.height >> z);
        $ === i.TEXTURE_3D || $ === i.TEXTURE_2D_ARRAY
          ? t.texImage3D($, z, _e, ce, Ce, _.depth, 0, xe, te, null)
          : t.texImage2D($, z, _e, ce, Ce, 0, xe, te, null);
      }
      t.bindFramebuffer(i.FRAMEBUFFER, T),
        de(_)
          ? o.framebufferTexture2DMultisampleEXT(i.FRAMEBUFFER, k, $, j.__webglTexture, 0, et(_))
          : ($ === i.TEXTURE_2D || ($ >= i.TEXTURE_CUBE_MAP_POSITIVE_X && $ <= i.TEXTURE_CUBE_MAP_NEGATIVE_Z)) &&
            i.framebufferTexture2D(i.FRAMEBUFFER, k, $, j.__webglTexture, z),
        t.bindFramebuffer(i.FRAMEBUFFER, null);
    }
    function be(T, _, I) {
      if ((i.bindRenderbuffer(i.RENDERBUFFER, T), _.depthBuffer)) {
        const k = _.depthTexture,
          $ = k && k.isDepthTexture ? k.type : null,
          z = E(_.stencilBuffer, $),
          xe = _.stencilBuffer ? i.DEPTH_STENCIL_ATTACHMENT : i.DEPTH_ATTACHMENT,
          te = et(_);
        de(_)
          ? o.renderbufferStorageMultisampleEXT(i.RENDERBUFFER, te, z, _.width, _.height)
          : I
          ? i.renderbufferStorageMultisample(i.RENDERBUFFER, te, z, _.width, _.height)
          : i.renderbufferStorage(i.RENDERBUFFER, z, _.width, _.height),
          i.framebufferRenderbuffer(i.FRAMEBUFFER, xe, i.RENDERBUFFER, T);
      } else {
        const k = _.textures;
        for (let $ = 0; $ < k.length; $++) {
          const z = k[$],
            xe = s.convert(z.format, z.colorSpace),
            te = s.convert(z.type),
            _e = y(z.internalFormat, xe, te, z.colorSpace),
            ge = et(_);
          I && de(_) === !1
            ? i.renderbufferStorageMultisample(i.RENDERBUFFER, ge, _e, _.width, _.height)
            : de(_)
            ? o.renderbufferStorageMultisampleEXT(i.RENDERBUFFER, ge, _e, _.width, _.height)
            : i.renderbufferStorage(i.RENDERBUFFER, _e, _.width, _.height);
        }
      }
      i.bindRenderbuffer(i.RENDERBUFFER, null);
    }
    function Pe(T, _) {
      if (_ && _.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
      if ((t.bindFramebuffer(i.FRAMEBUFFER, T), !(_.depthTexture && _.depthTexture.isDepthTexture)))
        throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
      const k = n.get(_.depthTexture);
      (k.__renderTarget = _),
        (!k.__webglTexture || _.depthTexture.image.width !== _.width || _.depthTexture.image.height !== _.height) &&
          ((_.depthTexture.image.width = _.width),
          (_.depthTexture.image.height = _.height),
          (_.depthTexture.needsUpdate = !0)),
        K(_.depthTexture, 0);
      const $ = k.__webglTexture,
        z = et(_);
      if (_.depthTexture.format === 1026)
        de(_)
          ? o.framebufferTexture2DMultisampleEXT(i.FRAMEBUFFER, i.DEPTH_ATTACHMENT, i.TEXTURE_2D, $, 0, z)
          : i.framebufferTexture2D(i.FRAMEBUFFER, i.DEPTH_ATTACHMENT, i.TEXTURE_2D, $, 0);
      else if (_.depthTexture.format === 1027)
        de(_)
          ? o.framebufferTexture2DMultisampleEXT(i.FRAMEBUFFER, i.DEPTH_STENCIL_ATTACHMENT, i.TEXTURE_2D, $, 0, z)
          : i.framebufferTexture2D(i.FRAMEBUFFER, i.DEPTH_STENCIL_ATTACHMENT, i.TEXTURE_2D, $, 0);
      else throw new Error("Unknown depthTexture format");
    }
    function st(T) {
      const _ = n.get(T),
        I = T.isWebGLCubeRenderTarget === !0;
      if (_.__boundDepthTexture !== T.depthTexture) {
        const k = T.depthTexture;
        if ((_.__depthDisposeCallback && _.__depthDisposeCallback(), k)) {
          const $ = () => {
            delete _.__boundDepthTexture, delete _.__depthDisposeCallback, k.removeEventListener("dispose", $);
          };
          k.addEventListener("dispose", $), (_.__depthDisposeCallback = $);
        }
        _.__boundDepthTexture = k;
      }
      if (T.depthTexture && !_.__autoAllocateDepthBuffer) {
        if (I) throw new Error("target.depthTexture not supported in Cube render targets");
        const k = T.texture.mipmaps;
        k && k.length > 0 ? Pe(_.__webglFramebuffer[0], T) : Pe(_.__webglFramebuffer, T);
      } else if (I) {
        _.__webglDepthbuffer = [];
        for (let k = 0; k < 6; k++)
          if ((t.bindFramebuffer(i.FRAMEBUFFER, _.__webglFramebuffer[k]), _.__webglDepthbuffer[k] === void 0))
            (_.__webglDepthbuffer[k] = i.createRenderbuffer()), be(_.__webglDepthbuffer[k], T, !1);
          else {
            const $ = T.stencilBuffer ? i.DEPTH_STENCIL_ATTACHMENT : i.DEPTH_ATTACHMENT,
              z = _.__webglDepthbuffer[k];
            i.bindRenderbuffer(i.RENDERBUFFER, z), i.framebufferRenderbuffer(i.FRAMEBUFFER, $, i.RENDERBUFFER, z);
          }
      } else {
        const k = T.texture.mipmaps;
        if (
          (k && k.length > 0
            ? t.bindFramebuffer(i.FRAMEBUFFER, _.__webglFramebuffer[0])
            : t.bindFramebuffer(i.FRAMEBUFFER, _.__webglFramebuffer),
          _.__webglDepthbuffer === void 0)
        )
          (_.__webglDepthbuffer = i.createRenderbuffer()), be(_.__webglDepthbuffer, T, !1);
        else {
          const $ = T.stencilBuffer ? i.DEPTH_STENCIL_ATTACHMENT : i.DEPTH_ATTACHMENT,
            z = _.__webglDepthbuffer;
          i.bindRenderbuffer(i.RENDERBUFFER, z), i.framebufferRenderbuffer(i.FRAMEBUFFER, $, i.RENDERBUFFER, z);
        }
      }
      t.bindFramebuffer(i.FRAMEBUFFER, null);
    }
    function Ge(T, _, I) {
      const k = n.get(T);
      _ !== void 0 && Ae(k.__webglFramebuffer, T, T.texture, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, 0),
        I !== void 0 && st(T);
    }
    function A(T) {
      const _ = T.texture,
        I = n.get(T),
        k = n.get(_);
      T.addEventListener("dispose", P);
      const $ = T.textures,
        z = T.isWebGLCubeRenderTarget === !0,
        xe = $.length > 1;
      if (
        (xe ||
          (k.__webglTexture === void 0 && (k.__webglTexture = i.createTexture()),
          (k.__version = _.version),
          a.memory.textures++),
        z)
      ) {
        I.__webglFramebuffer = [];
        for (let te = 0; te < 6; te++)
          if (_.mipmaps && _.mipmaps.length > 0) {
            I.__webglFramebuffer[te] = [];
            for (let _e = 0; _e < _.mipmaps.length; _e++) I.__webglFramebuffer[te][_e] = i.createFramebuffer();
          } else I.__webglFramebuffer[te] = i.createFramebuffer();
      } else {
        if (_.mipmaps && _.mipmaps.length > 0) {
          I.__webglFramebuffer = [];
          for (let te = 0; te < _.mipmaps.length; te++) I.__webglFramebuffer[te] = i.createFramebuffer();
        } else I.__webglFramebuffer = i.createFramebuffer();
        if (xe)
          for (let te = 0, _e = $.length; te < _e; te++) {
            const ge = n.get($[te]);
            ge.__webglTexture === void 0 && ((ge.__webglTexture = i.createTexture()), a.memory.textures++);
          }
        if (T.samples > 0 && de(T) === !1) {
          (I.__webglMultisampledFramebuffer = i.createFramebuffer()),
            (I.__webglColorRenderbuffer = []),
            t.bindFramebuffer(i.FRAMEBUFFER, I.__webglMultisampledFramebuffer);
          for (let te = 0; te < $.length; te++) {
            const _e = $[te];
            (I.__webglColorRenderbuffer[te] = i.createRenderbuffer()),
              i.bindRenderbuffer(i.RENDERBUFFER, I.__webglColorRenderbuffer[te]);
            const ge = s.convert(_e.format, _e.colorSpace),
              j = s.convert(_e.type),
              ce = y(_e.internalFormat, ge, j, _e.colorSpace, T.isXRRenderTarget === !0),
              Ce = et(T);
            i.renderbufferStorageMultisample(i.RENDERBUFFER, Ce, ce, T.width, T.height),
              i.framebufferRenderbuffer(
                i.FRAMEBUFFER,
                i.COLOR_ATTACHMENT0 + te,
                i.RENDERBUFFER,
                I.__webglColorRenderbuffer[te]
              );
          }
          i.bindRenderbuffer(i.RENDERBUFFER, null),
            T.depthBuffer &&
              ((I.__webglDepthRenderbuffer = i.createRenderbuffer()), be(I.__webglDepthRenderbuffer, T, !0)),
            t.bindFramebuffer(i.FRAMEBUFFER, null);
        }
      }
      if (z) {
        t.bindTexture(i.TEXTURE_CUBE_MAP, k.__webglTexture), Fe(i.TEXTURE_CUBE_MAP, _);
        for (let te = 0; te < 6; te++)
          if (_.mipmaps && _.mipmaps.length > 0)
            for (let _e = 0; _e < _.mipmaps.length; _e++)
              Ae(I.__webglFramebuffer[te][_e], T, _, i.COLOR_ATTACHMENT0, i.TEXTURE_CUBE_MAP_POSITIVE_X + te, _e);
          else Ae(I.__webglFramebuffer[te], T, _, i.COLOR_ATTACHMENT0, i.TEXTURE_CUBE_MAP_POSITIVE_X + te, 0);
        p(_) && u(i.TEXTURE_CUBE_MAP), t.unbindTexture();
      } else if (xe) {
        for (let te = 0, _e = $.length; te < _e; te++) {
          const ge = $[te],
            j = n.get(ge);
          let ce = i.TEXTURE_2D;
          (T.isWebGL3DRenderTarget || T.isWebGLArrayRenderTarget) &&
            (ce = T.isWebGL3DRenderTarget ? i.TEXTURE_3D : i.TEXTURE_2D_ARRAY),
            t.bindTexture(ce, j.__webglTexture),
            Fe(ce, ge),
            Ae(I.__webglFramebuffer, T, ge, i.COLOR_ATTACHMENT0 + te, ce, 0),
            p(ge) && u(ce);
        }
        t.unbindTexture();
      } else {
        let te = i.TEXTURE_2D;
        if (
          ((T.isWebGL3DRenderTarget || T.isWebGLArrayRenderTarget) &&
            (te = T.isWebGL3DRenderTarget ? i.TEXTURE_3D : i.TEXTURE_2D_ARRAY),
          t.bindTexture(te, k.__webglTexture),
          Fe(te, _),
          _.mipmaps && _.mipmaps.length > 0)
        )
          for (let _e = 0; _e < _.mipmaps.length; _e++) Ae(I.__webglFramebuffer[_e], T, _, i.COLOR_ATTACHMENT0, te, _e);
        else Ae(I.__webglFramebuffer, T, _, i.COLOR_ATTACHMENT0, te, 0);
        p(_) && u(te), t.unbindTexture();
      }
      T.depthBuffer && st(T);
    }
    function Ze(T) {
      const _ = T.textures;
      for (let I = 0, k = _.length; I < k; I++) {
        const $ = _[I];
        if (p($)) {
          const z = C(T),
            xe = n.get($).__webglTexture;
          t.bindTexture(z, xe), u(z), t.unbindTexture();
        }
      }
    }
    const Te = [],
      He = [];
    function Se(T) {
      if (T.samples > 0) {
        if (de(T) === !1) {
          const _ = T.textures,
            I = T.width,
            k = T.height;
          let $ = i.COLOR_BUFFER_BIT;
          const z = T.stencilBuffer ? i.DEPTH_STENCIL_ATTACHMENT : i.DEPTH_ATTACHMENT,
            xe = n.get(T),
            te = _.length > 1;
          if (te)
            for (let ge = 0; ge < _.length; ge++)
              t.bindFramebuffer(i.FRAMEBUFFER, xe.__webglMultisampledFramebuffer),
                i.framebufferRenderbuffer(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0 + ge, i.RENDERBUFFER, null),
                t.bindFramebuffer(i.FRAMEBUFFER, xe.__webglFramebuffer),
                i.framebufferTexture2D(i.DRAW_FRAMEBUFFER, i.COLOR_ATTACHMENT0 + ge, i.TEXTURE_2D, null, 0);
          t.bindFramebuffer(i.READ_FRAMEBUFFER, xe.__webglMultisampledFramebuffer);
          const _e = T.texture.mipmaps;
          _e && _e.length > 0
            ? t.bindFramebuffer(i.DRAW_FRAMEBUFFER, xe.__webglFramebuffer[0])
            : t.bindFramebuffer(i.DRAW_FRAMEBUFFER, xe.__webglFramebuffer);
          for (let ge = 0; ge < _.length; ge++) {
            if (
              (T.resolveDepthBuffer &&
                (T.depthBuffer && ($ |= i.DEPTH_BUFFER_BIT),
                T.stencilBuffer && T.resolveStencilBuffer && ($ |= i.STENCIL_BUFFER_BIT)),
              te)
            ) {
              i.framebufferRenderbuffer(
                i.READ_FRAMEBUFFER,
                i.COLOR_ATTACHMENT0,
                i.RENDERBUFFER,
                xe.__webglColorRenderbuffer[ge]
              );
              const j = n.get(_[ge]).__webglTexture;
              i.framebufferTexture2D(i.DRAW_FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, j, 0);
            }
            i.blitFramebuffer(0, 0, I, k, 0, 0, I, k, $, i.NEAREST),
              c === !0 &&
                ((Te.length = 0),
                (He.length = 0),
                Te.push(i.COLOR_ATTACHMENT0 + ge),
                T.depthBuffer &&
                  T.resolveDepthBuffer === !1 &&
                  (Te.push(z), He.push(z), i.invalidateFramebuffer(i.DRAW_FRAMEBUFFER, He)),
                i.invalidateFramebuffer(i.READ_FRAMEBUFFER, Te));
          }
          if ((t.bindFramebuffer(i.READ_FRAMEBUFFER, null), t.bindFramebuffer(i.DRAW_FRAMEBUFFER, null), te))
            for (let ge = 0; ge < _.length; ge++) {
              t.bindFramebuffer(i.FRAMEBUFFER, xe.__webglMultisampledFramebuffer),
                i.framebufferRenderbuffer(
                  i.FRAMEBUFFER,
                  i.COLOR_ATTACHMENT0 + ge,
                  i.RENDERBUFFER,
                  xe.__webglColorRenderbuffer[ge]
                );
              const j = n.get(_[ge]).__webglTexture;
              t.bindFramebuffer(i.FRAMEBUFFER, xe.__webglFramebuffer),
                i.framebufferTexture2D(i.DRAW_FRAMEBUFFER, i.COLOR_ATTACHMENT0 + ge, i.TEXTURE_2D, j, 0);
            }
          t.bindFramebuffer(i.DRAW_FRAMEBUFFER, xe.__webglMultisampledFramebuffer);
        } else if (T.depthBuffer && T.resolveDepthBuffer === !1 && c) {
          const _ = T.stencilBuffer ? i.DEPTH_STENCIL_ATTACHMENT : i.DEPTH_ATTACHMENT;
          i.invalidateFramebuffer(i.DRAW_FRAMEBUFFER, [_]);
        }
      }
    }
    function et(T) {
      return Math.min(r.maxSamples, T.samples);
    }
    function de(T) {
      const _ = n.get(T);
      return T.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && _.__useRenderToTexture !== !1;
    }
    function Ne(T) {
      const _ = a.render.frame;
      h.get(T) !== _ && (h.set(T, _), T.update());
    }
    function ft(T, _) {
      const I = T.colorSpace,
        k = T.format,
        $ = T.type;
      return (
        T.isCompressedTexture === !0 ||
          T.isVideoTexture === !0 ||
          (I !== pn &&
            I !== "" &&
            (ze.getTransfer(I) === Xe
              ? (k !== 1023 || $ !== 1009) &&
                console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.")
              : console.error("THREE.WebGLTextures: Unsupported texture color space:", I))),
        _
      );
    }
    function at(T) {
      return (
        typeof HTMLImageElement < "u" && T instanceof HTMLImageElement
          ? ((l.width = T.naturalWidth || T.width), (l.height = T.naturalHeight || T.height))
          : typeof VideoFrame < "u" && T instanceof VideoFrame
          ? ((l.width = T.displayWidth), (l.height = T.displayHeight))
          : ((l.width = T.width), (l.height = T.height)),
        l
      );
    }
    (this.allocateTextureUnit = V),
      (this.resetTextureUnits = q),
      (this.setTexture2D = K),
      (this.setTexture2DArray = X),
      (this.setTexture3D = ee),
      (this.setTextureCube = G),
      (this.rebindTextures = Ge),
      (this.setupRenderTarget = A),
      (this.updateRenderTargetMipmap = Ze),
      (this.updateMultisampleRenderTarget = Se),
      (this.setupDepthRenderbuffer = st),
      (this.setupFrameBufferTexture = Ae),
      (this.useMultisampledRTT = de);
  }
  function tu(i, e) {
    function t(n, r = "") {
      let s;
      const a = ze.getTransfer(r);
      if (n === 1009) return i.UNSIGNED_BYTE;
      if (n === 1017) return i.UNSIGNED_SHORT_4_4_4_4;
      if (n === 1018) return i.UNSIGNED_SHORT_5_5_5_1;
      if (n === 35902) return i.UNSIGNED_INT_5_9_9_9_REV;
      if (n === 1010) return i.BYTE;
      if (n === 1011) return i.SHORT;
      if (n === 1012) return i.UNSIGNED_SHORT;
      if (n === 1013) return i.INT;
      if (n === 1014) return i.UNSIGNED_INT;
      if (n === 1015) return i.FLOAT;
      if (n === 1016) return i.HALF_FLOAT;
      if (n === 1021) return i.ALPHA;
      if (n === 1022) return i.RGB;
      if (n === 1023) return i.RGBA;
      if (n === 1026) return i.DEPTH_COMPONENT;
      if (n === 1027) return i.DEPTH_STENCIL;
      if (n === 1028) return i.RED;
      if (n === 1029) return i.RED_INTEGER;
      if (n === 1030) return i.RG;
      if (n === 1031) return i.RG_INTEGER;
      if (n === 1033) return i.RGBA_INTEGER;
      if (n === 33776 || n === 33777 || n === 33778 || n === 33779)
        if (a === Xe)
          if (((s = e.get("WEBGL_compressed_texture_s3tc_srgb")), s !== null)) {
            if (n === 33776) return s.COMPRESSED_SRGB_S3TC_DXT1_EXT;
            if (n === 33777) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
            if (n === 33778) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
            if (n === 33779) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
          } else return null;
        else if (((s = e.get("WEBGL_compressed_texture_s3tc")), s !== null)) {
          if (n === 33776) return s.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (n === 33777) return s.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (n === 33778) return s.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (n === 33779) return s.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else return null;
      if (n === 35840 || n === 35841 || n === 35842 || n === 35843)
        if (((s = e.get("WEBGL_compressed_texture_pvrtc")), s !== null)) {
          if (n === 35840) return s.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
          if (n === 35841) return s.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
          if (n === 35842) return s.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
          if (n === 35843) return s.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
        } else return null;
      if (n === 36196 || n === 37492 || n === 37496)
        if (((s = e.get("WEBGL_compressed_texture_etc")), s !== null)) {
          if (n === 36196 || n === 37492) return a === Xe ? s.COMPRESSED_SRGB8_ETC2 : s.COMPRESSED_RGB8_ETC2;
          if (n === 37496) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : s.COMPRESSED_RGBA8_ETC2_EAC;
        } else return null;
      if (
        n === 37808 ||
        n === 37809 ||
        n === 37810 ||
        n === 37811 ||
        n === 37812 ||
        n === 37813 ||
        n === 37814 ||
        n === 37815 ||
        n === 37816 ||
        n === 37817 ||
        n === 37818 ||
        n === 37819 ||
        n === 37820 ||
        n === 37821
      )
        if (((s = e.get("WEBGL_compressed_texture_astc")), s !== null)) {
          if (n === 37808) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : s.COMPRESSED_RGBA_ASTC_4x4_KHR;
          if (n === 37809) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : s.COMPRESSED_RGBA_ASTC_5x4_KHR;
          if (n === 37810) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : s.COMPRESSED_RGBA_ASTC_5x5_KHR;
          if (n === 37811) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : s.COMPRESSED_RGBA_ASTC_6x5_KHR;
          if (n === 37812) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : s.COMPRESSED_RGBA_ASTC_6x6_KHR;
          if (n === 37813) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : s.COMPRESSED_RGBA_ASTC_8x5_KHR;
          if (n === 37814) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : s.COMPRESSED_RGBA_ASTC_8x6_KHR;
          if (n === 37815) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : s.COMPRESSED_RGBA_ASTC_8x8_KHR;
          if (n === 37816) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : s.COMPRESSED_RGBA_ASTC_10x5_KHR;
          if (n === 37817) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : s.COMPRESSED_RGBA_ASTC_10x6_KHR;
          if (n === 37818) return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : s.COMPRESSED_RGBA_ASTC_10x8_KHR;
          if (n === 37819)
            return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : s.COMPRESSED_RGBA_ASTC_10x10_KHR;
          if (n === 37820)
            return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : s.COMPRESSED_RGBA_ASTC_12x10_KHR;
          if (n === 37821)
            return a === Xe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : s.COMPRESSED_RGBA_ASTC_12x12_KHR;
        } else return null;
      if (n === 36492 || n === 36494 || n === 36495)
        if (((s = e.get("EXT_texture_compression_bptc")), s !== null)) {
          if (n === 36492) return a === Xe ? s.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : s.COMPRESSED_RGBA_BPTC_UNORM_EXT;
          if (n === 36494) return s.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
          if (n === 36495) return s.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
        } else return null;
      if (n === 36283 || n === 36284 || n === 36285 || n === 36286)
        if (((s = e.get("EXT_texture_compression_rgtc")), s !== null)) {
          if (n === 36492) return s.COMPRESSED_RED_RGTC1_EXT;
          if (n === 36284) return s.COMPRESSED_SIGNED_RED_RGTC1_EXT;
          if (n === 36285) return s.COMPRESSED_RED_GREEN_RGTC2_EXT;
          if (n === 36286) return s.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
        } else return null;
      return n === 1020 ? i.UNSIGNED_INT_24_8 : i[n] !== void 0 ? i[n] : null;
    }
    return { convert: t };
  }
  class gs extends vt {
    constructor(e = null) {
      super(), (this.sourceTexture = e), (this.isExternalTexture = !0);
    }
  }
  const nu = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`,
    iu = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
  class ru {
    constructor() {
      (this.texture = null), (this.mesh = null), (this.depthNear = 0), (this.depthFar = 0);
    }
    init(e, t) {
      if (this.texture === null) {
        const n = new gs(e.texture);
        (e.depthNear !== t.depthNear || e.depthFar !== t.depthFar) &&
          ((this.depthNear = e.depthNear), (this.depthFar = e.depthFar)),
          (this.texture = n);
      }
    }
    getMesh(e) {
      if (this.texture !== null && this.mesh === null) {
        const t = e.cameras[0].viewport,
          n = new qt({
            vertexShader: nu,
            fragmentShader: iu,
            uniforms: { depthColor: { value: this.texture }, depthWidth: { value: t.z }, depthHeight: { value: t.w } }
          });
        this.mesh = new Xt(new _i(20, 20), n);
      }
      return this.mesh;
    }
    reset() {
      (this.texture = null), (this.mesh = null);
    }
    getDepthTexture() {
      return this.texture;
    }
  }
  class su extends mn {
    constructor(e, t) {
      super();
      const n = this;
      let r = null,
        s = 1,
        a = null,
        o = "local-floor",
        c = 1,
        l = null,
        h = null,
        f = null,
        d = null,
        m = null,
        v = null;
      const x = new ru(),
        p = {},
        u = t.getContextAttributes();
      let C = null,
        y = null;
      const E = [],
        D = [],
        w = new qe();
      let P = null;
      const F = new It();
      F.viewport = new rt();
      const M = new It();
      M.viewport = new rt();
      const S = [F, M],
        b = new sa();
      let q = null,
        V = null;
      (this.cameraAutoUpdate = !0),
        (this.enabled = !1),
        (this.isPresenting = !1),
        (this.getController = function (W) {
          let ae = E[W];
          return ae === void 0 && ((ae = new $i()), (E[W] = ae)), ae.getTargetRaySpace();
        }),
        (this.getControllerGrip = function (W) {
          let ae = E[W];
          return ae === void 0 && ((ae = new $i()), (E[W] = ae)), ae.getGripSpace();
        }),
        (this.getHand = function (W) {
          let ae = E[W];
          return ae === void 0 && ((ae = new $i()), (E[W] = ae)), ae.getHandSpace();
        });
      function H(W) {
        const ae = D.indexOf(W.inputSource);
        if (ae === -1) return;
        const ne = E[ae];
        ne !== void 0 &&
          (ne.update(W.inputSource, W.frame, l || a), ne.dispatchEvent({ type: W.type, data: W.inputSource }));
      }
      function K() {
        r.removeEventListener("select", H),
          r.removeEventListener("selectstart", H),
          r.removeEventListener("selectend", H),
          r.removeEventListener("squeeze", H),
          r.removeEventListener("squeezestart", H),
          r.removeEventListener("squeezeend", H),
          r.removeEventListener("end", K),
          r.removeEventListener("inputsourceschange", X);
        for (let W = 0; W < E.length; W++) {
          const ae = D[W];
          ae !== null && ((D[W] = null), E[W].disconnect(ae));
        }
        (q = null), (V = null), x.reset();
        for (const W in p) delete p[W];
        e.setRenderTarget(C),
          (m = null),
          (d = null),
          (f = null),
          (r = null),
          (y = null),
          $e.stop(),
          (n.isPresenting = !1),
          e.setPixelRatio(P),
          e.setSize(w.width, w.height, !1),
          n.dispatchEvent({ type: "sessionend" });
      }
      (this.setFramebufferScaleFactor = function (W) {
        (s = W),
          n.isPresenting === !0 &&
            console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
      }),
        (this.setReferenceSpaceType = function (W) {
          (o = W),
            n.isPresenting === !0 &&
              console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }),
        (this.getReferenceSpace = function () {
          return l || a;
        }),
        (this.setReferenceSpace = function (W) {
          l = W;
        }),
        (this.getBaseLayer = function () {
          return d !== null ? d : m;
        }),
        (this.getBinding = function () {
          return f;
        }),
        (this.getFrame = function () {
          return v;
        }),
        (this.getSession = function () {
          return r;
        }),
        (this.setSession = async function (W) {
          if (((r = W), r !== null)) {
            if (
              ((C = e.getRenderTarget()),
              r.addEventListener("select", H),
              r.addEventListener("selectstart", H),
              r.addEventListener("selectend", H),
              r.addEventListener("squeeze", H),
              r.addEventListener("squeezestart", H),
              r.addEventListener("squeezeend", H),
              r.addEventListener("end", K),
              r.addEventListener("inputsourceschange", X),
              u.xrCompatible !== !0 && (await t.makeXRCompatible()),
              (P = e.getPixelRatio()),
              e.getSize(w),
              typeof XRWebGLBinding < "u" && (f = new XRWebGLBinding(r, t)),
              f !== null && "createProjectionLayer" in XRWebGLBinding.prototype)
            ) {
              let ne = null,
                Ae = null,
                be = null;
              u.depth &&
                ((be = u.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24),
                (ne = u.stencil ? 1027 : 1026),
                (Ae = u.stencil ? 1020 : 1014));
              const Pe = { colorFormat: t.RGBA8, depthFormat: be, scaleFactor: s };
              (d = f.createProjectionLayer(Pe)),
                r.updateRenderState({ layers: [d] }),
                e.setPixelRatio(1),
                e.setSize(d.textureWidth, d.textureHeight, !1),
                (y = new en(d.textureWidth, d.textureHeight, {
                  format: 1023,
                  type: 1009,
                  depthTexture: new Gr(
                    d.textureWidth,
                    d.textureHeight,
                    Ae,
                    void 0,
                    void 0,
                    void 0,
                    void 0,
                    void 0,
                    void 0,
                    ne
                  ),
                  stencilBuffer: u.stencil,
                  colorSpace: e.outputColorSpace,
                  samples: u.antialias ? 4 : 0,
                  resolveDepthBuffer: d.ignoreDepthValues === !1,
                  resolveStencilBuffer: d.ignoreDepthValues === !1
                }));
            } else {
              const ne = {
                antialias: u.antialias,
                alpha: !0,
                depth: u.depth,
                stencil: u.stencil,
                framebufferScaleFactor: s
              };
              (m = new XRWebGLLayer(r, t, ne)),
                r.updateRenderState({ baseLayer: m }),
                e.setPixelRatio(1),
                e.setSize(m.framebufferWidth, m.framebufferHeight, !1),
                (y = new en(m.framebufferWidth, m.framebufferHeight, {
                  format: 1023,
                  type: 1009,
                  colorSpace: e.outputColorSpace,
                  stencilBuffer: u.stencil,
                  resolveDepthBuffer: m.ignoreDepthValues === !1,
                  resolveStencilBuffer: m.ignoreDepthValues === !1
                }));
            }
            (y.isXRRenderTarget = !0),
              this.setFoveation(c),
              (l = null),
              (a = await r.requestReferenceSpace(o)),
              $e.setContext(r),
              $e.start(),
              (n.isPresenting = !0),
              n.dispatchEvent({ type: "sessionstart" });
          }
        }),
        (this.getEnvironmentBlendMode = function () {
          if (r !== null) return r.environmentBlendMode;
        }),
        (this.getDepthTexture = function () {
          return x.getDepthTexture();
        });
      function X(W) {
        for (let ae = 0; ae < W.removed.length; ae++) {
          const ne = W.removed[ae],
            Ae = D.indexOf(ne);
          Ae >= 0 && ((D[Ae] = null), E[Ae].disconnect(ne));
        }
        for (let ae = 0; ae < W.added.length; ae++) {
          const ne = W.added[ae];
          let Ae = D.indexOf(ne);
          if (Ae === -1) {
            for (let Pe = 0; Pe < E.length; Pe++)
              if (Pe >= D.length) {
                D.push(ne), (Ae = Pe);
                break;
              } else if (D[Pe] === null) {
                (D[Pe] = ne), (Ae = Pe);
                break;
              }
            if (Ae === -1) break;
          }
          const be = E[Ae];
          be && be.connect(ne);
        }
      }
      const ee = new O(),
        G = new O();
      function se(W, ae, ne) {
        ee.setFromMatrixPosition(ae.matrixWorld), G.setFromMatrixPosition(ne.matrixWorld);
        const Ae = ee.distanceTo(G),
          be = ae.projectionMatrix.elements,
          Pe = ne.projectionMatrix.elements,
          st = be[14] / (be[10] - 1),
          Ge = be[14] / (be[10] + 1),
          A = (be[9] + 1) / be[5],
          Ze = (be[9] - 1) / be[5],
          Te = (be[8] - 1) / be[0],
          He = (Pe[8] + 1) / Pe[0],
          Se = st * Te,
          et = st * He,
          de = Ae / (-Te + He),
          Ne = de * -Te;
        if (
          (ae.matrixWorld.decompose(W.position, W.quaternion, W.scale),
          W.translateX(Ne),
          W.translateZ(de),
          W.matrixWorld.compose(W.position, W.quaternion, W.scale),
          W.matrixWorldInverse.copy(W.matrixWorld).invert(),
          be[10] === -1)
        )
          W.projectionMatrix.copy(ae.projectionMatrix), W.projectionMatrixInverse.copy(ae.projectionMatrixInverse);
        else {
          const ft = st + de,
            at = Ge + de,
            T = Se - Ne,
            _ = et + (Ae - Ne),
            I = ((A * Ge) / at) * ft,
            k = ((Ze * Ge) / at) * ft;
          W.projectionMatrix.makePerspective(T, _, I, k, ft, at),
            W.projectionMatrixInverse.copy(W.projectionMatrix).invert();
        }
      }
      function ue(W, ae) {
        ae === null ? W.matrixWorld.copy(W.matrix) : W.matrixWorld.multiplyMatrices(ae.matrixWorld, W.matrix),
          W.matrixWorldInverse.copy(W.matrixWorld).invert();
      }
      this.updateCamera = function (W) {
        if (r === null) return;
        let ae = W.near,
          ne = W.far;
        x.texture !== null && (x.depthNear > 0 && (ae = x.depthNear), x.depthFar > 0 && (ne = x.depthFar)),
          (b.near = M.near = F.near = ae),
          (b.far = M.far = F.far = ne),
          (q !== b.near || V !== b.far) &&
            (r.updateRenderState({ depthNear: b.near, depthFar: b.far }), (q = b.near), (V = b.far)),
          (b.layers.mask = W.layers.mask | 6),
          (F.layers.mask = b.layers.mask & 3),
          (M.layers.mask = b.layers.mask & 5);
        const Ae = W.parent,
          be = b.cameras;
        ue(b, Ae);
        for (let Pe = 0; Pe < be.length; Pe++) ue(be[Pe], Ae);
        be.length === 2 ? se(b, F, M) : b.projectionMatrix.copy(F.projectionMatrix), Me(W, b, Ae);
      };
      function Me(W, ae, ne) {
        ne === null
          ? W.matrix.copy(ae.matrixWorld)
          : (W.matrix.copy(ne.matrixWorld), W.matrix.invert(), W.matrix.multiply(ae.matrixWorld)),
          W.matrix.decompose(W.position, W.quaternion, W.scale),
          W.updateMatrixWorld(!0),
          W.projectionMatrix.copy(ae.projectionMatrix),
          W.projectionMatrixInverse.copy(ae.projectionMatrixInverse),
          W.isPerspectiveCamera && ((W.fov = Ai * 2 * Math.atan(1 / W.projectionMatrix.elements[5])), (W.zoom = 1));
      }
      (this.getCamera = function () {
        return b;
      }),
        (this.getFoveation = function () {
          if (!(d === null && m === null)) return c;
        }),
        (this.setFoveation = function (W) {
          (c = W),
            d !== null && (d.fixedFoveation = W),
            m !== null && m.fixedFoveation !== void 0 && (m.fixedFoveation = W);
        }),
        (this.hasDepthSensing = function () {
          return x.texture !== null;
        }),
        (this.getDepthSensingMesh = function () {
          return x.getMesh(b);
        }),
        (this.getCameraTexture = function (W) {
          return p[W];
        });
      let Fe = null;
      function Qe(W, ae) {
        if (((h = ae.getViewerPose(l || a)), (v = ae), h !== null)) {
          const ne = h.views;
          m !== null && (e.setRenderTargetFramebuffer(y, m.framebuffer), e.setRenderTarget(y));
          let Ae = !1;
          ne.length !== b.cameras.length && ((b.cameras.length = 0), (Ae = !0));
          for (let Ge = 0; Ge < ne.length; Ge++) {
            const A = ne[Ge];
            let Ze = null;
            if (m !== null) Ze = m.getViewport(A);
            else {
              const He = f.getViewSubImage(d, A);
              (Ze = He.viewport),
                Ge === 0 &&
                  (e.setRenderTargetTextures(y, He.colorTexture, He.depthStencilTexture), e.setRenderTarget(y));
            }
            let Te = S[Ge];
            Te === void 0 && ((Te = new It()), Te.layers.enable(Ge), (Te.viewport = new rt()), (S[Ge] = Te)),
              Te.matrix.fromArray(A.transform.matrix),
              Te.matrix.decompose(Te.position, Te.quaternion, Te.scale),
              Te.projectionMatrix.fromArray(A.projectionMatrix),
              Te.projectionMatrixInverse.copy(Te.projectionMatrix).invert(),
              Te.viewport.set(Ze.x, Ze.y, Ze.width, Ze.height),
              Ge === 0 && (b.matrix.copy(Te.matrix), b.matrix.decompose(b.position, b.quaternion, b.scale)),
              Ae === !0 && b.cameras.push(Te);
          }
          const be = r.enabledFeatures;
          if (be && be.includes("depth-sensing") && r.depthUsage == "gpu-optimized" && f) {
            const Ge = f.getDepthInformation(ne[0]);
            Ge && Ge.isValid && Ge.texture && x.init(Ge, r.renderState);
          }
          if (be && be.includes("camera-access") && (e.state.unbindTexture(), f))
            for (let Ge = 0; Ge < ne.length; Ge++) {
              const A = ne[Ge].camera;
              if (A) {
                let Ze = p[A];
                Ze || ((Ze = new gs()), (p[A] = Ze));
                const Te = f.getCameraImage(A);
                Ze.sourceTexture = Te;
              }
            }
        }
        for (let ne = 0; ne < E.length; ne++) {
          const Ae = D[ne],
            be = E[ne];
          Ae !== null && be !== void 0 && be.update(Ae, ae, l || a);
        }
        Fe && Fe(W, ae), ae.detectedPlanes && n.dispatchEvent({ type: "planesdetected", data: ae }), (v = null);
      }
      const $e = new Hr();
      $e.setAnimationLoop(Qe),
        (this.setAnimationLoop = function (W) {
          Fe = W;
        }),
        (this.dispose = function () {});
    }
  }
  const hn = new zt(),
    au = new ot();
  function ou(i, e) {
    function t(p, u) {
      p.matrixAutoUpdate === !0 && p.updateMatrix(), u.value.copy(p.matrix);
    }
    function n(p, u) {
      u.color.getRGB(p.fogColor.value, Dr(i)),
        u.isFog
          ? ((p.fogNear.value = u.near), (p.fogFar.value = u.far))
          : u.isFogExp2 && (p.fogDensity.value = u.density);
    }
    function r(p, u, C, y, E) {
      u.isMeshBasicMaterial || u.isMeshLambertMaterial
        ? s(p, u)
        : u.isMeshToonMaterial
        ? (s(p, u), f(p, u))
        : u.isMeshPhongMaterial
        ? (s(p, u), h(p, u))
        : u.isMeshStandardMaterial
        ? (s(p, u), d(p, u), u.isMeshPhysicalMaterial && m(p, u, E))
        : u.isMeshMatcapMaterial
        ? (s(p, u), v(p, u))
        : u.isMeshDepthMaterial
        ? s(p, u)
        : u.isMeshDistanceMaterial
        ? (s(p, u), x(p, u))
        : u.isMeshNormalMaterial
        ? s(p, u)
        : u.isLineBasicMaterial
        ? (a(p, u), u.isLineDashedMaterial && o(p, u))
        : u.isPointsMaterial
        ? c(p, u, C, y)
        : u.isSpriteMaterial
        ? l(p, u)
        : u.isShadowMaterial
        ? (p.color.value.copy(u.color), (p.opacity.value = u.opacity))
        : u.isShaderMaterial && (u.uniformsNeedUpdate = !1);
    }
    function s(p, u) {
      (p.opacity.value = u.opacity),
        u.color && p.diffuse.value.copy(u.color),
        u.emissive && p.emissive.value.copy(u.emissive).multiplyScalar(u.emissiveIntensity),
        u.map && ((p.map.value = u.map), t(u.map, p.mapTransform)),
        u.alphaMap && ((p.alphaMap.value = u.alphaMap), t(u.alphaMap, p.alphaMapTransform)),
        u.bumpMap &&
          ((p.bumpMap.value = u.bumpMap),
          t(u.bumpMap, p.bumpMapTransform),
          (p.bumpScale.value = u.bumpScale),
          u.side === 1 && (p.bumpScale.value *= -1)),
        u.normalMap &&
          ((p.normalMap.value = u.normalMap),
          t(u.normalMap, p.normalMapTransform),
          p.normalScale.value.copy(u.normalScale),
          u.side === 1 && p.normalScale.value.negate()),
        u.displacementMap &&
          ((p.displacementMap.value = u.displacementMap),
          t(u.displacementMap, p.displacementMapTransform),
          (p.displacementScale.value = u.displacementScale),
          (p.displacementBias.value = u.displacementBias)),
        u.emissiveMap && ((p.emissiveMap.value = u.emissiveMap), t(u.emissiveMap, p.emissiveMapTransform)),
        u.specularMap && ((p.specularMap.value = u.specularMap), t(u.specularMap, p.specularMapTransform)),
        u.alphaTest > 0 && (p.alphaTest.value = u.alphaTest);
      const C = e.get(u),
        y = C.envMap,
        E = C.envMapRotation;
      y &&
        ((p.envMap.value = y),
        hn.copy(E),
        (hn.x *= -1),
        (hn.y *= -1),
        (hn.z *= -1),
        y.isCubeTexture && y.isRenderTargetTexture === !1 && ((hn.y *= -1), (hn.z *= -1)),
        p.envMapRotation.value.setFromMatrix4(au.makeRotationFromEuler(hn)),
        (p.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1),
        (p.reflectivity.value = u.reflectivity),
        (p.ior.value = u.ior),
        (p.refractionRatio.value = u.refractionRatio)),
        u.lightMap &&
          ((p.lightMap.value = u.lightMap),
          (p.lightMapIntensity.value = u.lightMapIntensity),
          t(u.lightMap, p.lightMapTransform)),
        u.aoMap &&
          ((p.aoMap.value = u.aoMap), (p.aoMapIntensity.value = u.aoMapIntensity), t(u.aoMap, p.aoMapTransform));
    }
    function a(p, u) {
      p.diffuse.value.copy(u.color),
        (p.opacity.value = u.opacity),
        u.map && ((p.map.value = u.map), t(u.map, p.mapTransform));
    }
    function o(p, u) {
      (p.dashSize.value = u.dashSize), (p.totalSize.value = u.dashSize + u.gapSize), (p.scale.value = u.scale);
    }
    function c(p, u, C, y) {
      p.diffuse.value.copy(u.color),
        (p.opacity.value = u.opacity),
        (p.size.value = u.size * C),
        (p.scale.value = y * 0.5),
        u.map && ((p.map.value = u.map), t(u.map, p.uvTransform)),
        u.alphaMap && ((p.alphaMap.value = u.alphaMap), t(u.alphaMap, p.alphaMapTransform)),
        u.alphaTest > 0 && (p.alphaTest.value = u.alphaTest);
    }
    function l(p, u) {
      p.diffuse.value.copy(u.color),
        (p.opacity.value = u.opacity),
        (p.rotation.value = u.rotation),
        u.map && ((p.map.value = u.map), t(u.map, p.mapTransform)),
        u.alphaMap && ((p.alphaMap.value = u.alphaMap), t(u.alphaMap, p.alphaMapTransform)),
        u.alphaTest > 0 && (p.alphaTest.value = u.alphaTest);
    }
    function h(p, u) {
      p.specular.value.copy(u.specular), (p.shininess.value = Math.max(u.shininess, 1e-4));
    }
    function f(p, u) {
      u.gradientMap && (p.gradientMap.value = u.gradientMap);
    }
    function d(p, u) {
      (p.metalness.value = u.metalness),
        u.metalnessMap && ((p.metalnessMap.value = u.metalnessMap), t(u.metalnessMap, p.metalnessMapTransform)),
        (p.roughness.value = u.roughness),
        u.roughnessMap && ((p.roughnessMap.value = u.roughnessMap), t(u.roughnessMap, p.roughnessMapTransform)),
        u.envMap && (p.envMapIntensity.value = u.envMapIntensity);
    }
    function m(p, u, C) {
      (p.ior.value = u.ior),
        u.sheen > 0 &&
          (p.sheenColor.value.copy(u.sheenColor).multiplyScalar(u.sheen),
          (p.sheenRoughness.value = u.sheenRoughness),
          u.sheenColorMap && ((p.sheenColorMap.value = u.sheenColorMap), t(u.sheenColorMap, p.sheenColorMapTransform)),
          u.sheenRoughnessMap &&
            ((p.sheenRoughnessMap.value = u.sheenRoughnessMap), t(u.sheenRoughnessMap, p.sheenRoughnessMapTransform))),
        u.clearcoat > 0 &&
          ((p.clearcoat.value = u.clearcoat),
          (p.clearcoatRoughness.value = u.clearcoatRoughness),
          u.clearcoatMap && ((p.clearcoatMap.value = u.clearcoatMap), t(u.clearcoatMap, p.clearcoatMapTransform)),
          u.clearcoatRoughnessMap &&
            ((p.clearcoatRoughnessMap.value = u.clearcoatRoughnessMap),
            t(u.clearcoatRoughnessMap, p.clearcoatRoughnessMapTransform)),
          u.clearcoatNormalMap &&
            ((p.clearcoatNormalMap.value = u.clearcoatNormalMap),
            t(u.clearcoatNormalMap, p.clearcoatNormalMapTransform),
            p.clearcoatNormalScale.value.copy(u.clearcoatNormalScale),
            u.side === 1 && p.clearcoatNormalScale.value.negate())),
        u.dispersion > 0 && (p.dispersion.value = u.dispersion),
        u.iridescence > 0 &&
          ((p.iridescence.value = u.iridescence),
          (p.iridescenceIOR.value = u.iridescenceIOR),
          (p.iridescenceThicknessMinimum.value = u.iridescenceThicknessRange[0]),
          (p.iridescenceThicknessMaximum.value = u.iridescenceThicknessRange[1]),
          u.iridescenceMap &&
            ((p.iridescenceMap.value = u.iridescenceMap), t(u.iridescenceMap, p.iridescenceMapTransform)),
          u.iridescenceThicknessMap &&
            ((p.iridescenceThicknessMap.value = u.iridescenceThicknessMap),
            t(u.iridescenceThicknessMap, p.iridescenceThicknessMapTransform))),
        u.transmission > 0 &&
          ((p.transmission.value = u.transmission),
          (p.transmissionSamplerMap.value = C.texture),
          p.transmissionSamplerSize.value.set(C.width, C.height),
          u.transmissionMap &&
            ((p.transmissionMap.value = u.transmissionMap), t(u.transmissionMap, p.transmissionMapTransform)),
          (p.thickness.value = u.thickness),
          u.thicknessMap && ((p.thicknessMap.value = u.thicknessMap), t(u.thicknessMap, p.thicknessMapTransform)),
          (p.attenuationDistance.value = u.attenuationDistance),
          p.attenuationColor.value.copy(u.attenuationColor)),
        u.anisotropy > 0 &&
          (p.anisotropyVector.value.set(
            u.anisotropy * Math.cos(u.anisotropyRotation),
            u.anisotropy * Math.sin(u.anisotropyRotation)
          ),
          u.anisotropyMap && ((p.anisotropyMap.value = u.anisotropyMap), t(u.anisotropyMap, p.anisotropyMapTransform))),
        (p.specularIntensity.value = u.specularIntensity),
        p.specularColor.value.copy(u.specularColor),
        u.specularColorMap &&
          ((p.specularColorMap.value = u.specularColorMap), t(u.specularColorMap, p.specularColorMapTransform)),
        u.specularIntensityMap &&
          ((p.specularIntensityMap.value = u.specularIntensityMap),
          t(u.specularIntensityMap, p.specularIntensityMapTransform));
    }
    function v(p, u) {
      u.matcap && (p.matcap.value = u.matcap);
    }
    function x(p, u) {
      const C = e.get(u).light;
      p.referencePosition.value.setFromMatrixPosition(C.matrixWorld),
        (p.nearDistance.value = C.shadow.camera.near),
        (p.farDistance.value = C.shadow.camera.far);
    }
    return { refreshFogUniforms: n, refreshMaterialUniforms: r };
  }
  function lu(i, e, t, n) {
    let r = {},
      s = {},
      a = [];
    const o = i.getParameter(i.MAX_UNIFORM_BUFFER_BINDINGS);
    function c(C, y) {
      const E = y.program;
      n.uniformBlockBinding(C, E);
    }
    function l(C, y) {
      let E = r[C.id];
      E === void 0 && (v(C), (E = h(C)), (r[C.id] = E), C.addEventListener("dispose", p));
      const D = y.program;
      n.updateUBOMapping(C, D);
      const w = e.render.frame;
      s[C.id] !== w && (d(C), (s[C.id] = w));
    }
    function h(C) {
      const y = f();
      C.__bindingPointIndex = y;
      const E = i.createBuffer(),
        D = C.__size,
        w = C.usage;
      return (
        i.bindBuffer(i.UNIFORM_BUFFER, E),
        i.bufferData(i.UNIFORM_BUFFER, D, w),
        i.bindBuffer(i.UNIFORM_BUFFER, null),
        i.bindBufferBase(i.UNIFORM_BUFFER, y, E),
        E
      );
    }
    function f() {
      for (let C = 0; C < o; C++) if (a.indexOf(C) === -1) return a.push(C), C;
      return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
    }
    function d(C) {
      const y = r[C.id],
        E = C.uniforms,
        D = C.__cache;
      i.bindBuffer(i.UNIFORM_BUFFER, y);
      for (let w = 0, P = E.length; w < P; w++) {
        const F = Array.isArray(E[w]) ? E[w] : [E[w]];
        for (let M = 0, S = F.length; M < S; M++) {
          const b = F[M];
          if (m(b, w, M, D) === !0) {
            const q = b.__offset,
              V = Array.isArray(b.value) ? b.value : [b.value];
            let H = 0;
            for (let K = 0; K < V.length; K++) {
              const X = V[K],
                ee = x(X);
              typeof X == "number" || typeof X == "boolean"
                ? ((b.__data[0] = X), i.bufferSubData(i.UNIFORM_BUFFER, q + H, b.__data))
                : X.isMatrix3
                ? ((b.__data[0] = X.elements[0]),
                  (b.__data[1] = X.elements[1]),
                  (b.__data[2] = X.elements[2]),
                  (b.__data[3] = 0),
                  (b.__data[4] = X.elements[3]),
                  (b.__data[5] = X.elements[4]),
                  (b.__data[6] = X.elements[5]),
                  (b.__data[7] = 0),
                  (b.__data[8] = X.elements[6]),
                  (b.__data[9] = X.elements[7]),
                  (b.__data[10] = X.elements[8]),
                  (b.__data[11] = 0))
                : (X.toArray(b.__data, H), (H += ee.storage / Float32Array.BYTES_PER_ELEMENT));
            }
            i.bufferSubData(i.UNIFORM_BUFFER, q, b.__data);
          }
        }
      }
      i.bindBuffer(i.UNIFORM_BUFFER, null);
    }
    function m(C, y, E, D) {
      const w = C.value,
        P = y + "_" + E;
      if (D[P] === void 0) return typeof w == "number" || typeof w == "boolean" ? (D[P] = w) : (D[P] = w.clone()), !0;
      {
        const F = D[P];
        if (typeof w == "number" || typeof w == "boolean") {
          if (F !== w) return (D[P] = w), !0;
        } else if (F.equals(w) === !1) return F.copy(w), !0;
      }
      return !1;
    }
    function v(C) {
      const y = C.uniforms;
      let E = 0;
      const D = 16;
      for (let P = 0, F = y.length; P < F; P++) {
        const M = Array.isArray(y[P]) ? y[P] : [y[P]];
        for (let S = 0, b = M.length; S < b; S++) {
          const q = M[S],
            V = Array.isArray(q.value) ? q.value : [q.value];
          for (let H = 0, K = V.length; H < K; H++) {
            const X = V[H],
              ee = x(X),
              G = E % D,
              se = G % ee.boundary,
              ue = G + se;
            (E += se),
              ue !== 0 && D - ue < ee.storage && (E += D - ue),
              (q.__data = new Float32Array(ee.storage / Float32Array.BYTES_PER_ELEMENT)),
              (q.__offset = E),
              (E += ee.storage);
          }
        }
      }
      const w = E % D;
      return w > 0 && (E += D - w), (C.__size = E), (C.__cache = {}), this;
    }
    function x(C) {
      const y = { boundary: 0, storage: 0 };
      return (
        typeof C == "number" || typeof C == "boolean"
          ? ((y.boundary = 4), (y.storage = 4))
          : C.isVector2
          ? ((y.boundary = 8), (y.storage = 8))
          : C.isVector3 || C.isColor
          ? ((y.boundary = 16), (y.storage = 12))
          : C.isVector4
          ? ((y.boundary = 16), (y.storage = 16))
          : C.isMatrix3
          ? ((y.boundary = 48), (y.storage = 48))
          : C.isMatrix4
          ? ((y.boundary = 64), (y.storage = 64))
          : C.isTexture
          ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.")
          : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", C),
        y
      );
    }
    function p(C) {
      const y = C.target;
      y.removeEventListener("dispose", p);
      const E = a.indexOf(y.__bindingPointIndex);
      a.splice(E, 1), i.deleteBuffer(r[y.id]), delete r[y.id], delete s[y.id];
    }
    function u() {
      for (const C in r) i.deleteBuffer(r[C]);
      (a = []), (r = {}), (s = {});
    }
    return { bind: c, update: l, dispose: u };
  }
  class cu {
    constructor(e = {}) {
      const {
        canvas: t = As(),
        context: n = null,
        depth: r = !0,
        stencil: s = !1,
        alpha: a = !1,
        antialias: o = !1,
        premultipliedAlpha: c = !0,
        preserveDrawingBuffer: l = !1,
        powerPreference: h = "default",
        failIfMajorPerformanceCaveat: f = !1,
        reversedDepthBuffer: d = !1
      } = e;
      this.isWebGLRenderer = !0;
      let m;
      if (n !== null) {
        if (typeof WebGLRenderingContext < "u" && n instanceof WebGLRenderingContext)
          throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
        m = n.getContextAttributes().alpha;
      } else m = a;
      const v = new Uint32Array(4),
        x = new Int32Array(4);
      let p = null,
        u = null;
      const C = [],
        y = [];
      (this.domElement = t),
        (this.debug = { checkShaderErrors: !0, onShaderError: null }),
        (this.autoClear = !0),
        (this.autoClearColor = !0),
        (this.autoClearDepth = !0),
        (this.autoClearStencil = !0),
        (this.sortObjects = !0),
        (this.clippingPlanes = []),
        (this.localClippingEnabled = !1),
        (this.toneMapping = 0),
        (this.toneMappingExposure = 1),
        (this.transmissionResolutionScale = 1);
      const E = this;
      let D = !1;
      this._outputColorSpace = At;
      let w = 0,
        P = 0,
        F = null,
        M = -1,
        S = null;
      const b = new rt(),
        q = new rt();
      let V = null;
      const H = new ke(0);
      let K = 0,
        X = t.width,
        ee = t.height,
        G = 1,
        se = null,
        ue = null;
      const Me = new rt(0, 0, X, ee),
        Fe = new rt(0, 0, X, ee);
      let Qe = !1;
      const $e = new Nr();
      let W = !1,
        ae = !1;
      const ne = new ot(),
        Ae = new O(),
        be = new rt(),
        Pe = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
      let st = !1;
      function Ge() {
        return F === null ? G : 1;
      }
      let A = n;
      function Ze(g, L) {
        return t.getContext(g, L);
      }
      try {
        const g = {
          alpha: !0,
          depth: r,
          stencil: s,
          antialias: o,
          premultipliedAlpha: c,
          preserveDrawingBuffer: l,
          powerPreference: h,
          failIfMajorPerformanceCaveat: f
        };
        if (
          ("setAttribute" in t && t.setAttribute("data-engine", "three.js r179"),
          t.addEventListener("webglcontextlost", ie, !1),
          t.addEventListener("webglcontextrestored", fe, !1),
          t.addEventListener("webglcontextcreationerror", Z, !1),
          A === null)
        ) {
          const L = "webgl2";
          if (((A = Ze(L, g)), A === null))
            throw Ze(L)
              ? new Error("Error creating WebGL context with your selected attributes.")
              : new Error("Error creating WebGL context.");
        }
      } catch (g) {
        throw (console.error("THREE.WebGLRenderer: " + g.message), g);
      }
      let Te, He, Se, et, de, Ne, ft, at, T, _, I, k, $, z, xe, te, _e, ge, j, ce, Ce, ve, oe, Ue;
      function R() {
        (Te = new xl(A)),
          Te.init(),
          (ve = new tu(A, Te)),
          (He = new fl(A, Te, e, ve)),
          (Se = new Qc(A, Te)),
          He.reversedDepthBuffer && d && Se.buffers.depth.setReversed(!0),
          (et = new El(A)),
          (de = new zc()),
          (Ne = new eu(A, Te, Se, de, He, ve, et)),
          (ft = new pl(E)),
          (at = new vl(E)),
          (T = new oa(A)),
          (oe = new ul(A, T)),
          (_ = new Sl(A, T, et, oe)),
          (I = new yl(A, _, T, et)),
          (j = new Tl(A, He, Ne)),
          (te = new dl(de)),
          (k = new Gc(E, ft, at, Te, He, oe, te)),
          ($ = new ou(E, de)),
          (z = new Hc()),
          (xe = new $c(Te)),
          (ge = new cl(E, ft, at, Se, I, m, c)),
          (_e = new Jc(E, I, He)),
          (Ue = new lu(A, et, He, Se)),
          (ce = new hl(A, Te, et)),
          (Ce = new Ml(A, Te, et)),
          (et.programs = k.programs),
          (E.capabilities = He),
          (E.extensions = Te),
          (E.properties = de),
          (E.renderLists = z),
          (E.shadowMap = _e),
          (E.state = Se),
          (E.info = et);
      }
      R();
      const Q = new su(E, A);
      (this.xr = Q),
        (this.getContext = function () {
          return A;
        }),
        (this.getContextAttributes = function () {
          return A.getContextAttributes();
        }),
        (this.forceContextLoss = function () {
          const g = Te.get("WEBGL_lose_context");
          g && g.loseContext();
        }),
        (this.forceContextRestore = function () {
          const g = Te.get("WEBGL_lose_context");
          g && g.restoreContext();
        }),
        (this.getPixelRatio = function () {
          return G;
        }),
        (this.setPixelRatio = function (g) {
          g !== void 0 && ((G = g), this.setSize(X, ee, !1));
        }),
        (this.getSize = function (g) {
          return g.set(X, ee);
        }),
        (this.setSize = function (g, L, N = !0) {
          if (Q.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
          }
          (X = g),
            (ee = L),
            (t.width = Math.floor(g * G)),
            (t.height = Math.floor(L * G)),
            N === !0 && ((t.style.width = g + "px"), (t.style.height = L + "px")),
            this.setViewport(0, 0, g, L);
        }),
        (this.getDrawingBufferSize = function (g) {
          return g.set(X * G, ee * G).floor();
        }),
        (this.setDrawingBufferSize = function (g, L, N) {
          (X = g),
            (ee = L),
            (G = N),
            (t.width = Math.floor(g * N)),
            (t.height = Math.floor(L * N)),
            this.setViewport(0, 0, g, L);
        }),
        (this.getCurrentViewport = function (g) {
          return g.copy(b);
        }),
        (this.getViewport = function (g) {
          return g.copy(Me);
        }),
        (this.setViewport = function (g, L, N, B) {
          g.isVector4 ? Me.set(g.x, g.y, g.z, g.w) : Me.set(g, L, N, B),
            Se.viewport(b.copy(Me).multiplyScalar(G).round());
        }),
        (this.getScissor = function (g) {
          return g.copy(Fe);
        }),
        (this.setScissor = function (g, L, N, B) {
          g.isVector4 ? Fe.set(g.x, g.y, g.z, g.w) : Fe.set(g, L, N, B),
            Se.scissor(q.copy(Fe).multiplyScalar(G).round());
        }),
        (this.getScissorTest = function () {
          return Qe;
        }),
        (this.setScissorTest = function (g) {
          Se.setScissorTest((Qe = g));
        }),
        (this.setOpaqueSort = function (g) {
          se = g;
        }),
        (this.setTransparentSort = function (g) {
          ue = g;
        }),
        (this.getClearColor = function (g) {
          return g.copy(ge.getClearColor());
        }),
        (this.setClearColor = function () {
          ge.setClearColor(...arguments);
        }),
        (this.getClearAlpha = function () {
          return ge.getClearAlpha();
        }),
        (this.setClearAlpha = function () {
          ge.setClearAlpha(...arguments);
        }),
        (this.clear = function (g = !0, L = !0, N = !0) {
          let B = 0;
          if (g) {
            let U = !1;
            if (F !== null) {
              const J = F.texture.format;
              U = J === 1033 || J === 1031 || J === 1029;
            }
            if (U) {
              const J = F.texture.type,
                le = J === 1009 || J === 1014 || J === 1012 || J === 1020 || J === 1017 || J === 1018,
                pe = ge.getClearColor(),
                he = ge.getClearAlpha(),
                Re = pe.r,
                we = pe.g,
                Ee = pe.b;
              le
                ? ((v[0] = Re), (v[1] = we), (v[2] = Ee), (v[3] = he), A.clearBufferuiv(A.COLOR, 0, v))
                : ((x[0] = Re), (x[1] = we), (x[2] = Ee), (x[3] = he), A.clearBufferiv(A.COLOR, 0, x));
            } else B |= A.COLOR_BUFFER_BIT;
          }
          L && (B |= A.DEPTH_BUFFER_BIT),
            N && ((B |= A.STENCIL_BUFFER_BIT), this.state.buffers.stencil.setMask(4294967295)),
            A.clear(B);
        }),
        (this.clearColor = function () {
          this.clear(!0, !1, !1);
        }),
        (this.clearDepth = function () {
          this.clear(!1, !0, !1);
        }),
        (this.clearStencil = function () {
          this.clear(!1, !1, !0);
        }),
        (this.dispose = function () {
          t.removeEventListener("webglcontextlost", ie, !1),
            t.removeEventListener("webglcontextrestored", fe, !1),
            t.removeEventListener("webglcontextcreationerror", Z, !1),
            ge.dispose(),
            z.dispose(),
            xe.dispose(),
            de.dispose(),
            ft.dispose(),
            at.dispose(),
            I.dispose(),
            oe.dispose(),
            Ue.dispose(),
            k.dispose(),
            Q.dispose(),
            Q.removeEventListener("sessionstart", Nt),
            Q.removeEventListener("sessionend", vs),
            fn.stop();
        });
      function ie(g) {
        g.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), (D = !0);
      }
      function fe() {
        console.log("THREE.WebGLRenderer: Context Restored."), (D = !1);
        const g = et.autoReset,
          L = _e.enabled,
          N = _e.autoUpdate,
          B = _e.needsUpdate,
          U = _e.type;
        R(), (et.autoReset = g), (_e.enabled = L), (_e.autoUpdate = N), (_e.needsUpdate = B), (_e.type = U);
      }
      function Z(g) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", g.statusMessage);
      }
      function Y(g) {
        const L = g.target;
        L.removeEventListener("dispose", Y), me(L);
      }
      function me(g) {
        De(g), de.remove(g);
      }
      function De(g) {
        const L = de.get(g).programs;
        L !== void 0 &&
          (L.forEach(function (N) {
            k.releaseProgram(N);
          }),
          g.isShaderMaterial && k.releaseShaderCache(g));
      }
      this.renderBufferDirect = function (g, L, N, B, U, J) {
        L === null && (L = Pe);
        const le = U.isMesh && U.matrixWorld.determinant() < 0,
          pe = uu(g, L, N, B, U);
        Se.setMaterial(B, le);
        let he = N.index,
          Re = 1;
        if (B.wireframe === !0) {
          if (((he = _.getWireframeAttribute(N)), he === void 0)) return;
          Re = 2;
        }
        const we = N.drawRange,
          Ee = N.attributes.position;
        let Oe = we.start * Re,
          Ye = (we.start + we.count) * Re;
        J !== null && ((Oe = Math.max(Oe, J.start * Re)), (Ye = Math.min(Ye, (J.start + J.count) * Re))),
          he !== null
            ? ((Oe = Math.max(Oe, 0)), (Ye = Math.min(Ye, he.count)))
            : Ee != null && ((Oe = Math.max(Oe, 0)), (Ye = Math.min(Ye, Ee.count)));
        const it = Ye - Oe;
        if (it < 0 || it === 1 / 0) return;
        oe.setup(U, B, pe, N, he);
        let je,
          Ke = ce;
        if ((he !== null && ((je = T.get(he)), (Ke = Ce), Ke.setIndex(je)), U.isMesh))
          B.wireframe === !0
            ? (Se.setLineWidth(B.wireframeLinewidth * Ge()), Ke.setMode(A.LINES))
            : Ke.setMode(A.TRIANGLES);
        else if (U.isLine) {
          let ye = B.linewidth;
          ye === void 0 && (ye = 1),
            Se.setLineWidth(ye * Ge()),
            U.isLineSegments ? Ke.setMode(A.LINES) : U.isLineLoop ? Ke.setMode(A.LINE_LOOP) : Ke.setMode(A.LINE_STRIP);
        } else U.isPoints ? Ke.setMode(A.POINTS) : U.isSprite && Ke.setMode(A.TRIANGLES);
        if (U.isBatchedMesh)
          if (U._multiDrawInstances !== null)
            _n(
              "THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."
            ),
              Ke.renderMultiDrawInstances(
                U._multiDrawStarts,
                U._multiDrawCounts,
                U._multiDrawCount,
                U._multiDrawInstances
              );
          else if (Te.get("WEBGL_multi_draw"))
            Ke.renderMultiDraw(U._multiDrawStarts, U._multiDrawCounts, U._multiDrawCount);
          else {
            const ye = U._multiDrawStarts,
              tt = U._multiDrawCounts,
              Ve = U._multiDrawCount,
              Tt = he ? T.get(he).bytesPerElement : 1,
              In = de.get(B).currentProgram.getUniforms();
            for (let yt = 0; yt < Ve; yt++) In.setValue(A, "_gl_DrawID", yt), Ke.render(ye[yt] / Tt, tt[yt]);
          }
        else if (U.isInstancedMesh) Ke.renderInstances(Oe, it, U.count);
        else if (N.isInstancedBufferGeometry) {
          const ye = N._maxInstanceCount !== void 0 ? N._maxInstanceCount : 1 / 0,
            tt = Math.min(N.instanceCount, ye);
          Ke.renderInstances(Oe, it, tt);
        } else Ke.render(Oe, it);
      };
      function Je(g, L, N) {
        g.transparent === !0 && g.side === 2 && g.forceSinglePass === !1
          ? ((g.side = 1),
            (g.needsUpdate = !0),
            Ti(g, L, N),
            (g.side = 0),
            (g.needsUpdate = !0),
            Ti(g, L, N),
            (g.side = 2))
          : Ti(g, L, N);
      }
      (this.compile = function (g, L, N = null) {
        N === null && (N = g),
          (u = xe.get(N)),
          u.init(L),
          y.push(u),
          N.traverseVisible(function (U) {
            U.isLight && U.layers.test(L.layers) && (u.pushLight(U), U.castShadow && u.pushShadow(U));
          }),
          g !== N &&
            g.traverseVisible(function (U) {
              U.isLight && U.layers.test(L.layers) && (u.pushLight(U), U.castShadow && u.pushShadow(U));
            }),
          u.setupLights();
        const B = new Set();
        return (
          g.traverse(function (U) {
            if (!(U.isMesh || U.isPoints || U.isLine || U.isSprite)) return;
            const J = U.material;
            if (J)
              if (Array.isArray(J))
                for (let le = 0; le < J.length; le++) {
                  const pe = J[le];
                  Je(pe, N, U), B.add(pe);
                }
              else Je(J, N, U), B.add(J);
          }),
          (u = y.pop()),
          B
        );
      }),
        (this.compileAsync = function (g, L, N = null) {
          const B = this.compile(g, L, N);
          return new Promise(U => {
            function J() {
              if (
                (B.forEach(function (le) {
                  de.get(le).currentProgram.isReady() && B.delete(le);
                }),
                B.size === 0)
              ) {
                U(g);
                return;
              }
              setTimeout(J, 10);
            }
            Te.get("KHR_parallel_shader_compile") !== null ? J() : setTimeout(J, 10);
          });
        });
      let We = null;
      function Yt(g) {
        We && We(g);
      }
      function Nt() {
        fn.stop();
      }
      function vs() {
        fn.start();
      }
      const fn = new Hr();
      fn.setAnimationLoop(Yt),
        typeof self < "u" && fn.setContext(self),
        (this.setAnimationLoop = function (g) {
          (We = g), Q.setAnimationLoop(g), g === null ? fn.stop() : fn.start();
        }),
        Q.addEventListener("sessionstart", Nt),
        Q.addEventListener("sessionend", vs),
        (this.render = function (g, L) {
          if (L !== void 0 && L.isCamera !== !0) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
          }
          if (D === !0) return;
          if (
            (g.matrixWorldAutoUpdate === !0 && g.updateMatrixWorld(),
            L.parent === null && L.matrixWorldAutoUpdate === !0 && L.updateMatrixWorld(),
            Q.enabled === !0 &&
              Q.isPresenting === !0 &&
              (Q.cameraAutoUpdate === !0 && Q.updateCamera(L), (L = Q.getCamera())),
            g.isScene === !0 && g.onBeforeRender(E, g, L, F),
            (u = xe.get(g, y.length)),
            u.init(L),
            y.push(u),
            ne.multiplyMatrices(L.projectionMatrix, L.matrixWorldInverse),
            $e.setFromProjectionMatrix(ne, 2e3, L.reversedDepth),
            (ae = this.localClippingEnabled),
            (W = te.init(this.clippingPlanes, ae)),
            (p = z.get(g, C.length)),
            p.init(),
            C.push(p),
            Q.enabled === !0 && Q.isPresenting === !0)
          ) {
            const J = E.xr.getDepthSensingMesh();
            J !== null && sr(J, L, -1 / 0, E.sortObjects);
          }
          sr(g, L, 0, E.sortObjects),
            p.finish(),
            E.sortObjects === !0 && p.sort(se, ue),
            (st = Q.enabled === !1 || Q.isPresenting === !1 || Q.hasDepthSensing() === !1),
            st && ge.addToRenderList(p, g),
            this.info.render.frame++,
            W === !0 && te.beginShadows();
          const N = u.state.shadowsArray;
          _e.render(N, g, L), W === !0 && te.endShadows(), this.info.autoReset === !0 && this.info.reset();
          const B = p.opaque,
            U = p.transmissive;
          if ((u.setupLights(), L.isArrayCamera)) {
            const J = L.cameras;
            if (U.length > 0)
              for (let le = 0, pe = J.length; le < pe; le++) {
                const he = J[le];
                Ss(B, U, g, he);
              }
            st && ge.render(g);
            for (let le = 0, pe = J.length; le < pe; le++) {
              const he = J[le];
              xs(p, g, he, he.viewport);
            }
          } else U.length > 0 && Ss(B, U, g, L), st && ge.render(g), xs(p, g, L);
          F !== null && P === 0 && (Ne.updateMultisampleRenderTarget(F), Ne.updateRenderTargetMipmap(F)),
            g.isScene === !0 && g.onAfterRender(E, g, L),
            oe.resetDefaultState(),
            (M = -1),
            (S = null),
            y.pop(),
            y.length > 0
              ? ((u = y[y.length - 1]), W === !0 && te.setGlobalState(E.clippingPlanes, u.state.camera))
              : (u = null),
            C.pop(),
            C.length > 0 ? (p = C[C.length - 1]) : (p = null);
        });
      function sr(g, L, N, B) {
        if (g.visible === !1) return;
        if (g.layers.test(L.layers)) {
          if (g.isGroup) N = g.renderOrder;
          else if (g.isLOD) g.autoUpdate === !0 && g.update(L);
          else if (g.isLight) u.pushLight(g), g.castShadow && u.pushShadow(g);
          else if (g.isSprite) {
            if (!g.frustumCulled || $e.intersectsSprite(g)) {
              B && be.setFromMatrixPosition(g.matrixWorld).applyMatrix4(ne);
              const le = I.update(g),
                pe = g.material;
              pe.visible && p.push(g, le, pe, N, be.z, null);
            }
          } else if ((g.isMesh || g.isLine || g.isPoints) && (!g.frustumCulled || $e.intersectsObject(g))) {
            const le = I.update(g),
              pe = g.material;
            if (
              (B &&
                (g.boundingSphere !== void 0
                  ? (g.boundingSphere === null && g.computeBoundingSphere(), be.copy(g.boundingSphere.center))
                  : (le.boundingSphere === null && le.computeBoundingSphere(), be.copy(le.boundingSphere.center)),
                be.applyMatrix4(g.matrixWorld).applyMatrix4(ne)),
              Array.isArray(pe))
            ) {
              const he = le.groups;
              for (let Re = 0, we = he.length; Re < we; Re++) {
                const Ee = he[Re],
                  Oe = pe[Ee.materialIndex];
                Oe && Oe.visible && p.push(g, le, Oe, N, be.z, Ee);
              }
            } else pe.visible && p.push(g, le, pe, N, be.z, null);
          }
        }
        const J = g.children;
        for (let le = 0, pe = J.length; le < pe; le++) sr(J[le], L, N, B);
      }
      function xs(g, L, N, B) {
        const U = g.opaque,
          J = g.transmissive,
          le = g.transparent;
        u.setupLightsView(N),
          W === !0 && te.setGlobalState(E.clippingPlanes, N),
          B && Se.viewport(b.copy(B)),
          U.length > 0 && Ei(U, L, N),
          J.length > 0 && Ei(J, L, N),
          le.length > 0 && Ei(le, L, N),
          Se.buffers.depth.setTest(!0),
          Se.buffers.depth.setMask(!0),
          Se.buffers.color.setMask(!0),
          Se.setPolygonOffset(!1);
      }
      function Ss(g, L, N, B) {
        if ((N.isScene === !0 ? N.overrideMaterial : null) !== null) return;
        u.state.transmissionRenderTarget[B.id] === void 0 &&
          (u.state.transmissionRenderTarget[B.id] = new en(1, 1, {
            generateMipmaps: !0,
            type: Te.has("EXT_color_buffer_half_float") || Te.has("EXT_color_buffer_float") ? 1016 : 1009,
            minFilter: 1008,
            samples: 4,
            stencilBuffer: s,
            resolveDepthBuffer: !1,
            resolveStencilBuffer: !1,
            colorSpace: ze.workingColorSpace
          }));
        const J = u.state.transmissionRenderTarget[B.id],
          le = B.viewport || b;
        J.setSize(le.z * E.transmissionResolutionScale, le.w * E.transmissionResolutionScale);
        const pe = E.getRenderTarget(),
          he = E.getActiveCubeFace(),
          Re = E.getActiveMipmapLevel();
        E.setRenderTarget(J),
          E.getClearColor(H),
          (K = E.getClearAlpha()),
          K < 1 && E.setClearColor(16777215, 0.5),
          E.clear(),
          st && ge.render(N);
        const we = E.toneMapping;
        E.toneMapping = 0;
        const Ee = B.viewport;
        if (
          (B.viewport !== void 0 && (B.viewport = void 0),
          u.setupLightsView(B),
          W === !0 && te.setGlobalState(E.clippingPlanes, B),
          Ei(g, N, B),
          Ne.updateMultisampleRenderTarget(J),
          Ne.updateRenderTargetMipmap(J),
          Te.has("WEBGL_multisampled_render_to_texture") === !1)
        ) {
          let Oe = !1;
          for (let Ye = 0, it = L.length; Ye < it; Ye++) {
            const je = L[Ye],
              Ke = je.object,
              ye = je.geometry,
              tt = je.material,
              Ve = je.group;
            if (tt.side === 2 && Ke.layers.test(B.layers)) {
              const Tt = tt.side;
              (tt.side = 1),
                (tt.needsUpdate = !0),
                Ms(Ke, N, B, ye, tt, Ve),
                (tt.side = Tt),
                (tt.needsUpdate = !0),
                (Oe = !0);
            }
          }
          Oe === !0 && (Ne.updateMultisampleRenderTarget(J), Ne.updateRenderTargetMipmap(J));
        }
        E.setRenderTarget(pe, he, Re), E.setClearColor(H, K), Ee !== void 0 && (B.viewport = Ee), (E.toneMapping = we);
      }
      function Ei(g, L, N) {
        const B = L.isScene === !0 ? L.overrideMaterial : null;
        for (let U = 0, J = g.length; U < J; U++) {
          const le = g[U],
            pe = le.object,
            he = le.geometry,
            Re = le.group;
          let we = le.material;
          we.allowOverride === !0 && B !== null && (we = B), pe.layers.test(N.layers) && Ms(pe, L, N, he, we, Re);
        }
      }
      function Ms(g, L, N, B, U, J) {
        g.onBeforeRender(E, L, N, B, U, J),
          g.modelViewMatrix.multiplyMatrices(N.matrixWorldInverse, g.matrixWorld),
          g.normalMatrix.getNormalMatrix(g.modelViewMatrix),
          U.onBeforeRender(E, L, N, B, g, J),
          U.transparent === !0 && U.side === 2 && U.forceSinglePass === !1
            ? ((U.side = 1),
              (U.needsUpdate = !0),
              E.renderBufferDirect(N, L, B, U, g, J),
              (U.side = 0),
              (U.needsUpdate = !0),
              E.renderBufferDirect(N, L, B, U, g, J),
              (U.side = 2))
            : E.renderBufferDirect(N, L, B, U, g, J),
          g.onAfterRender(E, L, N, B, U, J);
      }
      function Ti(g, L, N) {
        L.isScene !== !0 && (L = Pe);
        const B = de.get(g),
          U = u.state.lights,
          J = u.state.shadowsArray,
          le = U.state.version,
          pe = k.getParameters(g, U.state, J, L, N),
          he = k.getProgramCacheKey(pe);
        let Re = B.programs;
        (B.environment = g.isMeshStandardMaterial ? L.environment : null),
          (B.fog = L.fog),
          (B.envMap = (g.isMeshStandardMaterial ? at : ft).get(g.envMap || B.environment)),
          (B.envMapRotation = B.environment !== null && g.envMap === null ? L.environmentRotation : g.envMapRotation),
          Re === void 0 && (g.addEventListener("dispose", Y), (Re = new Map()), (B.programs = Re));
        let we = Re.get(he);
        if (we !== void 0) {
          if (B.currentProgram === we && B.lightsStateVersion === le) return Ts(g, pe), we;
        } else
          (pe.uniforms = k.getUniforms(g)),
            g.onBeforeCompile(pe, E),
            (we = k.acquireProgram(pe, he)),
            Re.set(he, we),
            (B.uniforms = pe.uniforms);
        const Ee = B.uniforms;
        return (
          ((!g.isShaderMaterial && !g.isRawShaderMaterial) || g.clipping === !0) && (Ee.clippingPlanes = te.uniform),
          Ts(g, pe),
          (B.needsLights = fu(g)),
          (B.lightsStateVersion = le),
          B.needsLights &&
            ((Ee.ambientLightColor.value = U.state.ambient),
            (Ee.lightProbe.value = U.state.probe),
            (Ee.directionalLights.value = U.state.directional),
            (Ee.directionalLightShadows.value = U.state.directionalShadow),
            (Ee.spotLights.value = U.state.spot),
            (Ee.spotLightShadows.value = U.state.spotShadow),
            (Ee.rectAreaLights.value = U.state.rectArea),
            (Ee.ltc_1.value = U.state.rectAreaLTC1),
            (Ee.ltc_2.value = U.state.rectAreaLTC2),
            (Ee.pointLights.value = U.state.point),
            (Ee.pointLightShadows.value = U.state.pointShadow),
            (Ee.hemisphereLights.value = U.state.hemi),
            (Ee.directionalShadowMap.value = U.state.directionalShadowMap),
            (Ee.directionalShadowMatrix.value = U.state.directionalShadowMatrix),
            (Ee.spotShadowMap.value = U.state.spotShadowMap),
            (Ee.spotLightMatrix.value = U.state.spotLightMatrix),
            (Ee.spotLightMap.value = U.state.spotLightMap),
            (Ee.pointShadowMap.value = U.state.pointShadowMap),
            (Ee.pointShadowMatrix.value = U.state.pointShadowMatrix)),
          (B.currentProgram = we),
          (B.uniformsList = null),
          we
        );
      }
      function Es(g) {
        if (g.uniformsList === null) {
          const L = g.currentProgram.getUniforms();
          g.uniformsList = Si.seqWithValue(L.seq, g.uniforms);
        }
        return g.uniformsList;
      }
      function Ts(g, L) {
        const N = de.get(g);
        (N.outputColorSpace = L.outputColorSpace),
          (N.batching = L.batching),
          (N.batchingColor = L.batchingColor),
          (N.instancing = L.instancing),
          (N.instancingColor = L.instancingColor),
          (N.instancingMorph = L.instancingMorph),
          (N.skinning = L.skinning),
          (N.morphTargets = L.morphTargets),
          (N.morphNormals = L.morphNormals),
          (N.morphColors = L.morphColors),
          (N.morphTargetsCount = L.morphTargetsCount),
          (N.numClippingPlanes = L.numClippingPlanes),
          (N.numIntersection = L.numClipIntersection),
          (N.vertexAlphas = L.vertexAlphas),
          (N.vertexTangents = L.vertexTangents),
          (N.toneMapping = L.toneMapping);
      }
      function uu(g, L, N, B, U) {
        L.isScene !== !0 && (L = Pe), Ne.resetTextureUnits();
        const J = L.fog,
          le = B.isMeshStandardMaterial ? L.environment : null,
          pe = F === null ? E.outputColorSpace : F.isXRRenderTarget === !0 ? F.texture.colorSpace : pn,
          he = (B.isMeshStandardMaterial ? at : ft).get(B.envMap || le),
          Re = B.vertexColors === !0 && !!N.attributes.color && N.attributes.color.itemSize === 4,
          we = !!N.attributes.tangent && (!!B.normalMap || B.anisotropy > 0),
          Ee = !!N.morphAttributes.position,
          Oe = !!N.morphAttributes.normal,
          Ye = !!N.morphAttributes.color;
        let it = 0;
        B.toneMapped && (F === null || F.isXRRenderTarget === !0) && (it = E.toneMapping);
        const je = N.morphAttributes.position || N.morphAttributes.normal || N.morphAttributes.color,
          Ke = je !== void 0 ? je.length : 0,
          ye = de.get(B),
          tt = u.state.lights;
        if (W === !0 && (ae === !0 || g !== S)) {
          const _t = g === S && B.id === M;
          te.setState(B, g, _t);
        }
        let Ve = !1;
        B.version === ye.__version
          ? ((ye.needsLights && ye.lightsStateVersion !== tt.state.version) ||
              ye.outputColorSpace !== pe ||
              (U.isBatchedMesh && ye.batching === !1) ||
              (!U.isBatchedMesh && ye.batching === !0) ||
              (U.isBatchedMesh && ye.batchingColor === !0 && U.colorTexture === null) ||
              (U.isBatchedMesh && ye.batchingColor === !1 && U.colorTexture !== null) ||
              (U.isInstancedMesh && ye.instancing === !1) ||
              (!U.isInstancedMesh && ye.instancing === !0) ||
              (U.isSkinnedMesh && ye.skinning === !1) ||
              (!U.isSkinnedMesh && ye.skinning === !0) ||
              (U.isInstancedMesh && ye.instancingColor === !0 && U.instanceColor === null) ||
              (U.isInstancedMesh && ye.instancingColor === !1 && U.instanceColor !== null) ||
              (U.isInstancedMesh && ye.instancingMorph === !0 && U.morphTexture === null) ||
              (U.isInstancedMesh && ye.instancingMorph === !1 && U.morphTexture !== null) ||
              ye.envMap !== he ||
              (B.fog === !0 && ye.fog !== J) ||
              (ye.numClippingPlanes !== void 0 &&
                (ye.numClippingPlanes !== te.numPlanes || ye.numIntersection !== te.numIntersection)) ||
              ye.vertexAlphas !== Re ||
              ye.vertexTangents !== we ||
              ye.morphTargets !== Ee ||
              ye.morphNormals !== Oe ||
              ye.morphColors !== Ye ||
              ye.toneMapping !== it ||
              ye.morphTargetsCount !== Ke) &&
            (Ve = !0)
          : ((Ve = !0), (ye.__version = B.version));
        let Tt = ye.currentProgram;
        Ve === !0 && (Tt = Ti(B, L, U));
        let In = !1,
          yt = !1,
          qn = !1;
        const nt = Tt.getUniforms(),
          Rt = ye.uniforms;
        if (
          (Se.useProgram(Tt.program) && ((In = !0), (yt = !0), (qn = !0)),
          B.id !== M && ((M = B.id), (yt = !0)),
          In || S !== g)
        ) {
          Se.buffers.depth.getReversed() &&
            g.reversedDepth !== !0 &&
            ((g._reversedDepth = !0), g.updateProjectionMatrix()),
            nt.setValue(A, "projectionMatrix", g.projectionMatrix),
            nt.setValue(A, "viewMatrix", g.matrixWorldInverse);
          const St = nt.map.cameraPosition;
          St !== void 0 && St.setValue(A, Ae.setFromMatrixPosition(g.matrixWorld)),
            He.logarithmicDepthBuffer && nt.setValue(A, "logDepthBufFC", 2 / (Math.log(g.far + 1) / Math.LN2)),
            (B.isMeshPhongMaterial ||
              B.isMeshToonMaterial ||
              B.isMeshLambertMaterial ||
              B.isMeshBasicMaterial ||
              B.isMeshStandardMaterial ||
              B.isShaderMaterial) &&
              nt.setValue(A, "isOrthographic", g.isOrthographicCamera === !0),
            S !== g && ((S = g), (yt = !0), (qn = !0));
        }
        if (U.isSkinnedMesh) {
          nt.setOptional(A, U, "bindMatrix"), nt.setOptional(A, U, "bindMatrixInverse");
          const _t = U.skeleton;
          _t && (_t.boneTexture === null && _t.computeBoneTexture(), nt.setValue(A, "boneTexture", _t.boneTexture, Ne));
        }
        U.isBatchedMesh &&
          (nt.setOptional(A, U, "batchingTexture"),
          nt.setValue(A, "batchingTexture", U._matricesTexture, Ne),
          nt.setOptional(A, U, "batchingIdTexture"),
          nt.setValue(A, "batchingIdTexture", U._indirectTexture, Ne),
          nt.setOptional(A, U, "batchingColorTexture"),
          U._colorsTexture !== null && nt.setValue(A, "batchingColorTexture", U._colorsTexture, Ne));
        const Ct = N.morphAttributes;
        if (
          ((Ct.position !== void 0 || Ct.normal !== void 0 || Ct.color !== void 0) && j.update(U, N, Tt),
          (yt || ye.receiveShadow !== U.receiveShadow) &&
            ((ye.receiveShadow = U.receiveShadow), nt.setValue(A, "receiveShadow", U.receiveShadow)),
          B.isMeshGouraudMaterial &&
            B.envMap !== null &&
            ((Rt.envMap.value = he),
            (Rt.flipEnvMap.value = he.isCubeTexture && he.isRenderTargetTexture === !1 ? -1 : 1)),
          B.isMeshStandardMaterial &&
            B.envMap === null &&
            L.environment !== null &&
            (Rt.envMapIntensity.value = L.environmentIntensity),
          yt &&
            (nt.setValue(A, "toneMappingExposure", E.toneMappingExposure),
            ye.needsLights && hu(Rt, qn),
            J && B.fog === !0 && $.refreshFogUniforms(Rt, J),
            $.refreshMaterialUniforms(Rt, B, G, ee, u.state.transmissionRenderTarget[g.id]),
            Si.upload(A, Es(ye), Rt, Ne)),
          B.isShaderMaterial &&
            B.uniformsNeedUpdate === !0 &&
            (Si.upload(A, Es(ye), Rt, Ne), (B.uniformsNeedUpdate = !1)),
          B.isSpriteMaterial && nt.setValue(A, "center", U.center),
          nt.setValue(A, "modelViewMatrix", U.modelViewMatrix),
          nt.setValue(A, "normalMatrix", U.normalMatrix),
          nt.setValue(A, "modelMatrix", U.matrixWorld),
          B.isShaderMaterial || B.isRawShaderMaterial)
        ) {
          const _t = B.uniformsGroups;
          for (let St = 0, ar = _t.length; St < ar; St++) {
            const dn = _t[St];
            Ue.update(dn, Tt), Ue.bind(dn, Tt);
          }
        }
        return Tt;
      }
      function hu(g, L) {
        (g.ambientLightColor.needsUpdate = L),
          (g.lightProbe.needsUpdate = L),
          (g.directionalLights.needsUpdate = L),
          (g.directionalLightShadows.needsUpdate = L),
          (g.pointLights.needsUpdate = L),
          (g.pointLightShadows.needsUpdate = L),
          (g.spotLights.needsUpdate = L),
          (g.spotLightShadows.needsUpdate = L),
          (g.rectAreaLights.needsUpdate = L),
          (g.hemisphereLights.needsUpdate = L);
      }
      function fu(g) {
        return (
          g.isMeshLambertMaterial ||
          g.isMeshToonMaterial ||
          g.isMeshPhongMaterial ||
          g.isMeshStandardMaterial ||
          g.isShadowMaterial ||
          (g.isShaderMaterial && g.lights === !0)
        );
      }
      (this.getActiveCubeFace = function () {
        return w;
      }),
        (this.getActiveMipmapLevel = function () {
          return P;
        }),
        (this.getRenderTarget = function () {
          return F;
        }),
        (this.setRenderTargetTextures = function (g, L, N) {
          const B = de.get(g);
          (B.__autoAllocateDepthBuffer = g.resolveDepthBuffer === !1),
            B.__autoAllocateDepthBuffer === !1 && (B.__useRenderToTexture = !1),
            (de.get(g.texture).__webglTexture = L),
            (de.get(g.depthTexture).__webglTexture = B.__autoAllocateDepthBuffer ? void 0 : N),
            (B.__hasExternalTextures = !0);
        }),
        (this.setRenderTargetFramebuffer = function (g, L) {
          const N = de.get(g);
          (N.__webglFramebuffer = L), (N.__useDefaultFramebuffer = L === void 0);
        });
      const du = A.createFramebuffer();
      (this.setRenderTarget = function (g, L = 0, N = 0) {
        (F = g), (w = L), (P = N);
        let B = !0,
          U = null,
          J = !1,
          le = !1;
        if (g) {
          const he = de.get(g);
          if (he.__useDefaultFramebuffer !== void 0) Se.bindFramebuffer(A.FRAMEBUFFER, null), (B = !1);
          else if (he.__webglFramebuffer === void 0) Ne.setupRenderTarget(g);
          else if (he.__hasExternalTextures)
            Ne.rebindTextures(g, de.get(g.texture).__webglTexture, de.get(g.depthTexture).__webglTexture);
          else if (g.depthBuffer) {
            const Ee = g.depthTexture;
            if (he.__boundDepthTexture !== Ee) {
              if (Ee !== null && de.has(Ee) && (g.width !== Ee.image.width || g.height !== Ee.image.height))
                throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
              Ne.setupDepthRenderbuffer(g);
            }
          }
          const Re = g.texture;
          (Re.isData3DTexture || Re.isDataArrayTexture || Re.isCompressedArrayTexture) && (le = !0);
          const we = de.get(g).__webglFramebuffer;
          g.isWebGLCubeRenderTarget
            ? (Array.isArray(we[L]) ? (U = we[L][N]) : (U = we[L]), (J = !0))
            : g.samples > 0 && Ne.useMultisampledRTT(g) === !1
            ? (U = de.get(g).__webglMultisampledFramebuffer)
            : Array.isArray(we)
            ? (U = we[N])
            : (U = we),
            b.copy(g.viewport),
            q.copy(g.scissor),
            (V = g.scissorTest);
        } else b.copy(Me).multiplyScalar(G).floor(), q.copy(Fe).multiplyScalar(G).floor(), (V = Qe);
        if (
          (N !== 0 && (U = du),
          Se.bindFramebuffer(A.FRAMEBUFFER, U) && B && Se.drawBuffers(g, U),
          Se.viewport(b),
          Se.scissor(q),
          Se.setScissorTest(V),
          J)
        ) {
          const he = de.get(g.texture);
          A.framebufferTexture2D(
            A.FRAMEBUFFER,
            A.COLOR_ATTACHMENT0,
            A.TEXTURE_CUBE_MAP_POSITIVE_X + L,
            he.__webglTexture,
            N
          );
        } else if (le) {
          const he = L;
          for (let Re = 0; Re < g.textures.length; Re++) {
            const we = de.get(g.textures[Re]);
            A.framebufferTextureLayer(A.FRAMEBUFFER, A.COLOR_ATTACHMENT0 + Re, we.__webglTexture, N, he);
          }
        } else if (g !== null && N !== 0) {
          const he = de.get(g.texture);
          A.framebufferTexture2D(A.FRAMEBUFFER, A.COLOR_ATTACHMENT0, A.TEXTURE_2D, he.__webglTexture, N);
        }
        M = -1;
      }),
        (this.readRenderTargetPixels = function (g, L, N, B, U, J, le, pe = 0) {
          if (!(g && g.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
          }
          let he = de.get(g).__webglFramebuffer;
          if ((g.isWebGLCubeRenderTarget && le !== void 0 && (he = he[le]), he)) {
            Se.bindFramebuffer(A.FRAMEBUFFER, he);
            try {
              const Re = g.textures[pe],
                we = Re.format,
                Ee = Re.type;
              if (!He.textureFormatReadable(we)) {
                console.error(
                  "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format."
                );
                return;
              }
              if (!He.textureTypeReadable(Ee)) {
                console.error(
                  "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type."
                );
                return;
              }
              L >= 0 &&
                L <= g.width - B &&
                N >= 0 &&
                N <= g.height - U &&
                (g.textures.length > 1 && A.readBuffer(A.COLOR_ATTACHMENT0 + pe),
                A.readPixels(L, N, B, U, ve.convert(we), ve.convert(Ee), J));
            } finally {
              const Re = F !== null ? de.get(F).__webglFramebuffer : null;
              Se.bindFramebuffer(A.FRAMEBUFFER, Re);
            }
          }
        }),
        (this.readRenderTargetPixelsAsync = async function (g, L, N, B, U, J, le, pe = 0) {
          if (!(g && g.isWebGLRenderTarget))
            throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
          let he = de.get(g).__webglFramebuffer;
          if ((g.isWebGLCubeRenderTarget && le !== void 0 && (he = he[le]), he))
            if (L >= 0 && L <= g.width - B && N >= 0 && N <= g.height - U) {
              Se.bindFramebuffer(A.FRAMEBUFFER, he);
              const Re = g.textures[pe],
                we = Re.format,
                Ee = Re.type;
              if (!He.textureFormatReadable(we))
                throw new Error(
                  "THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format."
                );
              if (!He.textureTypeReadable(Ee))
                throw new Error(
                  "THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type."
                );
              const Oe = A.createBuffer();
              A.bindBuffer(A.PIXEL_PACK_BUFFER, Oe),
                A.bufferData(A.PIXEL_PACK_BUFFER, J.byteLength, A.STREAM_READ),
                g.textures.length > 1 && A.readBuffer(A.COLOR_ATTACHMENT0 + pe),
                A.readPixels(L, N, B, U, ve.convert(we), ve.convert(Ee), 0);
              const Ye = F !== null ? de.get(F).__webglFramebuffer : null;
              Se.bindFramebuffer(A.FRAMEBUFFER, Ye);
              const it = A.fenceSync(A.SYNC_GPU_COMMANDS_COMPLETE, 0);
              return (
                A.flush(),
                await bs(A, it, 4),
                A.bindBuffer(A.PIXEL_PACK_BUFFER, Oe),
                A.getBufferSubData(A.PIXEL_PACK_BUFFER, 0, J),
                A.deleteBuffer(Oe),
                A.deleteSync(it),
                J
              );
            } else
              throw new Error(
                "THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range."
              );
        }),
        (this.copyFramebufferToTexture = function (g, L = null, N = 0) {
          const B = Math.pow(2, -N),
            U = Math.floor(g.image.width * B),
            J = Math.floor(g.image.height * B),
            le = L !== null ? L.x : 0,
            pe = L !== null ? L.y : 0;
          Ne.setTexture2D(g, 0), A.copyTexSubImage2D(A.TEXTURE_2D, N, 0, 0, le, pe, U, J), Se.unbindTexture();
        });
      const pu = A.createFramebuffer(),
        mu = A.createFramebuffer();
      (this.copyTextureToTexture = function (g, L, N = null, B = null, U = 0, J = null) {
        J === null &&
          (U !== 0
            ? (_n(
                "WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."
              ),
              (J = U),
              (U = 0))
            : (J = 0));
        let le, pe, he, Re, we, Ee, Oe, Ye, it;
        const je = g.isCompressedTexture ? g.mipmaps[J] : g.image;
        if (N !== null)
          (le = N.max.x - N.min.x),
            (pe = N.max.y - N.min.y),
            (he = N.isBox3 ? N.max.z - N.min.z : 1),
            (Re = N.min.x),
            (we = N.min.y),
            (Ee = N.isBox3 ? N.min.z : 0);
        else {
          const Ct = Math.pow(2, -U);
          (le = Math.floor(je.width * Ct)),
            (pe = Math.floor(je.height * Ct)),
            g.isDataArrayTexture ? (he = je.depth) : g.isData3DTexture ? (he = Math.floor(je.depth * Ct)) : (he = 1),
            (Re = 0),
            (we = 0),
            (Ee = 0);
        }
        B !== null ? ((Oe = B.x), (Ye = B.y), (it = B.z)) : ((Oe = 0), (Ye = 0), (it = 0));
        const Ke = ve.convert(L.format),
          ye = ve.convert(L.type);
        let tt;
        L.isData3DTexture
          ? (Ne.setTexture3D(L, 0), (tt = A.TEXTURE_3D))
          : L.isDataArrayTexture || L.isCompressedArrayTexture
          ? (Ne.setTexture2DArray(L, 0), (tt = A.TEXTURE_2D_ARRAY))
          : (Ne.setTexture2D(L, 0), (tt = A.TEXTURE_2D)),
          A.pixelStorei(A.UNPACK_FLIP_Y_WEBGL, L.flipY),
          A.pixelStorei(A.UNPACK_PREMULTIPLY_ALPHA_WEBGL, L.premultiplyAlpha),
          A.pixelStorei(A.UNPACK_ALIGNMENT, L.unpackAlignment);
        const Ve = A.getParameter(A.UNPACK_ROW_LENGTH),
          Tt = A.getParameter(A.UNPACK_IMAGE_HEIGHT),
          In = A.getParameter(A.UNPACK_SKIP_PIXELS),
          yt = A.getParameter(A.UNPACK_SKIP_ROWS),
          qn = A.getParameter(A.UNPACK_SKIP_IMAGES);
        A.pixelStorei(A.UNPACK_ROW_LENGTH, je.width),
          A.pixelStorei(A.UNPACK_IMAGE_HEIGHT, je.height),
          A.pixelStorei(A.UNPACK_SKIP_PIXELS, Re),
          A.pixelStorei(A.UNPACK_SKIP_ROWS, we),
          A.pixelStorei(A.UNPACK_SKIP_IMAGES, Ee);
        const nt = g.isDataArrayTexture || g.isData3DTexture,
          Rt = L.isDataArrayTexture || L.isData3DTexture;
        if (g.isDepthTexture) {
          const Ct = de.get(g),
            _t = de.get(L),
            St = de.get(Ct.__renderTarget),
            ar = de.get(_t.__renderTarget);
          Se.bindFramebuffer(A.READ_FRAMEBUFFER, St.__webglFramebuffer),
            Se.bindFramebuffer(A.DRAW_FRAMEBUFFER, ar.__webglFramebuffer);
          for (let dn = 0; dn < he; dn++)
            nt &&
              (A.framebufferTextureLayer(A.READ_FRAMEBUFFER, A.COLOR_ATTACHMENT0, de.get(g).__webglTexture, U, Ee + dn),
              A.framebufferTextureLayer(A.DRAW_FRAMEBUFFER, A.COLOR_ATTACHMENT0, de.get(L).__webglTexture, J, it + dn)),
              A.blitFramebuffer(Re, we, le, pe, Oe, Ye, le, pe, A.DEPTH_BUFFER_BIT, A.NEAREST);
          Se.bindFramebuffer(A.READ_FRAMEBUFFER, null), Se.bindFramebuffer(A.DRAW_FRAMEBUFFER, null);
        } else if (U !== 0 || g.isRenderTargetTexture || de.has(g)) {
          const Ct = de.get(g),
            _t = de.get(L);
          Se.bindFramebuffer(A.READ_FRAMEBUFFER, pu), Se.bindFramebuffer(A.DRAW_FRAMEBUFFER, mu);
          for (let St = 0; St < he; St++)
            nt
              ? A.framebufferTextureLayer(A.READ_FRAMEBUFFER, A.COLOR_ATTACHMENT0, Ct.__webglTexture, U, Ee + St)
              : A.framebufferTexture2D(A.READ_FRAMEBUFFER, A.COLOR_ATTACHMENT0, A.TEXTURE_2D, Ct.__webglTexture, U),
              Rt
                ? A.framebufferTextureLayer(A.DRAW_FRAMEBUFFER, A.COLOR_ATTACHMENT0, _t.__webglTexture, J, it + St)
                : A.framebufferTexture2D(A.DRAW_FRAMEBUFFER, A.COLOR_ATTACHMENT0, A.TEXTURE_2D, _t.__webglTexture, J),
              U !== 0
                ? A.blitFramebuffer(Re, we, le, pe, Oe, Ye, le, pe, A.COLOR_BUFFER_BIT, A.NEAREST)
                : Rt
                ? A.copyTexSubImage3D(tt, J, Oe, Ye, it + St, Re, we, le, pe)
                : A.copyTexSubImage2D(tt, J, Oe, Ye, Re, we, le, pe);
          Se.bindFramebuffer(A.READ_FRAMEBUFFER, null), Se.bindFramebuffer(A.DRAW_FRAMEBUFFER, null);
        } else
          Rt
            ? g.isDataTexture || g.isData3DTexture
              ? A.texSubImage3D(tt, J, Oe, Ye, it, le, pe, he, Ke, ye, je.data)
              : L.isCompressedArrayTexture
              ? A.compressedTexSubImage3D(tt, J, Oe, Ye, it, le, pe, he, Ke, je.data)
              : A.texSubImage3D(tt, J, Oe, Ye, it, le, pe, he, Ke, ye, je)
            : g.isDataTexture
            ? A.texSubImage2D(A.TEXTURE_2D, J, Oe, Ye, le, pe, Ke, ye, je.data)
            : g.isCompressedTexture
            ? A.compressedTexSubImage2D(A.TEXTURE_2D, J, Oe, Ye, je.width, je.height, Ke, je.data)
            : A.texSubImage2D(A.TEXTURE_2D, J, Oe, Ye, le, pe, Ke, ye, je);
        A.pixelStorei(A.UNPACK_ROW_LENGTH, Ve),
          A.pixelStorei(A.UNPACK_IMAGE_HEIGHT, Tt),
          A.pixelStorei(A.UNPACK_SKIP_PIXELS, In),
          A.pixelStorei(A.UNPACK_SKIP_ROWS, yt),
          A.pixelStorei(A.UNPACK_SKIP_IMAGES, qn),
          J === 0 && L.generateMipmaps && A.generateMipmap(tt),
          Se.unbindTexture();
      }),
        (this.copyTextureToTexture3D = function (g, L, N = null, B = null, U = 0) {
          return (
            _n(
              'WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.'
            ),
            this.copyTextureToTexture(g, L, N, B, U)
          );
        }),
        (this.initRenderTarget = function (g) {
          de.get(g).__webglFramebuffer === void 0 && Ne.setupRenderTarget(g);
        }),
        (this.initTexture = function (g) {
          g.isCubeTexture
            ? Ne.setTextureCube(g, 0)
            : g.isData3DTexture
            ? Ne.setTexture3D(g, 0)
            : g.isDataArrayTexture || g.isCompressedArrayTexture
            ? Ne.setTexture2DArray(g, 0)
            : Ne.setTexture2D(g, 0),
            Se.unbindTexture();
        }),
        (this.resetState = function () {
          (w = 0), (P = 0), (F = null), Se.reset(), oe.reset();
        }),
        typeof __THREE_DEVTOOLS__ < "u" &&
          __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
    }
    get coordinateSystem() {
      return 2e3;
    }
    get outputColorSpace() {
      return this._outputColorSpace;
    }
    set outputColorSpace(e) {
      this._outputColorSpace = e;
      const t = this.getContext();
      (t.drawingBufferColorSpace = ze._getDrawingBufferColorSpace(e)), (t.unpackColorSpace = ze._getUnpackColorSpace());
    }
  }
  window.THREE = {
    AdditiveBlending: 2,
    BufferAttribute: Ut,
    BufferGeometry: Wt,
    Color: ke,
    OrthographicCamera: zr,
    Points: na,
    Scene: Js,
    ShaderMaterial: qt,
    WebGLRenderer: cu
  };
})();
